//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ActivityCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ActivityCategories
     * @return The list of ActivityCategories
     */
    getActivityCategories( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activitycategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityCategories(_response);
        });
    }

    protected processGetActivityCategories(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ActivityCategory
     * @param body The ActivityCategory data to create
     * @return The newly created ActivityCategory data
     */
    createActivityCategory(body: ActivityCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityCategoryDTO> {
        let url_ = this.baseUrl + "/activitycategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityCategory(_response);
        });
    }

    protected processCreateActivityCategory(response: AxiosResponse): Promise<ApiResponse_activityCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_activityCategoryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityCategoryDTO>(null as any);
    }

    /**
     * Retrieve a ActivityCategory by ID
     * @param id The ID of the ActivityCategory to retrieve
     * @return The ActivityCategory data
     */
    getActivityCategoryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activityCategoryDTO> {
        let url_ = this.baseUrl + "/activitycategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityCategoryById(_response);
        });
    }

    protected processGetActivityCategoryById(response: AxiosResponse): Promise<ApiResponse_activityCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityCategoryDTO>(null as any);
    }

    /**
     * Update a ActivityCategory by ID
     * @param id The ID of the ActivityCategory to update
     * @param body The updated ActivityCategory data
     * @return The updated ActivityCategory data
     */
    updateActivityCategory(id: string, body: ActivityCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityCategoryDTO> {
        let url_ = this.baseUrl + "/activitycategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityCategory(_response);
        });
    }

    protected processUpdateActivityCategory(response: AxiosResponse): Promise<ApiResponse_activityCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityCategoryDTO>(null as any);
    }

    /**
     * Delete a ActivityCategory by ID
     * @param id The ID of the ActivityCategory to delete
     */
    deleteActivityCategory(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/activitycategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivityCategory(_response);
        });
    }

    protected processDeleteActivityCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ActivityCategories based on criteria
     * @param body The search criteria
     * @return The search results of ActivityCategories based on the criteria
     */
    searchActivityCategories(body: SearchRequestDTO_activityCategorySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/activitycategory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchActivityCategories(_response);
        });
    }

    protected processSearchActivityCategories(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ActivityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Activities
     * @return The list of Activities
     */
    getActivities( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivities(_response);
        });
    }

    protected processGetActivities(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Activity
     * @param body The Activity data to create
     * @return The newly created Activity data
     */
    createActivity(body: ActivityDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityDTO> {
        let url_ = this.baseUrl + "/activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivity(_response);
        });
    }

    protected processCreateActivity(response: AxiosResponse): Promise<ApiResponse_activityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_activityDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityDTO>(null as any);
    }

    /**
     * Retrieve a Activity by ID
     * @param id The ID of the Activity to retrieve
     * @return The Activity data
     */
    getActivityById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activityDTO> {
        let url_ = this.baseUrl + "/activity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityById(_response);
        });
    }

    protected processGetActivityById(response: AxiosResponse): Promise<ApiResponse_activityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityDTO>(null as any);
    }

    /**
     * Update a Activity by ID
     * @param id The ID of the Activity to update
     * @param body The updated Activity data
     * @return The updated Activity data
     */
    updateActivity(id: string, body: ActivityDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityDTO> {
        let url_ = this.baseUrl + "/activity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivity(_response);
        });
    }

    protected processUpdateActivity(response: AxiosResponse): Promise<ApiResponse_activityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityDTO>(null as any);
    }

    /**
     * Delete a Activity by ID
     * @param id The ID of the Activity to delete
     */
    deleteActivity(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/activity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivity(_response);
        });
    }

    protected processDeleteActivity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Activity Status (Bulk)
     * @param body The status update data
     * @return Number of activities updated
     */
    updateActivityQuickStatus(body: UpdateActivityStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/activity/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityQuickStatus(_response);
        });
    }

    protected processUpdateActivityQuickStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Retrieve Activity feedback HTML
     * @param id The ID of the Activity
     * @return The feedback HTML content, or null if none exists
     */
    getActivityFeedback(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activity/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityFeedback(_response);
        });
    }

    protected processGetActivityFeedback(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search Activities based on criteria
     * @param body The search criteria
     * @return The search results of Activities based on the criteria
     */
    searchActivities(body: SearchRequestDTO_activitySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/activity/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchActivities(_response);
        });
    }

    protected processSearchActivities(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Activities based on search criteria
     * @param body The search criteria
     * @return The export results of Activities based on the search criteria
     */
    exportActivities(body: SearchRequestDTO_activitySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activity/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportActivities(_response);
        });
    }

    protected processExportActivities(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Restore a Activity from deleted by ID
     * @param id The ID of the Activity to restore from deleted
     * @return The restored Activity data
     */
    restoreFromDeletedActivity(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activityDTO> {
        let url_ = this.baseUrl + "/activity/{id}/restore-deleted";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromDeletedActivity(_response);
        });
    }

    protected processRestoreFromDeletedActivity(response: AxiosResponse): Promise<ApiResponse_activityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityDTO>(null as any);
    }

    /**
     * Generate activity report PDF
     * @param memberId The member ID to generate activity report for
     * @return The URL of the generated activity report PDF
     */
    generateActivityReportPdf(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activity/report/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateActivityReportPdf(_response);
        });
    }

    protected processGenerateActivityReportPdf(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate activity report HTML
     * @param memberId The member ID to generate activity report for
     * @return The HTML content of the generated activity report
     */
    generateActivityReportHtml(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activity/report-html/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateActivityReportHtml(_response);
        });
    }

    protected processGenerateActivityReportHtml(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all Compliance Activities
     * @return The list of Compliance Activities
     */
    getComplianceActivities( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/activity/compliance-activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplianceActivities(_response);
        });
    }

    protected processGetComplianceActivities(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Retrieve Historical Compliance Activities
     * @param numberOfYears (optional) The number of historical years to retrieve (default: 6)
     * @return The structured Historical Compliance Activities
     */
    getComplianceActivitiesHistory(numberOfYears: number | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_complianceHistoryResponseDTO> {
        let url_ = this.baseUrl + "/activity/compliance-activities-history?";
        if (numberOfYears !== undefined && numberOfYears !== null)
            url_ += "numberOfYears=" + encodeURIComponent("" + numberOfYears) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComplianceActivitiesHistory(_response);
        });
    }

    protected processGetComplianceActivitiesHistory(response: AxiosResponse): Promise<ApiResponse_complianceHistoryResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_complianceHistoryResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_complianceHistoryResponseDTO>(null as any);
    }

    /**
     * Retrieve All Compliance Activities History
     * @param numberOfYears (optional) Optional: Maximum number of years to retrieve (0 = all years)
     * @return The complete compliance activities history
     */
    getAllComplianceActivitiesHistory(numberOfYears: number | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_complianceHistoryResponseDTO> {
        let url_ = this.baseUrl + "/activity/all-compliance-activities-history?";
        if (numberOfYears !== undefined && numberOfYears !== null)
            url_ += "numberOfYears=" + encodeURIComponent("" + numberOfYears) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllComplianceActivitiesHistory(_response);
        });
    }

    protected processGetAllComplianceActivitiesHistory(response: AxiosResponse): Promise<ApiResponse_complianceHistoryResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_complianceHistoryResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_complianceHistoryResponseDTO>(null as any);
    }

    /**
     * Generate sport shooting list PDF
     * @param memberId The member ID to generate sport shooting list for
     * @return The URL of the generated sport shooting list PDF
     */
    generateSportShootingListPdf(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activity/sport-shooting-list/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSportShootingListPdf(_response);
        });
    }

    protected processGenerateSportShootingListPdf(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate sport shooting list HTML
     * @param memberId The member ID to generate sport shooting list for
     * @return The HTML content of the generated sport shooting list
     */
    generateSportShootingListHtml(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activity/sport-shooting-list-html/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSportShootingListHtml(_response);
        });
    }

    protected processGenerateSportShootingListHtml(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get distinct years for activities
     * @return Distinct years in descending order
     */
    getActivityYears( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activity/years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityYears(_response);
        });
    }

    protected processGetActivityYears(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class ActivitySpeciesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ActivitySpecies
     * @return The list of ActivitySpecies
     */
    getActivitySpecies( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activityspecies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivitySpecies(_response);
        });
    }

    protected processGetActivitySpecies(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ActivitySpecies
     * @param body The ActivitySpecies data to create
     * @return The newly created ActivitySpecies data
     */
    createActivitySpecies(body: ActivitySpeciesDTO, cancelToken?: CancelToken): Promise<ApiResponse_activitySpeciesDTO> {
        let url_ = this.baseUrl + "/activityspecies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivitySpecies(_response);
        });
    }

    protected processCreateActivitySpecies(response: AxiosResponse): Promise<ApiResponse_activitySpeciesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_activitySpeciesDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activitySpeciesDTO>(null as any);
    }

    /**
     * Retrieve a ActivitySpecies by ID
     * @param id The ID of the ActivitySpecies to retrieve
     * @return The ActivitySpecies data
     */
    getActivitySpeciesById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activitySpeciesDTO> {
        let url_ = this.baseUrl + "/activityspecies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivitySpeciesById(_response);
        });
    }

    protected processGetActivitySpeciesById(response: AxiosResponse): Promise<ApiResponse_activitySpeciesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activitySpeciesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activitySpeciesDTO>(null as any);
    }

    /**
     * Update a ActivitySpecies by ID
     * @param id The ID of the ActivitySpecies to update
     * @param body The updated ActivitySpecies data
     * @return The updated ActivitySpecies data
     */
    updateActivitySpecies(id: string, body: ActivitySpeciesDTO, cancelToken?: CancelToken): Promise<ApiResponse_activitySpeciesDTO> {
        let url_ = this.baseUrl + "/activityspecies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivitySpecies(_response);
        });
    }

    protected processUpdateActivitySpecies(response: AxiosResponse): Promise<ApiResponse_activitySpeciesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activitySpeciesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activitySpeciesDTO>(null as any);
    }

    /**
     * Delete a ActivitySpecies by ID
     * @param id The ID of the ActivitySpecies to delete
     */
    deleteActivitySpecies(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/activityspecies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivitySpecies(_response);
        });
    }

    protected processDeleteActivitySpecies(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ActivitySpecies based on criteria
     * @param body The search criteria
     * @return The search results of ActivitySpecies based on the criteria
     */
    searchActivitySpecies(body: SearchRequestDTO_activitySpeciesSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/activityspecies/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchActivitySpecies(_response);
        });
    }

    protected processSearchActivitySpecies(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export ActivitySpecies based on search criteria
     * @param body The search criteria
     * @return The export results of ActivitySpecies based on the search criteria
     */
    exportActivitySpecies(body: SearchRequestDTO_activitySpeciesSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/activityspecies/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportActivitySpecies(_response);
        });
    }

    protected processExportActivitySpecies(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class ActivitySpeciesTypesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ActivitySpeciesTypes
     * @return The list of ActivitySpeciesTypes
     */
    getActivitySpeciesTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activityspeciestype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivitySpeciesTypes(_response);
        });
    }

    protected processGetActivitySpeciesTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class ActivitySpeciesTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Create a new ActivitySpeciesType
     * @param body The ActivitySpeciesType data to create
     * @return The newly created ActivitySpeciesType data
     */
    createActivitySpeciesType(body: ActivitySpeciesTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_activitySpeciesTypeDTO> {
        let url_ = this.baseUrl + "/activityspeciestype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivitySpeciesType(_response);
        });
    }

    protected processCreateActivitySpeciesType(response: AxiosResponse): Promise<ApiResponse_activitySpeciesTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_activitySpeciesTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activitySpeciesTypeDTO>(null as any);
    }

    /**
     * Retrieve a ActivitySpeciesType by ID
     * @param id The ID of the ActivitySpeciesType to retrieve
     * @return The ActivitySpeciesType data
     */
    getActivitySpeciesTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activitySpeciesTypeDTO> {
        let url_ = this.baseUrl + "/activityspeciestype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivitySpeciesTypeById(_response);
        });
    }

    protected processGetActivitySpeciesTypeById(response: AxiosResponse): Promise<ApiResponse_activitySpeciesTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activitySpeciesTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activitySpeciesTypeDTO>(null as any);
    }

    /**
     * Update a ActivitySpeciesType by ID
     * @param id The ID of the ActivitySpeciesType to update
     * @param body The updated ActivitySpeciesType data
     * @return The updated ActivitySpeciesType data
     */
    updateActivitySpeciesType(id: string, body: ActivitySpeciesTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_activitySpeciesTypeDTO> {
        let url_ = this.baseUrl + "/activityspeciestype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivitySpeciesType(_response);
        });
    }

    protected processUpdateActivitySpeciesType(response: AxiosResponse): Promise<ApiResponse_activitySpeciesTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activitySpeciesTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activitySpeciesTypeDTO>(null as any);
    }

    /**
     * Delete a ActivitySpeciesType by ID
     * @param id The ID of the ActivitySpeciesType to delete
     */
    deleteActivitySpeciesType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/activityspeciestype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivitySpeciesType(_response);
        });
    }

    protected processDeleteActivitySpeciesType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ActivitySpeciesType based on criteria
     * @param body The search criteria
     * @return The search results of ActivitySpeciesType based on the criteria
     */
    searchActivitySpeciesType(body: SearchRequestDTO_activitySpeciesTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/activityspeciestype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchActivitySpeciesType(_response);
        });
    }

    protected processSearchActivitySpeciesType(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ActivityStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ActivityStatuses
     * @return The list of ActivityStatuses
     */
    getActivityStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activitystatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityStatuses(_response);
        });
    }

    protected processGetActivityStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ActivityStatus
     * @param body The ActivityStatus data to create
     * @return The newly created ActivityStatus data
     */
    createActivityStatus(body: ActivityStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityStatusDTO> {
        let url_ = this.baseUrl + "/activitystatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityStatus(_response);
        });
    }

    protected processCreateActivityStatus(response: AxiosResponse): Promise<ApiResponse_activityStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_activityStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityStatusDTO>(null as any);
    }

    /**
     * Retrieve a ActivityStatus by ID
     * @param id The ID of the ActivityStatus to retrieve
     * @return The ActivityStatus data
     */
    getActivityStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activityStatusDTO> {
        let url_ = this.baseUrl + "/activitystatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityStatusById(_response);
        });
    }

    protected processGetActivityStatusById(response: AxiosResponse): Promise<ApiResponse_activityStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityStatusDTO>(null as any);
    }

    /**
     * Update a ActivityStatus by ID
     * @param id The ID of the ActivityStatus to update
     * @param body The updated ActivityStatus data
     * @return The updated ActivityStatus data
     */
    updateActivityStatus(id: string, body: ActivityStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityStatusDTO> {
        let url_ = this.baseUrl + "/activitystatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityStatus(_response);
        });
    }

    protected processUpdateActivityStatus(response: AxiosResponse): Promise<ApiResponse_activityStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityStatusDTO>(null as any);
    }

    /**
     * Delete a ActivityStatus by ID
     * @param id The ID of the ActivityStatus to delete
     */
    deleteActivityStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/activitystatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivityStatus(_response);
        });
    }

    protected processDeleteActivityStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ActivityStatuses based on criteria
     * @param body The search criteria
     * @return The search results of ActivityStatuses based on the criteria
     */
    searchActivityStatuses(body: SearchRequestDTO_activityStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/activitystatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchActivityStatuses(_response);
        });
    }

    protected processSearchActivityStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ActivityTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ActivityTypes
     * @return The list of ActivityTypes
     */
    getActivityTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/activitytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityTypes(_response);
        });
    }

    protected processGetActivityTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ActivityType
     * @param body The ActivityType data to create
     * @return The newly created ActivityType data
     */
    createActivityType(body: ActivityTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityTypeDTO> {
        let url_ = this.baseUrl + "/activitytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityType(_response);
        });
    }

    protected processCreateActivityType(response: AxiosResponse): Promise<ApiResponse_activityTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_activityTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityTypeDTO>(null as any);
    }

    /**
     * Retrieve a ActivityType by ID
     * @param id The ID of the ActivityType to retrieve
     * @return The ActivityType data
     */
    getActivityTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_activityTypeDTO> {
        let url_ = this.baseUrl + "/activitytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityTypeById(_response);
        });
    }

    protected processGetActivityTypeById(response: AxiosResponse): Promise<ApiResponse_activityTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityTypeDTO>(null as any);
    }

    /**
     * Update a ActivityType by ID
     * @param id The ID of the ActivityType to update
     * @param body The updated ActivityType data
     * @return The updated ActivityType data
     */
    updateActivityType(id: string, body: ActivityTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_activityTypeDTO> {
        let url_ = this.baseUrl + "/activitytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivityType(_response);
        });
    }

    protected processUpdateActivityType(response: AxiosResponse): Promise<ApiResponse_activityTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activityTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activityTypeDTO>(null as any);
    }

    /**
     * Delete a ActivityType by ID
     * @param id The ID of the ActivityType to delete
     */
    deleteActivityType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/activitytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteActivityType(_response);
        });
    }

    protected processDeleteActivityType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ActivityTypes based on criteria
     * @param body The search criteria
     * @return The search results of ActivityTypes based on the criteria
     */
    searchActivityTypes(body: SearchRequestDTO_activityTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/activitytype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchActivityTypes(_response);
        });
    }

    protected processSearchActivityTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ArticleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Articles
     * @return The list of Articles
     */
    getArticles( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/article";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Article
     * @param body The Article data to create
     * @return The newly created Article data
     */
    createArticle(body: ArticleDTO, cancelToken?: CancelToken): Promise<ApiResponse_articleDTO> {
        let url_ = this.baseUrl + "/article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateArticle(_response);
        });
    }

    protected processCreateArticle(response: AxiosResponse): Promise<ApiResponse_articleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_articleDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_articleDTO>(null as any);
    }

    /**
     * Retrieve a Article by ID
     * @param id The ID of the Article to retrieve
     * @return The Article data
     */
    getArticleById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_articleDTO> {
        let url_ = this.baseUrl + "/article/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticleById(_response);
        });
    }

    protected processGetArticleById(response: AxiosResponse): Promise<ApiResponse_articleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_articleDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_articleDTO>(null as any);
    }

    /**
     * Update a Article by ID
     * @param id The ID of the Article to update
     * @param body The updated Article data
     * @return The updated Article data
     */
    updateArticle(id: string, body: ArticleDTO, cancelToken?: CancelToken): Promise<ApiResponse_articleDTO> {
        let url_ = this.baseUrl + "/article/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateArticle(_response);
        });
    }

    protected processUpdateArticle(response: AxiosResponse): Promise<ApiResponse_articleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_articleDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_articleDTO>(null as any);
    }

    /**
     * Delete a Article by ID
     * @param id The ID of the Article to delete
     */
    deleteArticle(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/article/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Articles based on criteria
     * @param body The search criteria
     * @return The search results of Articles based on the criteria
     */
    searchArticles(body: SearchRequestDTO_articleSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/article/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchArticles(_response);
        });
    }

    protected processSearchArticles(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Get an article's rendered HTML
     * @param id The ID of the Article
     * @return The article's rendered HTML
     */
    getArticleContent(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/article/{id}/content";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticleContent(_response);
        });
    }

    protected processGetArticleContent(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Public article library
     * @param contentCategoryId (optional) Filter by content category.
     * @param search (optional) Case-insensitive match on the title or summary.
     * @param page (optional) 1-based page number. Defaults to 1.
     * @param pageSize (optional) Page size. Defaults to 20.
     * @param showOnLanding (optional) Filter to articles championed on the Info Hub landing. Omit for the whole library.
     * @return The public article library.
     */
    getArticlesPublic(contentCategoryId: string | null | undefined, search: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, showOnLanding: boolean | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/article/public?";
        if (contentCategoryId !== undefined && contentCategoryId !== null)
            url_ += "contentCategoryId=" + encodeURIComponent("" + contentCategoryId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showOnLanding !== undefined && showOnLanding !== null)
            url_ += "showOnLanding=" + encodeURIComponent("" + showOnLanding) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesPublic(_response);
        });
    }

    protected processGetArticlesPublic(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Public article by slug or id
     * @param idOrSlug The article's clean slug or its GUID.
     * @return The article and its HTML content.
     */
    getArticlePublicByIdOrSlug(idOrSlug: string, cancelToken?: CancelToken): Promise<ApiResponse_contentItemPublicDTO> {
        let url_ = this.baseUrl + "/article/public/{idOrSlug}";
        if (idOrSlug === undefined || idOrSlug === null)
            throw new globalThis.Error("The parameter 'idOrSlug' must be defined.");
        url_ = url_.replace("{idOrSlug}", encodeURIComponent("" + idOrSlug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlePublicByIdOrSlug(_response);
        });
    }

    protected processGetArticlePublicByIdOrSlug(response: AxiosResponse): Promise<ApiResponse_contentItemPublicDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_contentItemPublicDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_contentItemPublicDTO>(null as any);
    }
}

export class CertificateTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CertificateTypes
     * @return The list of CertificateTypes
     */
    getCertificateTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/certificatetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTypes(_response);
        });
    }

    protected processGetCertificateTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CertificateType
     * @param body The CertificateType data to create
     * @return The newly created CertificateType data
     */
    createCertificateType(body: CertificateTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_certificateTypeDTO> {
        let url_ = this.baseUrl + "/certificatetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCertificateType(_response);
        });
    }

    protected processCreateCertificateType(response: AxiosResponse): Promise<ApiResponse_certificateTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_certificateTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_certificateTypeDTO>(null as any);
    }

    /**
     * Retrieve a CertificateType by ID
     * @param id The ID of the CertificateType to retrieve
     * @return The CertificateType data
     */
    getCertificateTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_certificateTypeDTO> {
        let url_ = this.baseUrl + "/certificatetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCertificateTypeById(_response);
        });
    }

    protected processGetCertificateTypeById(response: AxiosResponse): Promise<ApiResponse_certificateTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_certificateTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_certificateTypeDTO>(null as any);
    }

    /**
     * Update a CertificateType by ID
     * @param id The ID of the CertificateType to update
     * @param body The updated CertificateType data
     * @return The updated CertificateType data
     */
    updateCertificateType(id: string, body: CertificateTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_certificateTypeDTO> {
        let url_ = this.baseUrl + "/certificatetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCertificateType(_response);
        });
    }

    protected processUpdateCertificateType(response: AxiosResponse): Promise<ApiResponse_certificateTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_certificateTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_certificateTypeDTO>(null as any);
    }

    /**
     * Delete a CertificateType by ID
     * @param id The ID of the CertificateType to delete
     */
    deleteCertificateType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/certificatetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCertificateType(_response);
        });
    }

    protected processDeleteCertificateType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CertificateTypes based on criteria
     * @param body The search criteria
     * @return The search results of CertificateTypes based on the criteria
     */
    searchCertificateTypes(body: SearchRequestDTO_certificateTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/certificatetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCertificateTypes(_response);
        });
    }

    protected processSearchCertificateTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ColourGradingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ColourGradings
     * @return The list of ColourGradings
     */
    getColourGradings( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/colourgrading";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetColourGradings(_response);
        });
    }

    protected processGetColourGradings(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ColourGrading
     * @param body The ColourGrading data to create
     * @return The newly created ColourGrading data
     */
    createColourGrading(body: ColourGradingDTO, cancelToken?: CancelToken): Promise<ApiResponse_colourGradingDTO> {
        let url_ = this.baseUrl + "/colourgrading";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateColourGrading(_response);
        });
    }

    protected processCreateColourGrading(response: AxiosResponse): Promise<ApiResponse_colourGradingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_colourGradingDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_colourGradingDTO>(null as any);
    }

    /**
     * Retrieve a ColourGrading by ID
     * @param id The ID of the ColourGrading to retrieve
     * @return The ColourGrading data
     */
    getColourGradingById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_colourGradingDTO> {
        let url_ = this.baseUrl + "/colourgrading/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetColourGradingById(_response);
        });
    }

    protected processGetColourGradingById(response: AxiosResponse): Promise<ApiResponse_colourGradingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_colourGradingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_colourGradingDTO>(null as any);
    }

    /**
     * Update a ColourGrading by ID
     * @param id The ID of the ColourGrading to update
     * @param body The updated ColourGrading data
     * @return The updated ColourGrading data
     */
    updateColourGrading(id: string, body: ColourGradingDTO, cancelToken?: CancelToken): Promise<ApiResponse_colourGradingDTO> {
        let url_ = this.baseUrl + "/colourgrading/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateColourGrading(_response);
        });
    }

    protected processUpdateColourGrading(response: AxiosResponse): Promise<ApiResponse_colourGradingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_colourGradingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_colourGradingDTO>(null as any);
    }

    /**
     * Delete a ColourGrading by ID
     * @param id The ID of the ColourGrading to delete
     */
    deleteColourGrading(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/colourgrading/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteColourGrading(_response);
        });
    }

    protected processDeleteColourGrading(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ColourGradings based on criteria
     * @param body The search criteria
     * @return The search results of ColourGradings based on the criteria
     */
    searchColourGradings(body: SearchRequestDTO_colourGradingSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/colourgrading/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchColourGradings(_response);
        });
    }

    protected processSearchColourGradings(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CompetencyTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetencyTypes
     * @return The list of CompetencyTypes
     */
    getCompetencyTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competencytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetencyTypes(_response);
        });
    }

    protected processGetCompetencyTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetencyType
     * @param body The CompetencyType data to create
     * @return The newly created CompetencyType data
     */
    createCompetencyType(body: CompetencyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_competencyTypeDTO> {
        let url_ = this.baseUrl + "/competencytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetencyType(_response);
        });
    }

    protected processCreateCompetencyType(response: AxiosResponse): Promise<ApiResponse_competencyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competencyTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competencyTypeDTO>(null as any);
    }

    /**
     * Retrieve a CompetencyType by ID
     * @param id The ID of the CompetencyType to retrieve
     * @return The CompetencyType data
     */
    getCompetencyTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competencyTypeDTO> {
        let url_ = this.baseUrl + "/competencytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetencyTypeById(_response);
        });
    }

    protected processGetCompetencyTypeById(response: AxiosResponse): Promise<ApiResponse_competencyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competencyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competencyTypeDTO>(null as any);
    }

    /**
     * Update a CompetencyType by ID
     * @param id The ID of the CompetencyType to update
     * @param body The updated CompetencyType data
     * @return The updated CompetencyType data
     */
    updateCompetencyType(id: string, body: CompetencyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_competencyTypeDTO> {
        let url_ = this.baseUrl + "/competencytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetencyType(_response);
        });
    }

    protected processUpdateCompetencyType(response: AxiosResponse): Promise<ApiResponse_competencyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competencyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competencyTypeDTO>(null as any);
    }

    /**
     * Delete a CompetencyType by ID
     * @param id The ID of the CompetencyType to delete
     */
    deleteCompetencyType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competencytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetencyType(_response);
        });
    }

    protected processDeleteCompetencyType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetencyTypes based on criteria
     * @param body The search criteria
     * @return The search results of CompetencyTypes based on the criteria
     */
    searchCompetencyTypes(body: SearchRequestDTO_competencyTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competencytype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetencyTypes(_response);
        });
    }

    protected processSearchCompetencyTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CompetitionClassClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionClasses
     * @return The list of CompetitionClasses
     */
    getCompetitionClasses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionclass";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionClasses(_response);
        });
    }

    protected processGetCompetitionClasses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionClass
     * @param body The CompetitionClass data to create
     * @return The newly created CompetitionClass data
     */
    createCompetitionClass(body: CompetitionClassDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionClassDTO> {
        let url_ = this.baseUrl + "/competitionclass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionClass(_response);
        });
    }

    protected processCreateCompetitionClass(response: AxiosResponse): Promise<ApiResponse_competitionClassDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionClassDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionClassDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionClass by ID
     * @param id The ID of the CompetitionClass to retrieve
     * @return The CompetitionClass data
     */
    getCompetitionClassById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionClassDTO> {
        let url_ = this.baseUrl + "/competitionclass/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionClassById(_response);
        });
    }

    protected processGetCompetitionClassById(response: AxiosResponse): Promise<ApiResponse_competitionClassDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionClassDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionClassDTO>(null as any);
    }

    /**
     * Update a CompetitionClass by ID
     * @param id The ID of the CompetitionClass to update
     * @param body The updated CompetitionClass data
     * @return The updated CompetitionClass data
     */
    updateCompetitionClass(id: string, body: CompetitionClassDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionClassDTO> {
        let url_ = this.baseUrl + "/competitionclass/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionClass(_response);
        });
    }

    protected processUpdateCompetitionClass(response: AxiosResponse): Promise<ApiResponse_competitionClassDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionClassDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionClassDTO>(null as any);
    }

    /**
     * Delete a CompetitionClass by ID
     * @param id The ID of the CompetitionClass to delete
     */
    deleteCompetitionClass(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionclass/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionClass(_response);
        });
    }

    protected processDeleteCompetitionClass(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionClasses based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionClasses based on the criteria
     */
    searchCompetitionClasses(body: SearchRequestDTO_competitionClassSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionclass/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionClasses(_response);
        });
    }

    protected processSearchCompetitionClasses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CompetitionClassTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionClassTypes
     * @return The list of CompetitionClassTypes
     */
    getCompetitionClassTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionclasstype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionClassTypes(_response);
        });
    }

    protected processGetCompetitionClassTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionClassType
     * @param body The CompetitionClassType data to create
     * @return The newly created CompetitionClassType data
     */
    createCompetitionClassType(body: CompetitionClassTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionClassTypeDTO> {
        let url_ = this.baseUrl + "/competitionclasstype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionClassType(_response);
        });
    }

    protected processCreateCompetitionClassType(response: AxiosResponse): Promise<ApiResponse_competitionClassTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionClassTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionClassTypeDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionClassType by ID
     * @param id The ID of the CompetitionClassType to retrieve
     * @return The CompetitionClassType data
     */
    getCompetitionClassTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionClassTypeDTO> {
        let url_ = this.baseUrl + "/competitionclasstype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionClassTypeById(_response);
        });
    }

    protected processGetCompetitionClassTypeById(response: AxiosResponse): Promise<ApiResponse_competitionClassTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionClassTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionClassTypeDTO>(null as any);
    }

    /**
     * Update a CompetitionClassType by ID
     * @param id The ID of the CompetitionClassType to update
     * @param body The updated CompetitionClassType data
     * @return The updated CompetitionClassType data
     */
    updateCompetitionClassType(id: string, body: CompetitionClassTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionClassTypeDTO> {
        let url_ = this.baseUrl + "/competitionclasstype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionClassType(_response);
        });
    }

    protected processUpdateCompetitionClassType(response: AxiosResponse): Promise<ApiResponse_competitionClassTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionClassTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionClassTypeDTO>(null as any);
    }

    /**
     * Delete a CompetitionClassType by ID
     * @param id The ID of the CompetitionClassType to delete
     */
    deleteCompetitionClassType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionclasstype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionClassType(_response);
        });
    }

    protected processDeleteCompetitionClassType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionClassTypes based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionClassTypes based on the criteria
     */
    searchCompetitionClassTypes(body: SearchRequestDTO_competitionClassTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionclasstype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionClassTypes(_response);
        });
    }

    protected processSearchCompetitionClassTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CompetitionEntryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionEntries
     * @return The list of CompetitionEntries
     */
    getCompetitionEntries( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionentry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionEntries(_response);
        });
    }

    protected processGetCompetitionEntries(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionEntry
     * @param body The CompetitionEntry data to create
     * @return The newly created CompetitionEntry data
     */
    createCompetitionEntry(body: CompetitionEntryDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionEntryDTO> {
        let url_ = this.baseUrl + "/competitionentry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionEntry(_response);
        });
    }

    protected processCreateCompetitionEntry(response: AxiosResponse): Promise<ApiResponse_competitionEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionEntryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionEntryDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionEntry by ID
     * @param id The ID of the CompetitionEntry to retrieve
     * @return The CompetitionEntry data
     */
    getCompetitionEntryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionEntryDTO> {
        let url_ = this.baseUrl + "/competitionentry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionEntryById(_response);
        });
    }

    protected processGetCompetitionEntryById(response: AxiosResponse): Promise<ApiResponse_competitionEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionEntryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionEntryDTO>(null as any);
    }

    /**
     * Update a CompetitionEntry by ID
     * @param id The ID of the CompetitionEntry to update
     * @param body The updated CompetitionEntry data
     * @return The updated CompetitionEntry data
     */
    updateCompetitionEntry(id: string, body: CompetitionEntryDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionEntryDTO> {
        let url_ = this.baseUrl + "/competitionentry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionEntry(_response);
        });
    }

    protected processUpdateCompetitionEntry(response: AxiosResponse): Promise<ApiResponse_competitionEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionEntryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionEntryDTO>(null as any);
    }

    /**
     * Delete a CompetitionEntry by ID
     * @param id The ID of the CompetitionEntry to delete
     */
    deleteCompetitionEntry(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionentry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionEntry(_response);
        });
    }

    protected processDeleteCompetitionEntry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update a CompetitionEntry Proof Of Payment by ID
     * @param id The ID of the CompetitionEntry to update
     * @param fileRecordId The file record ID of the proof of payment
     * @return The updated CompetitionEntry data
     */
    updateCompetitionEntryProofOfPayment(id: string, fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionEntryDTO> {
        let url_ = this.baseUrl + "/competitionentry/proofofpayment/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined and cannot be null.");
        else
            url_ += "fileRecordId=" + encodeURIComponent("" + fileRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionEntryProofOfPayment(_response);
        });
    }

    protected processUpdateCompetitionEntryProofOfPayment(response: AxiosResponse): Promise<ApiResponse_competitionEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionEntryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionEntryDTO>(null as any);
    }

    /**
     * Update CompetitionEntry Status (Bulk)
     * @param body The status update data
     * @return Number of competition entries updated
     */
    updateCompetitionEntryStatus(body: UpdateCompetitionEntryStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/competitionentry/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionEntryStatus(_response);
        });
    }

    protected processUpdateCompetitionEntryStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Validation error, e.g. one of the selected entries is already approved and paid.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Search CompetitionEntries based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionEntries based on the criteria
     */
    searchCompetitionEntries(body: SearchRequestDTO_competitionEntrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionentry/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionEntries(_response);
        });
    }

    protected processSearchCompetitionEntries(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Get the distinct years the current member has a competition entry in
     * @return The distinct competition entry years
     */
    getCompetitionEntryDistinctYears( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionentry/years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionEntryDistinctYears(_response);
        });
    }

    protected processGetCompetitionEntryDistinctYears(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Generate a competition participation certificate
     * @param memberId The member ID to generate the certificate for
     * @param year The competition entry year
     * @return The URL of the generated certificate
     */
    generateCompetitionParticipationCertificate(memberId: string, year: number, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionentry/participation-certificate/{memberId}/{year}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCompetitionParticipationCertificate(_response);
        });
    }

    protected processGenerateCompetitionParticipationCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate an HTML preview of a competition participation certificate
     * @param memberId The member ID to generate the certificate for
     * @param year The competition entry year
     * @return The HTML content of the generated certificate
     */
    generateHtmlCompetitionParticipationCertificate(memberId: string, year: number, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionentry/participation-certificate-html/{memberId}/{year}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateHtmlCompetitionParticipationCertificate(_response);
        });
    }

    protected processGenerateHtmlCompetitionParticipationCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Export CompetitionEntries based on search criteria
     * @param body The search criteria
     * @return The export results of CompetitionEntries based on the search criteria
     */
    exportCompetitionEntries(body: SearchRequestDTO_competitionEntrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionentry/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCompetitionEntries(_response);
        });
    }

    protected processExportCompetitionEntries(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CompetitionExerciseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionExercises
     * @return The list of CompetitionExercises
     */
    getCompetitionExercises( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionexercise";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionExercises(_response);
        });
    }

    protected processGetCompetitionExercises(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionExercise
     * @param body The CompetitionExercise data to create
     * @return The newly created CompetitionExercise data
     */
    createCompetitionExercise(body: CompetitionExerciseDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionExerciseDTO> {
        let url_ = this.baseUrl + "/competitionexercise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionExercise(_response);
        });
    }

    protected processCreateCompetitionExercise(response: AxiosResponse): Promise<ApiResponse_competitionExerciseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionExerciseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionExerciseDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionExercise by ID
     * @param id The ID of the CompetitionExercise to retrieve
     * @return The CompetitionExercise data
     */
    getCompetitionExerciseById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionExerciseDTO> {
        let url_ = this.baseUrl + "/competitionexercise/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionExerciseById(_response);
        });
    }

    protected processGetCompetitionExerciseById(response: AxiosResponse): Promise<ApiResponse_competitionExerciseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionExerciseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionExerciseDTO>(null as any);
    }

    /**
     * Update a CompetitionExercise by ID
     * @param id The ID of the CompetitionExercise to update
     * @param body The updated CompetitionExercise data
     * @return The updated CompetitionExercise data
     */
    updateCompetitionExercise(id: string, body: CompetitionExerciseDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionExerciseDTO> {
        let url_ = this.baseUrl + "/competitionexercise/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionExercise(_response);
        });
    }

    protected processUpdateCompetitionExercise(response: AxiosResponse): Promise<ApiResponse_competitionExerciseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionExerciseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionExerciseDTO>(null as any);
    }

    /**
     * Delete a CompetitionExercise by ID
     * @param id The ID of the CompetitionExercise to delete
     */
    deleteCompetitionExercise(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionexercise/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionExercise(_response);
        });
    }

    protected processDeleteCompetitionExercise(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionExercises based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionExercises based on the criteria
     */
    searchCompetitionExercises(body: SearchRequestDTO_competitionExerciseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionexercise/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionExercises(_response);
        });
    }

    protected processSearchCompetitionExercises(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export CompetitionExercises based on search criteria
     * @param body The search criteria
     * @return The export results of CompetitionExercises based on the search criteria
     */
    exportCompetitionExercises(body: SearchRequestDTO_competitionExerciseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionexercise/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCompetitionExercises(_response);
        });
    }

    protected processExportCompetitionExercises(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CompetitionExerciseTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionExerciseTypes
     * @return The list of CompetitionExerciseTypes
     */
    getCompetitionExerciseTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionexercisetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionExerciseTypes(_response);
        });
    }

    protected processGetCompetitionExerciseTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionExerciseType
     * @param body The CompetitionExerciseType data to create
     * @return The newly created CompetitionExerciseType data
     */
    createCompetitionExerciseType(body: CompetitionExerciseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionExerciseTypeDTO> {
        let url_ = this.baseUrl + "/competitionexercisetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionExerciseType(_response);
        });
    }

    protected processCreateCompetitionExerciseType(response: AxiosResponse): Promise<ApiResponse_competitionExerciseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionExerciseTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionExerciseTypeDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionExerciseType by ID
     * @param id The ID of the CompetitionExerciseType to retrieve
     * @return The CompetitionExerciseType data
     */
    getCompetitionExerciseTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionExerciseTypeDTO> {
        let url_ = this.baseUrl + "/competitionexercisetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionExerciseTypeById(_response);
        });
    }

    protected processGetCompetitionExerciseTypeById(response: AxiosResponse): Promise<ApiResponse_competitionExerciseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionExerciseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionExerciseTypeDTO>(null as any);
    }

    /**
     * Update a CompetitionExerciseType by ID
     * @param id The ID of the CompetitionExerciseType to update
     * @param body The updated CompetitionExerciseType data
     * @return The updated CompetitionExerciseType data
     */
    updateCompetitionExerciseType(id: string, body: CompetitionExerciseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionExerciseTypeDTO> {
        let url_ = this.baseUrl + "/competitionexercisetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionExerciseType(_response);
        });
    }

    protected processUpdateCompetitionExerciseType(response: AxiosResponse): Promise<ApiResponse_competitionExerciseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionExerciseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionExerciseTypeDTO>(null as any);
    }

    /**
     * Delete a CompetitionExerciseType by ID
     * @param id The ID of the CompetitionExerciseType to delete
     */
    deleteCompetitionExerciseType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionexercisetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionExerciseType(_response);
        });
    }

    protected processDeleteCompetitionExerciseType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionExerciseTypes based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionExerciseTypes based on the criteria
     */
    searchCompetitionExerciseTypes(body: SearchRequestDTO_competitionExerciseTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionexercisetypes/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionExerciseTypes(_response);
        });
    }

    protected processSearchCompetitionExerciseTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CompetitionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Competitions
     * @return The list of Competitions
     */
    getCompetitions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitions(_response);
        });
    }

    protected processGetCompetitions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Competition
     * @param body The Competition data to create
     * @return The newly created Competition data
     */
    createCompetition(body: CompetitionDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionDTO> {
        let url_ = this.baseUrl + "/competition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetition(_response);
        });
    }

    protected processCreateCompetition(response: AxiosResponse): Promise<ApiResponse_competitionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionDTO>(null as any);
    }

    /**
     * Retrieve a Competition by ID
     * @param id The ID of the Competition to retrieve
     * @return The Competition data
     */
    getCompetitionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionDTO> {
        let url_ = this.baseUrl + "/competition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionById(_response);
        });
    }

    protected processGetCompetitionById(response: AxiosResponse): Promise<ApiResponse_competitionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionDTO>(null as any);
    }

    /**
     * Update a Competition by ID
     * @param id The ID of the Competition to update
     * @param body The updated Competition data
     * @return The updated Competition data
     */
    updateCompetition(id: string, body: CompetitionDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionDTO> {
        let url_ = this.baseUrl + "/competition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetition(_response);
        });
    }

    protected processUpdateCompetition(response: AxiosResponse): Promise<ApiResponse_competitionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionDTO>(null as any);
    }

    /**
     * Delete a Competition by ID
     * @param id The ID of the Competition to delete
     */
    deleteCompetition(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competition/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetition(_response);
        });
    }

    protected processDeleteCompetition(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Competitions based on criteria
     * @param body The search criteria
     * @return The search results of Competitions based on the criteria
     */
    searchCompetitions(body: SearchRequestDTO_competitionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competition/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitions(_response);
        });
    }

    protected processSearchCompetitions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Competitions based on search criteria
     * @param body The search criteria
     * @return The export results of Competitions based on the search criteria
     */
    exportCompetitions(body: SearchRequestDTO_competitionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competition/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCompetitions(_response);
        });
    }

    protected processExportCompetitions(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CompetitionResultEntryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionResultEntries
     * @return The list of CompetitionResultEntries
     */
    getCompetitionResultEntries( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionresultentry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionResultEntries(_response);
        });
    }

    protected processGetCompetitionResultEntries(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionResultEntry
     * @param body The CompetitionResultEntry data to create
     * @return The newly created CompetitionResultEntry data
     */
    createCompetitionResultEntry(body: CompetitionResultEntryDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionResultEntryDTO> {
        let url_ = this.baseUrl + "/competitionresultentry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionResultEntry(_response);
        });
    }

    protected processCreateCompetitionResultEntry(response: AxiosResponse): Promise<ApiResponse_competitionResultEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionResultEntryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionResultEntryDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionResultEntry by ID
     * @param id The ID of the CompetitionResultEntry to retrieve
     * @return The CompetitionResultEntry data
     */
    getCompetitionResultEntryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionResultEntryDTO> {
        let url_ = this.baseUrl + "/competitionresultentry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionResultEntryById(_response);
        });
    }

    protected processGetCompetitionResultEntryById(response: AxiosResponse): Promise<ApiResponse_competitionResultEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionResultEntryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionResultEntryDTO>(null as any);
    }

    /**
     * Update a CompetitionResultEntry by ID
     * @param id The ID of the CompetitionResultEntry to update
     * @param body The updated CompetitionResultEntry data
     * @return The updated CompetitionResultEntry data
     */
    updateCompetitionResultEntry(id: string, body: CompetitionResultEntryDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionResultEntryDTO> {
        let url_ = this.baseUrl + "/competitionresultentry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionResultEntry(_response);
        });
    }

    protected processUpdateCompetitionResultEntry(response: AxiosResponse): Promise<ApiResponse_competitionResultEntryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionResultEntryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionResultEntryDTO>(null as any);
    }

    /**
     * Delete a CompetitionResultEntry by ID
     * @param id The ID of the CompetitionResultEntry to delete
     */
    deleteCompetitionResultEntry(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionresultentry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionResultEntry(_response);
        });
    }

    protected processDeleteCompetitionResultEntry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionResultEntries based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionResultEntries based on the criteria
     */
    searchCompetitionResultEntries(body: SearchRequestDTO_competitionResultEntrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionresultentry/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionResultEntries(_response);
        });
    }

    protected processSearchCompetitionResultEntries(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export CompetitionResultEntries based on search criteria
     * @param body The search criteria
     * @return The export results of CompetitionResultEntries based on the search criteria
     */
    exportCompetitionResultEntries(body: SearchRequestDTO_competitionResultEntrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionresultentry/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCompetitionResultEntries(_response);
        });
    }

    protected processExportCompetitionResultEntries(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get entries for a competition result with only exercise info loaded
     * @param competitionResultId The ID of the CompetitionResult
     * @return The lightweight list of entries for the competition result
     */
    getLightweightCompetitionResultEntriesForResult(competitionResultId: string, cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionresultentry/by-result/{competitionResultId}/lightweight";
        if (competitionResultId === undefined || competitionResultId === null)
            throw new globalThis.Error("The parameter 'competitionResultId' must be defined.");
        url_ = url_.replace("{competitionResultId}", encodeURIComponent("" + competitionResultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLightweightCompetitionResultEntriesForResult(_response);
        });
    }

    protected processGetLightweightCompetitionResultEntriesForResult(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Get the distinct competition years the current member has results for
     * @return The distinct competition years
     */
    getCompetitionResultEntryDistinctYears( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionresultentry/years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionResultEntryDistinctYears(_response);
        });
    }

    protected processGetCompetitionResultEntryDistinctYears(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Update the rank/position of a batch of entries
     * @param body The rank/position updates to apply
     * @return Confirmation that ranks were updated
     */
    updateCompetitionResultEntryRanks(body: CompetitionResultEntryRankUpdateDTO[], cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionresultentry/ranks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionResultEntryRanks(_response);
        });
    }

    protected processUpdateCompetitionResultEntryRanks(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CompetitionResultClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionResults
     * @return The list of CompetitionResults
     */
    getCompetitionResults( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionresult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionResults(_response);
        });
    }

    protected processGetCompetitionResults(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionResult
     * @param body The CompetitionResult data to create
     * @return The newly created CompetitionResult data
     */
    createCompetitionResult(body: CompetitionResultDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionResultDTO> {
        let url_ = this.baseUrl + "/competitionresult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionResult(_response);
        });
    }

    protected processCreateCompetitionResult(response: AxiosResponse): Promise<ApiResponse_competitionResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionResultDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionResultDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionResult by ID
     * @param id The ID of the CompetitionResult to retrieve
     * @return The CompetitionResult data
     */
    getCompetitionResultById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionResultDTO> {
        let url_ = this.baseUrl + "/competitionresult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionResultById(_response);
        });
    }

    protected processGetCompetitionResultById(response: AxiosResponse): Promise<ApiResponse_competitionResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionResultDTO>(null as any);
    }

    /**
     * Update a CompetitionResult by ID
     * @param id The ID of the CompetitionResult to update
     * @param body The updated CompetitionResult data
     * @return The updated CompetitionResult data
     */
    updateCompetitionResult(id: string, body: CompetitionResultDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionResultDTO> {
        let url_ = this.baseUrl + "/competitionresult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionResult(_response);
        });
    }

    protected processUpdateCompetitionResult(response: AxiosResponse): Promise<ApiResponse_competitionResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionResultDTO>(null as any);
    }

    /**
     * Delete a CompetitionResult by ID
     * @param id The ID of the CompetitionResult to delete
     */
    deleteCompetitionResult(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionresult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionResult(_response);
        });
    }

    protected processDeleteCompetitionResult(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionResults based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionResults based on the criteria
     */
    searchCompetitionResults(body: SearchRequestDTO_competitionResultSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionresult/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionResults(_response);
        });
    }

    protected processSearchCompetitionResults(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export CompetitionResults based on search criteria
     * @param body The search criteria
     * @return The export results of CompetitionResults based on the search criteria
     */
    exportCompetitionResults(body: SearchRequestDTO_competitionResultSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/competitionresult/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCompetitionResults(_response);
        });
    }

    protected processExportCompetitionResults(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CompetitionStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CompetitionStatuses
     * @return The list of CompetitionStatuses
     */
    getCompetitionStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/competitionstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionStatuses(_response);
        });
    }

    protected processGetCompetitionStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CompetitionStatus
     * @param body The CompetitionStatus data to create
     * @return The newly created CompetitionStatus data
     */
    createCompetitionStatus(body: CompetitionStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionStatusDTO> {
        let url_ = this.baseUrl + "/competitionstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompetitionStatus(_response);
        });
    }

    protected processCreateCompetitionStatus(response: AxiosResponse): Promise<ApiResponse_competitionStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_competitionStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionStatusDTO>(null as any);
    }

    /**
     * Retrieve a CompetitionStatus by ID
     * @param id The ID of the CompetitionStatus to retrieve
     * @return The CompetitionStatus data
     */
    getCompetitionStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_competitionStatusDTO> {
        let url_ = this.baseUrl + "/competitionstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitionStatusById(_response);
        });
    }

    protected processGetCompetitionStatusById(response: AxiosResponse): Promise<ApiResponse_competitionStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionStatusDTO>(null as any);
    }

    /**
     * Update a CompetitionStatus by ID
     * @param id The ID of the CompetitionStatus to update
     * @param body The updated CompetitionStatus data
     * @return The updated CompetitionStatus data
     */
    updateCompetitionStatus(id: string, body: CompetitionStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_competitionStatusDTO> {
        let url_ = this.baseUrl + "/competitionstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompetitionStatus(_response);
        });
    }

    protected processUpdateCompetitionStatus(response: AxiosResponse): Promise<ApiResponse_competitionStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_competitionStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_competitionStatusDTO>(null as any);
    }

    /**
     * Delete a CompetitionStatus by ID
     * @param id The ID of the CompetitionStatus to delete
     */
    deleteCompetitionStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/competitionstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompetitionStatus(_response);
        });
    }

    protected processDeleteCompetitionStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CompetitionStatuses based on criteria
     * @param body The search criteria
     * @return The search results of CompetitionStatuses based on the criteria
     */
    searchCompetitionStatuses(body: SearchRequestDTO_competitionStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/competitionstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompetitionStatuses(_response);
        });
    }

    protected processSearchCompetitionStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ComponentActionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ComponentActions
     * @return The list of ComponentActions
     */
    getComponentActions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/componentaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComponentActions(_response);
        });
    }

    protected processGetComponentActions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ComponentAction
     * @param body The ComponentAction data to create
     * @return The newly created ComponentAction data
     */
    createComponentAction(body: ComponentActionDTO, cancelToken?: CancelToken): Promise<ApiResponse_componentActionDTO> {
        let url_ = this.baseUrl + "/componentaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateComponentAction(_response);
        });
    }

    protected processCreateComponentAction(response: AxiosResponse): Promise<ApiResponse_componentActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_componentActionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_componentActionDTO>(null as any);
    }

    /**
     * Retrieve a ComponentAction by ID
     * @param id The ID of the ComponentAction to retrieve
     * @return The ComponentAction data
     */
    getComponentActionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_componentActionDTO> {
        let url_ = this.baseUrl + "/componentaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComponentActionById(_response);
        });
    }

    protected processGetComponentActionById(response: AxiosResponse): Promise<ApiResponse_componentActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_componentActionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_componentActionDTO>(null as any);
    }

    /**
     * Update a ComponentAction by ID
     * @param id The ID of the ComponentAction to update
     * @param body The updated ComponentAction data
     * @return The updated ComponentAction data
     */
    updateComponentAction(id: string, body: ComponentActionDTO, cancelToken?: CancelToken): Promise<ApiResponse_componentActionDTO> {
        let url_ = this.baseUrl + "/componentaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComponentAction(_response);
        });
    }

    protected processUpdateComponentAction(response: AxiosResponse): Promise<ApiResponse_componentActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_componentActionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_componentActionDTO>(null as any);
    }

    /**
     * Delete a ComponentAction by ID
     * @param id The ID of the ComponentAction to delete
     */
    deleteComponentAction(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/componentaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteComponentAction(_response);
        });
    }

    protected processDeleteComponentAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ComponentActions based on criteria
     * @param body The search criteria
     * @return The search results of ComponentActions based on the criteria
     */
    searchComponentActions(body: SearchRequestDTO_componentActionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/componentaction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchComponentActions(_response);
        });
    }

    protected processSearchComponentActions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ComponentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Components
     * @return The list of Components
     */
    getComponents( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/component";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComponents(_response);
        });
    }

    protected processGetComponents(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Component
     * @param body The Component data to create
     * @return The newly created Component data
     */
    createComponent(body: ComponentDTO, cancelToken?: CancelToken): Promise<ApiResponse_componentDTO> {
        let url_ = this.baseUrl + "/component";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateComponent(_response);
        });
    }

    protected processCreateComponent(response: AxiosResponse): Promise<ApiResponse_componentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_componentDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_componentDTO>(null as any);
    }

    /**
     * Retrieve a Component by ID
     * @param id The ID of the Component to retrieve
     * @return The Component data
     */
    getComponentById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_componentDTO> {
        let url_ = this.baseUrl + "/component/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComponentById(_response);
        });
    }

    protected processGetComponentById(response: AxiosResponse): Promise<ApiResponse_componentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_componentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_componentDTO>(null as any);
    }

    /**
     * Update a Component by ID
     * @param id The ID of the Component to update
     * @param body The updated Component data
     * @return The updated Component data
     */
    updateComponent(id: string, body: ComponentDTO, cancelToken?: CancelToken): Promise<ApiResponse_componentDTO> {
        let url_ = this.baseUrl + "/component/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComponent(_response);
        });
    }

    protected processUpdateComponent(response: AxiosResponse): Promise<ApiResponse_componentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_componentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_componentDTO>(null as any);
    }

    /**
     * Delete a Component by ID
     * @param id The ID of the Component to delete
     */
    deleteComponent(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/component/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteComponent(_response);
        });
    }

    protected processDeleteComponent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Components based on criteria
     * @param body The search criteria
     * @return The search results of Components based on the criteria
     */
    searchComponents(body: SearchRequestDTO_componentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/component/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchComponents(_response);
        });
    }

    protected processSearchComponents(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Get statuses for a component
     * @param id The ID of the component to get statuses for
     * @return The list of available statuses for the component
     */
    getComponentStatuses(id: string, cancelToken?: CancelToken): Promise<ApiResponse_lookupDTOOf> {
        let url_ = this.baseUrl + "/component/{id}/statuses";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetComponentStatuses(_response);
        });
    }

    protected processGetComponentStatuses(response: AxiosResponse): Promise<ApiResponse_lookupDTOOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_lookupDTOOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_lookupDTOOf>(null as any);
    }
}

export class ContentCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ContentCategories
     * @return The list of ContentCategories
     */
    getContentCategories( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/ContentCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentCategories(_response);
        });
    }

    protected processGetContentCategories(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ContentCategory
     * @param body The ContentCategory data to create
     * @return The newly created ContentCategory data
     */
    createContentCategory(body: ContentCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_contentCategoryDTO> {
        let url_ = this.baseUrl + "/ContentCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContentCategory(_response);
        });
    }

    protected processCreateContentCategory(response: AxiosResponse): Promise<ApiResponse_contentCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_contentCategoryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_contentCategoryDTO>(null as any);
    }

    /**
     * Retrieve a ContentCategory by ID
     * @param id The ID of the ContentCategory to retrieve
     * @return The ContentCategory data
     */
    getContentCategoryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_contentCategoryDTO> {
        let url_ = this.baseUrl + "/ContentCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentCategoryById(_response);
        });
    }

    protected processGetContentCategoryById(response: AxiosResponse): Promise<ApiResponse_contentCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_contentCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_contentCategoryDTO>(null as any);
    }

    /**
     * Update a ContentCategory by ID
     * @param id The ID of the ContentCategory to update
     * @param body The updated ContentCategory data
     * @return The updated ContentCategory data
     */
    updateContentCategory(id: string, body: ContentCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_contentCategoryDTO> {
        let url_ = this.baseUrl + "/ContentCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContentCategory(_response);
        });
    }

    protected processUpdateContentCategory(response: AxiosResponse): Promise<ApiResponse_contentCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_contentCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_contentCategoryDTO>(null as any);
    }

    /**
     * Delete a ContentCategory by ID
     * @param id The ID of the ContentCategory to delete
     */
    deleteContentCategory(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ContentCategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContentCategory(_response);
        });
    }

    protected processDeleteContentCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ContentCategories based on criteria
     * @param body The search criteria
     * @return The search results of ContentCategories based on the criteria
     */
    searchContentCategories(body: SearchRequestDTO_contentCategorySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/ContentCategory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchContentCategories(_response);
        });
    }

    protected processSearchContentCategories(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CountryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Countries
     * @return The list of Countries
     */
    getCountries( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Country
     * @param body The Country data to create
     * @return The newly created Country data
     */
    createCountry(body: CountryDTO, cancelToken?: CancelToken): Promise<ApiResponse_countryDTO> {
        let url_ = this.baseUrl + "/country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCountry(_response);
        });
    }

    protected processCreateCountry(response: AxiosResponse): Promise<ApiResponse_countryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_countryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_countryDTO>(null as any);
    }

    /**
     * Retrieve a Country by ID
     * @param id The ID of the Country to retrieve
     * @return The Country data
     */
    getCountryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_countryDTO> {
        let url_ = this.baseUrl + "/country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountryById(_response);
        });
    }

    protected processGetCountryById(response: AxiosResponse): Promise<ApiResponse_countryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_countryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_countryDTO>(null as any);
    }

    /**
     * Update a Country by ID
     * @param id The ID of the Country to update
     * @param body The updated Country data
     * @return The updated Country data
     */
    updateCountry(id: string, body: CountryDTO, cancelToken?: CancelToken): Promise<ApiResponse_countryDTO> {
        let url_ = this.baseUrl + "/country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCountry(_response);
        });
    }

    protected processUpdateCountry(response: AxiosResponse): Promise<ApiResponse_countryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_countryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_countryDTO>(null as any);
    }

    /**
     * Delete a Country by ID
     * @param id The ID of the Country to delete
     */
    deleteCountry(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCountry(_response);
        });
    }

    protected processDeleteCountry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Countries based on criteria
     * @param body The search criteria
     * @return The search results of Countries based on the criteria
     */
    searchCountries(body: SearchRequestDTO_countrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/country/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCountries(_response);
        });
    }

    protected processSearchCountries(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CourseEvaluationAnswerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CourseEvaluationAnswers
     * @return The list of CourseEvaluationAnswers
     */
    getCourseEvaluationAnswers( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/courseevaluationanswer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseEvaluationAnswers(_response);
        });
    }

    protected processGetCourseEvaluationAnswers(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CourseEvaluationAnswer
     * @param body The CourseEvaluationAnswer data to create
     * @return The newly created CourseEvaluationAnswer data
     */
    createCourseEvaluationAnswer(body: CourseEvaluationAnswerDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationAnswerDTO> {
        let url_ = this.baseUrl + "/courseevaluationanswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourseEvaluationAnswer(_response);
        });
    }

    protected processCreateCourseEvaluationAnswer(response: AxiosResponse): Promise<ApiResponse_courseEvaluationAnswerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseEvaluationAnswerDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationAnswerDTO>(null as any);
    }

    /**
     * Retrieve a CourseEvaluationAnswer by ID
     * @param id The ID of the CourseEvaluationAnswer to retrieve
     * @return The CourseEvaluationAnswer data
     */
    getCourseEvaluationAnswerById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationAnswerDTO> {
        let url_ = this.baseUrl + "/courseevaluationanswer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseEvaluationAnswerById(_response);
        });
    }

    protected processGetCourseEvaluationAnswerById(response: AxiosResponse): Promise<ApiResponse_courseEvaluationAnswerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseEvaluationAnswerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationAnswerDTO>(null as any);
    }

    /**
     * Update a CourseEvaluationAnswer by ID
     * @param id The ID of the CourseEvaluationAnswer to update
     * @param body The updated CourseEvaluationAnswer data
     * @return The updated CourseEvaluationAnswer data
     */
    updateCourseEvaluationAnswer(id: string, body: CourseEvaluationAnswerDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationAnswerDTO> {
        let url_ = this.baseUrl + "/courseevaluationanswer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseEvaluationAnswer(_response);
        });
    }

    protected processUpdateCourseEvaluationAnswer(response: AxiosResponse): Promise<ApiResponse_courseEvaluationAnswerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseEvaluationAnswerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationAnswerDTO>(null as any);
    }

    /**
     * Delete a CourseEvaluationAnswer by ID
     * @param id The ID of the CourseEvaluationAnswer to delete
     */
    deleteCourseEvaluationAnswer(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/courseevaluationanswer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourseEvaluationAnswer(_response);
        });
    }

    protected processDeleteCourseEvaluationAnswer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CourseEvaluationAnswers based on criteria
     * @param body The search criteria
     * @return The search results of CourseEvaluationAnswers based on the criteria
     */
    searchCourseEvaluationAnswers(body: SearchRequestDTO_courseEvaluationAnswerSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/courseevaluationanswer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourseEvaluationAnswers(_response);
        });
    }

    protected processSearchCourseEvaluationAnswers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export CourseEvaluationAnswers based on search criteria
     * @param body The search criteria
     * @return The export results of CourseEvaluationAnswers based on the search criteria
     */
    exportCourseEvaluationAnswers(body: SearchRequestDTO_courseEvaluationAnswerSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/courseevaluationanswer/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCourseEvaluationAnswers(_response);
        });
    }

    protected processExportCourseEvaluationAnswers(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Create multiple CourseEvaluationAnswers
     * @param body The list of CourseEvaluationAnswer data to create
     * @return The newly created CourseEvaluationAnswer data
     */
    createBulkCourseEvaluationAnswer(body: CourseEvaluationAnswerDTO[], cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/courseevaluationanswer/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkCourseEvaluationAnswer(_response);
        });
    }

    protected processCreateBulkCourseEvaluationAnswer(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_list_1>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }
}

export class CourseEvaluationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CourseEvaluations
     * @return The list of CourseEvaluations
     */
    getCourseEvaluations( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/courseevaluation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseEvaluations(_response);
        });
    }

    protected processGetCourseEvaluations(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CourseEvaluation
     * @param body The CourseEvaluation data to create
     * @return The newly created CourseEvaluation data
     */
    createCourseEvaluation(body: CourseEvaluationDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationDTO> {
        let url_ = this.baseUrl + "/courseevaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourseEvaluation(_response);
        });
    }

    protected processCreateCourseEvaluation(response: AxiosResponse): Promise<ApiResponse_courseEvaluationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseEvaluationDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationDTO>(null as any);
    }

    /**
     * Retrieve a CourseEvaluation by ID
     * @param id The ID of the CourseEvaluation to retrieve
     * @return The CourseEvaluation data
     */
    getCourseEvaluationById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationDTO> {
        let url_ = this.baseUrl + "/courseevaluation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseEvaluationById(_response);
        });
    }

    protected processGetCourseEvaluationById(response: AxiosResponse): Promise<ApiResponse_courseEvaluationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseEvaluationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationDTO>(null as any);
    }

    /**
     * Update a CourseEvaluation by ID
     * @param id The ID of the CourseEvaluation to update
     * @param body The updated CourseEvaluation data
     * @return The updated CourseEvaluation data
     */
    updateCourseEvaluation(id: string, body: CourseEvaluationDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationDTO> {
        let url_ = this.baseUrl + "/courseevaluation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseEvaluation(_response);
        });
    }

    protected processUpdateCourseEvaluation(response: AxiosResponse): Promise<ApiResponse_courseEvaluationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseEvaluationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationDTO>(null as any);
    }

    /**
     * Delete a CourseEvaluation by ID
     * @param id The ID of the CourseEvaluation to delete
     */
    deleteCourseEvaluation(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/courseevaluation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourseEvaluation(_response);
        });
    }

    protected processDeleteCourseEvaluation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve CourseEvaluations by Course ID
     * @param courseId The Course ID of the CourseEvaluation to retrieve
     * @return The CourseEvaluation data
     */
    getCourseEvaluationByCourseId(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/courseevaluation/by-course/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseEvaluationByCourseId(_response);
        });
    }

    protected processGetCourseEvaluationByCourseId(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Search CourseEvaluations based on criteria
     * @param body The search criteria
     * @return The search results of CourseEvaluations based on the criteria
     */
    searchCourseEvaluations(body: SearchRequestDTO_courseEvaluationSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/courseevaluation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourseEvaluations(_response);
        });
    }

    protected processSearchCourseEvaluations(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export CourseEvaluations based on search criteria
     * @param body The search criteria
     * @return The export results of CourseEvaluations based on the search criteria
     */
    exportCourseEvaluations(body: SearchRequestDTO_courseEvaluationSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/courseevaluation/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCourseEvaluations(_response);
        });
    }

    protected processExportCourseEvaluations(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Submit a completed course evaluation
     * @param body The evaluation submission data, including all answers
     * @return The result of the evaluation submission
     */
    submitCourseEvaluation(body: CourseEvaluationSubmissionDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseEvaluationSubmissionResultDTO> {
        let url_ = this.baseUrl + "/courseevaluation/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitCourseEvaluation(_response);
        });
    }

    protected processSubmitCourseEvaluation(response: AxiosResponse): Promise<ApiResponse_courseEvaluationSubmissionResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseEvaluationSubmissionResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseEvaluationSubmissionResultDTO>(null as any);
    }

    /**
     * Check an examinee ID for shared-device usage and flag if needed
     * @param body The examinee ID, member ID and course ID for the current attempt
     * @return True if a note was flagged, false otherwise
     */
    checkExamineeId(body: CheckExamineeIdRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/courseevaluation/check-examinee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckExamineeId(_response);
        });
    }

    protected processCheckExamineeId(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Export duplicate examinee IDs (CookieGuids)
     * @param body Search criteria with CreatedFrom/CreatedTo date filters
     * @return The SAS URL to download the Excel file with duplicate examinee data
     */
    exportDuplicateCookieGuids(body: SearchRequestDTO_courseEvaluationSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/courseevaluation/export-duplicates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDuplicateCookieGuids(_response);
        });
    }

    protected processExportDuplicateCookieGuids(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CourseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Courses
     * @return The list of Courses
     */
    getCourses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/course";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Course
     * @param body The Course data to create
     * @return The newly created Course data
     */
    createCourse(body: CourseDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourse(_response);
        });
    }

    protected processCreateCourse(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Retrieve a Course by ID
     * @param id The ID of the Course to retrieve
     * @return The Course data
     */
    getCourseById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseById(_response);
        });
    }

    protected processGetCourseById(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Update a Course by ID
     * @param id The ID of the Course to update
     * @param body The updated Course data
     * @return The updated Course data
     */
    updateCourse(id: string, body: CourseDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourse(_response);
        });
    }

    protected processUpdateCourse(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Delete a Course by ID
     * @param id The ID of the Course to delete
     */
    deleteCourse(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/course/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourse(_response);
        });
    }

    protected processDeleteCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve Course feedback HTML
     * @param id The ID of the Course
     * @return The feedback HTML content, or null if none exists
     */
    getCourseFeedback(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/course/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseFeedback(_response);
        });
    }

    protected processGetCourseFeedback(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Update a Course Proof Of Payment by ID
     * @param id The ID of the Course to update
     * @param fileRecordId The file record ID of the proof of payment
     * @return The updated Course data
     */
    updateCourseProofOfPayment(id: string, fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/proofofpayment/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined and cannot be null.");
        else
            url_ += "fileRecordId=" + encodeURIComponent("" + fileRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseProofOfPayment(_response);
        });
    }

    protected processUpdateCourseProofOfPayment(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Send Proof Of Payment Upload Link
     * @param id The ID of the Course
     * @return Email sent successfully
     */
    sendCourseProofOfPaymentLink(id: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/course/{id}/send-pop-link";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendCourseProofOfPaymentLink(_response);
        });
    }

    protected processSendCourseProofOfPaymentLink(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Update course statuses in bulk
     * @param body The bulk status update data
     * @return Number of courses successfully updated
     */
    updateCourseQuickStatus(body: UpdateCourseStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/course/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseQuickStatus(_response);
        });
    }

    protected processUpdateCourseQuickStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Forfeit a course
     * @param id The ID of the course to forfeit
     * @param body The forfeiture details
     * @return The forfeited course
     */
    forfeitCourse(id: string, body: ForfeitureRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/{id}/forfeit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForfeitCourse(_response);
        });
    }

    protected processForfeitCourse(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Generate forfeiture document URL
     * @param id The ID of the Course
     * @return The SAS URL of the generated forfeiture document
     */
    getCourseForfeitureDocument(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/course/{id}/forfeiture-document";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseForfeitureDocument(_response);
        });
    }

    protected processGetCourseForfeitureDocument(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Download forfeiture document PDF
     * @param id The ID of the Course
     * @return The forfeiture document PDF
     */
    downloadCourseForfeitureDocument(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/course/{id}/forfeiture-document/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCourseForfeitureDocument(_response);
        });
    }

    protected processDownloadCourseForfeitureDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download course study material
     * @param id The ID of the Course
     * @return The SAS URI for downloading the study material PDF
     */
    getCourseStudyMaterial(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/course/{id}/study-material";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseStudyMaterial(_response);
        });
    }

    protected processGetCourseStudyMaterial(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Restore a Course from deleted by ID
     * @param id The ID of the Course to restore from deleted
     * @return The restored Course data
     */
    restoreFromDeletedCourse(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/{id}/restore-deleted";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromDeletedCourse(_response);
        });
    }

    protected processRestoreFromDeletedCourse(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Search Courses based on criteria
     * @param body The search criteria
     * @return The search results of Courses based on the criteria
     */
    searchCourses(body: SearchRequestDTO_courseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/course/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourses(_response);
        });
    }

    protected processSearchCourses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Courses based on search criteria
     * @param body The search criteria
     * @return The export results of Courses based on the search criteria
     */
    exportCourses(body: SearchRequestDTO_courseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/course/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCourses(_response);
        });
    }

    protected processExportCourses(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CourseMaterialTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CourseMaterialTypes
     * @return The list of CourseMaterialTypes
     */
    getCourseMaterialTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/coursematerialtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseMaterialTypes(_response);
        });
    }

    protected processGetCourseMaterialTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CourseMaterialType
     * @param body The CourseMaterialType data to create
     * @return The newly created CourseMaterialType data
     */
    createCourseMaterialType(body: CourseMaterialTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseMaterialTypeDTO> {
        let url_ = this.baseUrl + "/coursematerialtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourseMaterialType(_response);
        });
    }

    protected processCreateCourseMaterialType(response: AxiosResponse): Promise<ApiResponse_courseMaterialTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseMaterialTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseMaterialTypeDTO>(null as any);
    }

    /**
     * Retrieve a CourseMaterialType by ID
     * @param id The ID of the CourseMaterialType to retrieve
     * @return The CourseMaterialType data
     */
    getCourseMaterialTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseMaterialTypeDTO> {
        let url_ = this.baseUrl + "/coursematerialtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseMaterialTypeById(_response);
        });
    }

    protected processGetCourseMaterialTypeById(response: AxiosResponse): Promise<ApiResponse_courseMaterialTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseMaterialTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseMaterialTypeDTO>(null as any);
    }

    /**
     * Update a CourseMaterialType by ID
     * @param id The ID of the CourseMaterialType to update
     * @param body The updated CourseMaterialType data
     * @return The updated CourseMaterialType data
     */
    updateCourseMaterialType(id: string, body: CourseMaterialTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseMaterialTypeDTO> {
        let url_ = this.baseUrl + "/coursematerialtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseMaterialType(_response);
        });
    }

    protected processUpdateCourseMaterialType(response: AxiosResponse): Promise<ApiResponse_courseMaterialTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseMaterialTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseMaterialTypeDTO>(null as any);
    }

    /**
     * Delete a CourseMaterialType by ID
     * @param id The ID of the CourseMaterialType to delete
     */
    deleteCourseMaterialType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/coursematerialtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourseMaterialType(_response);
        });
    }

    protected processDeleteCourseMaterialType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CourseMaterialTypes based on criteria
     * @param body The search criteria
     * @return The search results of CourseMaterialTypes based on the criteria
     */
    searchCourseMaterialTypes(body: SearchRequestDTO_courseMaterialTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/coursematerialtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourseMaterialTypes(_response);
        });
    }

    protected processSearchCourseMaterialTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CourseStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CourseStatuses
     * @return The list of CourseStatuses
     */
    getCourseStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/coursestatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseStatuses(_response);
        });
    }

    protected processGetCourseStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CourseStatus
     * @param body The CourseStatus data to create
     * @return The newly created CourseStatus data
     */
    createCourseStatus(body: CourseStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseStatusDTO> {
        let url_ = this.baseUrl + "/coursestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourseStatus(_response);
        });
    }

    protected processCreateCourseStatus(response: AxiosResponse): Promise<ApiResponse_courseStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseStatusDTO>(null as any);
    }

    /**
     * Retrieve a CourseStatus by ID
     * @param id The ID of the CourseStatus to retrieve
     * @return The CourseStatus data
     */
    getCourseStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseStatusDTO> {
        let url_ = this.baseUrl + "/coursestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseStatusById(_response);
        });
    }

    protected processGetCourseStatusById(response: AxiosResponse): Promise<ApiResponse_courseStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseStatusDTO>(null as any);
    }

    /**
     * Update a CourseStatus by ID
     * @param id The ID of the CourseStatus to update
     * @param body The updated CourseStatus data
     * @return The updated CourseStatus data
     */
    updateCourseStatus(id: string, body: CourseStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseStatusDTO> {
        let url_ = this.baseUrl + "/coursestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseStatus(_response);
        });
    }

    protected processUpdateCourseStatus(response: AxiosResponse): Promise<ApiResponse_courseStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseStatusDTO>(null as any);
    }

    /**
     * Delete a CourseStatus by ID
     * @param id The ID of the CourseStatus to delete
     */
    deleteCourseStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/coursestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourseStatus(_response);
        });
    }

    protected processDeleteCourseStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CourseStatuses based on criteria
     * @param body The search criteria
     * @return The search results of CourseStatuses based on the criteria
     */
    searchCourseStatuses(body: SearchRequestDTO_courseStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/coursestatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourseStatuses(_response);
        });
    }

    protected processSearchCourseStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CourseTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all CourseTypes
     * @return The list of CourseTypes
     */
    getCourseTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/coursetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseTypes(_response);
        });
    }

    protected processGetCourseTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new CourseType
     * @param body The CourseType data to create
     * @return The newly created CourseType data
     */
    createCourseType(body: CourseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseTypeDTO> {
        let url_ = this.baseUrl + "/coursetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourseType(_response);
        });
    }

    protected processCreateCourseType(response: AxiosResponse): Promise<ApiResponse_courseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseTypeDTO>(null as any);
    }

    /**
     * Retrieve a CourseType by ID
     * @param id The ID of the CourseType to retrieve
     * @return The CourseType data
     */
    getCourseTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseTypeDTO> {
        let url_ = this.baseUrl + "/coursetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseTypeById(_response);
        });
    }

    protected processGetCourseTypeById(response: AxiosResponse): Promise<ApiResponse_courseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseTypeDTO>(null as any);
    }

    /**
     * Update a CourseType by ID
     * @param id The ID of the CourseType to update
     * @param body The updated CourseType data
     * @return The updated CourseType data
     */
    updateCourseType(id: string, body: CourseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseTypeDTO> {
        let url_ = this.baseUrl + "/coursetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourseType(_response);
        });
    }

    protected processUpdateCourseType(response: AxiosResponse): Promise<ApiResponse_courseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseTypeDTO>(null as any);
    }

    /**
     * Delete a CourseType by ID
     * @param id The ID of the CourseType to delete
     */
    deleteCourseType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/coursetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourseType(_response);
        });
    }

    protected processDeleteCourseType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search CourseTypes based on criteria
     * @param body The search criteria
     * @return The search results of CourseTypes based on the criteria
     */
    searchCourseTypes(body: SearchRequestDTO_courseTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/coursetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourseTypes(_response);
        });
    }

    protected processSearchCourseTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class DocumentTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all DocumentTypes
     * @return The list of DocumentTypes
     */
    getDocumentTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/documenttype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentTypes(_response);
        });
    }

    protected processGetDocumentTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new DocumentType
     * @param body The DocumentType data to create
     * @return The newly created DocumentType data
     */
    createDocumentType(body: DocumentTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_documentTypeDTO> {
        let url_ = this.baseUrl + "/documenttype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDocumentType(_response);
        });
    }

    protected processCreateDocumentType(response: AxiosResponse): Promise<ApiResponse_documentTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_documentTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_documentTypeDTO>(null as any);
    }

    /**
     * Retrieve a DocumentType by ID
     * @param id The ID of the DocumentType to retrieve
     * @return The DocumentType data
     */
    getDocumentTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_documentTypeDTO> {
        let url_ = this.baseUrl + "/documenttype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentTypeById(_response);
        });
    }

    protected processGetDocumentTypeById(response: AxiosResponse): Promise<ApiResponse_documentTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_documentTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_documentTypeDTO>(null as any);
    }

    /**
     * Update a DocumentType by ID
     * @param id The ID of the DocumentType to update
     * @param body The updated DocumentType data
     * @return The updated DocumentType data
     */
    updateDocumentType(id: string, body: DocumentTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_documentTypeDTO> {
        let url_ = this.baseUrl + "/documenttype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDocumentType(_response);
        });
    }

    protected processUpdateDocumentType(response: AxiosResponse): Promise<ApiResponse_documentTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_documentTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_documentTypeDTO>(null as any);
    }

    /**
     * Delete a DocumentType by ID
     * @param id The ID of the DocumentType to delete
     */
    deleteDocumentType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/documenttype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocumentType(_response);
        });
    }

    protected processDeleteDocumentType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search DocumentTypes based on criteria
     * @param body The search criteria
     * @return The search results of DocumentTypes based on the criteria
     */
    searchDocumentTypes(body: SearchRequestDTO_documentTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/documenttype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchDocumentTypes(_response);
        });
    }

    protected processSearchDocumentTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EmailMessageAttachmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EmailMessageAttachments
     * @return The list of EmailMessageAttachments
     */
    getEmailMessageAttachments( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/emailmessageattachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessageAttachments(_response);
        });
    }

    protected processGetEmailMessageAttachments(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EmailMessageAttachment
     * @param body The EmailMessageAttachment data to create
     * @return The newly created EmailMessageAttachment data
     */
    createEmailMessageAttachment(body: EmailMessageAttachmentDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageAttachmentDTO> {
        let url_ = this.baseUrl + "/emailmessageattachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailMessageAttachment(_response);
        });
    }

    protected processCreateEmailMessageAttachment(response: AxiosResponse): Promise<ApiResponse_emailMessageAttachmentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_emailMessageAttachmentDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageAttachmentDTO>(null as any);
    }

    /**
     * Retrieve a EmailMessageAttachment by ID
     * @param id The ID of the EmailMessageAttachment to retrieve
     * @return The EmailMessageAttachment data
     */
    getEmailMessageAttachmentById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageAttachmentDTO> {
        let url_ = this.baseUrl + "/emailmessageattachment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessageAttachmentById(_response);
        });
    }

    protected processGetEmailMessageAttachmentById(response: AxiosResponse): Promise<ApiResponse_emailMessageAttachmentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageAttachmentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageAttachmentDTO>(null as any);
    }

    /**
     * Update a EmailMessageAttachment by ID
     * @param id The ID of the EmailMessageAttachment to update
     * @param body The updated EmailMessageAttachment data
     * @return The updated EmailMessageAttachment data
     */
    updateEmailMessageAttachment(id: string, body: EmailMessageAttachmentDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageAttachmentDTO> {
        let url_ = this.baseUrl + "/emailmessageattachment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmailMessageAttachment(_response);
        });
    }

    protected processUpdateEmailMessageAttachment(response: AxiosResponse): Promise<ApiResponse_emailMessageAttachmentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageAttachmentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageAttachmentDTO>(null as any);
    }

    /**
     * Delete a EmailMessageAttachment by ID
     * @param id The ID of the EmailMessageAttachment to delete
     */
    deleteEmailMessageAttachment(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/emailmessageattachment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailMessageAttachment(_response);
        });
    }

    protected processDeleteEmailMessageAttachment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EmailMessageAttachments based on criteria
     * @param body The search criteria
     * @return The search results of EmailMessageAttachments based on the criteria
     */
    searchEmailMessageAttachments(body: SearchRequestDTO_emailMessageAttachmentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/emailmessageattachment/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEmailMessageAttachments(_response);
        });
    }

    protected processSearchEmailMessageAttachments(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export EmailMessageAttachments based on search criteria
     * @param body The search criteria
     * @return The export results of EmailMessageAttachments based on the search criteria
     */
    exportEmailMessageAttachments(body: SearchRequestDTO_emailMessageAttachmentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/emailmessageattachment/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportEmailMessageAttachments(_response);
        });
    }

    protected processExportEmailMessageAttachments(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class EmailMessageClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EmailMessages
     * @return The list of EmailMessages
     */
    getEmailMessages( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/emailmessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessages(_response);
        });
    }

    protected processGetEmailMessages(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EmailMessage
     * @param body The EmailMessage data to create
     * @return The newly created EmailMessage data
     */
    createEmailMessage(body: EmailMessageDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageDTO> {
        let url_ = this.baseUrl + "/emailmessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailMessage(_response);
        });
    }

    protected processCreateEmailMessage(response: AxiosResponse): Promise<ApiResponse_emailMessageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_emailMessageDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageDTO>(null as any);
    }

    /**
     * Retrieve a EmailMessage by ID
     * @param id The ID of the EmailMessage to retrieve
     * @return The EmailMessage data
     */
    getEmailMessageById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageDTO> {
        let url_ = this.baseUrl + "/emailmessage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessageById(_response);
        });
    }

    protected processGetEmailMessageById(response: AxiosResponse): Promise<ApiResponse_emailMessageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageDTO>(null as any);
    }

    /**
     * Update a EmailMessage by ID
     * @param id The ID of the EmailMessage to update
     * @param body The updated EmailMessage data
     * @return The updated EmailMessage data
     */
    updateEmailMessage(id: string, body: EmailMessageDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageDTO> {
        let url_ = this.baseUrl + "/emailmessage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmailMessage(_response);
        });
    }

    protected processUpdateEmailMessage(response: AxiosResponse): Promise<ApiResponse_emailMessageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageDTO>(null as any);
    }

    /**
     * Delete a EmailMessage by ID
     * @param id The ID of the EmailMessage to delete
     */
    deleteEmailMessage(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/emailmessage/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailMessage(_response);
        });
    }

    protected processDeleteEmailMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EmailMessages based on criteria
     * @param body The search criteria
     * @return The search results of EmailMessages based on the criteria
     */
    searchEmailMessages(body: SearchRequestDTO_emailMessageSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/emailmessage/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEmailMessages(_response);
        });
    }

    protected processSearchEmailMessages(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Search EmailMessages without thread assignment or that are root messages
     * @param body The search criteria
     * @return The search results of EmailMessages based on the criteria
     */
    searchEmailAndThreadMessages(body: SearchRequestDTO_emailMessageSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/emailmessage/search-thread-messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEmailAndThreadMessages(_response);
        });
    }

    protected processSearchEmailAndThreadMessages(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export EmailMessages based on search criteria
     * @param body The search criteria
     * @return The export results of EmailMessages based on the search criteria
     */
    exportEmailMessages(body: SearchRequestDTO_emailMessageSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/emailmessage/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportEmailMessages(_response);
        });
    }

    protected processExportEmailMessages(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Queue an email to an existing thread
     * @param body The email data to queue
     * @return The newly queued email message
     */
    sendEmail(body: EmailMessageDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageDTO> {
        let url_ = this.baseUrl + "/emailmessage/queue-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: AxiosResponse): Promise<ApiResponse_emailMessageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_emailMessageDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageDTO>(null as any);
    }

    /**
     * Queue a reply email to an existing thread
     * @param body The email reply data to queue
     * @return The newly queued reply email message
     */
    createEmailReply(body: EmailMessageDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageDTO> {
        let url_ = this.baseUrl + "/emailmessage/queue-reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailReply(_response);
        });
    }

    protected processCreateEmailReply(response: AxiosResponse): Promise<ApiResponse_emailMessageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_emailMessageDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageDTO>(null as any);
    }
}

export class EmailMessageThreadClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EmailMessageThreads
     * @return The list of EmailMessageThreads
     */
    getEmailMessageThreads( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/replies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessageThreads(_response);
        });
    }

    protected processGetEmailMessageThreads(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EmailMessageThread
     * @param body The EmailMessageThread data to create
     * @return The newly created EmailMessageThread data
     */
    createEmailMessageThread(body: EmailMessageThreadDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageThreadDTO> {
        let url_ = this.baseUrl + "/replies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailMessageThread(_response);
        });
    }

    protected processCreateEmailMessageThread(response: AxiosResponse): Promise<ApiResponse_emailMessageThreadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_emailMessageThreadDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageThreadDTO>(null as any);
    }

    /**
     * Retrieve a EmailMessageThread by ID
     * @param id The ID of the EmailMessageThread to retrieve
     * @return The EmailMessageThread data
     */
    getEmailMessageThreadById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageThreadDTO> {
        let url_ = this.baseUrl + "/replies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessageThreadById(_response);
        });
    }

    protected processGetEmailMessageThreadById(response: AxiosResponse): Promise<ApiResponse_emailMessageThreadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageThreadDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageThreadDTO>(null as any);
    }

    /**
     * Update a EmailMessageThread by ID
     * @param id The ID of the EmailMessageThread to update
     * @param body The updated EmailMessageThread data
     * @return The updated EmailMessageThread data
     */
    updateEmailMessageThread(id: string, body: EmailMessageThreadDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageThreadDTO> {
        let url_ = this.baseUrl + "/replies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmailMessageThread(_response);
        });
    }

    protected processUpdateEmailMessageThread(response: AxiosResponse): Promise<ApiResponse_emailMessageThreadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageThreadDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageThreadDTO>(null as any);
    }

    /**
     * Delete a EmailMessageThread by ID
     * @param id The ID of the EmailMessageThread to delete
     */
    deleteEmailMessageThread(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/replies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailMessageThread(_response);
        });
    }

    protected processDeleteEmailMessageThread(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EmailMessageThreads based on criteria
     * @param body The search criteria
     * @return The search results of EmailMessageThreads based on the criteria
     */
    searchEmailMessageThreads(body: SearchRequestDTO_emailMessageThreadSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/replies/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEmailMessageThreads(_response);
        });
    }

    protected processSearchEmailMessageThreads(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export EmailMessageThreads based on search criteria
     * @param body The search criteria
     * @return The export results of EmailMessageThreads based on the search criteria
     */
    exportEmailMessageThreads(body: SearchRequestDTO_emailMessageThreadSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/replies/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportEmailMessageThreads(_response);
        });
    }

    protected processExportEmailMessageThreads(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Mark an email thread as replied
     * @param id The ID of the EmailMessageThread to mark as replied
     * @return The updated EmailMessageThread data
     */
    markEmailMessageThreadAsReplied(id: string, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageThreadDTO> {
        let url_ = this.baseUrl + "/replies/{id}/reply";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkEmailMessageThreadAsReplied(_response);
        });
    }

    protected processMarkEmailMessageThreadAsReplied(response: AxiosResponse): Promise<ApiResponse_emailMessageThreadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageThreadDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageThreadDTO>(null as any);
    }

    /**
     * Mark an email thread as resolved
     * @param id The ID of the EmailMessageThread to mark as resolved
     * @return The updated EmailMessageThread data
     */
    markEmailMessageThreadAsResolved(id: string, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageThreadDTO> {
        let url_ = this.baseUrl + "/replies/{id}/resolve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkEmailMessageThreadAsResolved(_response);
        });
    }

    protected processMarkEmailMessageThreadAsResolved(response: AxiosResponse): Promise<ApiResponse_emailMessageThreadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageThreadDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageThreadDTO>(null as any);
    }

    /**
     * Set rating for email thread
     * @param threadId The ID of the EmailMessageThread to rate
     * @param rating The rating value (1-5, where 1=poor and 5=excellent)
     * @return The updated EmailMessageThread data with rating
     */
    setEmailMessageThreadRating(threadId: string, rating: number, cancelToken?: CancelToken): Promise<ApiResponse_emailMessageThreadDTO> {
        let url_ = this.baseUrl + "/replies/{threadId}/rate/{rating}";
        if (threadId === undefined || threadId === null)
            throw new globalThis.Error("The parameter 'threadId' must be defined.");
        url_ = url_.replace("{threadId}", encodeURIComponent("" + threadId));
        if (rating === undefined || rating === null)
            throw new globalThis.Error("The parameter 'rating' must be defined.");
        url_ = url_.replace("{rating}", encodeURIComponent("" + rating));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEmailMessageThreadRating(_response);
        });
    }

    protected processSetEmailMessageThreadRating(response: AxiosResponse): Promise<ApiResponse_emailMessageThreadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailMessageThreadDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Invalid rating value or rating already submitted", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailMessageThreadDTO>(null as any);
    }
}

export class EmailTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EmailTypes
     * @return The list of EmailTypes
     */
    getEmailTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/emailtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTypes(_response);
        });
    }

    protected processGetEmailTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EmailType
     * @param body The EmailType data to create
     * @return The newly created EmailType data
     */
    createEmailType(body: EmailTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailTypeDTO> {
        let url_ = this.baseUrl + "/emailtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmailType(_response);
        });
    }

    protected processCreateEmailType(response: AxiosResponse): Promise<ApiResponse_emailTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_emailTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailTypeDTO>(null as any);
    }

    /**
     * Retrieve a EmailType by ID
     * @param id The ID of the EmailType to retrieve
     * @return The EmailType data
     */
    getEmailTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_emailTypeDTO> {
        let url_ = this.baseUrl + "/emailtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTypeById(_response);
        });
    }

    protected processGetEmailTypeById(response: AxiosResponse): Promise<ApiResponse_emailTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailTypeDTO>(null as any);
    }

    /**
     * Update a EmailType by ID
     * @param id The ID of the EmailType to update
     * @param body The updated EmailType data
     * @return The updated EmailType data
     */
    updateEmailType(id: string, body: EmailTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_emailTypeDTO> {
        let url_ = this.baseUrl + "/emailtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmailType(_response);
        });
    }

    protected processUpdateEmailType(response: AxiosResponse): Promise<ApiResponse_emailTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_emailTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_emailTypeDTO>(null as any);
    }

    /**
     * Delete a EmailType by ID
     * @param id The ID of the EmailType to delete
     */
    deleteEmailType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/emailtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmailType(_response);
        });
    }

    protected processDeleteEmailType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EmailTypes based on criteria
     * @param body The search criteria
     * @return The search results of EmailTypes based on the criteria
     */
    searchEmailTypes(body: SearchRequestDTO_emailTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/emailtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEmailTypes(_response);
        });
    }

    protected processSearchEmailTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EndorsementLicenceTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EndorsementLicenceTypes
     * @return The list of EndorsementLicenceTypes
     */
    getEndorsementLicenceTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/endorsementlicencetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEndorsementLicenceTypes(_response);
        });
    }

    protected processGetEndorsementLicenceTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EndorsementLicenceType
     * @param body The EndorsementLicenceType data to create
     * @return The newly created EndorsementLicenceType data
     */
    createEndorsementLicenceType(body: EndorsementLicenceTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_endorsementLicenceTypeDTO> {
        let url_ = this.baseUrl + "/endorsementlicencetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEndorsementLicenceType(_response);
        });
    }

    protected processCreateEndorsementLicenceType(response: AxiosResponse): Promise<ApiResponse_endorsementLicenceTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_endorsementLicenceTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementLicenceTypeDTO>(null as any);
    }

    /**
     * Retrieve a EndorsementLicenceType by ID
     * @param id The ID of the EndorsementLicenceType to retrieve
     * @return The EndorsementLicenceType data
     */
    getEndorsementLicenceTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_endorsementLicenceTypeDTO> {
        let url_ = this.baseUrl + "/endorsementlicencetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEndorsementLicenceTypeById(_response);
        });
    }

    protected processGetEndorsementLicenceTypeById(response: AxiosResponse): Promise<ApiResponse_endorsementLicenceTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_endorsementLicenceTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementLicenceTypeDTO>(null as any);
    }

    /**
     * Update a EndorsementLicenceType by ID
     * @param id The ID of the EndorsementLicenceType to update
     * @param body The updated EndorsementLicenceType data
     * @return The updated EndorsementLicenceType data
     */
    updateEndorsementLicenceType(id: string, body: EndorsementLicenceTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_endorsementLicenceTypeDTO> {
        let url_ = this.baseUrl + "/endorsementlicencetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEndorsementLicenceType(_response);
        });
    }

    protected processUpdateEndorsementLicenceType(response: AxiosResponse): Promise<ApiResponse_endorsementLicenceTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_endorsementLicenceTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementLicenceTypeDTO>(null as any);
    }

    /**
     * Delete a EndorsementLicenceType by ID
     * @param id The ID of the EndorsementLicenceType to delete
     */
    deleteEndorsementLicenceType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/endorsementlicencetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEndorsementLicenceType(_response);
        });
    }

    protected processDeleteEndorsementLicenceType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EndorsementLicenceTypes based on criteria
     * @param body The search criteria
     * @return The search results of EndorsementLicenceTypes based on the criteria
     */
    searchEndorsementLicenceTypes(body: SearchRequestDTO_endorsementLicenceTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/endorsementlicencetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEndorsementLicenceTypes(_response);
        });
    }

    protected processSearchEndorsementLicenceTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EndorsementMotivationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EndorsementMotivations
     * @return The list of EndorsementMotivations
     */
    getEndorsementMotivations( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/endorsementmotivation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEndorsementMotivations(_response);
        });
    }

    protected processGetEndorsementMotivations(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EndorsementMotivation
     * @param body The EndorsementMotivation data to create
     * @return The newly created EndorsementMotivation data
     */
    createEndorsementMotivation(body: EndorsementMotivationDTO, cancelToken?: CancelToken): Promise<ApiResponse_endorsementMotivationDTO> {
        let url_ = this.baseUrl + "/endorsementmotivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEndorsementMotivation(_response);
        });
    }

    protected processCreateEndorsementMotivation(response: AxiosResponse): Promise<ApiResponse_endorsementMotivationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_endorsementMotivationDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementMotivationDTO>(null as any);
    }

    /**
     * Retrieve a EndorsementMotivation by ID
     * @param id The ID of the EndorsementMotivation to retrieve
     * @return The EndorsementMotivation data
     */
    getEndorsementMotivationById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_endorsementMotivationDTO> {
        let url_ = this.baseUrl + "/endorsementmotivation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEndorsementMotivationById(_response);
        });
    }

    protected processGetEndorsementMotivationById(response: AxiosResponse): Promise<ApiResponse_endorsementMotivationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_endorsementMotivationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementMotivationDTO>(null as any);
    }

    /**
     * Update a EndorsementMotivation by ID
     * @param id The ID of the EndorsementMotivation to update
     * @param body The updated EndorsementMotivation data
     * @return The updated EndorsementMotivation data
     */
    updateEndorsementMotivation(id: string, body: EndorsementMotivationDTO, cancelToken?: CancelToken): Promise<ApiResponse_endorsementMotivationDTO> {
        let url_ = this.baseUrl + "/endorsementmotivation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEndorsementMotivation(_response);
        });
    }

    protected processUpdateEndorsementMotivation(response: AxiosResponse): Promise<ApiResponse_endorsementMotivationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_endorsementMotivationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementMotivationDTO>(null as any);
    }

    /**
     * Delete a EndorsementMotivation by ID
     * @param id The ID of the EndorsementMotivation to delete
     */
    deleteEndorsementMotivation(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/endorsementmotivation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEndorsementMotivation(_response);
        });
    }

    protected processDeleteEndorsementMotivation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EndorsementMotivations based on criteria
     * @param body The search criteria
     * @return The search results of EndorsementMotivations based on the criteria
     */
    searchEndorsementMotivations(body: SearchRequestDTO_endorsementMotivationSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/endorsementmotivation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEndorsementMotivations(_response);
        });
    }

    protected processSearchEndorsementMotivations(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EndorsementStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EndorsementStatuses
     * @return The list of EndorsementStatuses
     */
    getEndorsementStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/endorsementstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEndorsementStatuses(_response);
        });
    }

    protected processGetEndorsementStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EndorsementStatus
     * @param body The EndorsementStatus data to create
     * @return The newly created EndorsementStatus data
     */
    createEndorsementStatus(body: EndorsementStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_endorsementStatusDTO> {
        let url_ = this.baseUrl + "/endorsementstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEndorsementStatus(_response);
        });
    }

    protected processCreateEndorsementStatus(response: AxiosResponse): Promise<ApiResponse_endorsementStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_endorsementStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementStatusDTO>(null as any);
    }

    /**
     * Retrieve a EndorsementStatus by ID
     * @param id The ID of the EndorsementStatus to retrieve
     * @return The EndorsementStatus data
     */
    getEndorsementStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_endorsementStatusDTO> {
        let url_ = this.baseUrl + "/endorsementstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEndorsementStatusById(_response);
        });
    }

    protected processGetEndorsementStatusById(response: AxiosResponse): Promise<ApiResponse_endorsementStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_endorsementStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementStatusDTO>(null as any);
    }

    /**
     * Update a EndorsementStatus by ID
     * @param id The ID of the EndorsementStatus to update
     * @param body The updated EndorsementStatus data
     * @return The updated EndorsementStatus data
     */
    updateEndorsementStatus(id: string, body: EndorsementStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_endorsementStatusDTO> {
        let url_ = this.baseUrl + "/endorsementstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEndorsementStatus(_response);
        });
    }

    protected processUpdateEndorsementStatus(response: AxiosResponse): Promise<ApiResponse_endorsementStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_endorsementStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_endorsementStatusDTO>(null as any);
    }

    /**
     * Delete a EndorsementStatus by ID
     * @param id The ID of the EndorsementStatus to delete
     */
    deleteEndorsementStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/endorsementstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEndorsementStatus(_response);
        });
    }

    protected processDeleteEndorsementStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EndorsementStatuses based on criteria
     * @param body The search criteria
     * @return The search results of EndorsementStatuses based on the criteria
     */
    searchEndorsementStatuses(body: SearchRequestDTO_endorsementStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/endorsementstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEndorsementStatuses(_response);
        });
    }

    protected processSearchEndorsementStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EnquiryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Enquiries
     * @return The list of Enquiries
     */
    getEnquiries( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/enquiry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnquiries(_response);
        });
    }

    protected processGetEnquiries(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Enquiry
     * @param body The Enquiry data to create
     * @return The newly created Enquiry data
     */
    createEnquiry(body: EnquiryDTO, cancelToken?: CancelToken): Promise<ApiResponse_enquiryDTO> {
        let url_ = this.baseUrl + "/enquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnquiry(_response);
        });
    }

    protected processCreateEnquiry(response: AxiosResponse): Promise<ApiResponse_enquiryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_enquiryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_enquiryDTO>(null as any);
    }

    /**
     * Retrieve a Enquiry by ID
     * @param id The ID of the Enquiry to retrieve
     * @return The Enquiry data
     */
    getEnquiryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_enquiryDTO> {
        let url_ = this.baseUrl + "/enquiry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnquiryById(_response);
        });
    }

    protected processGetEnquiryById(response: AxiosResponse): Promise<ApiResponse_enquiryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_enquiryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_enquiryDTO>(null as any);
    }

    /**
     * Update a Enquiry by ID
     * @param id The ID of the Enquiry to update
     * @param body The updated Enquiry data
     * @return The updated Enquiry data
     */
    updateEnquiry(id: string, body: EnquiryDTO, cancelToken?: CancelToken): Promise<ApiResponse_enquiryDTO> {
        let url_ = this.baseUrl + "/enquiry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnquiry(_response);
        });
    }

    protected processUpdateEnquiry(response: AxiosResponse): Promise<ApiResponse_enquiryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_enquiryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_enquiryDTO>(null as any);
    }

    /**
     * Delete a Enquiry by ID
     * @param id The ID of the Enquiry to delete
     */
    deleteEnquiry(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/enquiry/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEnquiry(_response);
        });
    }

    protected processDeleteEnquiry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Enquiries based on criteria
     * @param body The search criteria
     * @return The search results of Enquiries based on the criteria
     */
    searchEnquiries(body: SearchRequestDTO_enquirySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/enquiry/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEnquiries(_response);
        });
    }

    protected processSearchEnquiries(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EnquiryTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EnquiryTypes
     * @return The list of EnquiryTypes
     */
    getEnquiryTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/enquirytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnquiryTypes(_response);
        });
    }

    protected processGetEnquiryTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EnquiryType
     * @param body The EnquiryType data to create
     * @return The newly created EnquiryType data
     */
    createEnquiryType(body: EnquiryTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_enquiryTypeDTO> {
        let url_ = this.baseUrl + "/enquirytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnquiryType(_response);
        });
    }

    protected processCreateEnquiryType(response: AxiosResponse): Promise<ApiResponse_enquiryTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_enquiryTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_enquiryTypeDTO>(null as any);
    }

    /**
     * Retrieve a EnquiryType by ID
     * @param id The ID of the EnquiryType to retrieve
     * @return The EnquiryType data
     */
    getEnquiryTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_enquiryTypeDTO> {
        let url_ = this.baseUrl + "/enquirytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnquiryTypeById(_response);
        });
    }

    protected processGetEnquiryTypeById(response: AxiosResponse): Promise<ApiResponse_enquiryTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_enquiryTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_enquiryTypeDTO>(null as any);
    }

    /**
     * Update a EnquiryType by ID
     * @param id The ID of the EnquiryType to update
     * @param body The updated EnquiryType data
     * @return The updated EnquiryType data
     */
    updateEnquiryType(id: string, body: EnquiryTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_enquiryTypeDTO> {
        let url_ = this.baseUrl + "/enquirytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnquiryType(_response);
        });
    }

    protected processUpdateEnquiryType(response: AxiosResponse): Promise<ApiResponse_enquiryTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_enquiryTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_enquiryTypeDTO>(null as any);
    }

    /**
     * Delete a EnquiryType by ID
     * @param id The ID of the EnquiryType to delete
     */
    deleteEnquiryType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/enquirytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEnquiryType(_response);
        });
    }

    protected processDeleteEnquiryType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EnquiryTypes based on criteria
     * @param body The search criteria
     * @return The search results of EnquiryTypes based on the criteria
     */
    searchEnquiryTypes(body: SearchRequestDTO_enquiryTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/enquirytype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEnquiryTypes(_response);
        });
    }

    protected processSearchEnquiryTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class EvaluationStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all EvaluationStatuses
     * @return The list of EvaluationStatuses
     */
    getEvaluationStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/evaluationstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvaluationStatuses(_response);
        });
    }

    protected processGetEvaluationStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new EvaluationStatus
     * @param body The EvaluationStatus data to create
     * @return The newly created EvaluationStatus data
     */
    createEvaluationStatus(body: EvaluationStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_evaluationStatusDTO> {
        let url_ = this.baseUrl + "/evaluationstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEvaluationStatus(_response);
        });
    }

    protected processCreateEvaluationStatus(response: AxiosResponse): Promise<ApiResponse_evaluationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_evaluationStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_evaluationStatusDTO>(null as any);
    }

    /**
     * Retrieve a EvaluationStatus by ID
     * @param id The ID of the EvaluationStatus to retrieve
     * @return The EvaluationStatus data
     */
    getEvaluationStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_evaluationStatusDTO> {
        let url_ = this.baseUrl + "/evaluationstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEvaluationStatusById(_response);
        });
    }

    protected processGetEvaluationStatusById(response: AxiosResponse): Promise<ApiResponse_evaluationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_evaluationStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_evaluationStatusDTO>(null as any);
    }

    /**
     * Update a EvaluationStatus by ID
     * @param id The ID of the EvaluationStatus to update
     * @param body The updated EvaluationStatus data
     * @return The updated EvaluationStatus data
     */
    updateEvaluationStatus(id: string, body: EvaluationStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_evaluationStatusDTO> {
        let url_ = this.baseUrl + "/evaluationstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEvaluationStatus(_response);
        });
    }

    protected processUpdateEvaluationStatus(response: AxiosResponse): Promise<ApiResponse_evaluationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_evaluationStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_evaluationStatusDTO>(null as any);
    }

    /**
     * Delete a EvaluationStatus by ID
     * @param id The ID of the EvaluationStatus to delete
     */
    deleteEvaluationStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/evaluationstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEvaluationStatus(_response);
        });
    }

    protected processDeleteEvaluationStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search EvaluationStatuses based on criteria
     * @param body The search criteria
     * @return The search results of EvaluationStatuses based on the criteria
     */
    searchEvaluationStatuses(body: SearchRequestDTO_evaluationStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/evaluationstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchEvaluationStatuses(_response);
        });
    }

    protected processSearchEvaluationStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ExerciseActivityTargetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ExerciseActivityTargets
     * @return The list of ExerciseActivityTargets
     */
    getExerciseActivityTargets( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/exerciseactivitytarget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseActivityTargets(_response);
        });
    }

    protected processGetExerciseActivityTargets(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ExerciseActivityTarget
     * @param body The ExerciseActivityTarget data to create
     * @return The newly created ExerciseActivityTarget data
     */
    createExerciseActivityTarget(body: ExerciseActivityTargetDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseActivityTargetDTO> {
        let url_ = this.baseUrl + "/exerciseactivitytarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExerciseActivityTarget(_response);
        });
    }

    protected processCreateExerciseActivityTarget(response: AxiosResponse): Promise<ApiResponse_exerciseActivityTargetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_exerciseActivityTargetDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseActivityTargetDTO>(null as any);
    }

    /**
     * Retrieve a ExerciseActivityTarget by ID
     * @param id The ID of the ExerciseActivityTarget to retrieve
     * @return The ExerciseActivityTarget data
     */
    getExerciseActivityTargetById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_exerciseActivityTargetDTO> {
        let url_ = this.baseUrl + "/exerciseactivitytarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseActivityTargetById(_response);
        });
    }

    protected processGetExerciseActivityTargetById(response: AxiosResponse): Promise<ApiResponse_exerciseActivityTargetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseActivityTargetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseActivityTargetDTO>(null as any);
    }

    /**
     * Update a ExerciseActivityTarget by ID
     * @param id The ID of the ExerciseActivityTarget to update
     * @param body The updated ExerciseActivityTarget data
     * @return The updated ExerciseActivityTarget data
     */
    updateExerciseActivityTarget(id: string, body: ExerciseActivityTargetDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseActivityTargetDTO> {
        let url_ = this.baseUrl + "/exerciseactivitytarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExerciseActivityTarget(_response);
        });
    }

    protected processUpdateExerciseActivityTarget(response: AxiosResponse): Promise<ApiResponse_exerciseActivityTargetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseActivityTargetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseActivityTargetDTO>(null as any);
    }

    /**
     * Delete a ExerciseActivityTarget by ID
     * @param id The ID of the ExerciseActivityTarget to delete
     */
    deleteExerciseActivityTarget(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/exerciseactivitytarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExerciseActivityTarget(_response);
        });
    }

    protected processDeleteExerciseActivityTarget(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ExerciseActivityTargets based on criteria
     * @param body The search criteria
     * @return The search results of ExerciseActivityTargets based on the criteria
     */
    searchExerciseActivityTargets(body: SearchRequestDTO_exerciseActivityTargetSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/exerciseactivitytarget/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchExerciseActivityTargets(_response);
        });
    }

    protected processSearchExerciseActivityTargets(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Generate and download an activity target PDF with date stamp
     * @param id The ID of the ExerciseActivityTarget to download as PDF
     * @return The SAS URI for downloading the generated PDF
     */
    downloadActivityTarget(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/exerciseactivitytarget/{id}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadActivityTarget(_response);
        });
    }

    protected processDownloadActivityTarget(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class ExerciseSpecificClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ExerciseSpecifics
     * @return The list of ExerciseSpecifics
     */
    getExerciseSpecifics( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/exercisespecific";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseSpecifics(_response);
        });
    }

    protected processGetExerciseSpecifics(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ExerciseSpecific
     * @param body The ExerciseSpecific data to create
     * @return The newly created ExerciseSpecific data
     */
    createExerciseSpecific(body: ExerciseSpecificDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseSpecificDTO> {
        let url_ = this.baseUrl + "/exercisespecific";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExerciseSpecific(_response);
        });
    }

    protected processCreateExerciseSpecific(response: AxiosResponse): Promise<ApiResponse_exerciseSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_exerciseSpecificDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseSpecificDTO>(null as any);
    }

    /**
     * Retrieve a ExerciseSpecific by ID
     * @param id The ID of the ExerciseSpecific to retrieve
     * @return The ExerciseSpecific data
     */
    getExerciseSpecificById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_exerciseSpecificDTO> {
        let url_ = this.baseUrl + "/exercisespecific/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseSpecificById(_response);
        });
    }

    protected processGetExerciseSpecificById(response: AxiosResponse): Promise<ApiResponse_exerciseSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseSpecificDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseSpecificDTO>(null as any);
    }

    /**
     * Update a ExerciseSpecific by ID
     * @param id The ID of the ExerciseSpecific to update
     * @param body The updated ExerciseSpecific data
     * @return The updated ExerciseSpecific data
     */
    updateExerciseSpecific(id: string, body: ExerciseSpecificDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseSpecificDTO> {
        let url_ = this.baseUrl + "/exercisespecific/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExerciseSpecific(_response);
        });
    }

    protected processUpdateExerciseSpecific(response: AxiosResponse): Promise<ApiResponse_exerciseSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseSpecificDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseSpecificDTO>(null as any);
    }

    /**
     * Delete a ExerciseSpecific by ID
     * @param id The ID of the ExerciseSpecific to delete
     */
    deleteExerciseSpecific(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/exercisespecific/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExerciseSpecific(_response);
        });
    }

    protected processDeleteExerciseSpecific(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ExerciseSpecifics based on criteria
     * @param body The search criteria
     * @return The search results of ExerciseSpecifics based on the criteria
     */
    searchExerciseSpecifics(body: SearchRequestDTO_exerciseSpecificSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/exercisespecific/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchExerciseSpecifics(_response);
        });
    }

    protected processSearchExerciseSpecifics(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ExerciseTargetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ExerciseTargets
     * @return The list of ExerciseTargets
     */
    getExerciseTargets( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/exercisetarget";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseTargets(_response);
        });
    }

    protected processGetExerciseTargets(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ExerciseTarget
     * @param body The ExerciseTarget data to create
     * @return The newly created ExerciseTarget data
     */
    createExerciseTarget(body: ExerciseTargetDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTargetDTO> {
        let url_ = this.baseUrl + "/exercisetarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExerciseTarget(_response);
        });
    }

    protected processCreateExerciseTarget(response: AxiosResponse): Promise<ApiResponse_exerciseTargetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_exerciseTargetDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTargetDTO>(null as any);
    }

    /**
     * Retrieve a ExerciseTarget by ID
     * @param id The ID of the ExerciseTarget to retrieve
     * @return The ExerciseTarget data
     */
    getExerciseTargetById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTargetDTO> {
        let url_ = this.baseUrl + "/exercisetarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseTargetById(_response);
        });
    }

    protected processGetExerciseTargetById(response: AxiosResponse): Promise<ApiResponse_exerciseTargetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseTargetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTargetDTO>(null as any);
    }

    /**
     * Update a ExerciseTarget by ID
     * @param id The ID of the ExerciseTarget to update
     * @param body The updated ExerciseTarget data
     * @return The updated ExerciseTarget data
     */
    updateExerciseTarget(id: string, body: ExerciseTargetDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTargetDTO> {
        let url_ = this.baseUrl + "/exercisetarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExerciseTarget(_response);
        });
    }

    protected processUpdateExerciseTarget(response: AxiosResponse): Promise<ApiResponse_exerciseTargetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseTargetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTargetDTO>(null as any);
    }

    /**
     * Delete a ExerciseTarget by ID
     * @param id The ID of the ExerciseTarget to delete
     */
    deleteExerciseTarget(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/exercisetarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExerciseTarget(_response);
        });
    }

    protected processDeleteExerciseTarget(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ExerciseTargets based on criteria
     * @param body The search criteria
     * @return The search results of ExerciseTargets based on the criteria
     */
    searchExerciseTargets(body: SearchRequestDTO_exerciseTargetSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/exercisetarget/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchExerciseTargets(_response);
        });
    }

    protected processSearchExerciseTargets(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Generate and download a postal target PDF with date stamp
     * @param id The ID of the ExerciseTarget to download as PDF
     * @param competitionEntryId (optional) The ID of the CompetitionEntry this target belongs to, embedded in the target's QR code for score submission
     * @param exerciseTypeId (optional) The ID of the ExerciseType this target is being downloaded for, embedded in the target's QR code
     * @param exerciseSpecificId (optional) The ID of the ExerciseSpecific this target is being downloaded for, embedded in the target's QR code
     * @return The SAS URI for downloading the generated PDF
     */
    downloadPostalTarget(id: string, competitionEntryId: string | null | undefined, exerciseTypeId: string | null | undefined, exerciseSpecificId: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/exercisetarget/{id}/download?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (competitionEntryId !== undefined && competitionEntryId !== null)
            url_ += "competitionEntryId=" + encodeURIComponent("" + competitionEntryId) + "&";
        if (exerciseTypeId !== undefined && exerciseTypeId !== null)
            url_ += "exerciseTypeId=" + encodeURIComponent("" + exerciseTypeId) + "&";
        if (exerciseSpecificId !== undefined && exerciseSpecificId !== null)
            url_ += "exerciseSpecificId=" + encodeURIComponent("" + exerciseSpecificId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPostalTarget(_response);
        });
    }

    protected processDownloadPostalTarget(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class ExerciseTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ExerciseTemplates
     * @return The list of ExerciseTemplates
     */
    getExerciseTemplates( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/exercisetemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseTemplates(_response);
        });
    }

    protected processGetExerciseTemplates(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ExerciseTemplate
     * @param body The ExerciseTemplate data to create
     * @return The newly created ExerciseTemplate data
     */
    createExerciseTemplate(body: ExerciseTemplateDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTemplateDTO> {
        let url_ = this.baseUrl + "/exercisetemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExerciseTemplate(_response);
        });
    }

    protected processCreateExerciseTemplate(response: AxiosResponse): Promise<ApiResponse_exerciseTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_exerciseTemplateDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTemplateDTO>(null as any);
    }

    /**
     * Retrieve a ExerciseTemplate by ID
     * @param id The ID of the ExerciseTemplate to retrieve
     * @return The ExerciseTemplate data
     */
    getExerciseTemplateById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTemplateDTO> {
        let url_ = this.baseUrl + "/exercisetemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseTemplateById(_response);
        });
    }

    protected processGetExerciseTemplateById(response: AxiosResponse): Promise<ApiResponse_exerciseTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseTemplateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTemplateDTO>(null as any);
    }

    /**
     * Update a ExerciseTemplate by ID
     * @param id The ID of the ExerciseTemplate to update
     * @param body The updated ExerciseTemplate data
     * @return The updated ExerciseTemplate data
     */
    updateExerciseTemplate(id: string, body: ExerciseTemplateDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTemplateDTO> {
        let url_ = this.baseUrl + "/exercisetemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExerciseTemplate(_response);
        });
    }

    protected processUpdateExerciseTemplate(response: AxiosResponse): Promise<ApiResponse_exerciseTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseTemplateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTemplateDTO>(null as any);
    }

    /**
     * Delete a ExerciseTemplate by ID
     * @param id The ID of the ExerciseTemplate to delete
     */
    deleteExerciseTemplate(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/exercisetemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExerciseTemplate(_response);
        });
    }

    protected processDeleteExerciseTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ExerciseTemplates based on criteria
     * @param body The search criteria
     * @return The search results of ExerciseTemplates based on the criteria
     */
    searchExerciseTemplates(body: SearchRequestDTO_exerciseTemplateSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/exercisetemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchExerciseTemplates(_response);
        });
    }

    protected processSearchExerciseTemplates(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ExerciseTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ExerciseTypes
     * @return The list of ExerciseTypes
     */
    getExerciseTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/exercisetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseTypes(_response);
        });
    }

    protected processGetExerciseTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ExerciseType
     * @param body The ExerciseType data to create
     * @return The newly created ExerciseType data
     */
    createExerciseType(body: ExerciseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTypeDTO> {
        let url_ = this.baseUrl + "/exercisetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExerciseType(_response);
        });
    }

    protected processCreateExerciseType(response: AxiosResponse): Promise<ApiResponse_exerciseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_exerciseTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTypeDTO>(null as any);
    }

    /**
     * Retrieve a ExerciseType by ID
     * @param id The ID of the ExerciseType to retrieve
     * @return The ExerciseType data
     */
    getExerciseTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTypeDTO> {
        let url_ = this.baseUrl + "/exercisetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExerciseTypeById(_response);
        });
    }

    protected processGetExerciseTypeById(response: AxiosResponse): Promise<ApiResponse_exerciseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTypeDTO>(null as any);
    }

    /**
     * Update a ExerciseType by ID
     * @param id The ID of the ExerciseType to update
     * @param body The updated ExerciseType data
     * @return The updated ExerciseType data
     */
    updateExerciseType(id: string, body: ExerciseTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_exerciseTypeDTO> {
        let url_ = this.baseUrl + "/exercisetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExerciseType(_response);
        });
    }

    protected processUpdateExerciseType(response: AxiosResponse): Promise<ApiResponse_exerciseTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exerciseTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exerciseTypeDTO>(null as any);
    }

    /**
     * Delete a ExerciseType by ID
     * @param id The ID of the ExerciseType to delete
     */
    deleteExerciseType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/exercisetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExerciseType(_response);
        });
    }

    protected processDeleteExerciseType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ExerciseTypes based on criteria
     * @param body The search criteria
     * @return The search results of ExerciseTypes based on the criteria
     */
    searchExerciseTypes(body: SearchRequestDTO_exerciseTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/exercisetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchExerciseTypes(_response);
        });
    }

    protected processSearchExerciseTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FarmStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FarmStatuses
     * @return The list of FarmStatuses
     */
    getFarmStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/farmstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFarmStatuses(_response);
        });
    }

    protected processGetFarmStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FarmStatus
     * @param body The FarmStatus data to create
     * @return The newly created FarmStatus data
     */
    createFarmStatus(body: FarmStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_farmStatusDTO> {
        let url_ = this.baseUrl + "/farmstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFarmStatus(_response);
        });
    }

    protected processCreateFarmStatus(response: AxiosResponse): Promise<ApiResponse_farmStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_farmStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_farmStatusDTO>(null as any);
    }

    /**
     * Retrieve a FarmStatus by ID
     * @param id The ID of the FarmStatus to retrieve
     * @return The FarmStatus data
     */
    getFarmStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_farmStatusDTO> {
        let url_ = this.baseUrl + "/farmstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFarmStatusById(_response);
        });
    }

    protected processGetFarmStatusById(response: AxiosResponse): Promise<ApiResponse_farmStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_farmStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_farmStatusDTO>(null as any);
    }

    /**
     * Update a FarmStatus by ID
     * @param id The ID of the FarmStatus to update
     * @param body The updated FarmStatus data
     * @return The updated FarmStatus data
     */
    updateFarmStatus(id: string, body: FarmStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_farmStatusDTO> {
        let url_ = this.baseUrl + "/farmstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFarmStatus(_response);
        });
    }

    protected processUpdateFarmStatus(response: AxiosResponse): Promise<ApiResponse_farmStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_farmStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_farmStatusDTO>(null as any);
    }

    /**
     * Delete a FarmStatus by ID
     * @param id The ID of the FarmStatus to delete
     */
    deleteFarmStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/farmstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFarmStatus(_response);
        });
    }

    protected processDeleteFarmStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FarmStatuses based on criteria
     * @param body The search criteria
     * @return The search results of FarmStatuses based on the criteria
     */
    searchFarmStatuses(body: SearchRequestDTO_farmStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/farmstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFarmStatuses(_response);
        });
    }

    protected processSearchFarmStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FarmTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FarmTypes
     * @return The list of FarmTypes
     */
    getFarmTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/farmtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFarmTypes(_response);
        });
    }

    protected processGetFarmTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FarmType
     * @param body The FarmType data to create
     * @return The newly created FarmType data
     */
    createFarmType(body: FarmTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_farmTypeDTO> {
        let url_ = this.baseUrl + "/farmtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFarmType(_response);
        });
    }

    protected processCreateFarmType(response: AxiosResponse): Promise<ApiResponse_farmTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_farmTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_farmTypeDTO>(null as any);
    }

    /**
     * Retrieve a FarmType by ID
     * @param id The ID of the FarmType to retrieve
     * @return The FarmType data
     */
    getFarmTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_farmTypeDTO> {
        let url_ = this.baseUrl + "/farmtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFarmTypeById(_response);
        });
    }

    protected processGetFarmTypeById(response: AxiosResponse): Promise<ApiResponse_farmTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_farmTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_farmTypeDTO>(null as any);
    }

    /**
     * Update a FarmType by ID
     * @param id The ID of the FarmType to update
     * @param body The updated FarmType data
     * @return The updated FarmType data
     */
    updateFarmType(id: string, body: FarmTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_farmTypeDTO> {
        let url_ = this.baseUrl + "/farmtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFarmType(_response);
        });
    }

    protected processUpdateFarmType(response: AxiosResponse): Promise<ApiResponse_farmTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_farmTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_farmTypeDTO>(null as any);
    }

    /**
     * Delete a FarmType by ID
     * @param id The ID of the FarmType to delete
     */
    deleteFarmType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/farmtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFarmType(_response);
        });
    }

    protected processDeleteFarmType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FarmTypes based on criteria
     * @param body The search criteria
     * @return The search results of FarmTypes based on the criteria
     */
    searchFarmTypes(body: SearchRequestDTO_farmTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/farmtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFarmTypes(_response);
        });
    }

    protected processSearchFarmTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FellowClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Fellows
     * @return The list of Fellows
     */
    getFellows( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/fellow";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFellows(_response);
        });
    }

    protected processGetFellows(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Fellow
     * @param body The Fellow data to create
     * @return The newly created Fellow data
     */
    createFellow(body: FellowDTO, cancelToken?: CancelToken): Promise<ApiResponse_fellowDTO> {
        let url_ = this.baseUrl + "/fellow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFellow(_response);
        });
    }

    protected processCreateFellow(response: AxiosResponse): Promise<ApiResponse_fellowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_fellowDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_fellowDTO>(null as any);
    }

    /**
     * Retrieve a Fellow by ID
     * @param id The ID of the Fellow to retrieve
     * @return The Fellow data
     */
    getFellowById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_fellowDTO> {
        let url_ = this.baseUrl + "/fellow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFellowById(_response);
        });
    }

    protected processGetFellowById(response: AxiosResponse): Promise<ApiResponse_fellowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_fellowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_fellowDTO>(null as any);
    }

    /**
     * Update a Fellow by ID
     * @param id The ID of the Fellow to update
     * @param body The updated Fellow data
     * @return The updated Fellow data
     */
    updateFellow(id: string, body: FellowDTO, cancelToken?: CancelToken): Promise<ApiResponse_fellowDTO> {
        let url_ = this.baseUrl + "/fellow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFellow(_response);
        });
    }

    protected processUpdateFellow(response: AxiosResponse): Promise<ApiResponse_fellowDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_fellowDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_fellowDTO>(null as any);
    }

    /**
     * Delete a Fellow by ID
     * @param id The ID of the Fellow to delete
     */
    deleteFellow(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/fellow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFellow(_response);
        });
    }

    protected processDeleteFellow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Fellows based on criteria
     * @param body The search criteria
     * @return The search results of Fellows based on the criteria
     */
    searchFellows(body: SearchRequestDTO_fellowSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/fellow/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFellows(_response);
        });
    }

    protected processSearchFellows(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Fellows based on search criteria
     * @param body The search criteria
     * @return The export results of Fellows based on the search criteria
     */
    exportFellows(body: SearchRequestDTO_fellowSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/fellow/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportFellows(_response);
        });
    }

    protected processExportFellows(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class FileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Uploads a file to quarantine storage
     * @param targetContainer The final container name where file should end up after scanning
     * @param fileName (optional) Optional file name to use
     * @param folder (optional) Optional folder path within container
     * @param body The file content to upload
     * @return The FileRecord ID of the uploaded file
     */
    uploadFile(targetContainer: string, fileName: string | null | undefined, folder: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/file/{targetContainer}/upload?";
        if (targetContainer === undefined || targetContainer === null)
            throw new globalThis.Error("The parameter 'targetContainer' must be defined.");
        url_ = url_.replace("{targetContainer}", encodeURIComponent("" + targetContainer));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (folder !== undefined && folder !== null)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Gets file information and optional SAS URL
     * @param fileRecordId The ID of the FileRecord
     * @return Data for the file
     */
    getFileUrl(fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_fileUrlResponseDTO> {
        let url_ = this.baseUrl + "/file/{fileRecordId}";
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined.");
        url_ = url_.replace("{fileRecordId}", encodeURIComponent("" + fileRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<ApiResponse_fileUrlResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_fileUrlResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_fileUrlResponseDTO>(null as any);
    }
}

export class FirearmActionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmActions
     * @return The list of FirearmActions
     */
    getFirearmActions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmActions(_response);
        });
    }

    protected processGetFirearmActions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmAction
     * @param body The FirearmAction data to create
     * @return The newly created FirearmAction data
     */
    createFirearmAction(body: FirearmActionDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmActionDTO> {
        let url_ = this.baseUrl + "/firearmaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmAction(_response);
        });
    }

    protected processCreateFirearmAction(response: AxiosResponse): Promise<ApiResponse_firearmActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmActionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmActionDTO>(null as any);
    }

    /**
     * Retrieve a FirearmAction by ID
     * @param id The ID of the FirearmAction to retrieve
     * @return The FirearmAction data
     */
    getFirearmActionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmActionDTO> {
        let url_ = this.baseUrl + "/firearmaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmActionById(_response);
        });
    }

    protected processGetFirearmActionById(response: AxiosResponse): Promise<ApiResponse_firearmActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmActionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmActionDTO>(null as any);
    }

    /**
     * Update a FirearmAction by ID
     * @param id The ID of the FirearmAction to update
     * @param body The updated FirearmAction data
     * @return The updated FirearmAction data
     */
    updateFirearmAction(id: string, body: FirearmActionDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmActionDTO> {
        let url_ = this.baseUrl + "/firearmaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmAction(_response);
        });
    }

    protected processUpdateFirearmAction(response: AxiosResponse): Promise<ApiResponse_firearmActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmActionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmActionDTO>(null as any);
    }

    /**
     * Delete a FirearmAction by ID
     * @param id The ID of the FirearmAction to delete
     */
    deleteFirearmAction(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmAction(_response);
        });
    }

    protected processDeleteFirearmAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmActions based on criteria
     * @param body The search criteria
     * @return The search results of FirearmActions based on the criteria
     */
    searchFirearmActions(body: SearchRequestDTO_firearmActionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmaction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmActions(_response);
        });
    }

    protected processSearchFirearmActions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmBarrelClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmBarrels
     * @return The list of FirearmBarrels
     */
    getFirearmBarrels( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmbarrel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmBarrels(_response);
        });
    }

    protected processGetFirearmBarrels(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmBarrel
     * @param body The FirearmBarrel data to create
     * @return The newly created FirearmBarrel data
     */
    createFirearmBarrel(body: FirearmBarrelDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmBarrelDTO> {
        let url_ = this.baseUrl + "/firearmbarrel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmBarrel(_response);
        });
    }

    protected processCreateFirearmBarrel(response: AxiosResponse): Promise<ApiResponse_firearmBarrelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmBarrelDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmBarrelDTO>(null as any);
    }

    /**
     * Retrieve a FirearmBarrel by ID
     * @param id The ID of the FirearmBarrel to retrieve
     * @return The FirearmBarrel data
     */
    getFirearmBarrelById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmBarrelDTO> {
        let url_ = this.baseUrl + "/firearmbarrel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmBarrelById(_response);
        });
    }

    protected processGetFirearmBarrelById(response: AxiosResponse): Promise<ApiResponse_firearmBarrelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmBarrelDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmBarrelDTO>(null as any);
    }

    /**
     * Update a FirearmBarrel by ID
     * @param id The ID of the FirearmBarrel to update
     * @param body The updated FirearmBarrel data
     * @return The updated FirearmBarrel data
     */
    updateFirearmBarrel(id: string, body: FirearmBarrelDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmBarrelDTO> {
        let url_ = this.baseUrl + "/firearmbarrel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmBarrel(_response);
        });
    }

    protected processUpdateFirearmBarrel(response: AxiosResponse): Promise<ApiResponse_firearmBarrelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmBarrelDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmBarrelDTO>(null as any);
    }

    /**
     * Delete a FirearmBarrel by ID
     * @param id The ID of the FirearmBarrel to delete
     */
    deleteFirearmBarrel(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmbarrel/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmBarrel(_response);
        });
    }

    protected processDeleteFirearmBarrel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmBarrels based on criteria
     * @param body The search criteria
     * @return The search results of FirearmBarrels based on the criteria
     */
    searchFirearmBarrels(body: SearchRequestDTO_firearmBarrelSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmbarrel/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmBarrels(_response);
        });
    }

    protected processSearchFirearmBarrels(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmBarrelMakeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmBarrelMakes
     * @return The list of FirearmBarrelMakes
     */
    getFirearmBarrelMakes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmbarrelmake";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmBarrelMakes(_response);
        });
    }

    protected processGetFirearmBarrelMakes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmBarrelMake
     * @param body The FirearmBarrelMake data to create
     * @return The newly created FirearmBarrelMake data
     */
    createFirearmBarrelMake(body: FirearmBarrelMakeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmBarrelMakeDTO> {
        let url_ = this.baseUrl + "/firearmbarrelmake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmBarrelMake(_response);
        });
    }

    protected processCreateFirearmBarrelMake(response: AxiosResponse): Promise<ApiResponse_firearmBarrelMakeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmBarrelMakeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmBarrelMakeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmBarrelMake by ID
     * @param id The ID of the FirearmBarrelMake to retrieve
     * @return The FirearmBarrelMake data
     */
    getFirearmBarrelMakeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmBarrelMakeDTO> {
        let url_ = this.baseUrl + "/firearmbarrelmake/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmBarrelMakeById(_response);
        });
    }

    protected processGetFirearmBarrelMakeById(response: AxiosResponse): Promise<ApiResponse_firearmBarrelMakeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmBarrelMakeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmBarrelMakeDTO>(null as any);
    }

    /**
     * Update a FirearmBarrelMake by ID
     * @param id The ID of the FirearmBarrelMake to update
     * @param body The updated FirearmBarrelMake data
     * @return The updated FirearmBarrelMake data
     */
    updateFirearmBarrelMake(id: string, body: FirearmBarrelMakeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmBarrelMakeDTO> {
        let url_ = this.baseUrl + "/firearmbarrelmake/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmBarrelMake(_response);
        });
    }

    protected processUpdateFirearmBarrelMake(response: AxiosResponse): Promise<ApiResponse_firearmBarrelMakeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmBarrelMakeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmBarrelMakeDTO>(null as any);
    }

    /**
     * Delete a FirearmBarrelMake by ID
     * @param id The ID of the FirearmBarrelMake to delete
     */
    deleteFirearmBarrelMake(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmbarrelmake/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmBarrelMake(_response);
        });
    }

    protected processDeleteFirearmBarrelMake(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmBarrelMakes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmBarrelMakes based on the criteria
     */
    searchFirearmBarrelMakes(body: SearchRequestDTO_firearmBarrelMakeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmbarrelmake/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmBarrelMakes(_response);
        });
    }

    protected processSearchFirearmBarrelMakes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmCalibreClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmCalibres
     * @return The list of FirearmCalibres
     */
    getFirearmCalibres( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmcalibre";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmCalibres(_response);
        });
    }

    protected processGetFirearmCalibres(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmCalibre
     * @param body The FirearmCalibre data to create
     * @return The newly created FirearmCalibre data
     */
    createFirearmCalibre(body: FirearmCalibreDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmCalibreDTO> {
        let url_ = this.baseUrl + "/firearmcalibre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmCalibre(_response);
        });
    }

    protected processCreateFirearmCalibre(response: AxiosResponse): Promise<ApiResponse_firearmCalibreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmCalibreDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmCalibreDTO>(null as any);
    }

    /**
     * Retrieve a FirearmCalibre by ID
     * @param id The ID of the FirearmCalibre to retrieve
     * @return The FirearmCalibre data
     */
    getFirearmCalibreById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmCalibreDTO> {
        let url_ = this.baseUrl + "/firearmcalibre/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmCalibreById(_response);
        });
    }

    protected processGetFirearmCalibreById(response: AxiosResponse): Promise<ApiResponse_firearmCalibreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmCalibreDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmCalibreDTO>(null as any);
    }

    /**
     * Update a FirearmCalibre by ID
     * @param id The ID of the FirearmCalibre to update
     * @param body The updated FirearmCalibre data
     * @return The updated FirearmCalibre data
     */
    updateFirearmCalibre(id: string, body: FirearmCalibreDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmCalibreDTO> {
        let url_ = this.baseUrl + "/firearmcalibre/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmCalibre(_response);
        });
    }

    protected processUpdateFirearmCalibre(response: AxiosResponse): Promise<ApiResponse_firearmCalibreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmCalibreDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmCalibreDTO>(null as any);
    }

    /**
     * Delete a FirearmCalibre by ID
     * @param id The ID of the FirearmCalibre to delete
     */
    deleteFirearmCalibre(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmcalibre/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmCalibre(_response);
        });
    }

    protected processDeleteFirearmCalibre(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmCalibres based on criteria
     * @param body The search criteria
     * @return The search results of FirearmCalibres based on the criteria
     */
    searchFirearmCalibres(body: SearchRequestDTO_firearmCalibreSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmcalibre/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmCalibres(_response);
        });
    }

    protected processSearchFirearmCalibres(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmCompetencyTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmCompetencyTypes
     * @return The list of FirearmCompetencyTypes
     */
    getFirearmCompetencyTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmcompetencytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmCompetencyTypes(_response);
        });
    }

    protected processGetFirearmCompetencyTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmCompetencyType
     * @param body The FirearmCompetencyType data to create
     * @return The newly created FirearmCompetencyType data
     */
    createFirearmCompetencyType(body: FirearmCompetencyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmCompetencyTypeDTO> {
        let url_ = this.baseUrl + "/firearmcompetencytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmCompetencyType(_response);
        });
    }

    protected processCreateFirearmCompetencyType(response: AxiosResponse): Promise<ApiResponse_firearmCompetencyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmCompetencyTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmCompetencyTypeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmCompetencyType by ID
     * @param id The ID of the FirearmCompetencyType to retrieve
     * @return The FirearmCompetencyType data
     */
    getFirearmCompetencyTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmCompetencyTypeDTO> {
        let url_ = this.baseUrl + "/firearmcompetencytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmCompetencyTypeById(_response);
        });
    }

    protected processGetFirearmCompetencyTypeById(response: AxiosResponse): Promise<ApiResponse_firearmCompetencyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmCompetencyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmCompetencyTypeDTO>(null as any);
    }

    /**
     * Update a FirearmCompetencyType by ID
     * @param id The ID of the FirearmCompetencyType to update
     * @param body The updated FirearmCompetencyType data
     * @return The updated FirearmCompetencyType data
     */
    updateFirearmCompetencyType(id: string, body: FirearmCompetencyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmCompetencyTypeDTO> {
        let url_ = this.baseUrl + "/firearmcompetencytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmCompetencyType(_response);
        });
    }

    protected processUpdateFirearmCompetencyType(response: AxiosResponse): Promise<ApiResponse_firearmCompetencyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmCompetencyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmCompetencyTypeDTO>(null as any);
    }

    /**
     * Delete a FirearmCompetencyType by ID
     * @param id The ID of the FirearmCompetencyType to delete
     */
    deleteFirearmCompetencyType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmcompetencytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmCompetencyType(_response);
        });
    }

    protected processDeleteFirearmCompetencyType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmCompetencyTypes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmCompetencyTypes based on the criteria
     */
    searchFirearmCompetencyTypes(body: SearchRequestDTO_firearmCompetencyTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmcompetencytype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmCompetencyTypes(_response);
        });
    }

    protected processSearchFirearmCompetencyTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmLooseBarrelTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmLooseBarrelTypes
     * @return The list of FirearmLooseBarrelTypes
     */
    getFirearmLooseBarrelTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmloosebarreltype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmLooseBarrelTypes(_response);
        });
    }

    protected processGetFirearmLooseBarrelTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmLooseBarrelType
     * @param body The FirearmLooseBarrelType data to create
     * @return The newly created FirearmLooseBarrelType data
     */
    createFirearmLooseBarrelType(body: FirearmLooseBarrelTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmLooseBarrelTypeDTO> {
        let url_ = this.baseUrl + "/firearmloosebarreltype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmLooseBarrelType(_response);
        });
    }

    protected processCreateFirearmLooseBarrelType(response: AxiosResponse): Promise<ApiResponse_firearmLooseBarrelTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmLooseBarrelTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmLooseBarrelTypeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmLooseBarrelType by ID
     * @param id The ID of the FirearmLooseBarrelType to retrieve
     * @return The FirearmLooseBarrelType data
     */
    getFirearmLooseBarrelTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmLooseBarrelTypeDTO> {
        let url_ = this.baseUrl + "/firearmloosebarreltype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmLooseBarrelTypeById(_response);
        });
    }

    protected processGetFirearmLooseBarrelTypeById(response: AxiosResponse): Promise<ApiResponse_firearmLooseBarrelTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmLooseBarrelTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmLooseBarrelTypeDTO>(null as any);
    }

    /**
     * Update a FirearmLooseBarrelType by ID
     * @param id The ID of the FirearmLooseBarrelType to update
     * @param body The updated FirearmLooseBarrelType data
     * @return The updated FirearmLooseBarrelType data
     */
    updateFirearmLooseBarrelType(id: string, body: FirearmLooseBarrelTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmLooseBarrelTypeDTO> {
        let url_ = this.baseUrl + "/firearmloosebarreltype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmLooseBarrelType(_response);
        });
    }

    protected processUpdateFirearmLooseBarrelType(response: AxiosResponse): Promise<ApiResponse_firearmLooseBarrelTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmLooseBarrelTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmLooseBarrelTypeDTO>(null as any);
    }

    /**
     * Delete a FirearmLooseBarrelType by ID
     * @param id The ID of the FirearmLooseBarrelType to delete
     */
    deleteFirearmLooseBarrelType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmloosebarreltype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmLooseBarrelType(_response);
        });
    }

    protected processDeleteFirearmLooseBarrelType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmLooseBarrelTypes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmLooseBarrelTypes based on the criteria
     */
    searchFirearmLooseBarrelTypes(body: SearchRequestDTO_firearmLooseBarrelTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmloosebarreltype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmLooseBarrelTypes(_response);
        });
    }

    protected processSearchFirearmLooseBarrelTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmMakeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmMakes
     * @return The list of FirearmMakes
     */
    getFirearmMakes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmmake";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmMakes(_response);
        });
    }

    protected processGetFirearmMakes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmMake
     * @param body The FirearmMake data to create
     * @return The newly created FirearmMake data
     */
    createFirearmMake(body: FirearmMakeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmMakeDTO> {
        let url_ = this.baseUrl + "/firearmmake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmMake(_response);
        });
    }

    protected processCreateFirearmMake(response: AxiosResponse): Promise<ApiResponse_firearmMakeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmMakeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmMakeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmMake by ID
     * @param id The ID of the FirearmMake to retrieve
     * @return The FirearmMake data
     */
    getFirearmMakeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmMakeDTO> {
        let url_ = this.baseUrl + "/firearmmake/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmMakeById(_response);
        });
    }

    protected processGetFirearmMakeById(response: AxiosResponse): Promise<ApiResponse_firearmMakeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmMakeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmMakeDTO>(null as any);
    }

    /**
     * Update a FirearmMake by ID
     * @param id The ID of the FirearmMake to update
     * @param body The updated FirearmMake data
     * @return The updated FirearmMake data
     */
    updateFirearmMake(id: string, body: FirearmMakeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmMakeDTO> {
        let url_ = this.baseUrl + "/firearmmake/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmMake(_response);
        });
    }

    protected processUpdateFirearmMake(response: AxiosResponse): Promise<ApiResponse_firearmMakeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmMakeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmMakeDTO>(null as any);
    }

    /**
     * Delete a FirearmMake by ID
     * @param id The ID of the FirearmMake to delete
     */
    deleteFirearmMake(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmmake/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmMake(_response);
        });
    }

    protected processDeleteFirearmMake(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmMakes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmMakes based on the criteria
     */
    searchFirearmMakes(body: SearchRequestDTO_firearmMakeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmmake/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmMakes(_response);
        });
    }

    protected processSearchFirearmMakes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmOwnerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmOwners
     * @return The list of FirearmOwners
     */
    getFirearmOwners( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmowner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmOwners(_response);
        });
    }

    protected processGetFirearmOwners(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmOwner
     * @param body The FirearmOwner data to create
     * @return The newly created FirearmOwner data
     */
    createFirearmOwner(body: FirearmOwnerDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmOwnerDTO> {
        let url_ = this.baseUrl + "/firearmowner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmOwner(_response);
        });
    }

    protected processCreateFirearmOwner(response: AxiosResponse): Promise<ApiResponse_firearmOwnerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmOwnerDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmOwnerDTO>(null as any);
    }

    /**
     * Retrieve a FirearmOwner by ID
     * @param id The ID of the FirearmOwner to retrieve
     * @return The FirearmOwner data
     */
    getFirearmOwnerById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmOwnerDTO> {
        let url_ = this.baseUrl + "/firearmowner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmOwnerById(_response);
        });
    }

    protected processGetFirearmOwnerById(response: AxiosResponse): Promise<ApiResponse_firearmOwnerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmOwnerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmOwnerDTO>(null as any);
    }

    /**
     * Update a FirearmOwner by ID
     * @param id The ID of the FirearmOwner to update
     * @param body The updated FirearmOwner data
     * @return The updated FirearmOwner data
     */
    updateFirearmOwner(id: string, body: FirearmOwnerDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmOwnerDTO> {
        let url_ = this.baseUrl + "/firearmowner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmOwner(_response);
        });
    }

    protected processUpdateFirearmOwner(response: AxiosResponse): Promise<ApiResponse_firearmOwnerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmOwnerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmOwnerDTO>(null as any);
    }

    /**
     * Delete a FirearmOwner by ID
     * @param id The ID of the FirearmOwner to delete
     */
    deleteFirearmOwner(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmowner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmOwner(_response);
        });
    }

    protected processDeleteFirearmOwner(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmOwners based on criteria
     * @param body The search criteria
     * @return The search results of FirearmOwners based on the criteria
     */
    searchFirearmOwners(body: SearchRequestDTO_firearmOwnerSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmowner/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmOwners(_response);
        });
    }

    protected processSearchFirearmOwners(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmPurposeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmPurposes
     * @return The list of FirearmPurposes
     */
    getFirearmPurposes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmpurpose";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmPurposes(_response);
        });
    }

    protected processGetFirearmPurposes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmPurpose
     * @param body The FirearmPurpose data to create
     * @return The newly created FirearmPurpose data
     */
    createFirearmPurpose(body: FirearmPurposeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmPurposeDTO> {
        let url_ = this.baseUrl + "/firearmpurpose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmPurpose(_response);
        });
    }

    protected processCreateFirearmPurpose(response: AxiosResponse): Promise<ApiResponse_firearmPurposeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmPurposeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmPurposeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmPurpose by ID
     * @param id The ID of the FirearmPurpose to retrieve
     * @return The FirearmPurpose data
     */
    getFirearmPurposeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmPurposeDTO> {
        let url_ = this.baseUrl + "/firearmpurpose/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmPurposeById(_response);
        });
    }

    protected processGetFirearmPurposeById(response: AxiosResponse): Promise<ApiResponse_firearmPurposeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmPurposeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmPurposeDTO>(null as any);
    }

    /**
     * Update a FirearmPurpose by ID
     * @param id The ID of the FirearmPurpose to update
     * @param body The updated FirearmPurpose data
     * @return The updated FirearmPurpose data
     */
    updateFirearmPurpose(id: string, body: FirearmPurposeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmPurposeDTO> {
        let url_ = this.baseUrl + "/firearmpurpose/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmPurpose(_response);
        });
    }

    protected processUpdateFirearmPurpose(response: AxiosResponse): Promise<ApiResponse_firearmPurposeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmPurposeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmPurposeDTO>(null as any);
    }

    /**
     * Delete a FirearmPurpose by ID
     * @param id The ID of the FirearmPurpose to delete
     */
    deleteFirearmPurpose(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmpurpose/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmPurpose(_response);
        });
    }

    protected processDeleteFirearmPurpose(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmPurposes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmPurposes based on the criteria
     */
    searchFirearmPurposes(body: SearchRequestDTO_firearmPurposeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmpurpose/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmPurposes(_response);
        });
    }

    protected processSearchFirearmPurposes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmSerialTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmSerialTypes
     * @return The list of FirearmSerialTypes
     */
    getFirearmSerialTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmserialtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmSerialTypes(_response);
        });
    }

    protected processGetFirearmSerialTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmSerialType
     * @param body The FirearmSerialType data to create
     * @return The newly created FirearmSerialType data
     */
    createFirearmSerialType(body: FirearmSerialTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmSerialTypeDTO> {
        let url_ = this.baseUrl + "/firearmserialtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmSerialType(_response);
        });
    }

    protected processCreateFirearmSerialType(response: AxiosResponse): Promise<ApiResponse_firearmSerialTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmSerialTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSerialTypeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmSerialType by ID
     * @param id The ID of the FirearmSerialType to retrieve
     * @return The FirearmSerialType data
     */
    getFirearmSerialTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmSerialTypeDTO> {
        let url_ = this.baseUrl + "/firearmserialtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmSerialTypeById(_response);
        });
    }

    protected processGetFirearmSerialTypeById(response: AxiosResponse): Promise<ApiResponse_firearmSerialTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmSerialTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSerialTypeDTO>(null as any);
    }

    /**
     * Update a FirearmSerialType by ID
     * @param id The ID of the FirearmSerialType to update
     * @param body The updated FirearmSerialType data
     * @return The updated FirearmSerialType data
     */
    updateFirearmSerialType(id: string, body: FirearmSerialTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmSerialTypeDTO> {
        let url_ = this.baseUrl + "/firearmserialtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmSerialType(_response);
        });
    }

    protected processUpdateFirearmSerialType(response: AxiosResponse): Promise<ApiResponse_firearmSerialTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmSerialTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSerialTypeDTO>(null as any);
    }

    /**
     * Delete a FirearmSerialType by ID
     * @param id The ID of the FirearmSerialType to delete
     */
    deleteFirearmSerialType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmserialtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmSerialType(_response);
        });
    }

    protected processDeleteFirearmSerialType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmSerialTypes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmSerialTypes based on the criteria
     */
    searchFirearmSerialTypes(body: SearchRequestDTO_firearmSerialTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmserialtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmSerialTypes(_response);
        });
    }

    protected processSearchFirearmSerialTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmSpecificClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmSpecifics
     * @return The list of FirearmSpecifics
     */
    getFirearmSpecifics( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmspecific";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmSpecifics(_response);
        });
    }

    protected processGetFirearmSpecifics(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmSpecific
     * @param body The FirearmSpecific data to create
     * @return The newly created FirearmSpecific data
     */
    createFirearmSpecific(body: FirearmSpecificDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmSpecificDTO> {
        let url_ = this.baseUrl + "/firearmspecific";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmSpecific(_response);
        });
    }

    protected processCreateFirearmSpecific(response: AxiosResponse): Promise<ApiResponse_firearmSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmSpecificDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSpecificDTO>(null as any);
    }

    /**
     * Retrieve a FirearmSpecific by ID
     * @param id The ID of the FirearmSpecific to retrieve
     * @return The FirearmSpecific data
     */
    getFirearmSpecificById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmSpecificDTO> {
        let url_ = this.baseUrl + "/firearmspecific/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmSpecificById(_response);
        });
    }

    protected processGetFirearmSpecificById(response: AxiosResponse): Promise<ApiResponse_firearmSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmSpecificDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSpecificDTO>(null as any);
    }

    /**
     * Update a FirearmSpecific by ID
     * @param id The ID of the FirearmSpecific to update
     * @param body The updated FirearmSpecific data
     * @return The updated FirearmSpecific data
     */
    updateFirearmSpecific(id: string, body: FirearmSpecificDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmSpecificDTO> {
        let url_ = this.baseUrl + "/firearmspecific/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmSpecific(_response);
        });
    }

    protected processUpdateFirearmSpecific(response: AxiosResponse): Promise<ApiResponse_firearmSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmSpecificDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSpecificDTO>(null as any);
    }

    /**
     * Delete a FirearmSpecific by ID
     * @param id The ID of the FirearmSpecific to delete
     */
    deleteFirearmSpecific(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmspecific/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmSpecific(_response);
        });
    }

    protected processDeleteFirearmSpecific(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve a FirearmSpecific by ID with exercises
     * @param id The ID of the FirearmSpecific to retrieve with exercises
     * @return The FirearmSpecific data  with exercises
     */
    getFirearmSpecificByIdWithExercises(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmSpecificDTO> {
        let url_ = this.baseUrl + "/firearmspecific/exercises/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmSpecificByIdWithExercises(_response);
        });
    }

    protected processGetFirearmSpecificByIdWithExercises(response: AxiosResponse): Promise<ApiResponse_firearmSpecificDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmSpecificDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmSpecificDTO>(null as any);
    }

    /**
     * Search FirearmSpecifics based on criteria
     * @param body The search criteria
     * @return The search results of FirearmSpecifics based on the criteria
     */
    searchFirearmSpecifics(body: SearchRequestDTO_firearmSpecificSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmspecific/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmSpecifics(_response);
        });
    }

    protected processSearchFirearmSpecifics(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class FirearmTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FirearmTypes
     * @return The list of FirearmTypes
     */
    getFirearmTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/firearmtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmTypes(_response);
        });
    }

    protected processGetFirearmTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FirearmType
     * @param body The FirearmType data to create
     * @return The newly created FirearmType data
     */
    createFirearmType(body: FirearmTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmTypeDTO> {
        let url_ = this.baseUrl + "/firearmtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFirearmType(_response);
        });
    }

    protected processCreateFirearmType(response: AxiosResponse): Promise<ApiResponse_firearmTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_firearmTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmTypeDTO>(null as any);
    }

    /**
     * Retrieve a FirearmType by ID
     * @param id The ID of the FirearmType to retrieve
     * @return The FirearmType data
     */
    getFirearmTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_firearmTypeDTO> {
        let url_ = this.baseUrl + "/firearmtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFirearmTypeById(_response);
        });
    }

    protected processGetFirearmTypeById(response: AxiosResponse): Promise<ApiResponse_firearmTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmTypeDTO>(null as any);
    }

    /**
     * Update a FirearmType by ID
     * @param id The ID of the FirearmType to update
     * @param body The updated FirearmType data
     * @return The updated FirearmType data
     */
    updateFirearmType(id: string, body: FirearmTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_firearmTypeDTO> {
        let url_ = this.baseUrl + "/firearmtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFirearmType(_response);
        });
    }

    protected processUpdateFirearmType(response: AxiosResponse): Promise<ApiResponse_firearmTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_firearmTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_firearmTypeDTO>(null as any);
    }

    /**
     * Delete a FirearmType by ID
     * @param id The ID of the FirearmType to delete
     */
    deleteFirearmType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/firearmtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFirearmType(_response);
        });
    }

    protected processDeleteFirearmType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FirearmTypes based on criteria
     * @param body The search criteria
     * @return The search results of FirearmTypes based on the criteria
     */
    searchFirearmTypes(body: SearchRequestDTO_firearmTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/firearmtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFirearmTypes(_response);
        });
    }

    protected processSearchFirearmTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ForfeitureReasonClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ForfeitureReasons
     * @return The list of ForfeitureReasons
     */
    getForfeitureReasons( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/forfeiturereason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForfeitureReasons(_response);
        });
    }

    protected processGetForfeitureReasons(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ForfeitureReason
     * @param body The ForfeitureReason data to create
     * @return The newly created ForfeitureReason data
     */
    createForfeitureReason(body: ForfeitureReasonDTO, cancelToken?: CancelToken): Promise<ApiResponse_forfeitureReasonDTO> {
        let url_ = this.baseUrl + "/forfeiturereason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateForfeitureReason(_response);
        });
    }

    protected processCreateForfeitureReason(response: AxiosResponse): Promise<ApiResponse_forfeitureReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_forfeitureReasonDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_forfeitureReasonDTO>(null as any);
    }

    /**
     * Retrieve a ForfeitureReason by ID
     * @param id The ID of the ForfeitureReason to retrieve
     * @return The ForfeitureReason data
     */
    getForfeitureReasonById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_forfeitureReasonDTO> {
        let url_ = this.baseUrl + "/forfeiturereason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForfeitureReasonById(_response);
        });
    }

    protected processGetForfeitureReasonById(response: AxiosResponse): Promise<ApiResponse_forfeitureReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_forfeitureReasonDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_forfeitureReasonDTO>(null as any);
    }

    /**
     * Update a ForfeitureReason by ID
     * @param id The ID of the ForfeitureReason to update
     * @param body The updated ForfeitureReason data
     * @return The updated ForfeitureReason data
     */
    updateForfeitureReason(id: string, body: ForfeitureReasonDTO, cancelToken?: CancelToken): Promise<ApiResponse_forfeitureReasonDTO> {
        let url_ = this.baseUrl + "/forfeiturereason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateForfeitureReason(_response);
        });
    }

    protected processUpdateForfeitureReason(response: AxiosResponse): Promise<ApiResponse_forfeitureReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_forfeitureReasonDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_forfeitureReasonDTO>(null as any);
    }

    /**
     * Delete a ForfeitureReason by ID
     * @param id The ID of the ForfeitureReason to delete
     */
    deleteForfeitureReason(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/forfeiturereason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteForfeitureReason(_response);
        });
    }

    protected processDeleteForfeitureReason(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ForfeitureReasons based on criteria
     * @param body The search criteria
     * @return The search results of ForfeitureReasons based on the criteria
     */
    searchForfeitureReasons(body: SearchRequestDTO_forfeitureReasonSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/forfeiturereason/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchForfeitureReasons(_response);
        });
    }

    protected processSearchForfeitureReasons(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export ForfeitureReasons based on search criteria
     * @param body The search criteria
     * @return The export results of ForfeitureReasons based on the search criteria
     */
    exportForfeitureReasons(body: SearchRequestDTO_forfeitureReasonSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/forfeiturereason/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportForfeitureReasons(_response);
        });
    }

    protected processExportForfeitureReasons(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class FriendAndPartnerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all FriendAndPartners
     * @return The list of FriendAndPartners
     */
    getFriendAndPartners( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/friendandpartner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFriendAndPartners(_response);
        });
    }

    protected processGetFriendAndPartners(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new FriendAndPartner
     * @param body The FriendAndPartner data to create
     * @return The newly created FriendAndPartner data
     */
    createFriendAndPartner(body: FriendAndPartnerDTO, cancelToken?: CancelToken): Promise<ApiResponse_friendAndPartnerDTO> {
        let url_ = this.baseUrl + "/friendandpartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFriendAndPartner(_response);
        });
    }

    protected processCreateFriendAndPartner(response: AxiosResponse): Promise<ApiResponse_friendAndPartnerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_friendAndPartnerDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_friendAndPartnerDTO>(null as any);
    }

    /**
     * Retrieve a FriendAndPartner by ID
     * @param id The ID of the FriendAndPartner to retrieve
     * @return The FriendAndPartner data
     */
    getFriendAndPartnerById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_friendAndPartnerDTO> {
        let url_ = this.baseUrl + "/friendandpartner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFriendAndPartnerById(_response);
        });
    }

    protected processGetFriendAndPartnerById(response: AxiosResponse): Promise<ApiResponse_friendAndPartnerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_friendAndPartnerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_friendAndPartnerDTO>(null as any);
    }

    /**
     * Update a FriendAndPartner by ID
     * @param id The ID of the FriendAndPartner to update
     * @param body The updated FriendAndPartner data
     * @return The updated FriendAndPartner data
     */
    updateFriendAndPartner(id: string, body: FriendAndPartnerDTO, cancelToken?: CancelToken): Promise<ApiResponse_friendAndPartnerDTO> {
        let url_ = this.baseUrl + "/friendandpartner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFriendAndPartner(_response);
        });
    }

    protected processUpdateFriendAndPartner(response: AxiosResponse): Promise<ApiResponse_friendAndPartnerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_friendAndPartnerDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_friendAndPartnerDTO>(null as any);
    }

    /**
     * Delete a FriendAndPartner by ID
     * @param id The ID of the FriendAndPartner to delete
     */
    deleteFriendAndPartner(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/friendandpartner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFriendAndPartner(_response);
        });
    }

    protected processDeleteFriendAndPartner(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search FriendAndPartners based on criteria
     * @param body The search criteria
     * @return The search results of FriendAndPartners based on the criteria
     */
    searchFriendAndPartners(body: SearchRequestDTO_friendAndPartnerSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/friendandpartner/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFriendAndPartners(_response);
        });
    }

    protected processSearchFriendAndPartners(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export FriendAndPartners based on search criteria
     * @param body The search criteria
     * @return The export results of FriendAndPartners based on the search criteria
     */
    exportFriendAndPartners(body: SearchRequestDTO_friendAndPartnerSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/friendandpartner/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportFriendAndPartners(_response);
        });
    }

    protected processExportFriendAndPartners(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class GenderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Genders
     * @return The list of Genders
     */
    getGenders( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/gender";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenders(_response);
        });
    }

    protected processGetGenders(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Gender
     * @param body The Gender data to create
     * @return The newly created Gender data
     */
    createGender(body: GenderDTO, cancelToken?: CancelToken): Promise<ApiResponse_genderDTO> {
        let url_ = this.baseUrl + "/gender";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGender(_response);
        });
    }

    protected processCreateGender(response: AxiosResponse): Promise<ApiResponse_genderDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_genderDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_genderDTO>(null as any);
    }

    /**
     * Retrieve a Gender by ID
     * @param id The ID of the Gender to retrieve
     * @return The Gender data
     */
    getGenderById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_genderDTO> {
        let url_ = this.baseUrl + "/gender/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenderById(_response);
        });
    }

    protected processGetGenderById(response: AxiosResponse): Promise<ApiResponse_genderDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_genderDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_genderDTO>(null as any);
    }

    /**
     * Update a Gender by ID
     * @param id The ID of the Gender to update
     * @param body The updated Gender data
     * @return The updated Gender data
     */
    updateGender(id: string, body: GenderDTO, cancelToken?: CancelToken): Promise<ApiResponse_genderDTO> {
        let url_ = this.baseUrl + "/gender/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGender(_response);
        });
    }

    protected processUpdateGender(response: AxiosResponse): Promise<ApiResponse_genderDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_genderDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_genderDTO>(null as any);
    }

    /**
     * Delete a Gender by ID
     * @param id The ID of the Gender to delete
     */
    deleteGender(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/gender/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGender(_response);
        });
    }

    protected processDeleteGender(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Genders based on criteria
     * @param body The search criteria
     * @return The search results of Genders based on the criteria
     */
    searchGenders(body: SearchRequestDTO_genderSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/gender/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchGenders(_response);
        });
    }

    protected processSearchGenders(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class GradingCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all GradingCategories
     * @return The list of GradingCategories
     */
    getGradingCategories( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/gradingcategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGradingCategories(_response);
        });
    }

    protected processGetGradingCategories(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new GradingCategory
     * @param body The GradingCategory data to create
     * @return The newly created GradingCategory data
     */
    createGradingCategory(body: GradingCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_gradingCategoryDTO> {
        let url_ = this.baseUrl + "/gradingcategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGradingCategory(_response);
        });
    }

    protected processCreateGradingCategory(response: AxiosResponse): Promise<ApiResponse_gradingCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_gradingCategoryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_gradingCategoryDTO>(null as any);
    }

    /**
     * Retrieve a GradingCategory by ID
     * @param id The ID of the GradingCategory to retrieve
     * @return The GradingCategory data
     */
    getGradingCategoryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_gradingCategoryDTO> {
        let url_ = this.baseUrl + "/gradingcategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGradingCategoryById(_response);
        });
    }

    protected processGetGradingCategoryById(response: AxiosResponse): Promise<ApiResponse_gradingCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_gradingCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_gradingCategoryDTO>(null as any);
    }

    /**
     * Update a GradingCategory by ID
     * @param id The ID of the GradingCategory to update
     * @param body The updated GradingCategory data
     * @return The updated GradingCategory data
     */
    updateGradingCategory(id: string, body: GradingCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_gradingCategoryDTO> {
        let url_ = this.baseUrl + "/gradingcategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGradingCategory(_response);
        });
    }

    protected processUpdateGradingCategory(response: AxiosResponse): Promise<ApiResponse_gradingCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_gradingCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_gradingCategoryDTO>(null as any);
    }

    /**
     * Delete a GradingCategory by ID
     * @param id The ID of the GradingCategory to delete
     */
    deleteGradingCategory(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/gradingcategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGradingCategory(_response);
        });
    }

    protected processDeleteGradingCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search GradingCategories based on criteria
     * @param body The search criteria
     * @return The search results of GradingCategories based on the criteria
     */
    searchGradingCategories(body: SearchRequestDTO_gradingCategorySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/gradingcategory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchGradingCategories(_response);
        });
    }

    protected processSearchGradingCategories(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class GradingTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all GradingTypes
     * @return The list of GradingTypes
     */
    getGradingTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/gradingtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGradingTypes(_response);
        });
    }

    protected processGetGradingTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new GradingType
     * @param body The GradingType data to create
     * @return The newly created GradingType data
     */
    createGradingType(body: GradingTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_gradingTypeDTO> {
        let url_ = this.baseUrl + "/gradingtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGradingType(_response);
        });
    }

    protected processCreateGradingType(response: AxiosResponse): Promise<ApiResponse_gradingTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_gradingTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_gradingTypeDTO>(null as any);
    }

    /**
     * Retrieve a GradingType by ID
     * @param id The ID of the GradingType to retrieve
     * @return The GradingType data
     */
    getGradingTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_gradingTypeDTO> {
        let url_ = this.baseUrl + "/gradingtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGradingTypeById(_response);
        });
    }

    protected processGetGradingTypeById(response: AxiosResponse): Promise<ApiResponse_gradingTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_gradingTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_gradingTypeDTO>(null as any);
    }

    /**
     * Update a GradingType by ID
     * @param id The ID of the GradingType to update
     * @param body The updated GradingType data
     * @return The updated GradingType data
     */
    updateGradingType(id: string, body: GradingTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_gradingTypeDTO> {
        let url_ = this.baseUrl + "/gradingtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGradingType(_response);
        });
    }

    protected processUpdateGradingType(response: AxiosResponse): Promise<ApiResponse_gradingTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_gradingTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_gradingTypeDTO>(null as any);
    }

    /**
     * Delete a GradingType by ID
     * @param id The ID of the GradingType to delete
     */
    deleteGradingType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/gradingtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGradingType(_response);
        });
    }

    protected processDeleteGradingType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search GradingTypes based on criteria
     * @param body The search criteria
     * @return The search results of GradingTypes based on the criteria
     */
    searchGradingTypes(body: SearchRequestDTO_gradingTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/gradingtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchGradingTypes(_response);
        });
    }

    protected processSearchGradingTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class InvoiceBatchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all InvoiceBatches
     * @return The list of InvoiceBatches
     */
    getInvoiceBatches( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoicebatch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceBatches(_response);
        });
    }

    protected processGetInvoiceBatches(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new InvoiceBatch
     * @param body The InvoiceBatch data to create
     * @return The newly created InvoiceBatch data
     */
    createInvoiceBatch(body: InvoiceBatchDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceBatchDTO> {
        let url_ = this.baseUrl + "/invoicebatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceBatch(_response);
        });
    }

    protected processCreateInvoiceBatch(response: AxiosResponse): Promise<ApiResponse_invoiceBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceBatchDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceBatchDTO>(null as any);
    }

    /**
     * Retrieve a InvoiceBatch by ID
     * @param id The ID of the InvoiceBatch to retrieve
     * @return The InvoiceBatch data
     */
    getInvoiceBatchById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceBatchDTO> {
        let url_ = this.baseUrl + "/invoicebatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceBatchById(_response);
        });
    }

    protected processGetInvoiceBatchById(response: AxiosResponse): Promise<ApiResponse_invoiceBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceBatchDTO>(null as any);
    }

    /**
     * Update a InvoiceBatch by ID
     * @param id The ID of the InvoiceBatch to update
     * @param body The updated InvoiceBatch data
     * @return The updated InvoiceBatch data
     */
    updateInvoiceBatch(id: string, body: InvoiceBatchDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceBatchDTO> {
        let url_ = this.baseUrl + "/invoicebatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceBatch(_response);
        });
    }

    protected processUpdateInvoiceBatch(response: AxiosResponse): Promise<ApiResponse_invoiceBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceBatchDTO>(null as any);
    }

    /**
     * Delete a InvoiceBatch by ID
     * @param id The ID of the InvoiceBatch to delete
     */
    deleteInvoiceBatch(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoicebatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoiceBatch(_response);
        });
    }

    protected processDeleteInvoiceBatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search InvoiceBatches based on criteria
     * @param body The search criteria
     * @return The search results of InvoiceBatches based on the criteria
     */
    searchInvoiceBatches(body: SearchRequestDTO_invoiceBatchSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoicebatch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceBatches(_response);
        });
    }

    protected processSearchInvoiceBatches(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export InvoiceBatches based on search criteria
     * @param body The search criteria
     * @return The export results of InvoiceBatches based on the search criteria
     */
    exportInvoiceBatches(body: SearchRequestDTO_invoiceBatchSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoicebatch/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInvoiceBatches(_response);
        });
    }

    protected processExportInvoiceBatches(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Regenerate invoices for a batch
     * @param id The ID of the InvoiceBatch to regenerate
     * @return Regeneration queued successfully
     */
    regenerateInvoiceBatch(id: string, cancelToken?: CancelToken): Promise<ApiResponse_object> {
        let url_ = this.baseUrl + "/invoicebatch/{id}/regenerate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegenerateInvoiceBatch(_response);
        });
    }

    protected processRegenerateInvoiceBatch(response: AxiosResponse): Promise<ApiResponse_object> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = JSON.parse(resultData202);
            return Promise.resolve<ApiResponse_object>(result202);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_object>(null as any);
    }

    /**
     * Get regeneration status for a batch
     * @param id The ID of the InvoiceBatch
     * @return The regeneration status
     */
    getInvoiceBatchRegenerationStatus(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceBatchRegenerationStatusDTO> {
        let url_ = this.baseUrl + "/invoicebatch/{id}/regeneration-status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceBatchRegenerationStatus(_response);
        });
    }

    protected processGetInvoiceBatchRegenerationStatus(response: AxiosResponse): Promise<ApiResponse_invoiceBatchRegenerationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceBatchRegenerationStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceBatchRegenerationStatusDTO>(null as any);
    }

    /**
     * Get invoice batches for a member
     * @param memberId The member ID to retrieve invoice batches for
     * @return The list of invoice batches for this member
     */
    getMemberInvoiceBatches(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoicebatch/member/{memberId}/batches";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberInvoiceBatches(_response);
        });
    }

    protected processGetMemberInvoiceBatches(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Send renewal notices for a batch
     * @param id The ID of the InvoiceBatch to send notices for
     * @return Renewal notices queued successfully
     */
    sendBatchRenewalNotices(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoicebatch/{id}/send-notices";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendBatchRenewalNotices(_response);
        });
    }

    protected processSendBatchRenewalNotices(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class InvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Invoices
     * @return The list of Invoices
     */
    getInvoices( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Invoice
     * @param body The Invoice data to create
     * @return The newly created Invoice data
     */
    createInvoice(body: InvoiceDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Retrieve a Invoice by ID
     * @param id The ID of the Invoice to retrieve
     * @return The Invoice data
     */
    getInvoiceById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceById(_response);
        });
    }

    protected processGetInvoiceById(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Update a Invoice by ID
     * @param id The ID of the Invoice to update
     * @param body The updated Invoice data
     * @return The updated Invoice data
     */
    updateInvoice(id: string, body: InvoiceDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoice(_response);
        });
    }

    protected processUpdateInvoice(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Delete a Invoice by ID
     * @param id The ID of the Invoice to delete
     */
    deleteInvoice(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoice(_response);
        });
    }

    protected processDeleteInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create and immediately finalize an invoice
     * @param body The Invoice data to create and finalize
     * @return The finalized Invoice data
     */
    createAndFinalizeInvoice(body: InvoiceDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/create-finalized";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAndFinalizeInvoice(_response);
        });
    }

    protected processCreateAndFinalizeInvoice(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Search Invoices based on criteria
     * @param body The search criteria
     * @return The search results of Invoices based on the criteria
     */
    searchInvoices(body: SearchRequestDTO_invoiceSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoices(_response);
        });
    }

    protected processSearchInvoices(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Invoices based on search criteria
     * @param body The search criteria
     * @return The export results of Invoices based on the search criteria
     */
    exportInvoices(body: SearchRequestDTO_invoiceSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoice/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInvoices(_response);
        });
    }

    protected processExportInvoices(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Download invoice/payment notice PDF
     * @param id The invoice ID
     */
    downloadInvoiceNotice(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoice/{id}/download-notice";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoiceNotice(_response);
        });
    }

    protected processDownloadInvoiceNotice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 302) {
            const _responseText = response.data;
            let result302: any = null;
            let resultData302  = _responseText;
            result302 = JSON.parse(resultData302);
            return throwException("Redirects to the PDF file", status, _responseText, _headers, result302);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get invoice/payment notice PDF SAS URL
     * @param id The invoice ID
     * @return The SAS URL for the PDF file
     */
    getInvoiceNoticeSasUrl(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoice/{id}/sas-url";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceNoticeSasUrl(_response);
        });
    }

    protected processGetInvoiceNoticeSasUrl(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Revert a finalized invoice
     * @param id The invoice ID to revert
     * @return The reverted invoice
     */
    revertInvoice(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/{id}/revert";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevertInvoice(_response);
        });
    }

    protected processRevertInvoice(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Get display invoices for a member
     * @param memberId The member ID to retrieve invoices for
     * @return The filtered list of invoices for display
     */
    getMemberDisplayInvoices(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoice/member/{memberId}/display";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberDisplayInvoices(_response);
        });
    }

    protected processGetMemberDisplayInvoices(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Resend invoice or payment notice email
     * @param id The invoice ID to resend
     * @return Email resent successfully
     */
    resendInvoiceOrNotice(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoice/{id}/resend";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendInvoiceOrNotice(_response);
        });
    }

    protected processResendInvoiceOrNotice(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class InvoiceLineItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all InvoiceLineItems
     * @return The list of InvoiceLineItems
     */
    getInvoiceLineItems( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoicelineitem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceLineItems(_response);
        });
    }

    protected processGetInvoiceLineItems(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new InvoiceLineItem
     * @param body The InvoiceLineItem data to create
     * @return The newly created InvoiceLineItem data
     */
    createInvoiceLineItem(body: InvoiceLineItemDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceLineItemDTO> {
        let url_ = this.baseUrl + "/invoicelineitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceLineItem(_response);
        });
    }

    protected processCreateInvoiceLineItem(response: AxiosResponse): Promise<ApiResponse_invoiceLineItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceLineItemDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceLineItemDTO>(null as any);
    }

    /**
     * Retrieve a InvoiceLineItem by ID
     * @param id The ID of the InvoiceLineItem to retrieve
     * @return The InvoiceLineItem data
     */
    getInvoiceLineItemById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceLineItemDTO> {
        let url_ = this.baseUrl + "/invoicelineitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceLineItemById(_response);
        });
    }

    protected processGetInvoiceLineItemById(response: AxiosResponse): Promise<ApiResponse_invoiceLineItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceLineItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceLineItemDTO>(null as any);
    }

    /**
     * Update a InvoiceLineItem by ID
     * @param id The ID of the InvoiceLineItem to update
     * @param body The updated InvoiceLineItem data
     * @return The updated InvoiceLineItem data
     */
    updateInvoiceLineItem(id: string, body: InvoiceLineItemDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceLineItemDTO> {
        let url_ = this.baseUrl + "/invoicelineitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceLineItem(_response);
        });
    }

    protected processUpdateInvoiceLineItem(response: AxiosResponse): Promise<ApiResponse_invoiceLineItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceLineItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceLineItemDTO>(null as any);
    }

    /**
     * Delete a InvoiceLineItem by ID
     * @param id The ID of the InvoiceLineItem to delete
     */
    deleteInvoiceLineItem(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoicelineitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoiceLineItem(_response);
        });
    }

    protected processDeleteInvoiceLineItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search InvoiceLineItems based on criteria
     * @param body The search criteria
     * @return The search results of InvoiceLineItems based on the criteria
     */
    searchInvoiceLineItems(body: SearchRequestDTO_invoiceLineItemSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoicelineitem/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceLineItems(_response);
        });
    }

    protected processSearchInvoiceLineItems(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export InvoiceLineItems based on search criteria
     * @param body The search criteria
     * @return The export results of InvoiceLineItems based on the search criteria
     */
    exportInvoiceLineItems(body: SearchRequestDTO_invoiceLineItemSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoicelineitem/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInvoiceLineItems(_response);
        });
    }

    protected processExportInvoiceLineItems(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class InvoiceStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all InvoiceStatuses
     * @return The list of InvoiceStatuses
     */
    getInvoiceStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoicestatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceStatuses(_response);
        });
    }

    protected processGetInvoiceStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new InvoiceStatus
     * @param body The InvoiceStatus data to create
     * @return The newly created InvoiceStatus data
     */
    createInvoiceStatus(body: InvoiceStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceStatusDTO> {
        let url_ = this.baseUrl + "/invoicestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceStatus(_response);
        });
    }

    protected processCreateInvoiceStatus(response: AxiosResponse): Promise<ApiResponse_invoiceStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceStatusDTO>(null as any);
    }

    /**
     * Retrieve a InvoiceStatus by ID
     * @param id The ID of the InvoiceStatus to retrieve
     * @return The InvoiceStatus data
     */
    getInvoiceStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceStatusDTO> {
        let url_ = this.baseUrl + "/invoicestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceStatusById(_response);
        });
    }

    protected processGetInvoiceStatusById(response: AxiosResponse): Promise<ApiResponse_invoiceStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceStatusDTO>(null as any);
    }

    /**
     * Update a InvoiceStatus by ID
     * @param id The ID of the InvoiceStatus to update
     * @param body The updated InvoiceStatus data
     * @return The updated InvoiceStatus data
     */
    updateInvoiceStatus(id: string, body: InvoiceStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceStatusDTO> {
        let url_ = this.baseUrl + "/invoicestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceStatus(_response);
        });
    }

    protected processUpdateInvoiceStatus(response: AxiosResponse): Promise<ApiResponse_invoiceStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceStatusDTO>(null as any);
    }

    /**
     * Delete a InvoiceStatus by ID
     * @param id The ID of the InvoiceStatus to delete
     */
    deleteInvoiceStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoicestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoiceStatus(_response);
        });
    }

    protected processDeleteInvoiceStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search InvoiceStatuses based on criteria
     * @param body The search criteria
     * @return The search results of InvoiceStatuses based on the criteria
     */
    searchInvoiceStatuses(body: SearchRequestDTO_invoiceStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoicestatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceStatuses(_response);
        });
    }

    protected processSearchInvoiceStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class InvoiceTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all InvoiceTypes
     * @return The list of InvoiceTypes
     */
    getInvoiceTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoicetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceTypes(_response);
        });
    }

    protected processGetInvoiceTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new InvoiceType
     * @param body The InvoiceType data to create
     * @return The newly created InvoiceType data
     */
    createInvoiceType(body: InvoiceTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceTypeDTO> {
        let url_ = this.baseUrl + "/invoicetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceType(_response);
        });
    }

    protected processCreateInvoiceType(response: AxiosResponse): Promise<ApiResponse_invoiceTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceTypeDTO>(null as any);
    }

    /**
     * Retrieve a InvoiceType by ID
     * @param id The ID of the InvoiceType to retrieve
     * @return The InvoiceType data
     */
    getInvoiceTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceTypeDTO> {
        let url_ = this.baseUrl + "/invoicetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceTypeById(_response);
        });
    }

    protected processGetInvoiceTypeById(response: AxiosResponse): Promise<ApiResponse_invoiceTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceTypeDTO>(null as any);
    }

    /**
     * Update a InvoiceType by ID
     * @param id The ID of the InvoiceType to update
     * @param body The updated InvoiceType data
     * @return The updated InvoiceType data
     */
    updateInvoiceType(id: string, body: InvoiceTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_invoiceTypeDTO> {
        let url_ = this.baseUrl + "/invoicetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceType(_response);
        });
    }

    protected processUpdateInvoiceType(response: AxiosResponse): Promise<ApiResponse_invoiceTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceTypeDTO>(null as any);
    }

    /**
     * Delete a InvoiceType by ID
     * @param id The ID of the InvoiceType to delete
     */
    deleteInvoiceType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoicetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoiceType(_response);
        });
    }

    protected processDeleteInvoiceType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search InvoiceTypes based on criteria
     * @param body The search criteria
     * @return The search results of InvoiceTypes based on the criteria
     */
    searchInvoiceTypes(body: SearchRequestDTO_invoiceTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoicetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceTypes(_response);
        });
    }

    protected processSearchInvoiceTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class LanguageClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Languages
     * @return The list of Languages
     */
    getLanguages( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Language
     * @param body The Language data to create
     * @return The newly created Language data
     */
    createLanguage(body: LanguageDTO, cancelToken?: CancelToken): Promise<ApiResponse_languageDTO> {
        let url_ = this.baseUrl + "/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLanguage(_response);
        });
    }

    protected processCreateLanguage(response: AxiosResponse): Promise<ApiResponse_languageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_languageDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_languageDTO>(null as any);
    }

    /**
     * Retrieve a Language by ID
     * @param id The ID of the Language to retrieve
     * @return The Language data
     */
    getLanguageById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_languageDTO> {
        let url_ = this.baseUrl + "/language/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguageById(_response);
        });
    }

    protected processGetLanguageById(response: AxiosResponse): Promise<ApiResponse_languageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_languageDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_languageDTO>(null as any);
    }

    /**
     * Update a Language by ID
     * @param id The ID of the Language to update
     * @param body The updated Language data
     * @return The updated Language data
     */
    updateLanguage(id: string, body: LanguageDTO, cancelToken?: CancelToken): Promise<ApiResponse_languageDTO> {
        let url_ = this.baseUrl + "/language/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLanguage(_response);
        });
    }

    protected processUpdateLanguage(response: AxiosResponse): Promise<ApiResponse_languageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_languageDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_languageDTO>(null as any);
    }

    /**
     * Delete a Language by ID
     * @param id The ID of the Language to delete
     */
    deleteLanguage(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/language/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLanguage(_response);
        });
    }

    protected processDeleteLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Languages based on criteria
     * @param body The search criteria
     * @return The search results of Languages based on the criteria
     */
    searchLanguages(body: SearchRequestDTO_languageSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/language/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchLanguages(_response);
        });
    }

    protected processSearchLanguages(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ListingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Listings
     * @return The list of Listings
     */
    getListings( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/listing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListings(_response);
        });
    }

    protected processGetListings(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Listing
     * @param body The Listing data to create
     * @return The newly created Listing data
     */
    createListing(body: ListingDTO, cancelToken?: CancelToken): Promise<ApiResponse_listingDTO> {
        let url_ = this.baseUrl + "/listing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateListing(_response);
        });
    }

    protected processCreateListing(response: AxiosResponse): Promise<ApiResponse_listingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_listingDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingDTO>(null as any);
    }

    /**
     * Retrieve a Listing by ID
     * @param id The ID of the Listing to retrieve
     * @return The Listing data
     */
    getListingById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_listingDTO> {
        let url_ = this.baseUrl + "/listing/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingById(_response);
        });
    }

    protected processGetListingById(response: AxiosResponse): Promise<ApiResponse_listingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_listingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingDTO>(null as any);
    }

    /**
     * Update a Listing by ID
     * @param id The ID of the Listing to update
     * @param body The updated Listing data
     * @return The updated Listing data
     */
    updateListing(id: string, body: ListingDTO, cancelToken?: CancelToken): Promise<ApiResponse_listingDTO> {
        let url_ = this.baseUrl + "/listing/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateListing(_response);
        });
    }

    protected processUpdateListing(response: AxiosResponse): Promise<ApiResponse_listingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_listingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingDTO>(null as any);
    }

    /**
     * Delete a Listing by ID
     * @param id The ID of the Listing to delete
     */
    deleteListing(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/listing/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListing(_response);
        });
    }

    protected processDeleteListing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Listings based on criteria
     * @param body The search criteria
     * @return The search results of Listings based on the criteria
     */
    searchListings(body: SearchRequestDTO_listingSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/listing/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchListings(_response);
        });
    }

    protected processSearchListings(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Search Listings by proximity or name
     * @param latitude (optional) User's latitude (defaults to South Africa center)
     * @param longitude (optional) User's longitude (defaults to South Africa center)
     * @param limit (optional) Maximum number of results (default: 30, max: 100)
     * @param name (optional) Search by listing name or city (ignores proximity if provided)
     * @param listingTypeId (optional) Filter by listing type ID
     * @return List of Listings ordered by distance or name match
     */
    searchListingsByProximity(latitude: number | null | undefined, longitude: number | null | undefined, limit: number | null | undefined, name: string | null | undefined, listingTypeId: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/listing/proximity?";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (listingTypeId !== undefined && listingTypeId !== null)
            url_ += "listingTypeId=" + encodeURIComponent("" + listingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchListingsByProximity(_response);
        });
    }

    protected processSearchListingsByProximity(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class ListingStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ListingStatuses
     * @return The list of ListingStatuses
     */
    getListingStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/listingstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingStatuses(_response);
        });
    }

    protected processGetListingStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ListingStatus
     * @param body The ListingStatus data to create
     * @return The newly created ListingStatus data
     */
    createListingStatus(body: ListingStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_listingStatusDTO> {
        let url_ = this.baseUrl + "/listingstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateListingStatus(_response);
        });
    }

    protected processCreateListingStatus(response: AxiosResponse): Promise<ApiResponse_listingStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_listingStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingStatusDTO>(null as any);
    }

    /**
     * Retrieve a ListingStatus by ID
     * @param id The ID of the ListingStatus to retrieve
     * @return The ListingStatus data
     */
    getListingStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_listingStatusDTO> {
        let url_ = this.baseUrl + "/listingstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingStatusById(_response);
        });
    }

    protected processGetListingStatusById(response: AxiosResponse): Promise<ApiResponse_listingStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_listingStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingStatusDTO>(null as any);
    }

    /**
     * Update a ListingStatus by ID
     * @param id The ID of the ListingStatus to update
     * @param body The updated ListingStatus data
     * @return The updated ListingStatus data
     */
    updateListingStatus(id: string, body: ListingStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_listingStatusDTO> {
        let url_ = this.baseUrl + "/listingstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateListingStatus(_response);
        });
    }

    protected processUpdateListingStatus(response: AxiosResponse): Promise<ApiResponse_listingStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_listingStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingStatusDTO>(null as any);
    }

    /**
     * Delete a ListingStatus by ID
     * @param id The ID of the ListingStatus to delete
     */
    deleteListingStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/listingstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListingStatus(_response);
        });
    }

    protected processDeleteListingStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ListingStatuses based on criteria
     * @param body The search criteria
     * @return The search results of ListingStatuses based on the criteria
     */
    searchListingStatuses(body: SearchRequestDTO_listingStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/listingstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchListingStatuses(_response);
        });
    }

    protected processSearchListingStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ListingTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ListingTypes
     * @return The list of ListingTypes
     */
    getListingTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/listingtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingTypes(_response);
        });
    }

    protected processGetListingTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ListingType
     * @param body The ListingType data to create
     * @return The newly created ListingType data
     */
    createListingType(body: ListingTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_listingTypeDTO> {
        let url_ = this.baseUrl + "/listingtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateListingType(_response);
        });
    }

    protected processCreateListingType(response: AxiosResponse): Promise<ApiResponse_listingTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_listingTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingTypeDTO>(null as any);
    }

    /**
     * Retrieve a ListingType by ID
     * @param id The ID of the ListingType to retrieve
     * @return The ListingType data
     */
    getListingTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_listingTypeDTO> {
        let url_ = this.baseUrl + "/listingtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingTypeById(_response);
        });
    }

    protected processGetListingTypeById(response: AxiosResponse): Promise<ApiResponse_listingTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_listingTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingTypeDTO>(null as any);
    }

    /**
     * Update a ListingType by ID
     * @param id The ID of the ListingType to update
     * @param body The updated ListingType data
     * @return The updated ListingType data
     */
    updateListingType(id: string, body: ListingTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_listingTypeDTO> {
        let url_ = this.baseUrl + "/listingtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateListingType(_response);
        });
    }

    protected processUpdateListingType(response: AxiosResponse): Promise<ApiResponse_listingTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_listingTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_listingTypeDTO>(null as any);
    }

    /**
     * Delete a ListingType by ID
     * @param id The ID of the ListingType to delete
     */
    deleteListingType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/listingtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListingType(_response);
        });
    }

    protected processDeleteListingType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ListingTypes based on criteria
     * @param body The search criteria
     * @return The search results of ListingTypes based on the criteria
     */
    searchListingTypes(body: SearchRequestDTO_listingTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/listingtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchListingTypes(_response);
        });
    }

    protected processSearchListingTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberAdditionalDocumentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberAdditionalDocuments
     * @return The list of MemberAdditionalDocuments
     */
    getMemberAdditionalDocuments( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberadditionaldocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberAdditionalDocuments(_response);
        });
    }

    protected processGetMemberAdditionalDocuments(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberAdditionalDocument
     * @param body The MemberAdditionalDocument data to create
     * @return The newly created MemberAdditionalDocument data
     */
    createMemberAdditionalDocument(body: MemberAdditionalDocumentDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberAdditionalDocumentDTO> {
        let url_ = this.baseUrl + "/memberadditionaldocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberAdditionalDocument(_response);
        });
    }

    protected processCreateMemberAdditionalDocument(response: AxiosResponse): Promise<ApiResponse_memberAdditionalDocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberAdditionalDocumentDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberAdditionalDocumentDTO>(null as any);
    }

    /**
     * Retrieve a MemberAdditionalDocument by ID
     * @param id The ID of the MemberAdditionalDocument to retrieve
     * @return The MemberAdditionalDocument data
     */
    getMemberAdditionalDocumentById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberAdditionalDocumentDTO> {
        let url_ = this.baseUrl + "/memberadditionaldocument/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberAdditionalDocumentById(_response);
        });
    }

    protected processGetMemberAdditionalDocumentById(response: AxiosResponse): Promise<ApiResponse_memberAdditionalDocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberAdditionalDocumentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberAdditionalDocumentDTO>(null as any);
    }

    /**
     * Update a MemberAdditionalDocument by ID
     * @param id The ID of the MemberAdditionalDocument to update
     * @param body The updated MemberAdditionalDocument data
     * @return The updated MemberAdditionalDocument data
     */
    updateMemberAdditionalDocument(id: string, body: MemberAdditionalDocumentDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberAdditionalDocumentDTO> {
        let url_ = this.baseUrl + "/memberadditionaldocument/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberAdditionalDocument(_response);
        });
    }

    protected processUpdateMemberAdditionalDocument(response: AxiosResponse): Promise<ApiResponse_memberAdditionalDocumentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberAdditionalDocumentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberAdditionalDocumentDTO>(null as any);
    }

    /**
     * Delete a MemberAdditionalDocument by ID
     * @param id The ID of the MemberAdditionalDocument to delete
     */
    deleteMemberAdditionalDocument(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberadditionaldocument/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberAdditionalDocument(_response);
        });
    }

    protected processDeleteMemberAdditionalDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberAdditionalDocuments based on criteria
     * @param body The search criteria
     * @return The search results of MemberAdditionalDocuments based on the criteria
     */
    searchMemberAdditionalDocuments(body: SearchRequestDTO_memberAdditionalDocumentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberadditionaldocument/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberAdditionalDocuments(_response);
        });
    }

    protected processSearchMemberAdditionalDocuments(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberAdditionalDocuments based on search criteria
     * @param body The search criteria
     * @return The export results of MemberAdditionalDocuments based on the search criteria
     */
    exportMemberAdditionalDocuments(body: SearchRequestDTO_memberAdditionalDocumentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberadditionaldocument/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberAdditionalDocuments(_response);
        });
    }

    protected processExportMemberAdditionalDocuments(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberCancelReasonClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberCancelReasons
     * @return The list of MemberCancelReasons
     */
    getMemberCancelReasons( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membercancelreason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCancelReasons(_response);
        });
    }

    protected processGetMemberCancelReasons(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberCancelReason
     * @param body The MemberCancelReason data to create
     * @return The newly created MemberCancelReason data
     */
    createMemberCancelReason(body: MemberCancelReasonDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCancelReasonDTO> {
        let url_ = this.baseUrl + "/membercancelreason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberCancelReason(_response);
        });
    }

    protected processCreateMemberCancelReason(response: AxiosResponse): Promise<ApiResponse_memberCancelReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberCancelReasonDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCancelReasonDTO>(null as any);
    }

    /**
     * Retrieve a MemberCancelReason by ID
     * @param id The ID of the MemberCancelReason to retrieve
     * @return The MemberCancelReason data
     */
    getMemberCancelReasonById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberCancelReasonDTO> {
        let url_ = this.baseUrl + "/membercancelreason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCancelReasonById(_response);
        });
    }

    protected processGetMemberCancelReasonById(response: AxiosResponse): Promise<ApiResponse_memberCancelReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCancelReasonDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCancelReasonDTO>(null as any);
    }

    /**
     * Update a MemberCancelReason by ID
     * @param id The ID of the MemberCancelReason to update
     * @param body The updated MemberCancelReason data
     * @return The updated MemberCancelReason data
     */
    updateMemberCancelReason(id: string, body: MemberCancelReasonDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCancelReasonDTO> {
        let url_ = this.baseUrl + "/membercancelreason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberCancelReason(_response);
        });
    }

    protected processUpdateMemberCancelReason(response: AxiosResponse): Promise<ApiResponse_memberCancelReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCancelReasonDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCancelReasonDTO>(null as any);
    }

    /**
     * Delete a MemberCancelReason by ID
     * @param id The ID of the MemberCancelReason to delete
     */
    deleteMemberCancelReason(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membercancelreason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberCancelReason(_response);
        });
    }

    protected processDeleteMemberCancelReason(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberCancelReasons based on criteria
     * @param body The search criteria
     * @return The search results of MemberCancelReasons based on the criteria
     */
    searchMemberCancelReasons(body: SearchRequestDTO_memberCancelReasonSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membercancelreason/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberCancelReasons(_response);
        });
    }

    protected processSearchMemberCancelReasons(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberCategories
     * @return The list of MemberCategories
     */
    getMemberCategories( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membercategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCategories(_response);
        });
    }

    protected processGetMemberCategories(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberCategory
     * @param body The MemberCategory data to create
     * @return The newly created MemberCategory data
     */
    createMemberCategory(body: MemberCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCategoryDTO> {
        let url_ = this.baseUrl + "/membercategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberCategory(_response);
        });
    }

    protected processCreateMemberCategory(response: AxiosResponse): Promise<ApiResponse_memberCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberCategoryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCategoryDTO>(null as any);
    }

    /**
     * Retrieve a MemberCategory by ID
     * @param id The ID of the MemberCategory to retrieve
     * @return The MemberCategory data
     */
    getMemberCategoryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberCategoryDTO> {
        let url_ = this.baseUrl + "/membercategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCategoryById(_response);
        });
    }

    protected processGetMemberCategoryById(response: AxiosResponse): Promise<ApiResponse_memberCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCategoryDTO>(null as any);
    }

    /**
     * Update a MemberCategory by ID
     * @param id The ID of the MemberCategory to update
     * @param body The updated MemberCategory data
     * @return The updated MemberCategory data
     */
    updateMemberCategory(id: string, body: MemberCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCategoryDTO> {
        let url_ = this.baseUrl + "/membercategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberCategory(_response);
        });
    }

    protected processUpdateMemberCategory(response: AxiosResponse): Promise<ApiResponse_memberCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCategoryDTO>(null as any);
    }

    /**
     * Delete a MemberCategory by ID
     * @param id The ID of the MemberCategory to delete
     */
    deleteMemberCategory(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membercategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberCategory(_response);
        });
    }

    protected processDeleteMemberCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberCategories based on criteria
     * @param body The search criteria
     * @return The search results of MemberCategories based on the criteria
     */
    searchMemberCategories(body: SearchRequestDTO_memberCategorySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membercategory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberCategories(_response);
        });
    }

    protected processSearchMemberCategories(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberCompetencyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberCompetencies
     * @return The list of MemberCompetencies
     */
    getMemberCompetencies( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membercompetency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCompetencies(_response);
        });
    }

    protected processGetMemberCompetencies(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberCompetency
     * @param body The MemberCompetency data to create
     * @return The newly created MemberCompetency data
     */
    createMemberCompetency(body: MemberCompetencyDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCompetencyDTO> {
        let url_ = this.baseUrl + "/membercompetency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberCompetency(_response);
        });
    }

    protected processCreateMemberCompetency(response: AxiosResponse): Promise<ApiResponse_memberCompetencyDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberCompetencyDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCompetencyDTO>(null as any);
    }

    /**
     * Retrieve a MemberCompetency by ID
     * @param id The ID of the MemberCompetency to retrieve
     * @return The MemberCompetency data
     */
    getMemberCompetencyById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberCompetencyDTO> {
        let url_ = this.baseUrl + "/membercompetency/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCompetencyById(_response);
        });
    }

    protected processGetMemberCompetencyById(response: AxiosResponse): Promise<ApiResponse_memberCompetencyDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCompetencyDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCompetencyDTO>(null as any);
    }

    /**
     * Update a MemberCompetency by ID
     * @param id The ID of the MemberCompetency to update
     * @param body The updated MemberCompetency data
     * @return The updated MemberCompetency data
     */
    updateMemberCompetency(id: string, body: MemberCompetencyDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCompetencyDTO> {
        let url_ = this.baseUrl + "/membercompetency/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberCompetency(_response);
        });
    }

    protected processUpdateMemberCompetency(response: AxiosResponse): Promise<ApiResponse_memberCompetencyDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCompetencyDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCompetencyDTO>(null as any);
    }

    /**
     * Delete a MemberCompetency by ID
     * @param id The ID of the MemberCompetency to delete
     */
    deleteMemberCompetency(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membercompetency/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberCompetency(_response);
        });
    }

    protected processDeleteMemberCompetency(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create multiple MemberCompetencies
     * @param body The list of MemberCompetency data to create
     * @return Whether the MemberCompetency records were created successfully
     */
    createBulkMemberCompetency(body: MemberCompetencyDTO[], cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/membercompetency/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkMemberCompetency(_response);
        });
    }

    protected processCreateBulkMemberCompetency(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_boolean>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Search MemberCompetencies based on criteria
     * @param body The search criteria
     * @return The search results of MemberCompetencies based on the criteria
     */
    searchMemberCompetencies(body: SearchRequestDTO_memberCompetencySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membercompetency/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberCompetencies(_response);
        });
    }

    protected processSearchMemberCompetencies(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberDisciplinaryStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberDisciplinaryStatuses
     * @return The list of MemberDisciplinaryStatuses
     */
    getMemberDisciplinaryStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberdisciplinarystatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberDisciplinaryStatuses(_response);
        });
    }

    protected processGetMemberDisciplinaryStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberDisciplinaryStatus
     * @param body The MemberDisciplinaryStatus data to create
     * @return The newly created MemberDisciplinaryStatus data
     */
    createMemberDisciplinaryStatus(body: MemberDisciplinaryStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDisciplinaryStatusDTO> {
        let url_ = this.baseUrl + "/memberdisciplinarystatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberDisciplinaryStatus(_response);
        });
    }

    protected processCreateMemberDisciplinaryStatus(response: AxiosResponse): Promise<ApiResponse_memberDisciplinaryStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberDisciplinaryStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDisciplinaryStatusDTO>(null as any);
    }

    /**
     * Retrieve a MemberDisciplinaryStatus by ID
     * @param id The ID of the MemberDisciplinaryStatus to retrieve
     * @return The MemberDisciplinaryStatus data
     */
    getMemberDisciplinaryStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDisciplinaryStatusDTO> {
        let url_ = this.baseUrl + "/memberdisciplinarystatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberDisciplinaryStatusById(_response);
        });
    }

    protected processGetMemberDisciplinaryStatusById(response: AxiosResponse): Promise<ApiResponse_memberDisciplinaryStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDisciplinaryStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDisciplinaryStatusDTO>(null as any);
    }

    /**
     * Update a MemberDisciplinaryStatus by ID
     * @param id The ID of the MemberDisciplinaryStatus to update
     * @param body The updated MemberDisciplinaryStatus data
     * @return The updated MemberDisciplinaryStatus data
     */
    updateMemberDisciplinaryStatus(id: string, body: MemberDisciplinaryStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDisciplinaryStatusDTO> {
        let url_ = this.baseUrl + "/memberdisciplinarystatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberDisciplinaryStatus(_response);
        });
    }

    protected processUpdateMemberDisciplinaryStatus(response: AxiosResponse): Promise<ApiResponse_memberDisciplinaryStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDisciplinaryStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDisciplinaryStatusDTO>(null as any);
    }

    /**
     * Delete a MemberDisciplinaryStatus by ID
     * @param id The ID of the MemberDisciplinaryStatus to delete
     */
    deleteMemberDisciplinaryStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberdisciplinarystatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberDisciplinaryStatus(_response);
        });
    }

    protected processDeleteMemberDisciplinaryStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberDisciplinaryStatuses based on criteria
     * @param body The search criteria
     * @return The search results of MemberDisciplinaryStatuses based on the criteria
     */
    searchMemberDisciplinaryStatuses(body: SearchRequestDTO_memberDisciplinaryStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberdisciplinarystatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberDisciplinaryStatuses(_response);
        });
    }

    protected processSearchMemberDisciplinaryStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberEndorsementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberEndorsements
     * @return The list of MemberEndorsements
     */
    getMemberEndorsements( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberendorsement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsements(_response);
        });
    }

    protected processGetMemberEndorsements(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberEndorsement
     * @param body The MemberEndorsement data to create
     * @return The newly created MemberEndorsement data
     */
    createMemberEndorsement(body: MemberEndorsementDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberEndorsementDTO> {
        let url_ = this.baseUrl + "/memberendorsement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberEndorsement(_response);
        });
    }

    protected processCreateMemberEndorsement(response: AxiosResponse): Promise<ApiResponse_memberEndorsementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberEndorsementDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberEndorsementDTO>(null as any);
    }

    /**
     * Retrieve a MemberEndorsement by ID
     * @param id The ID of the MemberEndorsement to retrieve
     * @return The MemberEndorsement data
     */
    getMemberEndorsementById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberEndorsementDTO> {
        let url_ = this.baseUrl + "/memberendorsement/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsementById(_response);
        });
    }

    protected processGetMemberEndorsementById(response: AxiosResponse): Promise<ApiResponse_memberEndorsementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberEndorsementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberEndorsementDTO>(null as any);
    }

    /**
     * Update a MemberEndorsement by ID
     * @param id The ID of the MemberEndorsement to update
     * @param body The updated MemberEndorsement data
     * @return The updated MemberEndorsement data
     */
    updateMemberEndorsement(id: string, body: MemberEndorsementDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberEndorsementDTO> {
        let url_ = this.baseUrl + "/memberendorsement/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberEndorsement(_response);
        });
    }

    protected processUpdateMemberEndorsement(response: AxiosResponse): Promise<ApiResponse_memberEndorsementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberEndorsementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberEndorsementDTO>(null as any);
    }

    /**
     * Delete a MemberEndorsement by ID
     * @param id The ID of the MemberEndorsement to delete
     */
    deleteMemberEndorsement(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberendorsement/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberEndorsement(_response);
        });
    }

    protected processDeleteMemberEndorsement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve MemberEndorsement feedback HTML
     * @param id The ID of the MemberEndorsement
     * @return The feedback HTML content, or null if none exists
     */
    getMemberEndorsementFeedback(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberendorsement/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsementFeedback(_response);
        });
    }

    protected processGetMemberEndorsementFeedback(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Update MemberEndorsement Status (Bulk)
     * @param body The status update data
     * @return The number of endorsements successfully updated
     */
    updateMemberEndorsementStatus(body: UpdateMemberEndorsementStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/memberendorsement/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberEndorsementStatus(_response);
        });
    }

    protected processUpdateMemberEndorsementStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Search MemberEndorsements based on criteria
     * @param body The search criteria
     * @return The search results of MemberEndorsements based on the criteria
     */
    searchMemberEndorsements(body: SearchRequestDTO_memberEndorsementSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberendorsement/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberEndorsements(_response);
        });
    }

    protected processSearchMemberEndorsements(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Generate and get certificate URL
     * @param id The ID of the MemberEndorsement
     * @return The URL of the generated certificate
     */
    getMemberEndorsementCertificate(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberendorsement/{id}/certificate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsementCertificate(_response);
        });
    }

    protected processGetMemberEndorsementCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate and get declaration URL
     * @param id The ID of the MemberEndorsement
     * @return The URL of the generated declaration
     */
    getMemberEndorsementDeclaration(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberendorsement/{id}/declaration";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsementDeclaration(_response);
        });
    }

    protected processGetMemberEndorsementDeclaration(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate and get HTML certificate content
     * @param id The ID of the MemberEndorsement
     * @return The HTML content of the generated certificate
     */
    getMemberEndorsementHtmlCertificate(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberendorsement/{id}/certificate/html";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsementHtmlCertificate(_response);
        });
    }

    protected processGetMemberEndorsementHtmlCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Restore a MemberEndorsement from deleted by ID
     * @param id The ID of the MemberEndorsement to restore from deleted
     * @return The restored MemberEndorsement data
     */
    restoreFromDeletedEndorsement(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberEndorsementDTO> {
        let url_ = this.baseUrl + "/memberendorsement/{id}/restore-deleted";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromDeletedEndorsement(_response);
        });
    }

    protected processRestoreFromDeletedEndorsement(response: AxiosResponse): Promise<ApiResponse_memberEndorsementDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberEndorsementDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberEndorsementDTO>(null as any);
    }

    /**
     * Get distinct years for member endorsements
     * @return Distinct years in descending order
     */
    getMemberEndorsementYears( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberendorsement/years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberEndorsementYears(_response);
        });
    }

    protected processGetMemberEndorsementYears(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Export MemberEndorsements based on search criteria
     * @param body The search criteria
     * @return The export results of MemberEndorsements based on the search criteria
     */
    exportMemberEndorsements(body: SearchRequestDTO_memberEndorsementSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberendorsement/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberEndorsements(_response);
        });
    }

    protected processExportMemberEndorsements(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberFeeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberFees
     * @return The list of MemberFees
     */
    getMemberFees( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberfee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberFees(_response);
        });
    }

    protected processGetMemberFees(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberFee
     * @param body The MemberFee data to create
     * @return The newly created MemberFee data
     */
    createMemberFee(body: MemberFeeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberFeeDTO> {
        let url_ = this.baseUrl + "/memberfee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberFee(_response);
        });
    }

    protected processCreateMemberFee(response: AxiosResponse): Promise<ApiResponse_memberFeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberFeeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFeeDTO>(null as any);
    }

    /**
     * Retrieve a MemberFee by ID
     * @param id The ID of the MemberFee to retrieve
     * @return The MemberFee data
     */
    getMemberFeeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberFeeDTO> {
        let url_ = this.baseUrl + "/memberfee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberFeeById(_response);
        });
    }

    protected processGetMemberFeeById(response: AxiosResponse): Promise<ApiResponse_memberFeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberFeeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFeeDTO>(null as any);
    }

    /**
     * Update a MemberFee by ID
     * @param id The ID of the MemberFee to update
     * @param body The updated MemberFee data
     * @return The updated MemberFee data
     */
    updateMemberFee(id: string, body: MemberFeeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberFeeDTO> {
        let url_ = this.baseUrl + "/memberfee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberFee(_response);
        });
    }

    protected processUpdateMemberFee(response: AxiosResponse): Promise<ApiResponse_memberFeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberFeeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFeeDTO>(null as any);
    }

    /**
     * Delete a MemberFee by ID
     * @param id The ID of the MemberFee to delete
     */
    deleteMemberFee(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberfee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberFee(_response);
        });
    }

    protected processDeleteMemberFee(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberFees based on criteria
     * @param body The search criteria
     * @return The search results of MemberFees based on the criteria
     */
    searchMemberFees(body: SearchRequestDTO_memberFeeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberfee/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberFees(_response);
        });
    }

    protected processSearchMemberFees(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberFees based on search criteria
     * @param body The search criteria
     * @return The export results of MemberFees based on the search criteria
     */
    exportMemberFees(body: SearchRequestDTO_memberFeeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberfee/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberFees(_response);
        });
    }

    protected processExportMemberFees(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberFirearmClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberFirearms
     * @return The list of MemberFirearms
     */
    getMemberFirearms( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberfirearm";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberFirearms(_response);
        });
    }

    protected processGetMemberFirearms(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberFirearm
     * @param body The MemberFirearm data to create
     * @return The newly created MemberFirearm data
     */
    createMemberFirearm(body: MemberFirearmDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberFirearmDTO> {
        let url_ = this.baseUrl + "/memberfirearm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberFirearm(_response);
        });
    }

    protected processCreateMemberFirearm(response: AxiosResponse): Promise<ApiResponse_memberFirearmDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberFirearmDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFirearmDTO>(null as any);
    }

    /**
     * Retrieve a MemberFirearm by ID
     * @param id The ID of the MemberFirearm to retrieve
     * @return The MemberFirearm data
     */
    getMemberFirearmById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberFirearmDTO> {
        let url_ = this.baseUrl + "/memberfirearm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberFirearmById(_response);
        });
    }

    protected processGetMemberFirearmById(response: AxiosResponse): Promise<ApiResponse_memberFirearmDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberFirearmDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFirearmDTO>(null as any);
    }

    /**
     * Update a MemberFirearm by ID
     * @param id The ID of the MemberFirearm to update
     * @param body The updated MemberFirearm data
     * @return The updated MemberFirearm data
     */
    updateMemberFirearm(id: string, body: MemberFirearmDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberFirearmDTO> {
        let url_ = this.baseUrl + "/memberfirearm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberFirearm(_response);
        });
    }

    protected processUpdateMemberFirearm(response: AxiosResponse): Promise<ApiResponse_memberFirearmDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberFirearmDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFirearmDTO>(null as any);
    }

    /**
     * Delete a MemberFirearm by ID
     * @param id The ID of the MemberFirearm to delete
     */
    deleteMemberFirearm(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberfirearm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberFirearm(_response);
        });
    }

    protected processDeleteMemberFirearm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberFirearms based on criteria
     * @param body The search criteria
     * @return The search results of MemberFirearms based on the criteria
     */
    searchMemberFirearms(body: SearchRequestDTO_memberFirearmSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberfirearm/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberFirearms(_response);
        });
    }

    protected processSearchMemberFirearms(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Member firearms based on search criteria
     * @param body The search criteria
     * @return The export results of Member firearms based on the search criteria
     */
    exportMemberFireamrs(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberfirearm/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberFireamrs(_response);
        });
    }

    protected processExportMemberFireamrs(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberIdTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberIdTypes
     * @return The list of MemberIdTypes
     */
    getMemberIdTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberidtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberIdTypes(_response);
        });
    }

    protected processGetMemberIdTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberIdType
     * @param body The MemberIdType data to create
     * @return The newly created MemberIdType data
     */
    createMemberIdType(body: MemberIdTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberIdTypeDTO> {
        let url_ = this.baseUrl + "/memberidtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberIdType(_response);
        });
    }

    protected processCreateMemberIdType(response: AxiosResponse): Promise<ApiResponse_memberIdTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberIdTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberIdTypeDTO>(null as any);
    }

    /**
     * Retrieve a MemberIdType by ID
     * @param id The ID of the MemberIdType to retrieve
     * @return The MemberIdType data
     */
    getMemberIdTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberIdTypeDTO> {
        let url_ = this.baseUrl + "/memberidtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberIdTypeById(_response);
        });
    }

    protected processGetMemberIdTypeById(response: AxiosResponse): Promise<ApiResponse_memberIdTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberIdTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberIdTypeDTO>(null as any);
    }

    /**
     * Update a MemberIdType by ID
     * @param id The ID of the MemberIdType to update
     * @param body The updated MemberIdType data
     * @return The updated MemberIdType data
     */
    updateMemberIdType(id: string, body: MemberIdTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberIdTypeDTO> {
        let url_ = this.baseUrl + "/memberidtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberIdType(_response);
        });
    }

    protected processUpdateMemberIdType(response: AxiosResponse): Promise<ApiResponse_memberIdTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberIdTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberIdTypeDTO>(null as any);
    }

    /**
     * Delete a MemberIdType by ID
     * @param id The ID of the MemberIdType to delete
     */
    deleteMemberIdType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberidtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberIdType(_response);
        });
    }

    protected processDeleteMemberIdType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberIdTypes based on criteria
     * @param body The search criteria
     * @return The search results of MemberIdTypes based on the criteria
     */
    searchMemberIdTypes(body: SearchRequestDTO_memberIdTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberidtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberIdTypes(_response);
        });
    }

    protected processSearchMemberIdTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberReferralTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberReferralTypes
     * @return The list of MemberReferralTypes
     */
    getMemberReferralTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberreferraltype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberReferralTypes(_response);
        });
    }

    protected processGetMemberReferralTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberReferralType
     * @param body The MemberReferralType data to create
     * @return The newly created MemberReferralType data
     */
    createMemberReferralType(body: MemberReferralTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberReferralTypeDTO> {
        let url_ = this.baseUrl + "/memberreferraltype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberReferralType(_response);
        });
    }

    protected processCreateMemberReferralType(response: AxiosResponse): Promise<ApiResponse_memberReferralTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberReferralTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberReferralTypeDTO>(null as any);
    }

    /**
     * Retrieve a MemberReferralType by ID
     * @param id The ID of the MemberReferralType to retrieve
     * @return The MemberReferralType data
     */
    getMemberReferralTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberReferralTypeDTO> {
        let url_ = this.baseUrl + "/memberreferraltype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberReferralTypeById(_response);
        });
    }

    protected processGetMemberReferralTypeById(response: AxiosResponse): Promise<ApiResponse_memberReferralTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberReferralTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberReferralTypeDTO>(null as any);
    }

    /**
     * Update a MemberReferralType by ID
     * @param id The ID of the MemberReferralType to update
     * @param body The updated MemberReferralType data
     * @return The updated MemberReferralType data
     */
    updateMemberReferralType(id: string, body: MemberReferralTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberReferralTypeDTO> {
        let url_ = this.baseUrl + "/memberreferraltype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberReferralType(_response);
        });
    }

    protected processUpdateMemberReferralType(response: AxiosResponse): Promise<ApiResponse_memberReferralTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberReferralTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberReferralTypeDTO>(null as any);
    }

    /**
     * Delete a MemberReferralType by ID
     * @param id The ID of the MemberReferralType to delete
     */
    deleteMemberReferralType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberreferraltype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberReferralType(_response);
        });
    }

    protected processDeleteMemberReferralType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberReferralTypes based on criteria
     * @param body The search criteria
     * @return The search results of MemberReferralTypes based on the criteria
     */
    searchMemberReferralTypes(body: SearchRequestDTO_memberReferralTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberreferraltype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberReferralTypes(_response);
        });
    }

    protected processSearchMemberReferralTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberRegistrationStepClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberRegistrationSteps
     * @return The list of MemberRegistrationSteps
     */
    getMemberRegistrationSteps( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberregistrationstep";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberRegistrationSteps(_response);
        });
    }

    protected processGetMemberRegistrationSteps(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberRegistrationStep
     * @param body The MemberRegistrationStep data to create
     * @return The newly created MemberRegistrationStep data
     */
    createMemberRegistrationStep(body: MemberRegistrationStepDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberRegistrationStepDTO> {
        let url_ = this.baseUrl + "/memberregistrationstep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberRegistrationStep(_response);
        });
    }

    protected processCreateMemberRegistrationStep(response: AxiosResponse): Promise<ApiResponse_memberRegistrationStepDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberRegistrationStepDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegistrationStepDTO>(null as any);
    }

    /**
     * Retrieve a MemberRegistrationStep by ID
     * @param id The ID of the MemberRegistrationStep to retrieve
     * @return The MemberRegistrationStep data
     */
    getMemberRegistrationStepById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberRegistrationStepDTO> {
        let url_ = this.baseUrl + "/memberregistrationstep/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberRegistrationStepById(_response);
        });
    }

    protected processGetMemberRegistrationStepById(response: AxiosResponse): Promise<ApiResponse_memberRegistrationStepDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberRegistrationStepDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegistrationStepDTO>(null as any);
    }

    /**
     * Update a MemberRegistrationStep by ID
     * @param id The ID of the MemberRegistrationStep to update
     * @param body The updated MemberRegistrationStep data
     * @return The updated MemberRegistrationStep data
     */
    updateMemberRegistrationStep(id: string, body: MemberRegistrationStepDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberRegistrationStepDTO> {
        let url_ = this.baseUrl + "/memberregistrationstep/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberRegistrationStep(_response);
        });
    }

    protected processUpdateMemberRegistrationStep(response: AxiosResponse): Promise<ApiResponse_memberRegistrationStepDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberRegistrationStepDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegistrationStepDTO>(null as any);
    }

    /**
     * Delete a MemberRegistrationStep by ID
     * @param id The ID of the MemberRegistrationStep to delete
     */
    deleteMemberRegistrationStep(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberregistrationstep/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberRegistrationStep(_response);
        });
    }

    protected processDeleteMemberRegistrationStep(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberRegistrationSteps based on criteria
     * @param body The search criteria
     * @return The search results of MemberRegistrationSteps based on the criteria
     */
    searchMemberRegistrationSteps(body: SearchRequestDTO_memberRegistrationStepSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberregistrationstep/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberRegistrationSteps(_response);
        });
    }

    protected processSearchMemberRegistrationSteps(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberRegistrationTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberRegistrationTypes
     * @return The list of MemberRegistrationTypes
     */
    getMemberRegistrationTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberregistrationtype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberRegistrationTypes(_response);
        });
    }

    protected processGetMemberRegistrationTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberRegistrationType
     * @param body The MemberRegistrationType data to create
     * @return The newly created MemberRegistrationType data
     */
    createMemberRegistrationType(body: MemberRegistrationTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberRegistrationTypeDTO> {
        let url_ = this.baseUrl + "/memberregistrationtype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberRegistrationType(_response);
        });
    }

    protected processCreateMemberRegistrationType(response: AxiosResponse): Promise<ApiResponse_memberRegistrationTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberRegistrationTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegistrationTypeDTO>(null as any);
    }

    /**
     * Retrieve a MemberRegistrationType by ID
     * @param id The ID of the MemberRegistrationType to retrieve
     * @return The MemberRegistrationType data
     */
    getMemberRegistrationTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberRegistrationTypeDTO> {
        let url_ = this.baseUrl + "/memberregistrationtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberRegistrationTypeById(_response);
        });
    }

    protected processGetMemberRegistrationTypeById(response: AxiosResponse): Promise<ApiResponse_memberRegistrationTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberRegistrationTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegistrationTypeDTO>(null as any);
    }

    /**
     * Update a MemberRegistrationType by ID
     * @param id The ID of the MemberRegistrationType to update
     * @param body The updated MemberRegistrationType data
     * @return The updated MemberRegistrationType data
     */
    updateMemberRegistrationType(id: string, body: MemberRegistrationTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberRegistrationTypeDTO> {
        let url_ = this.baseUrl + "/memberregistrationtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberRegistrationType(_response);
        });
    }

    protected processUpdateMemberRegistrationType(response: AxiosResponse): Promise<ApiResponse_memberRegistrationTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberRegistrationTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegistrationTypeDTO>(null as any);
    }

    /**
     * Delete a MemberRegistrationType by ID
     * @param id The ID of the MemberRegistrationType to delete
     */
    deleteMemberRegistrationType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberregistrationtype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberRegistrationType(_response);
        });
    }

    protected processDeleteMemberRegistrationType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberRegistrationTypes based on criteria
     * @param body The search criteria
     * @return The search results of MemberRegistrationTypes based on the criteria
     */
    searchMemberRegistrationTypes(body: SearchRequestDTO_memberRegistrationTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberregistrationtype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberRegistrationTypes(_response);
        });
    }

    protected processSearchMemberRegistrationTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberStatuses
     * @return The list of MemberStatuses
     */
    getMemberStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberStatuses(_response);
        });
    }

    protected processGetMemberStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberStatus
     * @param body The MemberStatus data to create
     * @return The newly created MemberStatus data
     */
    createMemberStatus(body: MemberStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberStatusDTO> {
        let url_ = this.baseUrl + "/memberstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberStatus(_response);
        });
    }

    protected processCreateMemberStatus(response: AxiosResponse): Promise<ApiResponse_memberStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberStatusDTO>(null as any);
    }

    /**
     * Retrieve a MemberStatus by ID
     * @param id The ID of the MemberStatus to retrieve
     * @return The MemberStatus data
     */
    getMemberStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberStatusDTO> {
        let url_ = this.baseUrl + "/memberstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberStatusById(_response);
        });
    }

    protected processGetMemberStatusById(response: AxiosResponse): Promise<ApiResponse_memberStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberStatusDTO>(null as any);
    }

    /**
     * Update a MemberStatus by ID
     * @param id The ID of the MemberStatus to update
     * @param body The updated MemberStatus data
     * @return The updated MemberStatus data
     */
    updateMemberStatus(id: string, body: MemberStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberStatusDTO> {
        let url_ = this.baseUrl + "/memberstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberStatus(_response);
        });
    }

    protected processUpdateMemberStatus(response: AxiosResponse): Promise<ApiResponse_memberStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberStatusDTO>(null as any);
    }

    /**
     * Delete a MemberStatus by ID
     * @param id The ID of the MemberStatus to delete
     */
    deleteMemberStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberStatus(_response);
        });
    }

    protected processDeleteMemberStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberStatuses based on criteria
     * @param body The search criteria
     * @return The search results of MemberStatuses based on the criteria
     */
    searchMemberStatuses(body: SearchRequestDTO_memberStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberStatuses(_response);
        });
    }

    protected processSearchMemberStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberTerminationStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberTerminationStatuses
     * @return The list of MemberTerminationStatuses
     */
    getMemberTerminationStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberterminationstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTerminationStatuses(_response);
        });
    }

    protected processGetMemberTerminationStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberTerminationStatus
     * @param body The MemberTerminationStatus data to create
     * @return The newly created MemberTerminationStatus data
     */
    createMemberTerminationStatus(body: MemberTerminationStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTerminationStatusDTO> {
        let url_ = this.baseUrl + "/memberterminationstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberTerminationStatus(_response);
        });
    }

    protected processCreateMemberTerminationStatus(response: AxiosResponse): Promise<ApiResponse_memberTerminationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberTerminationStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTerminationStatusDTO>(null as any);
    }

    /**
     * Retrieve a MemberTerminationStatus by ID
     * @param id The ID of the MemberTerminationStatus to retrieve
     * @return The MemberTerminationStatus data
     */
    getMemberTerminationStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberTerminationStatusDTO> {
        let url_ = this.baseUrl + "/memberterminationstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTerminationStatusById(_response);
        });
    }

    protected processGetMemberTerminationStatusById(response: AxiosResponse): Promise<ApiResponse_memberTerminationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTerminationStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTerminationStatusDTO>(null as any);
    }

    /**
     * Update a MemberTerminationStatus by ID
     * @param id The ID of the MemberTerminationStatus to update
     * @param body The updated MemberTerminationStatus data
     * @return The updated MemberTerminationStatus data
     */
    updateMemberTerminationStatus(id: string, body: MemberTerminationStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTerminationStatusDTO> {
        let url_ = this.baseUrl + "/memberterminationstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberTerminationStatus(_response);
        });
    }

    protected processUpdateMemberTerminationStatus(response: AxiosResponse): Promise<ApiResponse_memberTerminationStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTerminationStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTerminationStatusDTO>(null as any);
    }

    /**
     * Delete a MemberTerminationStatus by ID
     * @param id The ID of the MemberTerminationStatus to delete
     */
    deleteMemberTerminationStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberterminationstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberTerminationStatus(_response);
        });
    }

    protected processDeleteMemberTerminationStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberTerminationStatuses based on criteria
     * @param body The search criteria
     * @return The search results of MemberTerminationStatuses based on the criteria
     */
    searchMemberTerminationStatuses(body: SearchRequestDTO_memberTerminationStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberterminationstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberTerminationStatuses(_response);
        });
    }

    protected processSearchMemberTerminationStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberTitleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberTitles
     * @return The list of MemberTitles
     */
    getMemberTitles( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membertitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTitles(_response);
        });
    }

    protected processGetMemberTitles(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberTitle
     * @param body The MemberTitle data to create
     * @return The newly created MemberTitle data
     */
    createMemberTitle(body: MemberTitleDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTitleDTO> {
        let url_ = this.baseUrl + "/membertitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberTitle(_response);
        });
    }

    protected processCreateMemberTitle(response: AxiosResponse): Promise<ApiResponse_memberTitleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberTitleDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTitleDTO>(null as any);
    }

    /**
     * Retrieve a MemberTitle by ID
     * @param id The ID of the MemberTitle to retrieve
     * @return The MemberTitle data
     */
    getMemberTitleById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberTitleDTO> {
        let url_ = this.baseUrl + "/membertitle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTitleById(_response);
        });
    }

    protected processGetMemberTitleById(response: AxiosResponse): Promise<ApiResponse_memberTitleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTitleDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTitleDTO>(null as any);
    }

    /**
     * Update a MemberTitle by ID
     * @param id The ID of the MemberTitle to update
     * @param body The updated MemberTitle data
     * @return The updated MemberTitle data
     */
    updateMemberTitle(id: string, body: MemberTitleDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTitleDTO> {
        let url_ = this.baseUrl + "/membertitle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberTitle(_response);
        });
    }

    protected processUpdateMemberTitle(response: AxiosResponse): Promise<ApiResponse_memberTitleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTitleDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTitleDTO>(null as any);
    }

    /**
     * Delete a MemberTitle by ID
     * @param id The ID of the MemberTitle to delete
     */
    deleteMemberTitle(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membertitle/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberTitle(_response);
        });
    }

    protected processDeleteMemberTitle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberTitles based on criteria
     * @param body The search criteria
     * @return The search results of MemberTitles based on the criteria
     */
    searchMemberTitles(body: SearchRequestDTO_memberTitleSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membertitle/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberTitles(_response);
        });
    }

    protected processSearchMemberTitles(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberTypes
     * @return The list of MemberTypes
     */
    getMemberTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membertype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTypes(_response);
        });
    }

    protected processGetMemberTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberType
     * @param body The MemberType data to create
     * @return The newly created MemberType data
     */
    createMemberType(body: MemberTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTypeDTO> {
        let url_ = this.baseUrl + "/membertype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberType(_response);
        });
    }

    protected processCreateMemberType(response: AxiosResponse): Promise<ApiResponse_memberTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTypeDTO>(null as any);
    }

    /**
     * Retrieve a MemberType by ID
     * @param id The ID of the MemberType to retrieve
     * @return The MemberType data
     */
    getMemberTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberTypeDTO> {
        let url_ = this.baseUrl + "/membertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTypeById(_response);
        });
    }

    protected processGetMemberTypeById(response: AxiosResponse): Promise<ApiResponse_memberTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTypeDTO>(null as any);
    }

    /**
     * Update a MemberType by ID
     * @param id The ID of the MemberType to update
     * @param body The updated MemberType data
     * @return The updated MemberType data
     */
    updateMemberType(id: string, body: MemberTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTypeDTO> {
        let url_ = this.baseUrl + "/membertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberType(_response);
        });
    }

    protected processUpdateMemberType(response: AxiosResponse): Promise<ApiResponse_memberTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTypeDTO>(null as any);
    }

    /**
     * Delete a MemberType by ID
     * @param id The ID of the MemberType to delete
     */
    deleteMemberType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberType(_response);
        });
    }

    protected processDeleteMemberType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberTypes based on criteria
     * @param body The search criteria
     * @return The search results of MemberTypes based on the criteria
     */
    searchMemberTypes(body: SearchRequestDTO_memberTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membertype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberTypes(_response);
        });
    }

    protected processSearchMemberTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MessageTemplateStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MessageTemplateStatuses
     * @return The list of MessageTemplateStatuses
     */
    getMessageTemplateStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/messagetemplatestatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageTemplateStatuses(_response);
        });
    }

    protected processGetMessageTemplateStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MessageTemplateStatus
     * @param body The MessageTemplateStatus data to create
     * @return The newly created MessageTemplateStatus data
     */
    createMessageTemplateStatus(body: MessageTemplateStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_messageTemplateStatusDTO> {
        let url_ = this.baseUrl + "/messagetemplatestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMessageTemplateStatus(_response);
        });
    }

    protected processCreateMessageTemplateStatus(response: AxiosResponse): Promise<ApiResponse_messageTemplateStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_messageTemplateStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_messageTemplateStatusDTO>(null as any);
    }

    /**
     * Retrieve a MessageTemplateStatus by ID
     * @param id The ID of the MessageTemplateStatus to retrieve
     * @return The MessageTemplateStatus data
     */
    getMessageTemplateStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_messageTemplateStatusDTO> {
        let url_ = this.baseUrl + "/messagetemplatestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageTemplateStatusById(_response);
        });
    }

    protected processGetMessageTemplateStatusById(response: AxiosResponse): Promise<ApiResponse_messageTemplateStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_messageTemplateStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_messageTemplateStatusDTO>(null as any);
    }

    /**
     * Update a MessageTemplateStatus by ID
     * @param id The ID of the MessageTemplateStatus to update
     * @param body The updated MessageTemplateStatus data
     * @return The updated MessageTemplateStatus data
     */
    updateMessageTemplateStatus(id: string, body: MessageTemplateStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_messageTemplateStatusDTO> {
        let url_ = this.baseUrl + "/messagetemplatestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMessageTemplateStatus(_response);
        });
    }

    protected processUpdateMessageTemplateStatus(response: AxiosResponse): Promise<ApiResponse_messageTemplateStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_messageTemplateStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_messageTemplateStatusDTO>(null as any);
    }

    /**
     * Delete a MessageTemplateStatus by ID
     * @param id The ID of the MessageTemplateStatus to delete
     */
    deleteMessageTemplateStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/messagetemplatestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMessageTemplateStatus(_response);
        });
    }

    protected processDeleteMessageTemplateStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MessageTemplateStatuses based on criteria
     * @param body The search criteria
     * @return The search results of MessageTemplateStatuses based on the criteria
     */
    searchMessageTemplateStatuses(body: SearchRequestDTO_messageTemplateStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/messagetemplatestatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMessageTemplateStatuses(_response);
        });
    }

    protected processSearchMessageTemplateStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ModuleTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ModuleTypes
     * @return The list of ModuleTypes
     */
    getModuleTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/moduletype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleTypes(_response);
        });
    }

    protected processGetModuleTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ModuleType
     * @param body The ModuleType data to create
     * @return The newly created ModuleType data
     */
    createModuleType(body: ModuleTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_moduleTypeDTO> {
        let url_ = this.baseUrl + "/moduletype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateModuleType(_response);
        });
    }

    protected processCreateModuleType(response: AxiosResponse): Promise<ApiResponse_moduleTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_moduleTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_moduleTypeDTO>(null as any);
    }

    /**
     * Retrieve a ModuleType by ID
     * @param id The ID of the ModuleType to retrieve
     * @return The ModuleType data
     */
    getModuleTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_moduleTypeDTO> {
        let url_ = this.baseUrl + "/moduletype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleTypeById(_response);
        });
    }

    protected processGetModuleTypeById(response: AxiosResponse): Promise<ApiResponse_moduleTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_moduleTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_moduleTypeDTO>(null as any);
    }

    /**
     * Update a ModuleType by ID
     * @param id The ID of the ModuleType to update
     * @param body The updated ModuleType data
     * @return The updated ModuleType data
     */
    updateModuleType(id: string, body: ModuleTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_moduleTypeDTO> {
        let url_ = this.baseUrl + "/moduletype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModuleType(_response);
        });
    }

    protected processUpdateModuleType(response: AxiosResponse): Promise<ApiResponse_moduleTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_moduleTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_moduleTypeDTO>(null as any);
    }

    /**
     * Delete a ModuleType by ID
     * @param id The ID of the ModuleType to delete
     */
    deleteModuleType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/moduletype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModuleType(_response);
        });
    }

    protected processDeleteModuleType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ModuleTypes based on criteria
     * @param body The search criteria
     * @return The search results of ModuleTypes based on the criteria
     */
    searchModuleTypes(body: SearchRequestDTO_moduleTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/moduletype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchModuleTypes(_response);
        });
    }

    protected processSearchModuleTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class NewsItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all NewsItems
     * @return The list of NewsItems
     */
    getNewsItems( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/newsitem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsItems(_response);
        });
    }

    protected processGetNewsItems(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new NewsItem
     * @param body The NewsItem data to create
     * @return The newly created NewsItem data
     */
    createNewsItem(body: NewsItemDTO, cancelToken?: CancelToken): Promise<ApiResponse_newsItemDTO> {
        let url_ = this.baseUrl + "/newsitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewsItem(_response);
        });
    }

    protected processCreateNewsItem(response: AxiosResponse): Promise<ApiResponse_newsItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_newsItemDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsItemDTO>(null as any);
    }

    /**
     * Retrieve a NewsItem by ID
     * @param id The ID of the NewsItem to retrieve
     * @return The NewsItem data
     */
    getNewsItemById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_newsItemDTO> {
        let url_ = this.baseUrl + "/newsitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsItemById(_response);
        });
    }

    protected processGetNewsItemById(response: AxiosResponse): Promise<ApiResponse_newsItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsItemDTO>(null as any);
    }

    /**
     * Update a NewsItem by ID
     * @param id The ID of the NewsItem to update
     * @param body The updated NewsItem data
     * @return The updated NewsItem data
     */
    updateNewsItem(id: string, body: NewsItemDTO, cancelToken?: CancelToken): Promise<ApiResponse_newsItemDTO> {
        let url_ = this.baseUrl + "/newsitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNewsItem(_response);
        });
    }

    protected processUpdateNewsItem(response: AxiosResponse): Promise<ApiResponse_newsItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsItemDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsItemDTO>(null as any);
    }

    /**
     * Delete a NewsItem by ID
     * @param id The ID of the NewsItem to delete
     */
    deleteNewsItem(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/newsitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNewsItem(_response);
        });
    }

    protected processDeleteNewsItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search NewsItems based on criteria
     * @param body The search criteria
     * @return The search results of NewsItems based on the criteria
     */
    searchNewsItems(body: SearchRequestDTO_newsItemSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/newsitem/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNewsItems(_response);
        });
    }

    protected processSearchNewsItems(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Get a news item's rendered HTML
     * @param id The ID of the NewsItem
     * @return The news item's rendered HTML
     */
    getNewsItemContent(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/newsitem/{id}/content";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsItemContent(_response);
        });
    }

    protected processGetNewsItemContent(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Public news feed
     * @param contentCategoryId (optional) Filter by content category.
     * @param search (optional) Case-insensitive match on the title or summary.
     * @param page (optional) 1-based page number. Defaults to 1.
     * @param pageSize (optional) Page size. Defaults to 20.
     * @param showOnLanding (optional) Filter to news items championed on the Info Hub landing. Omit for the whole feed.
     * @return The public news feed.
     */
    getNewsItemsPublic(contentCategoryId: string | null | undefined, search: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, showOnLanding: boolean | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/newsitem/public?";
        if (contentCategoryId !== undefined && contentCategoryId !== null)
            url_ += "contentCategoryId=" + encodeURIComponent("" + contentCategoryId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showOnLanding !== undefined && showOnLanding !== null)
            url_ += "showOnLanding=" + encodeURIComponent("" + showOnLanding) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsItemsPublic(_response);
        });
    }

    protected processGetNewsItemsPublic(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Public news item by slug or id
     * @param idOrSlug The news item's clean slug or its GUID.
     * @return The news item and its HTML content.
     */
    getNewsItemPublicByIdOrSlug(idOrSlug: string, cancelToken?: CancelToken): Promise<ApiResponse_contentItemPublicDTO> {
        let url_ = this.baseUrl + "/newsitem/public/{idOrSlug}";
        if (idOrSlug === undefined || idOrSlug === null)
            throw new globalThis.Error("The parameter 'idOrSlug' must be defined.");
        url_ = url_.replace("{idOrSlug}", encodeURIComponent("" + idOrSlug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsItemPublicByIdOrSlug(_response);
        });
    }

    protected processGetNewsItemPublicByIdOrSlug(response: AxiosResponse): Promise<ApiResponse_contentItemPublicDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_contentItemPublicDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_contentItemPublicDTO>(null as any);
    }
}

export class NewsletterCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all NewsletterCategories
     * @return The list of NewsletterCategories
     */
    getNewsletterCategories( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/newslettercategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsletterCategories(_response);
        });
    }

    protected processGetNewsletterCategories(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new NewsletterCategory
     * @param body The NewsletterCategory data to create
     * @return The newly created NewsletterCategory data
     */
    createNewsletterCategory(body: NewsletterCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_newsletterCategoryDTO> {
        let url_ = this.baseUrl + "/newslettercategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewsletterCategory(_response);
        });
    }

    protected processCreateNewsletterCategory(response: AxiosResponse): Promise<ApiResponse_newsletterCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_newsletterCategoryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterCategoryDTO>(null as any);
    }

    /**
     * Retrieve a NewsletterCategory by ID
     * @param id The ID of the NewsletterCategory to retrieve
     * @return The NewsletterCategory data
     */
    getNewsletterCategoryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_newsletterCategoryDTO> {
        let url_ = this.baseUrl + "/newslettercategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsletterCategoryById(_response);
        });
    }

    protected processGetNewsletterCategoryById(response: AxiosResponse): Promise<ApiResponse_newsletterCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsletterCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterCategoryDTO>(null as any);
    }

    /**
     * Update a NewsletterCategory by ID
     * @param id The ID of the NewsletterCategory to update
     * @param body The updated NewsletterCategory data
     * @return The updated NewsletterCategory data
     */
    updateNewsletterCategory(id: string, body: NewsletterCategoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_newsletterCategoryDTO> {
        let url_ = this.baseUrl + "/newslettercategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNewsletterCategory(_response);
        });
    }

    protected processUpdateNewsletterCategory(response: AxiosResponse): Promise<ApiResponse_newsletterCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsletterCategoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterCategoryDTO>(null as any);
    }

    /**
     * Delete a NewsletterCategory by ID
     * @param id The ID of the NewsletterCategory to delete
     */
    deleteNewsletterCategory(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/newslettercategory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNewsletterCategory(_response);
        });
    }

    protected processDeleteNewsletterCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search NewsletterCategories based on criteria
     * @param body The search criteria
     * @return The search results of NewsletterCategories based on the criteria
     */
    searchNewsletterCategories(body: SearchRequestDTO_newsletterCategorySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/newslettercategory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNewsletterCategories(_response);
        });
    }

    protected processSearchNewsletterCategories(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class NewsletterClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Newsletters
     * @return The list of Newsletters
     */
    getNewsletters( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/newsletter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsletters(_response);
        });
    }

    protected processGetNewsletters(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Newsletter
     * @param body The Newsletter data to create
     * @return The newly created Newsletter data
     */
    createNewsletter(body: NewsletterDTO, cancelToken?: CancelToken): Promise<ApiResponse_newsletterDTO> {
        let url_ = this.baseUrl + "/newsletter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewsletter(_response);
        });
    }

    protected processCreateNewsletter(response: AxiosResponse): Promise<ApiResponse_newsletterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_newsletterDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterDTO>(null as any);
    }

    /**
     * Retrieve a Newsletter by ID
     * @param id The ID of the Newsletter to retrieve
     * @return The Newsletter data
     */
    getNewsletterById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_newsletterDTO> {
        let url_ = this.baseUrl + "/newsletter/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsletterById(_response);
        });
    }

    protected processGetNewsletterById(response: AxiosResponse): Promise<ApiResponse_newsletterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsletterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterDTO>(null as any);
    }

    /**
     * Update a Newsletter by ID
     * @param id The ID of the Newsletter to update
     * @param body The updated Newsletter data
     * @return The updated Newsletter data
     */
    updateNewsletter(id: string, body: NewsletterDTO, cancelToken?: CancelToken): Promise<ApiResponse_newsletterDTO> {
        let url_ = this.baseUrl + "/newsletter/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNewsletter(_response);
        });
    }

    protected processUpdateNewsletter(response: AxiosResponse): Promise<ApiResponse_newsletterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsletterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterDTO>(null as any);
    }

    /**
     * Delete a Newsletter by ID
     * @param id The ID of the Newsletter to delete
     */
    deleteNewsletter(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/newsletter/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNewsletter(_response);
        });
    }

    protected processDeleteNewsletter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Newsletters based on criteria
     * @param body The search criteria
     * @return The search results of Newsletters based on the criteria
     */
    searchNewsletters(body: SearchRequestDTO_newsletterSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/newsletter/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNewsletters(_response);
        });
    }

    protected processSearchNewsletters(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Public newsletter archive
     * @param year (optional) Filter by year.
     * @param search (optional) Case-insensitive match on the newsletter title.
     * @param page (optional) 1-based page number. Defaults to 1.
     * @param pageSize (optional) Page size. Defaults to 20.
     * @return The public newsletter archive.
     */
    getNewslettersPublic(year: number | null | undefined, search: string | null | undefined, page: number | null | undefined, pageSize: number | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/newsletter/public?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewslettersPublic(_response);
        });
    }

    protected processGetNewslettersPublic(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Public newsletter by slug or id
     * @param idOrSlug The newsletter's clean slug or its GUID.
     * @return The newsletter and its HTML content.
     */
    getNewsletterPublicByIdOrSlug(idOrSlug: string, cancelToken?: CancelToken): Promise<ApiResponse_newsletterPublicDTO> {
        let url_ = this.baseUrl + "/newsletter/public/{idOrSlug}";
        if (idOrSlug === undefined || idOrSlug === null)
            throw new globalThis.Error("The parameter 'idOrSlug' must be defined.");
        url_ = url_.replace("{idOrSlug}", encodeURIComponent("" + idOrSlug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewsletterPublicByIdOrSlug(_response);
        });
    }

    protected processGetNewsletterPublicByIdOrSlug(response: AxiosResponse): Promise<ApiResponse_newsletterPublicDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_newsletterPublicDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_newsletterPublicDTO>(null as any);
    }
}

export class NoteClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Notes
     * @return The list of Notes
     */
    getNotes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/note";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotes(_response);
        });
    }

    protected processGetNotes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Note
     * @param body The Note data to create
     * @return The newly created Note data
     */
    createNote(body: NoteDTO, cancelToken?: CancelToken): Promise<ApiResponse_noteDTO> {
        let url_ = this.baseUrl + "/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNote(_response);
        });
    }

    protected processCreateNote(response: AxiosResponse): Promise<ApiResponse_noteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_noteDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_noteDTO>(null as any);
    }

    /**
     * Retrieve a Note by ID
     * @param id The ID of the Note to retrieve
     * @return The Note data
     */
    getNoteById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_noteDTO> {
        let url_ = this.baseUrl + "/note/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteById(_response);
        });
    }

    protected processGetNoteById(response: AxiosResponse): Promise<ApiResponse_noteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_noteDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_noteDTO>(null as any);
    }

    /**
     * Update a Note by ID
     * @param id The ID of the Note to update
     * @param body The updated Note data
     * @return The updated Note data
     */
    updateNote(id: string, body: NoteDTO, cancelToken?: CancelToken): Promise<ApiResponse_noteDTO> {
        let url_ = this.baseUrl + "/note/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNote(_response);
        });
    }

    protected processUpdateNote(response: AxiosResponse): Promise<ApiResponse_noteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_noteDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_noteDTO>(null as any);
    }

    /**
     * Delete a Note by ID
     * @param id The ID of the Note to delete
     */
    deleteNote(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/note/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNote(_response);
        });
    }

    protected processDeleteNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resolve a Note by ID
     * @param id The ID of the Note to resolve
     * @return Indicates whether the note was successfully resolved
     */
    resolveNote(id: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/note/{id}/resolve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveNote(_response);
        });
    }

    protected processResolveNote(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Search Notes based on criteria
     * @param body The search criteria
     * @return The search results of Notes based on the criteria
     */
    searchNotes(body: SearchRequestDTO_noteSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/note/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNotes(_response);
        });
    }

    protected processSearchNotes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Notes based on search criteria
     * @param body The search criteria
     * @return The export results of Notes based on the search criteria
     */
    exportNotes(body: SearchRequestDTO_noteSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/note/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportNotes(_response);
        });
    }

    protected processExportNotes(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class NoteTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all NoteTypes
     * @return The list of NoteTypes
     */
    getNoteTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/notetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteTypes(_response);
        });
    }

    protected processGetNoteTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new NoteType
     * @param body The NoteType data to create
     * @return The newly created NoteType data
     */
    createNoteType(body: NoteTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_noteTypeDTO> {
        let url_ = this.baseUrl + "/notetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNoteType(_response);
        });
    }

    protected processCreateNoteType(response: AxiosResponse): Promise<ApiResponse_noteTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_noteTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_noteTypeDTO>(null as any);
    }

    /**
     * Retrieve a NoteType by ID
     * @param id The ID of the NoteType to retrieve
     * @return The NoteType data
     */
    getNoteTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_noteTypeDTO> {
        let url_ = this.baseUrl + "/notetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteTypeById(_response);
        });
    }

    protected processGetNoteTypeById(response: AxiosResponse): Promise<ApiResponse_noteTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_noteTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_noteTypeDTO>(null as any);
    }

    /**
     * Update a NoteType by ID
     * @param id The ID of the NoteType to update
     * @param body The updated NoteType data
     * @return The updated NoteType data
     */
    updateNoteType(id: string, body: NoteTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_noteTypeDTO> {
        let url_ = this.baseUrl + "/notetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNoteType(_response);
        });
    }

    protected processUpdateNoteType(response: AxiosResponse): Promise<ApiResponse_noteTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_noteTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_noteTypeDTO>(null as any);
    }

    /**
     * Delete a NoteType by ID
     * @param id The ID of the NoteType to delete
     */
    deleteNoteType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/notetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNoteType(_response);
        });
    }

    protected processDeleteNoteType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search NoteTypes based on criteria
     * @param body The search criteria
     * @return The search results of NoteTypes based on the criteria
     */
    searchNoteTypes(body: SearchRequestDTO_noteTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/notetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNoteTypes(_response);
        });
    }

    protected processSearchNoteTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class PagesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Pages
     * @return The list of Pages
     */
    getPages( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/pages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPages(_response);
        });
    }

    protected processGetPages(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Page
     * @param body The Page data to create
     * @return The newly created Page data
     */
    createPage(body: PagesDTO, cancelToken?: CancelToken): Promise<ApiResponse_pagesDTO> {
        let url_ = this.baseUrl + "/pages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePage(_response);
        });
    }

    protected processCreatePage(response: AxiosResponse): Promise<ApiResponse_pagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_pagesDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pagesDTO>(null as any);
    }

    /**
     * Retrieve a Page by ID
     * @param id The ID of the Page to retrieve
     * @return The Page data
     */
    getPageById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_pagesDTO> {
        let url_ = this.baseUrl + "/pages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageById(_response);
        });
    }

    protected processGetPageById(response: AxiosResponse): Promise<ApiResponse_pagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_pagesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pagesDTO>(null as any);
    }

    /**
     * Update a Page by ID
     * @param id The ID of the Page to update
     * @param body The updated Page data
     * @return The updated Page data
     */
    updatePage(id: string, body: PagesDTO, cancelToken?: CancelToken): Promise<ApiResponse_pagesDTO> {
        let url_ = this.baseUrl + "/pages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePage(_response);
        });
    }

    protected processUpdatePage(response: AxiosResponse): Promise<ApiResponse_pagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_pagesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pagesDTO>(null as any);
    }

    /**
     * Delete a Page by ID
     * @param id The ID of the Page to delete
     */
    deletePage(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/pages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePage(_response);
        });
    }

    protected processDeletePage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Pages based on criteria
     * @param body The search criteria
     * @return The search results of Pages based on the criteria
     */
    searchPages(body: SearchRequestDTO_pagesSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/pages/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPages(_response);
        });
    }

    protected processSearchPages(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Get a page and its rendered HTML by slug
     * @param slug The full slug path of the page (e.g. 'about/committee').
     * @param preview (optional) When true, inactive pages are also returned (for admin preview). Defaults to false.
     * @return The page metadata and its rendered HTML content.
     */
    getPageBySlug(slug: string, preview: boolean | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_pageContentDTO> {
        let url_ = this.baseUrl + "/pages/by-slug?";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        if (preview !== undefined && preview !== null)
            url_ += "preview=" + encodeURIComponent("" + preview) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageBySlug(_response);
        });
    }

    protected processGetPageBySlug(response: AxiosResponse): Promise<ApiResponse_pageContentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_pageContentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pageContentDTO>(null as any);
    }

    /**
     * Move a page to a new parent
     * @param id The ID of the page to move
     * @param body The new parent (null for top level)
     * @return The move result
     */
    movePage(id: string, body: MovePageRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/pages/{id}/parent";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMovePage(_response);
        });
    }

    protected processMovePage(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class PaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Payments
     * @return The list of Payments
     */
    getPayments( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/payment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayments(_response);
        });
    }

    protected processGetPayments(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Payment
     * @param body The Payment data to create
     * @return The newly created Payment data
     */
    createPayment(body: PaymentDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentDTO> {
        let url_ = this.baseUrl + "/payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayment(_response);
        });
    }

    protected processCreatePayment(response: AxiosResponse): Promise<ApiResponse_paymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentDTO>(null as any);
    }

    /**
     * Retrieve a Payment by ID
     * @param id The ID of the Payment to retrieve
     * @return The Payment data
     */
    getPaymentById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentDTO> {
        let url_ = this.baseUrl + "/payment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentById(_response);
        });
    }

    protected processGetPaymentById(response: AxiosResponse): Promise<ApiResponse_paymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentDTO>(null as any);
    }

    /**
     * Update a Payment by ID
     * @param id The ID of the Payment to update
     * @param body The updated Payment data
     * @return The updated Payment data
     */
    updatePayment(id: string, body: PaymentDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentDTO> {
        let url_ = this.baseUrl + "/payment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePayment(_response);
        });
    }

    protected processUpdatePayment(response: AxiosResponse): Promise<ApiResponse_paymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentDTO>(null as any);
    }

    /**
     * Delete a Payment by ID
     * @param id The ID of the Payment to delete
     */
    deletePayment(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/payment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayment(_response);
        });
    }

    protected processDeletePayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Payments based on criteria
     * @param body The search criteria
     * @return The search results of Payments based on the criteria
     */
    searchPayments(body: SearchRequestDTO_paymentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/payment/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPayments(_response);
        });
    }

    protected processSearchPayments(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Payments based on search criteria
     * @param body The search criteria
     * @return The export results of Payments based on the search criteria
     */
    exportPayments(body: SearchRequestDTO_paymentSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/payment/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPayments(_response);
        });
    }

    protected processExportPayments(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Process PayFast payment notification for subscription
     * @param m_payment_id (optional) 
     * @param pf_payment_id (optional) 
     * @param payment_status (optional) 
     * @param item_name (optional) 
     * @param item_description (optional) 
     * @param amount_gross (optional) 
     * @param amount_fee (optional) 
     * @param amount_net (optional) 
     * @param custom_str1 (optional) 
     * @param custom_str2 (optional) 
     * @param custom_str3 (optional) 
     * @param custom_str4 (optional) 
     * @param custom_str5 (optional) 
     * @param custom_int1 (optional) 
     * @param custom_int2 (optional) 
     * @param custom_int3 (optional) 
     * @param custom_int4 (optional) 
     * @param custom_int5 (optional) 
     * @param name_first (optional) 
     * @param name_last (optional) 
     * @param email_address (optional) 
     * @param merchant_id (optional) 
     * @param signature (optional) 
     * @return The payment notification was processed successfully.
     */
    payFastPaymentNotification(m_payment_id: string | null | undefined, pf_payment_id: string | null | undefined, payment_status: string | null | undefined, item_name: string | null | undefined, item_description: string | null | undefined, amount_gross: number | null | undefined, amount_fee: number | null | undefined, amount_net: number | null | undefined, custom_str1: string | null | undefined, custom_str2: string | null | undefined, custom_str3: string | null | undefined, custom_str4: string | null | undefined, custom_str5: string | null | undefined, custom_int1: number | null | undefined, custom_int2: number | null | undefined, custom_int3: number | null | undefined, custom_int4: number | null | undefined, custom_int5: number | null | undefined, name_first: string | null | undefined, name_last: string | null | undefined, email_address: string | null | undefined, merchant_id: string | null | undefined, signature: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/payments/payfast/subscription/type/{type}";
        url_ = url_.replace(/[?&]$/, "");

        let content_ = "";
        if (m_payment_id !== undefined)
            content_ += encodeURIComponent("m_payment_id") + "=" + encodeURIComponent("" + m_payment_id) + "&";
        if (pf_payment_id !== undefined)
            content_ += encodeURIComponent("pf_payment_id") + "=" + encodeURIComponent("" + pf_payment_id) + "&";
        if (payment_status !== undefined)
            content_ += encodeURIComponent("payment_status") + "=" + encodeURIComponent("" + payment_status) + "&";
        if (item_name !== undefined)
            content_ += encodeURIComponent("item_name") + "=" + encodeURIComponent("" + item_name) + "&";
        if (item_description !== undefined)
            content_ += encodeURIComponent("item_description") + "=" + encodeURIComponent("" + item_description) + "&";
        if (amount_gross !== undefined)
            content_ += encodeURIComponent("amount_gross") + "=" + encodeURIComponent("" + amount_gross) + "&";
        if (amount_fee !== undefined)
            content_ += encodeURIComponent("amount_fee") + "=" + encodeURIComponent("" + amount_fee) + "&";
        if (amount_net !== undefined)
            content_ += encodeURIComponent("amount_net") + "=" + encodeURIComponent("" + amount_net) + "&";
        if (custom_str1 !== undefined)
            content_ += encodeURIComponent("custom_str1") + "=" + encodeURIComponent("" + custom_str1) + "&";
        if (custom_str2 !== undefined)
            content_ += encodeURIComponent("custom_str2") + "=" + encodeURIComponent("" + custom_str2) + "&";
        if (custom_str3 !== undefined)
            content_ += encodeURIComponent("custom_str3") + "=" + encodeURIComponent("" + custom_str3) + "&";
        if (custom_str4 !== undefined)
            content_ += encodeURIComponent("custom_str4") + "=" + encodeURIComponent("" + custom_str4) + "&";
        if (custom_str5 !== undefined)
            content_ += encodeURIComponent("custom_str5") + "=" + encodeURIComponent("" + custom_str5) + "&";
        if (custom_int1 !== undefined)
            content_ += encodeURIComponent("custom_int1") + "=" + encodeURIComponent("" + custom_int1) + "&";
        if (custom_int2 !== undefined)
            content_ += encodeURIComponent("custom_int2") + "=" + encodeURIComponent("" + custom_int2) + "&";
        if (custom_int3 !== undefined)
            content_ += encodeURIComponent("custom_int3") + "=" + encodeURIComponent("" + custom_int3) + "&";
        if (custom_int4 !== undefined)
            content_ += encodeURIComponent("custom_int4") + "=" + encodeURIComponent("" + custom_int4) + "&";
        if (custom_int5 !== undefined)
            content_ += encodeURIComponent("custom_int5") + "=" + encodeURIComponent("" + custom_int5) + "&";
        if (name_first !== undefined)
            content_ += encodeURIComponent("name_first") + "=" + encodeURIComponent("" + name_first) + "&";
        if (name_last !== undefined)
            content_ += encodeURIComponent("name_last") + "=" + encodeURIComponent("" + name_last) + "&";
        if (email_address !== undefined)
            content_ += encodeURIComponent("email_address") + "=" + encodeURIComponent("" + email_address) + "&";
        if (merchant_id !== undefined)
            content_ += encodeURIComponent("merchant_id") + "=" + encodeURIComponent("" + merchant_id) + "&";
        if (signature !== undefined)
            content_ += encodeURIComponent("signature") + "=" + encodeURIComponent("" + signature) + "&";
        content_ = content_.replace(/&$/, "");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayFastPaymentNotification(_response);
        });
    }

    protected processPayFastPaymentNotification(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Validation error or invalid data.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Error processing the payment notification.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Process EFT payment completion
     * @param body The EFT payment data containing PaymentId and ComponentId
     * @return The EFT payment was processed successfully.
     */
    eFTPaymentComplete(body: EftPaymentDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/payments/eft/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEFTPaymentComplete(_response);
        });
    }

    protected processEFTPaymentComplete(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Validation error or invalid data.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Payment not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Error processing the EFT payment.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class PaymentIntervalClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all PaymentIntervals
     * @return The list of PaymentIntervals
     */
    getPaymentIntervals( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/paymentinterval";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentIntervals(_response);
        });
    }

    protected processGetPaymentIntervals(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new PaymentInterval
     * @param body The PaymentInterval data to create
     * @return The newly created PaymentInterval data
     */
    createPaymentInterval(body: PaymentIntervalDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentIntervalDTO> {
        let url_ = this.baseUrl + "/paymentinterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentInterval(_response);
        });
    }

    protected processCreatePaymentInterval(response: AxiosResponse): Promise<ApiResponse_paymentIntervalDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentIntervalDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentIntervalDTO>(null as any);
    }

    /**
     * Retrieve a PaymentInterval by ID
     * @param id The ID of the PaymentInterval to retrieve
     * @return The PaymentInterval data
     */
    getPaymentIntervalById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentIntervalDTO> {
        let url_ = this.baseUrl + "/paymentinterval/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentIntervalById(_response);
        });
    }

    protected processGetPaymentIntervalById(response: AxiosResponse): Promise<ApiResponse_paymentIntervalDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentIntervalDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentIntervalDTO>(null as any);
    }

    /**
     * Update a PaymentInterval by ID
     * @param id The ID of the PaymentInterval to update
     * @param body The updated PaymentInterval data
     * @return The updated PaymentInterval data
     */
    updatePaymentInterval(id: string, body: PaymentIntervalDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentIntervalDTO> {
        let url_ = this.baseUrl + "/paymentinterval/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentInterval(_response);
        });
    }

    protected processUpdatePaymentInterval(response: AxiosResponse): Promise<ApiResponse_paymentIntervalDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentIntervalDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentIntervalDTO>(null as any);
    }

    /**
     * Delete a PaymentInterval by ID
     * @param id The ID of the PaymentInterval to delete
     */
    deletePaymentInterval(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/paymentinterval/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePaymentInterval(_response);
        });
    }

    protected processDeletePaymentInterval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search PaymentIntervals based on criteria
     * @param body The search criteria
     * @return The search results of PaymentIntervals based on the criteria
     */
    searchPaymentIntervals(body: SearchRequestDTO_paymentIntervalSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/paymentinterval/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPaymentIntervals(_response);
        });
    }

    protected processSearchPaymentIntervals(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class PaymentTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all PaymentTypes
     * @return The list of PaymentTypes
     */
    getPaymentTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/paymenttype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentTypes(_response);
        });
    }

    protected processGetPaymentTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new PaymentType
     * @param body The PaymentType data to create
     * @return The newly created PaymentType data
     */
    createPaymentType(body: PaymentTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentTypeDTO> {
        let url_ = this.baseUrl + "/paymenttype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentType(_response);
        });
    }

    protected processCreatePaymentType(response: AxiosResponse): Promise<ApiResponse_paymentTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_paymentTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentTypeDTO>(null as any);
    }

    /**
     * Retrieve a PaymentType by ID
     * @param id The ID of the PaymentType to retrieve
     * @return The PaymentType data
     */
    getPaymentTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_paymentTypeDTO> {
        let url_ = this.baseUrl + "/paymenttype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentTypeById(_response);
        });
    }

    protected processGetPaymentTypeById(response: AxiosResponse): Promise<ApiResponse_paymentTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentTypeDTO>(null as any);
    }

    /**
     * Update a PaymentType by ID
     * @param id The ID of the PaymentType to update
     * @param body The updated PaymentType data
     * @return The updated PaymentType data
     */
    updatePaymentType(id: string, body: PaymentTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_paymentTypeDTO> {
        let url_ = this.baseUrl + "/paymenttype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentType(_response);
        });
    }

    protected processUpdatePaymentType(response: AxiosResponse): Promise<ApiResponse_paymentTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_paymentTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_paymentTypeDTO>(null as any);
    }

    /**
     * Delete a PaymentType by ID
     * @param id The ID of the PaymentType to delete
     */
    deletePaymentType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/paymenttype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePaymentType(_response);
        });
    }

    protected processDeletePaymentType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search PaymentTypes based on criteria
     * @param body The search criteria
     * @return The search results of PaymentTypes based on the criteria
     */
    searchPaymentTypes(body: SearchRequestDTO_paymentTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/paymenttype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPaymentTypes(_response);
        });
    }

    protected processSearchPaymentTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ProvinceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Provinces
     * @return The list of Provinces
     */
    getProvinces( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/province";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProvinces(_response);
        });
    }

    protected processGetProvinces(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Province
     * @param body The Province data to create
     * @return The newly created Province data
     */
    createProvince(body: ProvinceDTO, cancelToken?: CancelToken): Promise<ApiResponse_provinceDTO> {
        let url_ = this.baseUrl + "/province";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProvince(_response);
        });
    }

    protected processCreateProvince(response: AxiosResponse): Promise<ApiResponse_provinceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_provinceDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_provinceDTO>(null as any);
    }

    /**
     * Retrieve a Province by ID
     * @param id The ID of the Province to retrieve
     * @return The Province data
     */
    getProvinceById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_provinceDTO> {
        let url_ = this.baseUrl + "/province/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProvinceById(_response);
        });
    }

    protected processGetProvinceById(response: AxiosResponse): Promise<ApiResponse_provinceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_provinceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_provinceDTO>(null as any);
    }

    /**
     * Update a Province by ID
     * @param id The ID of the Province to update
     * @param body The updated Province data
     * @return The updated Province data
     */
    updateProvince(id: string, body: ProvinceDTO, cancelToken?: CancelToken): Promise<ApiResponse_provinceDTO> {
        let url_ = this.baseUrl + "/province/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProvince(_response);
        });
    }

    protected processUpdateProvince(response: AxiosResponse): Promise<ApiResponse_provinceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_provinceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_provinceDTO>(null as any);
    }

    /**
     * Delete a Province by ID
     * @param id The ID of the Province to delete
     */
    deleteProvince(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/province/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProvince(_response);
        });
    }

    protected processDeleteProvince(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Provinces based on criteria
     * @param body The search criteria
     * @return The search results of Provinces based on the criteria
     */
    searchProvinces(body: SearchRequestDTO_provinceSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/province/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProvinces(_response);
        });
    }

    protected processSearchProvinces(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuestionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Questions
     * @return The list of Questions
     */
    getQuestions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/question";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestions(_response);
        });
    }

    protected processGetQuestions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Question
     * @param body The Question data to create
     * @return The newly created Question data
     */
    createQuestion(body: QuestionDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionDTO> {
        let url_ = this.baseUrl + "/question";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestion(_response);
        });
    }

    protected processCreateQuestion(response: AxiosResponse): Promise<ApiResponse_questionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_questionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionDTO>(null as any);
    }

    /**
     * Retrieve a Question by ID
     * @param id The ID of the Question to retrieve
     * @return The Question data
     */
    getQuestionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_questionDTO> {
        let url_ = this.baseUrl + "/question/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionById(_response);
        });
    }

    protected processGetQuestionById(response: AxiosResponse): Promise<ApiResponse_questionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionDTO>(null as any);
    }

    /**
     * Update a Question by ID
     * @param id The ID of the Question to update
     * @param body The updated Question data
     * @return The updated Question data
     */
    updateQuestion(id: string, body: QuestionDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionDTO> {
        let url_ = this.baseUrl + "/question/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestion(_response);
        });
    }

    protected processUpdateQuestion(response: AxiosResponse): Promise<ApiResponse_questionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionDTO>(null as any);
    }

    /**
     * Delete a Question by ID
     * @param id The ID of the Question to delete
     */
    deleteQuestion(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/question/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestion(_response);
        });
    }

    protected processDeleteQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Questions based on criteria
     * @param body The search criteria
     * @return The search results of Questions based on the criteria
     */
    searchQuestions(body: SearchRequestDTO_questionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/question/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuestions(_response);
        });
    }

    protected processSearchQuestions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuestionSetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all QuestionSets
     * @return The list of QuestionSets
     */
    getQuestionSets( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/questionset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSets(_response);
        });
    }

    protected processGetQuestionSets(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new QuestionSet
     * @param body The QuestionSet data to create
     * @return The newly created QuestionSet data
     */
    createQuestionSet(body: QuestionSetDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetDTO> {
        let url_ = this.baseUrl + "/questionset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuestionSet(_response);
        });
    }

    protected processCreateQuestionSet(response: AxiosResponse): Promise<ApiResponse_questionSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_questionSetDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetDTO>(null as any);
    }

    /**
     * Retrieve a QuestionSet by ID
     * @param id The ID of the QuestionSet to retrieve
     * @return The QuestionSet data
     */
    getQuestionSetById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_questionSetDTO> {
        let url_ = this.baseUrl + "/questionset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuestionSetById(_response);
        });
    }

    protected processGetQuestionSetById(response: AxiosResponse): Promise<ApiResponse_questionSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetDTO>(null as any);
    }

    /**
     * Update a QuestionSet by ID
     * @param id The ID of the QuestionSet to update
     * @param body The updated QuestionSet data
     * @return The updated QuestionSet data
     */
    updateQuestionSet(id: string, body: QuestionSetDTO, cancelToken?: CancelToken): Promise<ApiResponse_questionSetDTO> {
        let url_ = this.baseUrl + "/questionset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuestionSet(_response);
        });
    }

    protected processUpdateQuestionSet(response: AxiosResponse): Promise<ApiResponse_questionSetDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_questionSetDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_questionSetDTO>(null as any);
    }

    /**
     * Delete a QuestionSet by ID
     * @param id The ID of the QuestionSet to delete
     */
    deleteQuestionSet(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/questionset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestionSet(_response);
        });
    }

    protected processDeleteQuestionSet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search QuestionSets based on criteria
     * @param body The search criteria
     * @return The search results of QuestionSets based on the criteria
     */
    searchQuestionSets(body: SearchRequestDTO_questionSetSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/questionset/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuestionSets(_response);
        });
    }

    protected processSearchQuestionSets(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class QuickEventClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all QuickEvents
     * @return The list of QuickEvents
     */
    getQuickEvents( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/quickevent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuickEvents(_response);
        });
    }

    protected processGetQuickEvents(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new QuickEvent
     * @param body The QuickEvent data to create
     * @return The newly created QuickEvent data
     */
    createQuickEvent(body: QuickEventDTO, cancelToken?: CancelToken): Promise<ApiResponse_quickEventDTO> {
        let url_ = this.baseUrl + "/quickevent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateQuickEvent(_response);
        });
    }

    protected processCreateQuickEvent(response: AxiosResponse): Promise<ApiResponse_quickEventDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_quickEventDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_quickEventDTO>(null as any);
    }

    /**
     * Retrieve a QuickEvent by ID
     * @param id The ID of the QuickEvent to retrieve
     * @return The QuickEvent data
     */
    getQuickEventById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_quickEventDTO> {
        let url_ = this.baseUrl + "/quickevent/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuickEventById(_response);
        });
    }

    protected processGetQuickEventById(response: AxiosResponse): Promise<ApiResponse_quickEventDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_quickEventDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_quickEventDTO>(null as any);
    }

    /**
     * Update a QuickEvent by ID
     * @param id The ID of the QuickEvent to update
     * @param body The updated QuickEvent data
     * @return The updated QuickEvent data
     */
    updateQuickEvent(id: string, body: QuickEventDTO, cancelToken?: CancelToken): Promise<ApiResponse_quickEventDTO> {
        let url_ = this.baseUrl + "/quickevent/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuickEvent(_response);
        });
    }

    protected processUpdateQuickEvent(response: AxiosResponse): Promise<ApiResponse_quickEventDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_quickEventDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_quickEventDTO>(null as any);
    }

    /**
     * Delete a QuickEvent by ID
     * @param id The ID of the QuickEvent to delete
     */
    deleteQuickEvent(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/quickevent/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuickEvent(_response);
        });
    }

    protected processDeleteQuickEvent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search QuickEvents based on criteria
     * @param body The search criteria
     * @return The search results of QuickEvents based on the criteria
     */
    searchQuickEvents(body: SearchRequestDTO_quickEventSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/quickevent/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchQuickEvents(_response);
        });
    }

    protected processSearchQuickEvents(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Submit an activity for a quick event
     * @param body The submission details
     * @return Success indicator
     */
    submitQuickEventActivity(body: SubmitQuickEventActivityRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/quickevent/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitQuickEventActivity(_response);
        });
    }

    protected processSubmitQuickEventActivity(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }
}

export class RangeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Ranges
     * @return The list of Ranges
     */
    getRanges( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/range";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRanges(_response);
        });
    }

    protected processGetRanges(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Range
     * @param body The Range data to create
     * @return The newly created Range data
     */
    createRange(body: RangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeDTO> {
        let url_ = this.baseUrl + "/range";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRange(_response);
        });
    }

    protected processCreateRange(response: AxiosResponse): Promise<ApiResponse_rangeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rangeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeDTO>(null as any);
    }

    /**
     * Retrieve a Range by ID
     * @param id The ID of the Range to retrieve
     * @return The Range data
     */
    getRangeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rangeDTO> {
        let url_ = this.baseUrl + "/range/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeById(_response);
        });
    }

    protected processGetRangeById(response: AxiosResponse): Promise<ApiResponse_rangeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeDTO>(null as any);
    }

    /**
     * Update a Range by ID
     * @param id The ID of the Range to update
     * @param body The updated Range data
     * @return The updated Range data
     */
    updateRange(id: string, body: RangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeDTO> {
        let url_ = this.baseUrl + "/range/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRange(_response);
        });
    }

    protected processUpdateRange(response: AxiosResponse): Promise<ApiResponse_rangeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeDTO>(null as any);
    }

    /**
     * Delete a Range by ID
     * @param id The ID of the Range to delete
     */
    deleteRange(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/range/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRange(_response);
        });
    }

    protected processDeleteRange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Range Status (Bulk)
     * @param body The status update data
     * @return The number of ranges successfully updated
     */
    updateRangeQuickStatus(body: UpdateRangeStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/range/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRangeQuickStatus(_response);
        });
    }

    protected processUpdateRangeQuickStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Search Ranges based on criteria
     * @param body The search criteria
     * @return The search results of Ranges based on the criteria
     */
    searchRanges(body: SearchRequestDTO_rangeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/range/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRanges(_response);
        });
    }

    protected processSearchRanges(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RangeShootingReasonClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all RangeShootingReasons
     * @return The list of RangeShootingReasons
     */
    getRangeShootingReasons( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/rangeshootingreason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeShootingReasons(_response);
        });
    }

    protected processGetRangeShootingReasons(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new RangeShootingReason
     * @param body The RangeShootingReason data to create
     * @return The newly created RangeShootingReason data
     */
    createRangeShootingReason(body: RangeShootingReasonDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeShootingReasonDTO> {
        let url_ = this.baseUrl + "/rangeshootingreason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRangeShootingReason(_response);
        });
    }

    protected processCreateRangeShootingReason(response: AxiosResponse): Promise<ApiResponse_rangeShootingReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rangeShootingReasonDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeShootingReasonDTO>(null as any);
    }

    /**
     * Retrieve a RangeShootingReason by ID
     * @param id The ID of the RangeShootingReason to retrieve
     * @return The RangeShootingReason data
     */
    getRangeShootingReasonById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rangeShootingReasonDTO> {
        let url_ = this.baseUrl + "/rangeshootingreason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeShootingReasonById(_response);
        });
    }

    protected processGetRangeShootingReasonById(response: AxiosResponse): Promise<ApiResponse_rangeShootingReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeShootingReasonDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeShootingReasonDTO>(null as any);
    }

    /**
     * Update a RangeShootingReason by ID
     * @param id The ID of the RangeShootingReason to update
     * @param body The updated RangeShootingReason data
     * @return The updated RangeShootingReason data
     */
    updateRangeShootingReason(id: string, body: RangeShootingReasonDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeShootingReasonDTO> {
        let url_ = this.baseUrl + "/rangeshootingreason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRangeShootingReason(_response);
        });
    }

    protected processUpdateRangeShootingReason(response: AxiosResponse): Promise<ApiResponse_rangeShootingReasonDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeShootingReasonDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeShootingReasonDTO>(null as any);
    }

    /**
     * Delete a RangeShootingReason by ID
     * @param id The ID of the RangeShootingReason to delete
     */
    deleteRangeShootingReason(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/rangeshootingreason/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRangeShootingReason(_response);
        });
    }

    protected processDeleteRangeShootingReason(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search RangeShootingReasons based on criteria
     * @param body The search criteria
     * @return The search results of RangeShootingReasons based on the criteria
     */
    searchRangeShootingReasons(body: SearchRequestDTO_rangeShootingReasonSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/rangeshootingreason/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRangeShootingReasons(_response);
        });
    }

    protected processSearchRangeShootingReasons(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RangeStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all RangeStatuses
     * @return The list of RangeStatuses
     */
    getRangeStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/rangestatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeStatuses(_response);
        });
    }

    protected processGetRangeStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new RangeStatus
     * @param body The RangeStatus data to create
     * @return The newly created RangeStatus data
     */
    createRangeStatus(body: RangeStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeStatusDTO> {
        let url_ = this.baseUrl + "/rangestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRangeStatus(_response);
        });
    }

    protected processCreateRangeStatus(response: AxiosResponse): Promise<ApiResponse_rangeStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rangeStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeStatusDTO>(null as any);
    }

    /**
     * Retrieve a RangeStatus by ID
     * @param id The ID of the RangeStatus to retrieve
     * @return The RangeStatus data
     */
    getRangeStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rangeStatusDTO> {
        let url_ = this.baseUrl + "/rangestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeStatusById(_response);
        });
    }

    protected processGetRangeStatusById(response: AxiosResponse): Promise<ApiResponse_rangeStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeStatusDTO>(null as any);
    }

    /**
     * Update a RangeStatus by ID
     * @param id The ID of the RangeStatus to update
     * @param body The updated RangeStatus data
     * @return The updated RangeStatus data
     */
    updateRangeStatus(id: string, body: RangeStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeStatusDTO> {
        let url_ = this.baseUrl + "/rangestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRangeStatus(_response);
        });
    }

    protected processUpdateRangeStatus(response: AxiosResponse): Promise<ApiResponse_rangeStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeStatusDTO>(null as any);
    }

    /**
     * Delete a RangeStatus by ID
     * @param id The ID of the RangeStatus to delete
     */
    deleteRangeStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/rangestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRangeStatus(_response);
        });
    }

    protected processDeleteRangeStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search RangeStatuses based on criteria
     * @param body The search criteria
     * @return The search results of RangeStatuses based on the criteria
     */
    searchRangeStatuses(body: SearchRequestDTO_rangeStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/rangestatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRangeStatuses(_response);
        });
    }

    protected processSearchRangeStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RangeTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all RangeTypes
     * @return The list of RangeTypes
     */
    getRangeTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/rangetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeTypes(_response);
        });
    }

    protected processGetRangeTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new RangeType
     * @param body The RangeType data to create
     * @return The newly created RangeType data
     */
    createRangeType(body: RangeTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeTypeDTO> {
        let url_ = this.baseUrl + "/rangetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRangeType(_response);
        });
    }

    protected processCreateRangeType(response: AxiosResponse): Promise<ApiResponse_rangeTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rangeTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeTypeDTO>(null as any);
    }

    /**
     * Retrieve a RangeType by ID
     * @param id The ID of the RangeType to retrieve
     * @return The RangeType data
     */
    getRangeTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rangeTypeDTO> {
        let url_ = this.baseUrl + "/rangetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeTypeById(_response);
        });
    }

    protected processGetRangeTypeById(response: AxiosResponse): Promise<ApiResponse_rangeTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeTypeDTO>(null as any);
    }

    /**
     * Update a RangeType by ID
     * @param id The ID of the RangeType to update
     * @param body The updated RangeType data
     * @return The updated RangeType data
     */
    updateRangeType(id: string, body: RangeTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_rangeTypeDTO> {
        let url_ = this.baseUrl + "/rangetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRangeType(_response);
        });
    }

    protected processUpdateRangeType(response: AxiosResponse): Promise<ApiResponse_rangeTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rangeTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rangeTypeDTO>(null as any);
    }

    /**
     * Delete a RangeType by ID
     * @param id The ID of the RangeType to delete
     */
    deleteRangeType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/rangetype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRangeType(_response);
        });
    }

    protected processDeleteRangeType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search RangeTypes based on criteria
     * @param body The search criteria
     * @return The search results of RangeTypes based on the criteria
     */
    searchRangeTypes(body: SearchRequestDTO_rangeTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/rangetype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRangeTypes(_response);
        });
    }

    protected processSearchRangeTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ReconBatchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ReconBatches
     * @return The list of ReconBatches
     */
    getReconBatches( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/reconbatch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReconBatches(_response);
        });
    }

    protected processGetReconBatches(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ReconBatch
     * @param body The ReconBatch data to create
     * @return The newly created ReconBatch data
     */
    createReconBatch(body: ReconBatchDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconBatchDTO> {
        let url_ = this.baseUrl + "/reconbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReconBatch(_response);
        });
    }

    protected processCreateReconBatch(response: AxiosResponse): Promise<ApiResponse_reconBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_reconBatchDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconBatchDTO>(null as any);
    }

    /**
     * Retrieve a ReconBatch by ID
     * @param id The ID of the ReconBatch to retrieve
     * @return The ReconBatch data
     */
    getReconBatchById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_reconBatchDTO> {
        let url_ = this.baseUrl + "/reconbatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReconBatchById(_response);
        });
    }

    protected processGetReconBatchById(response: AxiosResponse): Promise<ApiResponse_reconBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconBatchDTO>(null as any);
    }

    /**
     * Update a ReconBatch by ID
     * @param id The ID of the ReconBatch to update
     * @param body The updated ReconBatch data
     * @return The updated ReconBatch data
     */
    updateReconBatch(id: string, body: ReconBatchDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconBatchDTO> {
        let url_ = this.baseUrl + "/reconbatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReconBatch(_response);
        });
    }

    protected processUpdateReconBatch(response: AxiosResponse): Promise<ApiResponse_reconBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconBatchDTO>(null as any);
    }

    /**
     * Delete a ReconBatch by ID
     * @param id The ID of the ReconBatch to delete
     */
    deleteReconBatch(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/reconbatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReconBatch(_response);
        });
    }

    protected processDeleteReconBatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ReconBatches based on criteria
     * @param body The search criteria
     * @return The search results of ReconBatches based on the criteria
     */
    searchReconBatches(body: SearchRequestDTO_reconBatchSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/reconbatch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchReconBatches(_response);
        });
    }

    protected processSearchReconBatches(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export ReconBatches based on search criteria
     * @param body The search criteria
     * @return The export results of ReconBatches based on the search criteria
     */
    exportReconBatches(body: SearchRequestDTO_reconBatchSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/reconbatch/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportReconBatches(_response);
        });
    }

    protected processExportReconBatches(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class ReconTransactionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ReconTransactions
     * @return The list of ReconTransactions
     */
    getReconTransactions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/recontransaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReconTransactions(_response);
        });
    }

    protected processGetReconTransactions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ReconTransaction
     * @param body The ReconTransaction data to create
     * @return The newly created ReconTransaction data
     */
    createReconTransaction(body: ReconTransactionDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReconTransaction(_response);
        });
    }

    protected processCreateReconTransaction(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }

    /**
     * Retrieve a ReconTransaction by ID
     * @param id The ID of the ReconTransaction to retrieve
     * @return The ReconTransaction data
     */
    getReconTransactionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReconTransactionById(_response);
        });
    }

    protected processGetReconTransactionById(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }

    /**
     * Update a ReconTransaction by ID
     * @param id The ID of the ReconTransaction to update
     * @param body The updated ReconTransaction data
     * @return The updated ReconTransaction data
     */
    updateReconTransaction(id: string, body: ReconTransactionDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReconTransaction(_response);
        });
    }

    protected processUpdateReconTransaction(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }

    /**
     * Delete a ReconTransaction by ID
     * @param id The ID of the ReconTransaction to delete
     */
    deleteReconTransaction(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/recontransaction/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReconTransaction(_response);
        });
    }

    protected processDeleteReconTransaction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ReconTransactions based on criteria
     * @param body The search criteria
     * @return The search results of ReconTransactions based on the criteria
     */
    searchReconTransactions(body: SearchRequestDTO_reconTransactionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/recontransaction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchReconTransactions(_response);
        });
    }

    protected processSearchReconTransactions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export ReconTransactions based on search criteria
     * @param body The search criteria
     * @return The export results of ReconTransactions based on the search criteria
     */
    exportReconTransactions(body: SearchRequestDTO_reconTransactionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/recontransaction/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportReconTransactions(_response);
        });
    }

    protected processExportReconTransactions(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Set recon transaction unallocated flag
     * @param id The ID of the ReconTransaction to update
     * @param body Payload containing isUnallocated flag
     * @return The updated ReconTransaction
     */
    setReconTransactionIsUnallocated(id: string, body: ReconTransactionSetUnallocatedRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction/{id}/set-unallocated";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetReconTransactionIsUnallocated(_response);
        });
    }

    protected processSetReconTransactionIsUnallocated(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }

    /**
     * Set recon transaction member
     * @param id The ID of the ReconTransaction to update
     * @param body Payload containing optional memberId
     * @return The updated ReconTransaction
     */
    setReconTransactionMember(id: string, body: ReconTransactionSetMemberRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction/{id}/set-member";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetReconTransactionMember(_response);
        });
    }

    protected processSetReconTransactionMember(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }

    /**
     * Set recon transaction component
     * @param id The ID of the ReconTransaction to update
     * @param body Payload containing optional componentId
     * @return The updated ReconTransaction
     */
    setReconTransactionComponent(id: string, body: ReconTransactionSetComponentRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction/{id}/set-component";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetReconTransactionComponent(_response);
        });
    }

    protected processSetReconTransactionComponent(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }

    /**
     * Mark recon transaction as manually ignored
     * @param id The ID of the ReconTransaction to update
     * @return The updated ReconTransaction
     */
    setReconTransactionManuallyIgnored(id: string, cancelToken?: CancelToken): Promise<ApiResponse_reconTransactionDTO> {
        let url_ = this.baseUrl + "/recontransaction/{id}/set-manually-ignored";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetReconTransactionManuallyIgnored(_response);
        });
    }

    protected processSetReconTransactionManuallyIgnored(response: AxiosResponse): Promise<ApiResponse_reconTransactionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTransactionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTransactionDTO>(null as any);
    }
}

export class ReconTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ReconTypes
     * @return The list of ReconTypes
     */
    getReconTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/recontype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReconTypes(_response);
        });
    }

    protected processGetReconTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ReconType
     * @param body The ReconType data to create
     * @return The newly created ReconType data
     */
    createReconType(body: ReconTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTypeDTO> {
        let url_ = this.baseUrl + "/recontype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReconType(_response);
        });
    }

    protected processCreateReconType(response: AxiosResponse): Promise<ApiResponse_reconTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_reconTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTypeDTO>(null as any);
    }

    /**
     * Retrieve a ReconType by ID
     * @param id The ID of the ReconType to retrieve
     * @return The ReconType data
     */
    getReconTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_reconTypeDTO> {
        let url_ = this.baseUrl + "/recontype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReconTypeById(_response);
        });
    }

    protected processGetReconTypeById(response: AxiosResponse): Promise<ApiResponse_reconTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTypeDTO>(null as any);
    }

    /**
     * Update a ReconType by ID
     * @param id The ID of the ReconType to update
     * @param body The updated ReconType data
     * @return The updated ReconType data
     */
    updateReconType(id: string, body: ReconTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_reconTypeDTO> {
        let url_ = this.baseUrl + "/recontype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReconType(_response);
        });
    }

    protected processUpdateReconType(response: AxiosResponse): Promise<ApiResponse_reconTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_reconTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_reconTypeDTO>(null as any);
    }

    /**
     * Delete a ReconType by ID
     * @param id The ID of the ReconType to delete
     */
    deleteReconType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/recontype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReconType(_response);
        });
    }

    protected processDeleteReconType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ReconTypes based on criteria
     * @param body The search criteria
     * @return The search results of ReconTypes based on the criteria
     */
    searchReconTypes(body: SearchRequestDTO_reconTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/recontype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchReconTypes(_response);
        });
    }

    protected processSearchReconTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RenewalStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all RenewalStatuses
     * @return The list of RenewalStatuses
     */
    getRenewalStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/renewalstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRenewalStatuses(_response);
        });
    }

    protected processGetRenewalStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new RenewalStatus
     * @param body The RenewalStatus data to create
     * @return The newly created RenewalStatus data
     */
    createRenewalStatus(body: RenewalStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_renewalStatusDTO> {
        let url_ = this.baseUrl + "/renewalstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRenewalStatus(_response);
        });
    }

    protected processCreateRenewalStatus(response: AxiosResponse): Promise<ApiResponse_renewalStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_renewalStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_renewalStatusDTO>(null as any);
    }

    /**
     * Retrieve a RenewalStatus by ID
     * @param id The ID of the RenewalStatus to retrieve
     * @return The RenewalStatus data
     */
    getRenewalStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_renewalStatusDTO> {
        let url_ = this.baseUrl + "/renewalstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRenewalStatusById(_response);
        });
    }

    protected processGetRenewalStatusById(response: AxiosResponse): Promise<ApiResponse_renewalStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_renewalStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_renewalStatusDTO>(null as any);
    }

    /**
     * Update a RenewalStatus by ID
     * @param id The ID of the RenewalStatus to update
     * @param body The updated RenewalStatus data
     * @return The updated RenewalStatus data
     */
    updateRenewalStatus(id: string, body: RenewalStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_renewalStatusDTO> {
        let url_ = this.baseUrl + "/renewalstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRenewalStatus(_response);
        });
    }

    protected processUpdateRenewalStatus(response: AxiosResponse): Promise<ApiResponse_renewalStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_renewalStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_renewalStatusDTO>(null as any);
    }

    /**
     * Delete a RenewalStatus by ID
     * @param id The ID of the RenewalStatus to delete
     */
    deleteRenewalStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/renewalstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRenewalStatus(_response);
        });
    }

    protected processDeleteRenewalStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search RenewalStatuses based on criteria
     * @param body The search criteria
     * @return The search results of RenewalStatuses based on the criteria
     */
    searchRenewalStatuses(body: SearchRequestDTO_renewalStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/renewalstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRenewalStatuses(_response);
        });
    }

    protected processSearchRenewalStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ReplyTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ReplyTemplates
     * @return The list of ReplyTemplates
     */
    getReplyTemplates( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/replytemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplyTemplates(_response);
        });
    }

    protected processGetReplyTemplates(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ReplyTemplate
     * @param body The ReplyTemplate data to create
     * @return The newly created ReplyTemplate data
     */
    createReplyTemplate(body: ReplyTemplateDTO, cancelToken?: CancelToken): Promise<ApiResponse_replyTemplateDTO> {
        let url_ = this.baseUrl + "/replytemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReplyTemplate(_response);
        });
    }

    protected processCreateReplyTemplate(response: AxiosResponse): Promise<ApiResponse_replyTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_replyTemplateDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_replyTemplateDTO>(null as any);
    }

    /**
     * Retrieve a ReplyTemplate by ID
     * @param id The ID of the ReplyTemplate to retrieve
     * @return The ReplyTemplate data
     */
    getReplyTemplateById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_replyTemplateDTO> {
        let url_ = this.baseUrl + "/replytemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplyTemplateById(_response);
        });
    }

    protected processGetReplyTemplateById(response: AxiosResponse): Promise<ApiResponse_replyTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_replyTemplateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_replyTemplateDTO>(null as any);
    }

    /**
     * Update a ReplyTemplate by ID
     * @param id The ID of the ReplyTemplate to update
     * @param body The updated ReplyTemplate data
     * @return The updated ReplyTemplate data
     */
    updateReplyTemplate(id: string, body: ReplyTemplateDTO, cancelToken?: CancelToken): Promise<ApiResponse_replyTemplateDTO> {
        let url_ = this.baseUrl + "/replytemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReplyTemplate(_response);
        });
    }

    protected processUpdateReplyTemplate(response: AxiosResponse): Promise<ApiResponse_replyTemplateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_replyTemplateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_replyTemplateDTO>(null as any);
    }

    /**
     * Delete a ReplyTemplate by ID
     * @param id The ID of the ReplyTemplate to delete
     */
    deleteReplyTemplate(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/replytemplate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReplyTemplate(_response);
        });
    }

    protected processDeleteReplyTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ReplyTemplates based on criteria
     * @param body The search criteria
     * @return The search results of ReplyTemplates based on the criteria
     */
    searchReplyTemplates(body: SearchRequestDTO_replyTemplateSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/replytemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchReplyTemplates(_response);
        });
    }

    protected processSearchReplyTemplates(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ReplyTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ReplyTypes
     * @return The list of ReplyTypes
     */
    getReplyTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/replytype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplyTypes(_response);
        });
    }

    protected processGetReplyTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ReplyType
     * @param body The ReplyType data to create
     * @return The newly created ReplyType data
     */
    createReplyType(body: ReplyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_replyTypeDTO> {
        let url_ = this.baseUrl + "/replytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReplyType(_response);
        });
    }

    protected processCreateReplyType(response: AxiosResponse): Promise<ApiResponse_replyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_replyTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_replyTypeDTO>(null as any);
    }

    /**
     * Retrieve a ReplyType by ID
     * @param id The ID of the ReplyType to retrieve
     * @return The ReplyType data
     */
    getReplyTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_replyTypeDTO> {
        let url_ = this.baseUrl + "/replytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReplyTypeById(_response);
        });
    }

    protected processGetReplyTypeById(response: AxiosResponse): Promise<ApiResponse_replyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_replyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_replyTypeDTO>(null as any);
    }

    /**
     * Update a ReplyType by ID
     * @param id The ID of the ReplyType to update
     * @param body The updated ReplyType data
     * @return The updated ReplyType data
     */
    updateReplyType(id: string, body: ReplyTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_replyTypeDTO> {
        let url_ = this.baseUrl + "/replytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReplyType(_response);
        });
    }

    protected processUpdateReplyType(response: AxiosResponse): Promise<ApiResponse_replyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_replyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_replyTypeDTO>(null as any);
    }

    /**
     * Delete a ReplyType by ID
     * @param id The ID of the ReplyType to delete
     */
    deleteReplyType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/replytype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReplyType(_response);
        });
    }

    protected processDeleteReplyType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ReplyTypes based on criteria
     * @param body The search criteria
     * @return The search results of ReplyTypes based on the criteria
     */
    searchReplyTypes(body: SearchRequestDTO_replyTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/replytype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchReplyTypes(_response);
        });
    }

    protected processSearchReplyTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class RplClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Rpls
     * @return The list of Rpls
     */
    getRpls( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/rpl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRpls(_response);
        });
    }

    protected processGetRpls(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Rpl
     * @param body The Rpl data to create
     * @return The newly created Rpl data
     */
    createRpl(body: RplDTO, cancelToken?: CancelToken): Promise<ApiResponse_rplDTO> {
        let url_ = this.baseUrl + "/rpl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRpl(_response);
        });
    }

    protected processCreateRpl(response: AxiosResponse): Promise<ApiResponse_rplDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rplDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplDTO>(null as any);
    }

    /**
     * Retrieve a Rpl by ID
     * @param id The ID of the Rpl to retrieve
     * @return The Rpl data
     */
    getRplById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rplDTO> {
        let url_ = this.baseUrl + "/rpl/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRplById(_response);
        });
    }

    protected processGetRplById(response: AxiosResponse): Promise<ApiResponse_rplDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplDTO>(null as any);
    }

    /**
     * Update a Rpl by ID
     * @param id The ID of the Rpl to update
     * @param body The updated Rpl data
     * @return The updated Rpl data
     */
    updateRpl(id: string, body: RplDTO, cancelToken?: CancelToken): Promise<ApiResponse_rplDTO> {
        let url_ = this.baseUrl + "/rpl/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRpl(_response);
        });
    }

    protected processUpdateRpl(response: AxiosResponse): Promise<ApiResponse_rplDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplDTO>(null as any);
    }

    /**
     * Delete a Rpl by ID
     * @param id The ID of the Rpl to delete
     */
    deleteRpl(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/rpl/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRpl(_response);
        });
    }

    protected processDeleteRpl(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve Rpl feedback HTML
     * @param id The ID of the Rpl
     * @return The feedback HTML content, or null if none exists
     */
    getRplFeedback(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/rpl/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRplFeedback(_response);
        });
    }

    protected processGetRplFeedback(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Update a RPL Proof Of Payment by ID
     * @param id The ID of the RPL to update
     * @param fileRecordId The file record ID of the proof of payment
     * @return The updated RPL data
     */
    updateRplProofOfPayment(id: string, fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_rplDTO> {
        let url_ = this.baseUrl + "/rpl/proofofpayment/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined and cannot be null.");
        else
            url_ += "fileRecordId=" + encodeURIComponent("" + fileRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRplProofOfPayment(_response);
        });
    }

    protected processUpdateRplProofOfPayment(response: AxiosResponse): Promise<ApiResponse_rplDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplDTO>(null as any);
    }

    /**
     * Send Proof Of Payment Upload Link
     * @param id The ID of the RPL
     * @return Email sent successfully
     */
    sendRplProofOfPaymentLink(id: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/rpl/{id}/send-pop-link";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendRplProofOfPaymentLink(_response);
        });
    }

    protected processSendRplProofOfPaymentLink(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Update RPL statuses in bulk
     * @param body The bulk status update data
     * @return Number of RPLs successfully updated
     */
    updateRplQuickStatus(body: UpdateRplStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/rpl/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRplQuickStatus(_response);
        });
    }

    protected processUpdateRplQuickStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Forfeit an RPL
     * @param id The ID of the RPL to forfeit
     * @param body The forfeiture details
     * @return The forfeited RPL
     */
    forfeitRpl(id: string, body: ForfeitureRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_rplDTO> {
        let url_ = this.baseUrl + "/rpl/{id}/forfeit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForfeitRpl(_response);
        });
    }

    protected processForfeitRpl(response: AxiosResponse): Promise<ApiResponse_rplDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplDTO>(null as any);
    }

    /**
     * Generate forfeiture document URL
     * @param id The ID of the RPL
     * @return The SAS URL of the generated forfeiture document
     */
    getRplForfeitureDocument(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/rpl/{id}/forfeiture-document";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRplForfeitureDocument(_response);
        });
    }

    protected processGetRplForfeitureDocument(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Download forfeiture document PDF
     * @param id The ID of the RPL
     * @return The forfeiture document PDF
     */
    downloadRplForfeitureDocument(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/rpl/{id}/forfeiture-document/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadRplForfeitureDocument(_response);
        });
    }

    protected processDownloadRplForfeitureDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Search Rpls based on criteria
     * @param body The search criteria
     * @return The search results of Rpls based on the criteria
     */
    searchRpls(body: SearchRequestDTO_rplSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/rpl/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRpls(_response);
        });
    }

    protected processSearchRpls(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Rpls based on search criteria
     * @param body The search criteria
     * @return The export results of Rpls based on the search criteria
     */
    exportRpls(body: SearchRequestDTO_rplSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/rpl/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRpls(_response);
        });
    }

    protected processExportRpls(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Restore a Rpl from deleted by ID
     * @param id The ID of the Rpl to restore from deleted
     * @return The restored Rpl data
     */
    restoreFromDeletedRpl(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rplDTO> {
        let url_ = this.baseUrl + "/rpl/{id}/restore-deleted";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromDeletedRpl(_response);
        });
    }

    protected processRestoreFromDeletedRpl(response: AxiosResponse): Promise<ApiResponse_rplDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplDTO>(null as any);
    }
}

export class RplStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all RplStatuses
     * @return The list of RplStatuses
     */
    getRplStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/rplstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRplStatuses(_response);
        });
    }

    protected processGetRplStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new RplStatus
     * @param body The RplStatus data to create
     * @return The newly created RplStatus data
     */
    createRplStatus(body: RplStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_rplStatusDTO> {
        let url_ = this.baseUrl + "/rplstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRplStatus(_response);
        });
    }

    protected processCreateRplStatus(response: AxiosResponse): Promise<ApiResponse_rplStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_rplStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplStatusDTO>(null as any);
    }

    /**
     * Retrieve a RplStatus by ID
     * @param id The ID of the RplStatus to retrieve
     * @return The RplStatus data
     */
    getRplStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_rplStatusDTO> {
        let url_ = this.baseUrl + "/rplstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRplStatusById(_response);
        });
    }

    protected processGetRplStatusById(response: AxiosResponse): Promise<ApiResponse_rplStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplStatusDTO>(null as any);
    }

    /**
     * Update a RplStatus by ID
     * @param id The ID of the RplStatus to update
     * @param body The updated RplStatus data
     * @return The updated RplStatus data
     */
    updateRplStatus(id: string, body: RplStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_rplStatusDTO> {
        let url_ = this.baseUrl + "/rplstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRplStatus(_response);
        });
    }

    protected processUpdateRplStatus(response: AxiosResponse): Promise<ApiResponse_rplStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_rplStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_rplStatusDTO>(null as any);
    }

    /**
     * Delete a RplStatus by ID
     * @param id The ID of the RplStatus to delete
     */
    deleteRplStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/rplstatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRplStatus(_response);
        });
    }

    protected processDeleteRplStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search RplStatuses based on criteria
     * @param body The search criteria
     * @return The search results of RplStatuses based on the criteria
     */
    searchRplStatuses(body: SearchRequestDTO_rplStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/rplstatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchRplStatuses(_response);
        });
    }

    protected processSearchRplStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ScoreClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Scores
     * @return The list of Scores
     */
    getScores( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/score";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScores(_response);
        });
    }

    protected processGetScores(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Score
     * @param body The Score data to create
     * @return The newly created Score data
     */
    createScore(body: ScoreDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreDTO> {
        let url_ = this.baseUrl + "/score";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateScore(_response);
        });
    }

    protected processCreateScore(response: AxiosResponse): Promise<ApiResponse_scoreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_scoreDTO>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Validation error, e.g. the competition entry is not eligible for score submission.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreDTO>(null as any);
    }

    /**
     * Retrieve a Score by ID
     * @param id The ID of the Score to retrieve
     * @return The Score data
     */
    getScoreById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_scoreDTO> {
        let url_ = this.baseUrl + "/score/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreById(_response);
        });
    }

    protected processGetScoreById(response: AxiosResponse): Promise<ApiResponse_scoreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreDTO>(null as any);
    }

    /**
     * Update a Score by ID
     * @param id The ID of the Score to update
     * @param body The updated Score data
     * @return The updated Score data
     */
    updateScore(id: string, body: ScoreDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreDTO> {
        let url_ = this.baseUrl + "/score/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateScore(_response);
        });
    }

    protected processUpdateScore(response: AxiosResponse): Promise<ApiResponse_scoreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreDTO>(null as any);
    }

    /**
     * Delete a Score by ID
     * @param id The ID of the Score to delete
     */
    deleteScore(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/score/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScore(_response);
        });
    }

    protected processDeleteScore(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve Score feedback HTML
     * @param id The ID of the Score
     * @return The feedback HTML content, or null if none exists
     */
    getScoreFeedback(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/score/{id}/feedback";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreFeedback(_response);
        });
    }

    protected processGetScoreFeedback(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Update Score Status (Bulk)
     * @param body The status update data
     * @return The number of scores successfully updated
     */
    updateScoreQuickStatus(body: UpdateScoreStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/score/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateScoreQuickStatus(_response);
        });
    }

    protected processUpdateScoreQuickStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Restore a Score from deleted by ID
     * @param id The ID of the Score to restore from deleted
     * @return The restored Score data
     */
    restoreFromDeletedScore(id: string, cancelToken?: CancelToken): Promise<ApiResponse_scoreDTO> {
        let url_ = this.baseUrl + "/score/{id}/restore-deleted";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromDeletedScore(_response);
        });
    }

    protected processRestoreFromDeletedScore(response: AxiosResponse): Promise<ApiResponse_scoreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreDTO>(null as any);
    }

    /**
     * Search Scores based on criteria
     * @param body The search criteria
     * @return The search results of Scores based on the criteria
     */
    searchScores(body: SearchRequestDTO_scoreSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/score/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchScores(_response);
        });
    }

    protected processSearchScores(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Scores based on search criteria
     * @param body The search criteria
     * @return The export results of Scores based on the search criteria
     */
    exportScores(body: SearchRequestDTO_scoreSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/score/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportScores(_response);
        });
    }

    protected processExportScores(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get distinct years for scores
     * @return Distinct years in descending order
     */
    getScoreYears( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/score/years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreYears(_response);
        });
    }

    protected processGetScoreYears(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class ScoreStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ScoreStatuses
     * @return The list of ScoreStatuses
     */
    getScoreStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/scorestatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreStatuses(_response);
        });
    }

    protected processGetScoreStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ScoreStatus
     * @param body The ScoreStatus data to create
     * @return The newly created ScoreStatus data
     */
    createScoreStatus(body: ScoreStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreStatusDTO> {
        let url_ = this.baseUrl + "/scorestatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateScoreStatus(_response);
        });
    }

    protected processCreateScoreStatus(response: AxiosResponse): Promise<ApiResponse_scoreStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_scoreStatusDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreStatusDTO>(null as any);
    }

    /**
     * Retrieve a ScoreStatus by ID
     * @param id The ID of the ScoreStatus to retrieve
     * @return The ScoreStatus data
     */
    getScoreStatusById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_scoreStatusDTO> {
        let url_ = this.baseUrl + "/scorestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreStatusById(_response);
        });
    }

    protected processGetScoreStatusById(response: AxiosResponse): Promise<ApiResponse_scoreStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreStatusDTO>(null as any);
    }

    /**
     * Update a ScoreStatus by ID
     * @param id The ID of the ScoreStatus to update
     * @param body The updated ScoreStatus data
     * @return The updated ScoreStatus data
     */
    updateScoreStatus(id: string, body: ScoreStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreStatusDTO> {
        let url_ = this.baseUrl + "/scorestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateScoreStatus(_response);
        });
    }

    protected processUpdateScoreStatus(response: AxiosResponse): Promise<ApiResponse_scoreStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreStatusDTO>(null as any);
    }

    /**
     * Delete a ScoreStatus by ID
     * @param id The ID of the ScoreStatus to delete
     */
    deleteScoreStatus(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/scorestatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScoreStatus(_response);
        });
    }

    protected processDeleteScoreStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ScoreStatuses based on criteria
     * @param body The search criteria
     * @return The search results of ScoreStatuses based on the criteria
     */
    searchScoreStatuses(body: SearchRequestDTO_scoreStatusSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/scorestatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchScoreStatuses(_response);
        });
    }

    protected processSearchScoreStatuses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class ScoreTargetFileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ScoreTargetFiles
     * @return The list of ScoreTargetFiles
     */
    getScoreTargetFiles( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/scoretargetfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreTargetFiles(_response);
        });
    }

    protected processGetScoreTargetFiles(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ScoreTargetFile
     * @param body The ScoreTargetFile data to create
     * @return The newly created ScoreTargetFile data
     */
    createScoreTargetFile(body: ScoreTargetFileDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreTargetFileDTO> {
        let url_ = this.baseUrl + "/scoretargetfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateScoreTargetFile(_response);
        });
    }

    protected processCreateScoreTargetFile(response: AxiosResponse): Promise<ApiResponse_scoreTargetFileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_scoreTargetFileDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreTargetFileDTO>(null as any);
    }

    /**
     * Retrieve a ScoreTargetFile by ID
     * @param id The ID of the ScoreTargetFile to retrieve
     * @return The ScoreTargetFile data
     */
    getScoreTargetFileById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_scoreTargetFileDTO> {
        let url_ = this.baseUrl + "/scoretargetfile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreTargetFileById(_response);
        });
    }

    protected processGetScoreTargetFileById(response: AxiosResponse): Promise<ApiResponse_scoreTargetFileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreTargetFileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreTargetFileDTO>(null as any);
    }

    /**
     * Update a ScoreTargetFile by ID
     * @param id The ID of the ScoreTargetFile to update
     * @param body The updated ScoreTargetFile data
     * @return The updated ScoreTargetFile data
     */
    updateScoreTargetFile(id: string, body: ScoreTargetFileDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreTargetFileDTO> {
        let url_ = this.baseUrl + "/scoretargetfile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateScoreTargetFile(_response);
        });
    }

    protected processUpdateScoreTargetFile(response: AxiosResponse): Promise<ApiResponse_scoreTargetFileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreTargetFileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreTargetFileDTO>(null as any);
    }

    /**
     * Delete a ScoreTargetFile by ID
     * @param id The ID of the ScoreTargetFile to delete
     */
    deleteScoreTargetFile(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/scoretargetfile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScoreTargetFile(_response);
        });
    }

    protected processDeleteScoreTargetFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ScoreTargetFiles based on criteria
     * @param body The search criteria
     * @return The search results of ScoreTargetFiles based on the criteria
     */
    searchScoreTargetFiles(body: SearchRequestDTO_scoreTargetFileSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/scoretargetfile/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchScoreTargetFiles(_response);
        });
    }

    protected processSearchScoreTargetFiles(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export ScoreTargetFiles based on search criteria
     * @param body The search criteria
     * @return The export results of ScoreTargetFiles based on the search criteria
     */
    exportScoreTargetFiles(body: SearchRequestDTO_scoreTargetFileSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/scoretargetfile/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportScoreTargetFiles(_response);
        });
    }

    protected processExportScoreTargetFiles(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class ScoreTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all ScoreTypes
     * @return The list of ScoreTypes
     */
    getScoreTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/scoretype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreTypes(_response);
        });
    }

    protected processGetScoreTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new ScoreType
     * @param body The ScoreType data to create
     * @return The newly created ScoreType data
     */
    createScoreType(body: ScoreTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreTypeDTO> {
        let url_ = this.baseUrl + "/scoretype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateScoreType(_response);
        });
    }

    protected processCreateScoreType(response: AxiosResponse): Promise<ApiResponse_scoreTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_scoreTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreTypeDTO>(null as any);
    }

    /**
     * Retrieve a ScoreType by ID
     * @param id The ID of the ScoreType to retrieve
     * @return The ScoreType data
     */
    getScoreTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_scoreTypeDTO> {
        let url_ = this.baseUrl + "/scoretype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScoreTypeById(_response);
        });
    }

    protected processGetScoreTypeById(response: AxiosResponse): Promise<ApiResponse_scoreTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreTypeDTO>(null as any);
    }

    /**
     * Update a ScoreType by ID
     * @param id The ID of the ScoreType to update
     * @param body The updated ScoreType data
     * @return The updated ScoreType data
     */
    updateScoreType(id: string, body: ScoreTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_scoreTypeDTO> {
        let url_ = this.baseUrl + "/scoretype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateScoreType(_response);
        });
    }

    protected processUpdateScoreType(response: AxiosResponse): Promise<ApiResponse_scoreTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_scoreTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_scoreTypeDTO>(null as any);
    }

    /**
     * Delete a ScoreType by ID
     * @param id The ID of the ScoreType to delete
     */
    deleteScoreType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/scoretype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScoreType(_response);
        });
    }

    protected processDeleteScoreType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search ScoreTypes based on criteria
     * @param body The search criteria
     * @return The search results of ScoreTypes based on the criteria
     */
    searchScoreTypes(body: SearchRequestDTO_scoreTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/scoretype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchScoreTypes(_response);
        });
    }

    protected processSearchScoreTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class VatRateHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all VAT rate history records
     * @return The list of VAT rate history records
     */
    getVatRateHistories( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/vatratehistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVatRateHistories(_response);
        });
    }

    protected processGetVatRateHistories(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new VAT rate history record
     * @param body The VatRateHistory data to create
     * @return The newly created VatRateHistory data
     */
    createVatRateHistory(body: VatRateHistoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_vatRateHistoryDTO> {
        let url_ = this.baseUrl + "/vatratehistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVatRateHistory(_response);
        });
    }

    protected processCreateVatRateHistory(response: AxiosResponse): Promise<ApiResponse_vatRateHistoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_vatRateHistoryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_vatRateHistoryDTO>(null as any);
    }

    /**
     * Retrieve a VAT rate history record by ID
     * @param id The ID of the VatRateHistory record to retrieve
     * @return The VatRateHistory data
     */
    getVatRateHistoryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_vatRateHistoryDTO> {
        let url_ = this.baseUrl + "/vatratehistory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVatRateHistoryById(_response);
        });
    }

    protected processGetVatRateHistoryById(response: AxiosResponse): Promise<ApiResponse_vatRateHistoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_vatRateHistoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_vatRateHistoryDTO>(null as any);
    }

    /**
     * Update a VAT rate history record by ID
     * @param id The ID of the VatRateHistory record to update
     * @param body The updated VatRateHistory data
     * @return The updated VatRateHistory data
     */
    updateVatRateHistory(id: string, body: VatRateHistoryDTO, cancelToken?: CancelToken): Promise<ApiResponse_vatRateHistoryDTO> {
        let url_ = this.baseUrl + "/vatratehistory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVatRateHistory(_response);
        });
    }

    protected processUpdateVatRateHistory(response: AxiosResponse): Promise<ApiResponse_vatRateHistoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_vatRateHistoryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_vatRateHistoryDTO>(null as any);
    }

    /**
     * Delete a VAT rate history record by ID
     * @param id The ID of the VatRateHistory record to delete
     */
    deleteVatRateHistory(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/vatratehistory/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVatRateHistory(_response);
        });
    }

    protected processDeleteVatRateHistory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search VAT rate history records based on criteria
     * @param body The search criteria
     * @return The search results of VatRateHistory records based on the criteria
     */
    searchVatRateHistories(body: SearchRequestDTO_vatRateHistorySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/vatratehistory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchVatRateHistories(_response);
        });
    }

    protected processSearchVatRateHistories(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class AuditLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve an audit log by ID
     * @param id The ID of the audit log to retrieve
     * @return The audit log data
     */
    getAuditLogById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_auditLogDTO> {
        let url_ = this.baseUrl + "/auditlogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogById(_response);
        });
    }

    protected processGetAuditLogById(response: AxiosResponse): Promise<ApiResponse_auditLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_auditLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_auditLogDTO>(null as any);
    }

    /**
     * Search audit logs based on criteria
     * @param body The search criteria
     * @return The search results of audit logs based on the criteria
     */
    searchAuditLogs(body: SearchRequestDTO_auditLogSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/auditlogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAuditLogs(_response);
        });
    }

    protected processSearchAuditLogs(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve distinct table names
     * @return The list of distinct table names
     */
    getDistinctTableNames( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/auditlogs/tablenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDistinctTableNames(_response);
        });
    }

    protected processGetDistinctTableNames(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Generates a token for user authentication
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    generateToken(body: LoginUserDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateToken(_response);
        });
    }

    protected processGenerateToken(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for user authentication via two factor authentication
     * @param body Two factor auth data for token generation
     * @return JWT token for authenticated requests
     */
    generateTokenTwoFactor(body: LoginTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/twofactor/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateTokenTwoFactor(_response);
        });
    }

    protected processGenerateTokenTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Refreshes an access token
     * @param body Payload containing the refresh token
     * @return The refreshed access token, refresh token, and expiration time.
     */
    refreshToken(body: RefreshTokenDTO, cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request in case of invalid refresh token.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the refresh token is expired or invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }

    /**
     * Setup Two-Factor Authentication
     * @param userId The ID of the user
     * @return TOTP setup details including QR code and secret
     */
    setupTwoFactor(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        let url_ = this.baseUrl + "/auth/{userId}/two-factor/setup";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupTwoFactor(_response);
        });
    }

    protected processSetupTwoFactor(response: AxiosResponse): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(null as any);
    }

    /**
     * Verify Two-Factor Authentication Code
     * @param body Payload containing the TOTP code and user ID.
     * @return Verification success message.
     */
    verifyTwoFactor(body: VerifyTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/two-factor/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTwoFactor(_response);
        });
    }

    protected processVerifyTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request if the payload is invalid.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the TOTP code is invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Validates a Google sign in token and returns JWT token
     * @param body Google sign in token
     * @return JWT token for authenticated requests
     */
    googleTokenExchange(body: TokenExchangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/tokenexchange/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleTokenExchange(_response);
        });
    }

    protected processGoogleTokenExchange(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, invalid Google sign in token", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when impersonating a member
     * @param body User credentials for token generation
     * @return JWT token and refresh token for authenticated requests
     */
    impersonateMemberLogin(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/impersonate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogin(_response);
        });
    }

    protected processImpersonateMemberLogin(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }

    /**
     * Generates a token for an admin when logging out of a member
     * @return JWT token and refresh token for authenticated requests
     */
    impersonateMemberLogout( cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/impersonate/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogout(_response);
        });
    }

    protected processImpersonateMemberLogout(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request, invalid impersonation context.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }
}

export class BankClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Banks
     * @return The list of Banks
     */
    getBanks( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/banks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBanks(_response);
        });
    }

    protected processGetBanks(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Bank
     * @param body The Bank data to create
     * @return The newly created Bank data
     */
    createBank(body: BankDTO, cancelToken?: CancelToken): Promise<ApiResponse_bankDTO> {
        let url_ = this.baseUrl + "/banks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBank(_response);
        });
    }

    protected processCreateBank(response: AxiosResponse): Promise<ApiResponse_bankDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bankDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bankDTO>(null as any);
    }

    /**
     * Retrieve a Bank by ID
     * @param id The ID of the Bank to retrieve
     * @return The Bank data
     */
    getBankById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bankDTO> {
        let url_ = this.baseUrl + "/banks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBankById(_response);
        });
    }

    protected processGetBankById(response: AxiosResponse): Promise<ApiResponse_bankDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bankDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bankDTO>(null as any);
    }

    /**
     * Update a Bank by ID
     * @param id The ID of the Bank to update
     * @param body The updated Bank data
     * @return The updated Bank data
     */
    updateBank(id: string, body: BankDTO, cancelToken?: CancelToken): Promise<ApiResponse_bankDTO> {
        let url_ = this.baseUrl + "/banks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBank(_response);
        });
    }

    protected processUpdateBank(response: AxiosResponse): Promise<ApiResponse_bankDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bankDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bankDTO>(null as any);
    }

    /**
     * Delete a Bank by ID
     * @param id The ID of the Bank to delete
     * @return The Bank was successfully deleted
     */
    deleteBank(id: string, cancelToken?: CancelToken): Promise<ApiResponse_object> {
        let url_ = this.baseUrl + "/banks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBank(_response);
        });
    }

    protected processDeleteBank(response: AxiosResponse): Promise<ApiResponse_object> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            result204 = JSON.parse(resultData204);
            return Promise.resolve<ApiResponse_object>(result204);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_object>(null as any);
    }

    /**
     * Search for Banks
     * @param body The search criteria
     * @return The search results of Banks based on the criteria
     */
    searchBanks(body: SearchRequestDTO_bankSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/banks/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBanks(_response);
        });
    }

    protected processSearchBanks(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class BulkEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all bulk email statuses.
     * @return List of bulk email statuses.
     */
    getAllBulkEmailStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBulkEmailStatuses(_response);
        });
    }

    protected processGetAllBulkEmailStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Process a bulk email
     * @param id The ID of the bulk email to process
     * @return The processed bulk email data
     */
    processBulkEmail(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}/process";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBulkEmail(_response);
        });
    }

    protected processProcessBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request response if processing fails", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Server error response", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Send a test bulk email
     * @param id The ID of the bulk email to test
     * @param body The test email request containing the recipient email address
     * @return Test email sent successfully
     */
    sendTestBulkEmail(id: string, body: SendTestBulkEmailRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/bulkemails/{id}/test";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestBulkEmail(_response);
        });
    }

    protected processSendTestBulkEmail(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request response if sending fails", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Server error response", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all bulk emails
     * @return The list of bulk emails
     */
    getBulkEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmails(_response);
        });
    }

    protected processGetBulkEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new bulk email
     * @param body The bulk email data to create
     * @return The newly created bulk email data
     */
    createBulkEmail(body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkEmail(_response);
        });
    }

    protected processCreateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve a bulk email by ID
     * @param id The ID of the bulk email to retrieve
     * @return The bulk email data
     */
    getBulkEmailById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmailById(_response);
        });
    }

    protected processGetBulkEmailById(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Update a bulk email by ID
     * @param id The ID of the bulk email to update
     * @param body The updated bulk email data
     * @return The updated bulk email data
     */
    updateBulkEmail(id: string, body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBulkEmail(_response);
        });
    }

    protected processUpdateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Delete a bulk email by ID
     * @param id The ID of the bulk email to delete
     */
    deleteBulkEmail(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBulkEmail(_response);
        });
    }

    protected processDeleteBulkEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a bulk email attachment
     * @param fileName (optional) Optional file name for saving the file. If not provided, a unique name will be generated.
     * @param body The raw file content to upload
     * @return The File Record Id of the uploaded file
     */
    uploadBulkEmailAttachment(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/bulkemails/attachments/upload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBulkEmailAttachment(_response);
        });
    }

    protected processUploadBulkEmailAttachment(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request: Invalid file or missing parameters.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("An error occurred while uploading the file.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Search bulk emails based on criteria
     * @param body The search criteria
     * @return The search results of bulk emails based on the criteria
     */
    searchBulkEmails(body: SearchRequestDTO_bulkEmailSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/bulkemails/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBulkEmails(_response);
        });
    }

    protected processSearchBulkEmails(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CommunicationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Unsubscribe an email using a token.
     * @param body Token data for unsubscribing an email.
     * @return Result of the unsubscribe action.
     */
    unsubscribeEmail(body: UnsubscribedEmailRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/communication/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeEmail(_response);
        });
    }

    protected processUnsubscribeEmail(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Cancel an incomplete membership registration using a token, soft-deleting the member.
     * @param body Token data for cancelling a membership registration.
     * @return Result of the cancellation action.
     */
    cancelRegistration(body: CancelRegistrationRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/communication/cancel-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelRegistration(_response);
        });
    }

    protected processCancelRegistration(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all unsubscribed emails.
     * @return List of unsubscribed emails.
     */
    getAllUnsubscribedEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/unsubscribed-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUnsubscribedEmails(_response);
        });
    }

    protected processGetAllUnsubscribedEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve all communication lists.
     * @return List of communication lists.
     */
    getAllCommunicationLists( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCommunicationLists(_response);
        });
    }

    protected processGetAllCommunicationLists(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class CompanyInfoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all company infos
     * @return The list of company infos
     */
    getCompanyInfos( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfos(_response);
        });
    }

    protected processGetCompanyInfos(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new company info
     * @param body The company info data to create
     * @return The newly created data.
     */
    createCompanyInfo(body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompanyInfo(_response);
        });
    }

    protected processCreateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Retrieve a company info by ID
     * @param id The ID of the company info to retrieve
     * @return The company info data
     */
    getCompanyInfoById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfoById(_response);
        });
    }

    protected processGetCompanyInfoById(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Update a company info by ID
     * @param id The ID of the company info to update
     * @param body The updated company info data
     * @return The updated company info data.
     */
    updateCompanyInfo(id: string, body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyInfo(_response);
        });
    }

    protected processUpdateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Delete a company info by ID
     * @param id The ID of the company info to delete
     */
    deleteCompanyInfo(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompanyInfo(_response);
        });
    }

    protected processDeleteCompanyInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search company infos based on criteria
     * @param body The search criteria
     * @return The search results of company info based on the criteria
     */
    searchCompanyInfos(body: SearchRequestDTO_companyInfoSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/companyinfos/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompanyInfos(_response);
        });
    }

    protected processSearchCompanyInfos(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class DebitOrderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Create a new debit order mandate
     * @param body The debit order mandate data
     * @return The newly created mandate
     */
    createDebitOrderMandate(body: CreateDebitOrderMandateRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_createDebitOrderMandateResponseDTO> {
        let url_ = this.baseUrl + "/debitorders/mandate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDebitOrderMandate(_response);
        });
    }

    protected processCreateDebitOrderMandate(response: AxiosResponse): Promise<ApiResponse_createDebitOrderMandateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_createDebitOrderMandateResponseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_createDebitOrderMandateResponseDTO>(null as any);
    }

    /**
     * Resubmit mandate to Netcash
     * @param mandateId The ID of the mandate to submit
     * @return The submission response
     */
    resubmitDebitOrderMandate(mandateId: string, cancelToken?: CancelToken): Promise<ApiResponse_batchFileResponseDTO> {
        let url_ = this.baseUrl + "/debitorders/submit/{mandateId}";
        if (mandateId === undefined || mandateId === null)
            throw new globalThis.Error("The parameter 'mandateId' must be defined.");
        url_ = url_.replace("{mandateId}", encodeURIComponent("" + mandateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmitDebitOrderMandate(_response);
        });
    }

    protected processResubmitDebitOrderMandate(response: AxiosResponse): Promise<ApiResponse_batchFileResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_batchFileResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_batchFileResponseDTO>(null as any);
    }

    /**
     * Get mandate by ID
     * @param mandateId The ID of the mandate
     * @return The mandate details
     */
    getDebitOrderMandateById(mandateId: string, cancelToken?: CancelToken): Promise<ApiResponse_mandateStatusDTO> {
        let url_ = this.baseUrl + "/debitorders/mandate/{mandateId}";
        if (mandateId === undefined || mandateId === null)
            throw new globalThis.Error("The parameter 'mandateId' must be defined.");
        url_ = url_.replace("{mandateId}", encodeURIComponent("" + mandateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDebitOrderMandateById(_response);
        });
    }

    protected processGetDebitOrderMandateById(response: AxiosResponse): Promise<ApiResponse_mandateStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_mandateStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_mandateStatusDTO>(null as any);
    }

    /**
     * Update an existing debit order mandate
     * @param mandateId The ID of the mandate to update
     * @param body Updated mandate data
     * @return Update response
     */
    updateDebitOrderMandate(mandateId: string, body: UpdateDebitOrderMandateRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_createDebitOrderMandateResponseDTO> {
        let url_ = this.baseUrl + "/debitorders/mandate/{mandateId}";
        if (mandateId === undefined || mandateId === null)
            throw new globalThis.Error("The parameter 'mandateId' must be defined.");
        url_ = url_.replace("{mandateId}", encodeURIComponent("" + mandateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDebitOrderMandate(_response);
        });
    }

    protected processUpdateDebitOrderMandate(response: AxiosResponse): Promise<ApiResponse_createDebitOrderMandateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_createDebitOrderMandateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_createDebitOrderMandateResponseDTO>(null as any);
    }

    /**
     * Get all mandates for a member
     * @param memberId The ID of the member
     * @return The list of mandates
     */
    getMandatesByMember(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/debitorders/member/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMandatesByMember(_response);
        });
    }

    protected processGetMandatesByMember(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Get data needed for debit order mandate form
     * @param invoiceId The ID of the invoice
     * @return Form data including invoice details and bank list
     */
    getMandateFormData(invoiceId: string, cancelToken?: CancelToken): Promise<ApiResponse_mandateFormDataDTO> {
        let url_ = this.baseUrl + "/debitorders/mandate-form-data/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMandateFormData(_response);
        });
    }

    protected processGetMandateFormData(response: AxiosResponse): Promise<ApiResponse_mandateFormDataDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_mandateFormDataDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Invoice not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_mandateFormDataDTO>(null as any);
    }

    /**
     * Get edit form data for an existing mandate
     * @param mandateId The ID of the mandate to edit
     * @return Current mandate data and bank list
     */
    getMandateEditFormData(mandateId: string, cancelToken?: CancelToken): Promise<ApiResponse_mandateEditFormDataDTO> {
        let url_ = this.baseUrl + "/debitorders/mandate-edit-data/{mandateId}";
        if (mandateId === undefined || mandateId === null)
            throw new globalThis.Error("The parameter 'mandateId' must be defined.");
        url_ = url_.replace("{mandateId}", encodeURIComponent("" + mandateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMandateEditFormData(_response);
        });
    }

    protected processGetMandateEditFormData(response: AxiosResponse): Promise<ApiResponse_mandateEditFormDataDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_mandateEditFormDataDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Mandate not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_mandateEditFormDataDTO>(null as any);
    }
}

export class DedicatedStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Generate certificate for dedicated status
     * @param courseTypeId The course type ID to generate certificate for
     * @param itemId The specific item ID (RPL or Course) to generate certificate for
     * @return The URL of the generated certificate
     */
    generateDedicatedStatusCertificate(courseTypeId: string, itemId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/dedicated-status/certificate/{courseTypeId}/{itemId}";
        if (courseTypeId === undefined || courseTypeId === null)
            throw new globalThis.Error("The parameter 'courseTypeId' must be defined.");
        url_ = url_.replace("{courseTypeId}", encodeURIComponent("" + courseTypeId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDedicatedStatusCertificate(_response);
        });
    }

    protected processGenerateDedicatedStatusCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate HTML certificate for dedicated status
     * @param courseTypeId The course type ID to generate certificate for
     * @param itemId The specific item ID (RPL or Course) to generate certificate for
     * @return The HTML content of the generated certificate
     */
    generateHtmlDedicatedStatusCertificate(courseTypeId: string, itemId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/dedicated-status/html-certificate/{courseTypeId}/{itemId}";
        if (courseTypeId === undefined || courseTypeId === null)
            throw new globalThis.Error("The parameter 'courseTypeId' must be defined.");
        url_ = url_.replace("{courseTypeId}", encodeURIComponent("" + courseTypeId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateHtmlDedicatedStatusCertificate(_response);
        });
    }

    protected processGenerateHtmlDedicatedStatusCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Check if a dedicated status certificate is forfeited
     * @param id The Course or RPL item ID
     * @return True if the certificate has been forfeited
     */
    checkDedicatedStatusIsForfeited(id: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/dedicated-status/{id}/is-forfeited";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDedicatedStatusIsForfeited(_response);
        });
    }

    protected processCheckDedicatedStatusIsForfeited(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }
}

export class IntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Verify a member for an integration partner
     * @param x_Client_Id Client ID issued to the partner.
     * @param x_Timestamp Current time in Unix seconds. Rejected if more than 5 minutes from server time.
     * @param x_Signature Lowercase hex HMAC-SHA256(signing secret, timestamp + "\n" + raw body).
     * @param body The key ID and the base64 ciphertext of the 13-digit SA ID number.
     * @return Verification result, including when the person is not a member.
     */
    integrationVerifyMember(x_Client_Id: string, x_Timestamp: string, x_Signature: string, body: MemberVerificationRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberVerificationResponseDTO> {
        let url_ = this.baseUrl + "/integrations/v1/members/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "X-Client-Id": x_Client_Id !== undefined && x_Client_Id !== null ? "" + x_Client_Id : "",
                "X-Timestamp": x_Timestamp !== undefined && x_Timestamp !== null ? "" + x_Timestamp : "",
                "X-Signature": x_Signature !== undefined && x_Signature !== null ? "" + x_Signature : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrationVerifyMember(_response);
        });
    }

    protected processIntegrationVerifyMember(response: AxiosResponse): Promise<ApiResponse_memberVerificationResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberVerificationResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("INVALID_REQUEST, INVALID_ID_NUMBER, UNKNOWN_KEY_ID or DECRYPTION_FAILED.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("MISSING_AUTH_HEADERS, UNKNOWN_CLIENT, TIMESTAMP_OUT_OF_RANGE or INVALID_SIGNATURE.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("SCOPE_NOT_GRANTED.", status, _responseText, _headers, result403);

        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = JSON.parse(resultData429);
            return throwException("RATE_LIMITED, with a Retry-After header in seconds.", status, _responseText, _headers, result429);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("INTERNAL_ERROR. Safe to retry once.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberVerificationResponseDTO>(null as any);
    }
}

export class MarksmanGradingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get all years and categories a member qualified for
     * @param memberId The ID of the member
     * @return The member's marksman grading qualifications by year
     */
    getMemberMarksmanQualifications(memberId: string, cancelToken?: CancelToken): Promise<ApiResponse_marksmanGradingQualificationDTO> {
        let url_ = this.baseUrl + "/marksmangrading/qualifications/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberMarksmanQualifications(_response);
        });
    }

    protected processGetMemberMarksmanQualifications(response: AxiosResponse): Promise<ApiResponse_marksmanGradingQualificationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_marksmanGradingQualificationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_marksmanGradingQualificationDTO>(null as any);
    }

    /**
     * Generate marksman grading certificate
     * @param body The certificate generation request
     * @return The URL of the generated certificate
     */
    generateMarksmanGradingCertificate(body: MarksmanGradingCertificateRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/marksmangrading/certificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateMarksmanGradingCertificate(_response);
        });
    }

    protected processGenerateMarksmanGradingCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Checks if an Id exists.
     * @param id The Id.
     * @return Payload of ApiResponse containing Boolean
     */
    checkIdExists(id: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/members/check-id?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIdExists(_response);
        });
    }

    protected processCheckIdExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Retrieve a Member by ID
     * @param id The ID of the Member to retrieve
     * @return The Member data
     */
    getMemberById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberById(_response);
        });
    }

    protected processGetMemberById(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Update a Member by ID
     * @param id The ID of the Member to update
     * @param body The updated Member data
     * @return The updated Member data
     */
    updateMember(id: string, body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMember(_response);
        });
    }

    protected processUpdateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Delete a Member by ID
     * @param id The ID of the Member to delete
     */
    deleteMember(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMember(_response);
        });
    }

    protected processDeleteMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a new Member
     * @param body The Member data to create
     * @return The newly created Member data
     */
    createMember(body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMember(_response);
        });
    }

    protected processCreateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Confirm a member's email address
     * @param body The email confirmation data
     * @return Email confirmation result
     */
    confirmMemberEmail(body: ConfirmEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmMemberEmail(_response);
        });
    }

    protected processConfirmMemberEmail(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Move a Member to a registration step
     * @param id The ID of the Member
     * @param body The target registration step
     * @return The updated Member data
     */
    updateMemberRegistrationProgress(id: string, body: UpdateMemberRegistrationStepDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}/registration-step";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberRegistrationProgress(_response);
        });
    }

    protected processUpdateMemberRegistrationProgress(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = JSON.parse(resultData409);
            return throwException("The registration is already complete or the step change is not allowed", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Update Member Status (Bulk)
     * @param body The status update data
     * @return The number of members successfully updated
     */
    updateMemberQuickStatus(body: UpdateMemberStatusDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/member/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberQuickStatus(_response);
        });
    }

    protected processUpdateMemberQuickStatus(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Archive Members (Bulk)
     * @param body The list of member IDs to archive
     * @return The number of members successfully archived
     */
    bulkArchiveMembers(body: BulkMemberIdsDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/member/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkArchiveMembers(_response);
        });
    }

    protected processBulkArchiveMembers(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Delete Members (Bulk)
     * @param body The list of member IDs to delete
     * @return The number of members successfully deleted
     */
    bulkDeleteMembers(body: BulkMemberIdsDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/member/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkDeleteMembers(_response);
        });
    }

    protected processBulkDeleteMembers(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Update a Member Proof Of Payment by ID
     * @param id The ID of the Member to update
     * @param fileRecordId The file record ID of the proof of payment
     * @return The updated Member data
     */
    updateMemberProofOfPayment(id: string, fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/proofofpayment/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined and cannot be null.");
        else
            url_ += "fileRecordId=" + encodeURIComponent("" + fileRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberProofOfPayment(_response);
        });
    }

    protected processUpdateMemberProofOfPayment(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Send Proof Of Payment Upload Link
     * @param id The ID of the Member
     * @return Email sent successfully
     */
    sendMemberProofOfPaymentLink(id: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/{id}/send-pop-link";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMemberProofOfPaymentLink(_response);
        });
    }

    protected processSendMemberProofOfPaymentLink(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get current member's profile
     * @return The member profile data
     */
    getMemberProfile( cancelToken?: CancelToken): Promise<ApiResponse_memberProfileDTO> {
        let url_ = this.baseUrl + "/member/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberProfile(_response);
        });
    }

    protected processGetMemberProfile(response: AxiosResponse): Promise<ApiResponse_memberProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberProfileDTO>(null as any);
    }

    /**
     * Update current member's profile
     * @param body The updated member profile data
     * @return The updated member profile data
     */
    updateMemberProfile(body: MemberProfileDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberProfileDTO> {
        let url_ = this.baseUrl + "/member/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberProfile(_response);
        });
    }

    protected processUpdateMemberProfile(response: AxiosResponse): Promise<ApiResponse_memberProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberProfileDTO>(null as any);
    }

    /**
     * Search Members based on criteria
     * @param body The search criteria
     * @return The search results of Members based on the criteria
     */
    searchMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/member/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMembers(_response);
        });
    }

    protected processSearchMembers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Archive a Member by ID
     * @param id The ID of the Member to archive
     * @return The archived Member data
     */
    archiveMember(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}/archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveMember(_response);
        });
    }

    protected processArchiveMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Restore a Member from archive by ID
     * @param id The ID of the Member to restore from archive
     * @return The restored Member data
     */
    restoreFromArchiveMember(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}/restore-archive";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromArchiveMember(_response);
        });
    }

    protected processRestoreFromArchiveMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Restore a Member from deleted by ID
     * @param id The ID of the Member to restore from deleted
     * @return The restored Member data
     */
    restoreFromDeletedMember(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}/restore-deleted";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFromDeletedMember(_response);
        });
    }

    protected processRestoreFromDeletedMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Export Members based on search criteria
     * @param body The search criteria
     * @return The export results of Members based on the search criteria
     */
    exportMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMembers(_response);
        });
    }

    protected processExportMembers(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve a simplified Member view by ID
     * @param id The ID of the Member to retrieve
     * @return The simplified Member data
     */
    getMemberSimplifiedById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberSimpleDTO> {
        let url_ = this.baseUrl + "/member/{id}/simplified";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberSimplifiedById(_response);
        });
    }

    protected processGetMemberSimplifiedById(response: AxiosResponse): Promise<ApiResponse_memberSimpleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberSimpleDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberSimpleDTO>(null as any);
    }

    /**
     * Lookup Member ID by certificate
     * @param body The certificate lookup data
     * @return The member ID associated with the certificate
     */
    lookupMemberByCertificate(body: LookupMemberByCertificateDTO, cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/member/lookup-by-certificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupMemberByCertificate(_response);
        });
    }

    protected processLookupMemberByCertificate(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Certificate not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Reset a Member's password
     * @param id The ID of the Member whose password to reset
     * @param body The password reset data
     * @return Password reset confirmation
     */
    resetMemberPassword(id: string, body: MemberResetPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/{id}/reset-password";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetMemberPassword(_response);
        });
    }

    protected processResetMemberPassword(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Generate and get certificate URL
     * @param id The ID of the Member
     * @return The URL of the generated certificate
     */
    getMemberCertificate(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/certificate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCertificate(_response);
        });
    }

    protected processGetMemberCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate and get HTML certificate content
     * @param id The ID of the Member
     * @return The HTML content of the generated certificate
     */
    getMemberHtmlCertificate(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/certificate/html";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberHtmlCertificate(_response);
        });
    }

    protected processGetMemberHtmlCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate and get member card URL
     * @param id The ID of the Member
     * @return The URL of the generated member card
     */
    getMemberCard(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/member-card";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCard(_response);
        });
    }

    protected processGetMemberCard(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate and get HTML member card content
     * @param id The ID of the Member
     * @return The HTML content of the generated member card
     */
    getMemberHtmlCard(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/member-card/html";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberHtmlCard(_response);
        });
    }

    protected processGetMemberHtmlCard(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generate and get debit order mandate URL
     * @param id The ID of the Member
     * @return The URL of the generated debit order mandate
     */
    getMemberDebitOrderMandate(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/debit-order-mandate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberDebitOrderMandate(_response);
        });
    }

    protected processGetMemberDebitOrderMandate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Download debit order mandate PDF
     * @param id The ID of the Member
     * @return The debit order mandate PDF
     */
    downloadMemberDebitOrderMandate(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/member/{id}/debit-order-mandate/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadMemberDebitOrderMandate(_response);
        });
    }

    protected processDownloadMemberDebitOrderMandate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Generate anniversary certificate
     * @param id The ID of the Member
     * @param years The anniversary milestone year (10, 20, 25, or 30)
     * @return The temporary download URL of the anniversary certificate (valid for 10 minutes)
     */
    getAnniversaryCertificate(id: string, years: number, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/anniversary-certificate/{years}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (years === undefined || years === null)
            throw new globalThis.Error("The parameter 'years' must be defined.");
        url_ = url_.replace("{years}", encodeURIComponent("" + years));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnniversaryCertificate(_response);
        });
    }

    protected processGetAnniversaryCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get anniversary certificate HTML preview
     * @param id The ID of the Member
     * @param years The anniversary milestone year (10, 20, 25, or 30)
     * @return The HTML content of the anniversary certificate
     */
    getAnniversaryHtmlCertificate(id: string, years: number, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/{id}/anniversary-certificate/{years}/html";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (years === undefined || years === null)
            throw new globalThis.Error("The parameter 'years' must be defined.");
        url_ = url_.replace("{years}", encodeURIComponent("" + years));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnniversaryHtmlCertificate(_response);
        });
    }

    protected processGetAnniversaryHtmlCertificate(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get reached anniversary milestones
     * @param id The ID of the Member
     * @return List of reached milestone years
     */
    getAnniversaryMilestones(id: string, cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/member/{id}/anniversary-milestones";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnniversaryMilestones(_response);
        });
    }

    protected processGetAnniversaryMilestones(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Export Life Members report
     * @param fromDate (optional) Start date (yyyy-MM-dd) — filters by DateTransitionedToLifeMember
     * @param toDate (optional) End date (yyyy-MM-dd) — filters by DateTransitionedToLifeMember
     * @return SAS URL to download the Excel report
     */
    exportLifeMembersReport(fromDate: string | null | undefined, toDate: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/reports/life-members?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportLifeMembersReport(_response);
        });
    }

    protected processExportLifeMembersReport(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Activate a member partner opt-in
     * @param body The member and partner IDs
     * @return The partner opt-in URL to redirect to
     */
    activateMemberPartnerOptIn(body: ActivatePartnerOptInDTO, cancelToken?: CancelToken): Promise<ApiResponse_activatePartnerOptInResultDTO> {
        let url_ = this.baseUrl + "/member/activate-partner-opt-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateMemberPartnerOptIn(_response);
        });
    }

    protected processActivateMemberPartnerOptIn(response: AxiosResponse): Promise<ApiResponse_activatePartnerOptInResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_activatePartnerOptInResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_activatePartnerOptInResultDTO>(null as any);
    }
}

export class MemberOtpClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Create a new MemberOTP
     * @param deliveryMethod (optional) Delivery method: 'sms' or 'email'. Defaults to 'sms'.
     * @return Success message
     */
    createMemberOTP(deliveryMethod: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberotp?";
        if (deliveryMethod !== undefined && deliveryMethod !== null)
            url_ += "deliveryMethod=" + encodeURIComponent("" + deliveryMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberOTP(_response);
        });
    }

    protected processCreateMemberOTP(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Checks if an otp is valid.
     * @param otp The otp.
     * @return Payload of ApiResponse containing Boolean
     */
    verifyOtp(otp: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/members/check-otp?";
        if (otp === undefined || otp === null)
            throw new globalThis.Error("The parameter 'otp' must be defined and cannot be null.");
        else
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyOtp(_response);
        });
    }

    protected processVerifyOtp(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }
}

export class NetcashBatchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get all draft Netcash batches
     * @return The draft batches
     */
    getNetcashBatchDrafts( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/netcashbatch/drafts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNetcashBatchDrafts(_response);
        });
    }

    protected processGetNetcashBatchDrafts(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Create an empty draft Netcash batch
     * @param body The month and year the batch is for
     * @return The new draft batch
     */
    createNetcashBatchDraft(body: CreateNetcashBatchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_netcashBatchDTO> {
        let url_ = this.baseUrl + "/netcashbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNetcashBatchDraft(_response);
        });
    }

    protected processCreateNetcashBatchDraft(response: AxiosResponse): Promise<ApiResponse_netcashBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashBatchDTO>(null as any);
    }

    /**
     * Get a Netcash batch
     * @param id The ID of the Netcash batch
     * @return The batch
     */
    getNetcashBatch(id: string, cancelToken?: CancelToken): Promise<ApiResponse_netcashBatchDTO> {
        let url_ = this.baseUrl + "/netcashbatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNetcashBatch(_response);
        });
    }

    protected processGetNetcashBatch(response: AxiosResponse): Promise<ApiResponse_netcashBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashBatchDTO>(null as any);
    }

    /**
     * Delete a draft Netcash batch
     * @param id The ID of the draft batch to delete
     * @return Deleted successfully
     */
    deleteNetcashBatchDraft(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/netcashbatch/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNetcashBatchDraft(_response);
        });
    }

    protected processDeleteNetcashBatchDraft(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get pushed Netcash batch history
     * @return Pushed batch history
     */
    getNetcashBatchHistory( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/netcashbatch/history";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNetcashBatchHistory(_response);
        });
    }

    protected processGetNetcashBatchHistory(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Add invoices to a specific draft Netcash batch
     * @param id The ID of the draft Netcash batch to add to
     * @param body The invoice IDs to add
     * @return The updated draft batch and how many invoices were added or skipped
     */
    addInvoicesToNetcashBatch(id: string, body: AddInvoicesToNetcashBatchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_netcashAddInvoicesResultDTO> {
        let url_ = this.baseUrl + "/netcashbatch/{id}/add-invoices";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddInvoicesToNetcashBatch(_response);
        });
    }

    protected processAddInvoicesToNetcashBatch(response: AxiosResponse): Promise<ApiResponse_netcashAddInvoicesResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashAddInvoicesResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashAddInvoicesResultDTO>(null as any);
    }

    /**
     * Add a whole invoice batch's debit order sales orders to a Netcash batch
     * @param invoiceBatchId The ID of the InvoiceBatch whose debit order sales orders should be added
     * @param body (optional) The target draft (or month and year for a new one)
     * @return The draft batch and how many invoices were added or skipped
     */
    addDebitOrderInvoiceBatchToNetcashBatch(invoiceBatchId: string, body: AddInvoiceBatchToNetcashBatchRequestDTO | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_netcashAddInvoicesResultDTO> {
        let url_ = this.baseUrl + "/netcashbatch/add-from-invoicebatch/{invoiceBatchId}";
        if (invoiceBatchId === undefined || invoiceBatchId === null)
            throw new globalThis.Error("The parameter 'invoiceBatchId' must be defined.");
        url_ = url_.replace("{invoiceBatchId}", encodeURIComponent("" + invoiceBatchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDebitOrderInvoiceBatchToNetcashBatch(_response);
        });
    }

    protected processAddDebitOrderInvoiceBatchToNetcashBatch(response: AxiosResponse): Promise<ApiResponse_netcashAddInvoicesResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashAddInvoicesResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashAddInvoicesResultDTO>(null as any);
    }

    /**
     * Which of these invoices are already committed to a Netcash batch
     * @param body The invoice IDs to check
     * @return The invoices that are already committed
     */
    getNetcashInvoiceAvailability(body: NetcashInvoiceAvailabilityRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_netcashInvoiceAvailabilityResultDTO> {
        let url_ = this.baseUrl + "/netcashbatch/invoice-availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNetcashInvoiceAvailability(_response);
        });
    }

    protected processGetNetcashInvoiceAvailability(response: AxiosResponse): Promise<ApiResponse_netcashInvoiceAvailabilityResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashInvoiceAvailabilityResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashInvoiceAvailabilityResultDTO>(null as any);
    }

    /**
     * Remove a line item from a draft Netcash batch
     * @param id The ID of the line item to remove
     * @return Removed successfully
     */
    removeNetcashBatchLineItem(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/netcashbatch/lineitem/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveNetcashBatchLineItem(_response);
        });
    }

    protected processRemoveNetcashBatchLineItem(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Mark a pushed Netcash batch as cancelled
     * @param id The ID of the pushed batch
     * @return The batch, now cancelled
     */
    markNetcashBatchCancelled(id: string, cancelToken?: CancelToken): Promise<ApiResponse_netcashBatchDTO> {
        let url_ = this.baseUrl + "/netcashbatch/{id}/mark-cancelled";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkNetcashBatchCancelled(_response);
        });
    }

    protected processMarkNetcashBatchCancelled(response: AxiosResponse): Promise<ApiResponse_netcashBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashBatchDTO>(null as any);
    }

    /**
     * Release a member from a pushed Netcash batch
     * @param id The ID of the line item to release
     * @return The updated batch
     */
    releaseNetcashBatchLineItem(id: string, cancelToken?: CancelToken): Promise<ApiResponse_netcashBatchDTO> {
        let url_ = this.baseUrl + "/netcashbatch/lineitem/{id}/release";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReleaseNetcashBatchLineItem(_response);
        });
    }

    protected processReleaseNetcashBatchLineItem(response: AxiosResponse): Promise<ApiResponse_netcashBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_netcashBatchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashBatchDTO>(null as any);
    }

    /**
     * Queue a Netcash batch for push
     * @param id The ID of the Netcash batch to push
     * @param body The collection date (yyyy-MM-dd) - a business day at least 2 business days away
     * @return The batch, now marked as pushing
     */
    pushNetcashBatch(id: string, body: PushNetcashBatchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_netcashBatchDTO> {
        let url_ = this.baseUrl + "/netcashbatch/{id}/push";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushNetcashBatch(_response);
        });
    }

    protected processPushNetcashBatch(response: AxiosResponse): Promise<ApiResponse_netcashBatchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = JSON.parse(resultData202);
            return Promise.resolve<ApiResponse_netcashBatchDTO>(result202);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_netcashBatchDTO>(null as any);
    }
}

export class PayFastClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Calculate PayFast transaction fee
     * @param body The base amount to calculate fees for
     * @return The calculated PayFast fee breakdown
     */
    calculatePayFastFee(body: CalculatePayFastFeeRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_calculatePayFastFeeResponseDTO> {
        let url_ = this.baseUrl + "/payfast/calculate-fee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculatePayFastFee(_response);
        });
    }

    protected processCalculatePayFastFee(response: AxiosResponse): Promise<ApiResponse_calculatePayFastFeeResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_calculatePayFastFeeResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Error calculating fees", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_calculatePayFastFeeResponseDTO>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Checks if an email exists.
     * @param email The email address.
     * @return Payload of ApiResponse containing Boolean
     */
    checkEmailExists(email: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/users/check-email?";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailExists(_response);
        });
    }

    protected processCheckEmailExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Checks if a phone number exists.
     * @param phonenumber The phone number.
     * @return Payload of ApiResponse containing Boolean
     */
    checkPhoneNumberExists(phonenumber: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/users/check-phone-number?";
        if (phonenumber === undefined || phonenumber === null)
            throw new globalThis.Error("The parameter 'phonenumber' must be defined and cannot be null.");
        else
            url_ += "phonenumber=" + encodeURIComponent("" + phonenumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPhoneNumberExists(_response);
        });
    }

    protected processCheckPhoneNumberExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get a user by ID
     * @param id The ID of the user to fetch
     * @return Payload of ApiResponse containing UserDTO
     */
    getUserById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Update an existing user
     * @return Payload of ApiResponse containing UserEditDTO
     */
    updateUser(id: string, body: UserEditDTO, cancelToken?: CancelToken): Promise<ApiResponse_userEditDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ApiResponse_userEditDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userEditDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userEditDTO>(null as any);
    }

    /**
     * Deletes an existing user
     * @return Payload of ApiResponse containing String
     */
    deleteUser(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search for users
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    searchUsers(body: SearchRequestDTO_userSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/user/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Gets a list of all available permissions
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    getAllPermissions( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Gets permissions for a specific user
     * @param userId The ID of the user whose permissions to fetch
     * @return List of user's permissions
     */
    getUserPermissions(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Create a new user
     * @return Payload of ApiResponse containing UserDTO
     */
    createUser(body: UserCreateDTO, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_userDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Generates a password reset link
     * @return Payload of ApiResponse containing String
     */
    forgotPassword(body: ForgotPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Resets a user's password using a reset token
     * @return Payload of ApiResponse containing String
     */
    resetPassword(body: ResetPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Uploads a users profile picture.
     * @param fileName (optional) The file name to use when saving the image
     * @param body The raw image file to upload
     * @return The URL of the uploaded image
     */
    uploadProfilePicture(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/upload-profile-picture?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProfilePicture(_response);
        });
    }

    protected processUploadProfilePicture(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a SAS token for a user's profile picture.
     * @param userId The ID of the user.
     * @return The SAS URL for the profile picture.
     */
    generateProfilePictureSas(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/users/{userId}/profile-picture";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateProfilePictureSas(_response);
        });
    }

    protected processGenerateProfilePictureSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export interface ActivatePartnerOptInDTO {
    memberId?: string | undefined;
    partnerId?: string | undefined;
}

export interface ActivatePartnerOptInResultDTO {
    optInUrl?: string | undefined;
    alreadyOptedIn?: boolean | undefined;
    partnerName?: string | undefined;
}

export interface ActivityCategoryDTO {
    id?: string | undefined;
    activityTypeId?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
    activityType?: ActivityTypeDTO | undefined;
}

export interface ActivityCategorySearchRequestDTO {
    activityTypeId?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ActivityDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    isDeleted?: boolean | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    scoreId?: string | undefined;
    activityStatusId?: string | undefined;
    activityStatus?: ActivityStatusDTO | undefined;
    activityTypeId?: string | undefined;
    activityType?: ActivityTypeDTO | undefined;
    typeOther?: string | undefined;
    activityCategoryId?: string | undefined;
    activityCategory?: ActivityCategoryDTO | undefined;
    isQuickEvent?: boolean | undefined;
    categoryOther?: string | undefined;
    dateYear?: string | undefined;
    complianceYear?: string | undefined;
    complianceYearDisplay?: number | undefined;
    activityDate?: Date | undefined;
    leaveDate?: Date | undefined;
    returnDate?: Date | undefined;
    dateDays?: number | undefined;
    activityReason?: string | undefined;
    countryId?: string | undefined;
    country?: CountryDTO | undefined;
    provinceId?: string | undefined;
    province?: ProvinceDTO | undefined;
    provinceOther?: string | undefined;
    typeActivity?: string | undefined;
    town?: string | undefined;
    location?: string | undefined;
    unitsLoaded?: string | undefined;
    propellant?: string | undefined;
    casing?: string | undefined;
    bulletWeight?: string | undefined;
    reloadingPress?: string | undefined;
    makeOfDie?: string | undefined;
    speed?: string | undefined;
    isHuntAnimal?: boolean | undefined;
    memberFirearmId?: string | undefined;
    memberFirearm?: MemberFirearmDTO | undefined;
    firearmTypeId?: string | undefined;
    firearmSpecificId?: string | undefined;
    firearmCalibreId?: string | undefined;
    firearmCalibreOther?: string | undefined;
    confirmationFileId?: string | undefined;
    additionalConfirmationFile1Id?: string | undefined;
    additionalConfirmationFile2Id?: string | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    feedbackFileId?: string | undefined;
    statusDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    nonActiveTypeId?: string | undefined;
    nonActiveType?: ActivityTypeDTO | undefined;
    notes?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
    activitySpecies?: ActivitySpeciesDTO[] | undefined;
}

export interface ActivitySearchRequestDTO {
    generalSearchTerm?: string | undefined;
    memberId?: string | undefined;
    idPassportNumber?: string | undefined;
    scoreId?: string | undefined;
    activityStatusId?: string | undefined;
    activityTypeId?: string | undefined;
    typeOther?: string | undefined;
    activityCategoryId?: string | undefined;
    categoryOther?: string | undefined;
    dateYear?: string | undefined;
    complianceYear?: string | undefined;
    activityDate?: Date | undefined;
    leaveDate?: Date | undefined;
    returnDate?: Date | undefined;
    dateDays?: number | undefined;
    activityReason?: string | undefined;
    countryId?: string | undefined;
    provinceId?: string | undefined;
    provinceOther?: string | undefined;
    typeActivity?: string | undefined;
    town?: string | undefined;
    location?: string | undefined;
    unitsLoaded?: string | undefined;
    propellant?: string | undefined;
    casing?: string | undefined;
    bulletWeight?: string | undefined;
    reloadingPress?: string | undefined;
    makeOfDie?: string | undefined;
    speed?: string | undefined;
    isHuntAnimal?: boolean | undefined;
    memberFirearmId?: string | undefined;
    firearmTypeId?: string | undefined;
    firearmSpecificId?: string | undefined;
    firearmCalibreId?: string | undefined;
    firearmCalibreOther?: string | undefined;
    confirmationFileId?: string | undefined;
    additionalConfirmationFile1Id?: string | undefined;
    additionalConfirmationFile2Id?: string | undefined;
    replyTemplateId?: string | undefined;
    statusDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    nonActiveTypeId?: string | undefined;
    notes?: string | undefined;
    isDeleted?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface ActivitySpeciesDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    activityId?: string | undefined;
    memberId?: string | undefined;
    activitySpeciesTypeId?: string | undefined;
    activitySpeciesType?: ActivitySpeciesTypeDTO | undefined;
    speciesOther?: string | undefined;
    genderId?: string | undefined;
    gender?: GenderDTO | undefined;
    total?: number | undefined;
}

export interface ActivitySpeciesSearchRequestDTO {
    activityId?: string | undefined;
    memberId?: string | undefined;
    activitySpeciesTypeId?: string | undefined;
    speciesOther?: string | undefined;
    genderId?: string | undefined;
    total?: number | undefined;
}

export interface ActivitySpeciesTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    activityTypeId?: string | undefined;
    activityCategoryId?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    activityType?: ActivityTypeDTO | undefined;
    activityCategory?: ActivityCategoryDTO | undefined;
}

export interface ActivitySpeciesTypeSearchRequestDTO {
    activityTypeId?: string | undefined;
    activityCategoryId?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ActivityStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ActivityStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ActivityTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface ActivityTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface AddInvoiceBatchToNetcashBatchRequestDTO {
    netcashBatchId?: string | undefined;
    year?: number | undefined;
    month?: number | undefined;
}

export interface AddInvoicesToNetcashBatchRequestDTO {
    invoiceIds?: string[] | undefined;
}

export interface ApiResponse_activatePartnerOptInResultDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivatePartnerOptInResultDTO | undefined;
}

export interface ApiResponse_activityCategoryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivityCategoryDTO | undefined;
}

export interface ApiResponse_activityDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivityDTO | undefined;
}

export interface ApiResponse_activitySpeciesDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivitySpeciesDTO | undefined;
}

export interface ApiResponse_activitySpeciesTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivitySpeciesTypeDTO | undefined;
}

export interface ApiResponse_activityStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivityStatusDTO | undefined;
}

export interface ApiResponse_activityTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivityTypeDTO | undefined;
}

export interface ApiResponse_articleDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ArticleDTO | undefined;
}

export interface ApiResponse_auditLogDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuditLogDTO | undefined;
}

export interface ApiResponse_authDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuthDTO | undefined;
}

export interface ApiResponse_bankDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BankDTO | undefined;
}

export interface ApiResponse_batchFileResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BatchFileResponseDTO | undefined;
}

export interface ApiResponse_boolean {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: boolean | undefined;
}

export interface ApiResponse_bulkEmailDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BulkEmailDTO | undefined;
}

export interface ApiResponse_calculatePayFastFeeResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CalculatePayFastFeeResponseDTO | undefined;
}

export interface ApiResponse_certificateTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CertificateTypeDTO | undefined;
}

export interface ApiResponse_colourGradingDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ColourGradingDTO | undefined;
}

export interface ApiResponse_companyInfoDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompanyInfoDTO | undefined;
}

export interface ApiResponse_competencyTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetencyTypeDTO | undefined;
}

export interface ApiResponse_competitionClassDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionClassDTO | undefined;
}

export interface ApiResponse_competitionClassTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionClassTypeDTO | undefined;
}

export interface ApiResponse_competitionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionDTO | undefined;
}

export interface ApiResponse_competitionEntryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionEntryDTO | undefined;
}

export interface ApiResponse_competitionExerciseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionExerciseDTO | undefined;
}

export interface ApiResponse_competitionExerciseTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionExerciseTypeDTO | undefined;
}

export interface ApiResponse_competitionResultDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionResultDTO | undefined;
}

export interface ApiResponse_competitionResultEntryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionResultEntryDTO | undefined;
}

export interface ApiResponse_competitionStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompetitionStatusDTO | undefined;
}

export interface ApiResponse_complianceHistoryResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ComplianceHistoryResponseDTO | undefined;
}

export interface ApiResponse_componentActionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ComponentActionDTO | undefined;
}

export interface ApiResponse_componentDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ComponentDTO | undefined;
}

export interface ApiResponse_contentCategoryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ContentCategoryDTO | undefined;
}

export interface ApiResponse_contentItemPublicDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ContentItemPublicDTO | undefined;
}

export interface ApiResponse_countryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CountryDTO | undefined;
}

export interface ApiResponse_courseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseDTO | undefined;
}

export interface ApiResponse_courseEvaluationAnswerDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseEvaluationAnswerDTO | undefined;
}

export interface ApiResponse_courseEvaluationDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseEvaluationDTO | undefined;
}

export interface ApiResponse_courseEvaluationSubmissionResultDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseEvaluationSubmissionResultDTO | undefined;
}

export interface ApiResponse_courseMaterialTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseMaterialTypeDTO | undefined;
}

export interface ApiResponse_courseStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseStatusDTO | undefined;
}

export interface ApiResponse_courseTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseTypeDTO | undefined;
}

export interface ApiResponse_createDebitOrderMandateResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CreateDebitOrderMandateResponseDTO | undefined;
}

export interface ApiResponse_documentTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: DocumentTypeDTO | undefined;
}

export interface ApiResponse_emailMessageAttachmentDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EmailMessageAttachmentDTO | undefined;
}

export interface ApiResponse_emailMessageDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EmailMessageDTO | undefined;
}

export interface ApiResponse_emailMessageThreadDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EmailMessageThreadDTO | undefined;
}

export interface ApiResponse_emailTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EmailTypeDTO | undefined;
}

export interface ApiResponse_endorsementLicenceTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EndorsementLicenceTypeDTO | undefined;
}

export interface ApiResponse_endorsementMotivationDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EndorsementMotivationDTO | undefined;
}

export interface ApiResponse_endorsementStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EndorsementStatusDTO | undefined;
}

export interface ApiResponse_enquiryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EnquiryDTO | undefined;
}

export interface ApiResponse_enquiryTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EnquiryTypeDTO | undefined;
}

export interface ApiResponse_evaluationStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: EvaluationStatusDTO | undefined;
}

export interface ApiResponse_exerciseActivityTargetDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExerciseActivityTargetDTO | undefined;
}

export interface ApiResponse_exerciseSpecificDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExerciseSpecificDTO | undefined;
}

export interface ApiResponse_exerciseTargetDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExerciseTargetDTO | undefined;
}

export interface ApiResponse_exerciseTemplateDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExerciseTemplateDTO | undefined;
}

export interface ApiResponse_exerciseTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExerciseTypeDTO | undefined;
}

export interface ApiResponse_farmStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FarmStatusDTO | undefined;
}

export interface ApiResponse_farmTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FarmTypeDTO | undefined;
}

export interface ApiResponse_fellowDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FellowDTO | undefined;
}

export interface ApiResponse_fileUrlResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FileUrlResponseDTO | undefined;
}

export interface ApiResponse_firearmActionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmActionDTO | undefined;
}

export interface ApiResponse_firearmBarrelDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmBarrelDTO | undefined;
}

export interface ApiResponse_firearmBarrelMakeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmBarrelMakeDTO | undefined;
}

export interface ApiResponse_firearmCalibreDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmCalibreDTO | undefined;
}

export interface ApiResponse_firearmCompetencyTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmCompetencyTypeDTO | undefined;
}

export interface ApiResponse_firearmLooseBarrelTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmLooseBarrelTypeDTO | undefined;
}

export interface ApiResponse_firearmMakeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmMakeDTO | undefined;
}

export interface ApiResponse_firearmOwnerDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmOwnerDTO | undefined;
}

export interface ApiResponse_firearmPurposeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmPurposeDTO | undefined;
}

export interface ApiResponse_firearmSerialTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmSerialTypeDTO | undefined;
}

export interface ApiResponse_firearmSpecificDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmSpecificDTO | undefined;
}

export interface ApiResponse_firearmTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FirearmTypeDTO | undefined;
}

export interface ApiResponse_forfeitureReasonDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ForfeitureReasonDTO | undefined;
}

export interface ApiResponse_friendAndPartnerDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FriendAndPartnerDTO | undefined;
}

export interface ApiResponse_genderDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: GenderDTO | undefined;
}

export interface ApiResponse_gradingCategoryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: GradingCategoryDTO | undefined;
}

export interface ApiResponse_gradingTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: GradingTypeDTO | undefined;
}

export interface ApiResponse_guid {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_iEnumerable_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivityCategoryDTO[] | undefined;
}

export interface ApiResponse_int32 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: number | undefined;
}

export interface ApiResponse_invoiceBatchDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceBatchDTO | undefined;
}

export interface ApiResponse_invoiceBatchRegenerationStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceBatchRegenerationStatusDTO | undefined;
}

export interface ApiResponse_invoiceDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceDTO | undefined;
}

export interface ApiResponse_invoiceLineItemDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceLineItemDTO | undefined;
}

export interface ApiResponse_invoiceStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceStatusDTO | undefined;
}

export interface ApiResponse_invoiceTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceTypeDTO | undefined;
}

export interface ApiResponse_languageDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: LanguageDTO | undefined;
}

export interface ApiResponse_list_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ActivityDTO[] | undefined;
}

export interface ApiResponse_listingDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ListingDTO | undefined;
}

export interface ApiResponse_listingStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ListingStatusDTO | undefined;
}

export interface ApiResponse_listingTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ListingTypeDTO | undefined;
}

export interface ApiResponse_lookupDTOOf {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: LookupDTO[] | undefined;
}

export interface ApiResponse_mandateEditFormDataDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MandateEditFormDataDTO | undefined;
}

export interface ApiResponse_mandateFormDataDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MandateFormDataDTO | undefined;
}

export interface ApiResponse_mandateStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MandateStatusDTO | undefined;
}

export interface ApiResponse_marksmanGradingQualificationDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MarksmanGradingQualificationDTO | undefined;
}

export interface ApiResponse_memberAdditionalDocumentDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberAdditionalDocumentDTO | undefined;
}

export interface ApiResponse_memberCancelReasonDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberCancelReasonDTO | undefined;
}

export interface ApiResponse_memberCategoryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberCategoryDTO | undefined;
}

export interface ApiResponse_memberCompetencyDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberCompetencyDTO | undefined;
}

export interface ApiResponse_memberDisciplinaryStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberDisciplinaryStatusDTO | undefined;
}

export interface ApiResponse_memberDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberDTO | undefined;
}

export interface ApiResponse_memberEndorsementDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberEndorsementDTO | undefined;
}

export interface ApiResponse_memberFeeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberFeeDTO | undefined;
}

export interface ApiResponse_memberFirearmDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberFirearmDTO | undefined;
}

export interface ApiResponse_memberIdTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberIdTypeDTO | undefined;
}

export interface ApiResponse_memberProfileDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberProfileDTO | undefined;
}

export interface ApiResponse_memberReferralTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberReferralTypeDTO | undefined;
}

export interface ApiResponse_memberRegistrationStepDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberRegistrationStepDTO | undefined;
}

export interface ApiResponse_memberRegistrationTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberRegistrationTypeDTO | undefined;
}

export interface ApiResponse_memberSimpleDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberSimpleDTO | undefined;
}

export interface ApiResponse_memberStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberStatusDTO | undefined;
}

export interface ApiResponse_memberTerminationStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberTerminationStatusDTO | undefined;
}

export interface ApiResponse_memberTitleDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberTitleDTO | undefined;
}

export interface ApiResponse_memberTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberTypeDTO | undefined;
}

export interface ApiResponse_memberVerificationResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberVerificationResponseDTO | undefined;
}

export interface ApiResponse_messageTemplateStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MessageTemplateStatusDTO | undefined;
}

export interface ApiResponse_moduleTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ModuleTypeDTO | undefined;
}

export interface ApiResponse_netcashAddInvoicesResultDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NetcashAddInvoicesResultDTO | undefined;
}

export interface ApiResponse_netcashBatchDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NetcashBatchDTO | undefined;
}

export interface ApiResponse_netcashInvoiceAvailabilityResultDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NetcashInvoiceAvailabilityResultDTO | undefined;
}

export interface ApiResponse_newsItemDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NewsItemDTO | undefined;
}

export interface ApiResponse_newsletterCategoryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NewsletterCategoryDTO | undefined;
}

export interface ApiResponse_newsletterDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NewsletterDTO | undefined;
}

export interface ApiResponse_newsletterPublicDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NewsletterPublicDTO | undefined;
}

export interface ApiResponse_noteDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NoteDTO | undefined;
}

export interface ApiResponse_noteTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: NoteTypeDTO | undefined;
}

export interface ApiResponse_object {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: any | undefined;
}

export interface ApiResponse_pageContentDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PageContentDTO | undefined;
}

export interface ApiResponse_pagesDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PagesDTO | undefined;
}

export interface ApiResponse_paymentDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentDTO | undefined;
}

export interface ApiResponse_paymentIntervalDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentIntervalDTO | undefined;
}

export interface ApiResponse_paymentTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PaymentTypeDTO | undefined;
}

export interface ApiResponse_provinceDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ProvinceDTO | undefined;
}

export interface ApiResponse_questionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuestionDTO | undefined;
}

export interface ApiResponse_questionSetDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuestionSetDTO | undefined;
}

export interface ApiResponse_quickEventDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: QuickEventDTO | undefined;
}

export interface ApiResponse_rangeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RangeDTO | undefined;
}

export interface ApiResponse_rangeShootingReasonDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RangeShootingReasonDTO | undefined;
}

export interface ApiResponse_rangeStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RangeStatusDTO | undefined;
}

export interface ApiResponse_rangeTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RangeTypeDTO | undefined;
}

export interface ApiResponse_reconBatchDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ReconBatchDTO | undefined;
}

export interface ApiResponse_reconTransactionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ReconTransactionDTO | undefined;
}

export interface ApiResponse_reconTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ReconTypeDTO | undefined;
}

export interface ApiResponse_renewalStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RenewalStatusDTO | undefined;
}

export interface ApiResponse_replyTemplateDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ReplyTemplateDTO | undefined;
}

export interface ApiResponse_replyTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ReplyTypeDTO | undefined;
}

export interface ApiResponse_rplDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RplDTO | undefined;
}

export interface ApiResponse_rplStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: RplStatusDTO | undefined;
}

export interface ApiResponse_scoreDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ScoreDTO | undefined;
}

export interface ApiResponse_scoreStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ScoreStatusDTO | undefined;
}

export interface ApiResponse_scoreTargetFileDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ScoreTargetFileDTO | undefined;
}

export interface ApiResponse_scoreTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ScoreTypeDTO | undefined;
}

export interface ApiResponse_searchResponseDTO_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SearchResponseDTO_activityCategoryDTO | undefined;
}

export interface ApiResponse_string {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_twoFactorSetupResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: TwoFactorSetupResponseDTO | undefined;
}

export interface ApiResponse_userDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserDTO | undefined;
}

export interface ApiResponse_userEditDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserEditDTO | undefined;
}

export interface ApiResponse_vatRateHistoryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: VatRateHistoryDTO | undefined;
}

export interface ArticleDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    slug?: string | undefined;
    date?: Date | undefined;
    summary?: string | undefined;
    contentFileId?: string | undefined;
    content?: string | undefined;
    body?: string | undefined;
    externalUrl?: string | undefined;
    pictureFileRecordId?: string | undefined;
    contentCategoryId?: string | undefined;
    contentCategory?: ContentCategoryDTO | undefined;
    showOnLanding?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface ArticleSearchRequestDTO {
    title?: string | undefined;
    slug?: string | undefined;
    date?: Date | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    pictureFileRecordId?: string | undefined;
    contentCategoryId?: string | undefined;
    isActive?: boolean | undefined;
}

export interface AuditLogDTO {
    action?: string | undefined;
    tableName?: string | undefined;
    recordId?: string | undefined;
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    changedBy?: string | undefined;
}

export interface AuditLogSearchRequestDTO {
    tableName?: string | undefined;
    recordId?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface AuthDTO {
    accessToken?: string | undefined;
    expiresAt?: number | undefined;
    refreshToken?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
}

export interface BankDTO {
    id?: string | undefined;
    friendlyName?: string | undefined;
    netcashName?: string | undefined;
    branchCode?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface BankOptionDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface BankSearchRequestDTO {
    friendlyName?: string | undefined;
    netcashName?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface BatchFileResponseDTO {
    fileToken?: string | undefined;
    status?: string | undefined;
    submittedCount?: number | undefined;
    errors?: string[] | undefined;
}

export interface BulkEmailDTO {
    id?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    bulkEmailStatusId?: string | undefined;
    communicationListId?: string | undefined;
    totalCount?: number | undefined;
    totalCountProcessed?: number | undefined;
    totalBatches?: number | undefined;
    processedBatches?: number | undefined;
    fileRecordId?: string | undefined;
    customListFileRecordId?: string | undefined;
    bulkEmailStatusName?: string | undefined;
    communicationListName?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
}

export interface BulkEmailSearchRequestDTO {
    subject?: string | undefined;
}

export interface BulkMemberIdsDTO {
    recordIds?: string[] | undefined;
}

export interface CalculatePayFastFeeRequestDTO {
    amount?: number | undefined;
}

export interface CalculatePayFastFeeResponseDTO {
    baseAmount?: number | undefined;
    payFastFee?: number | undefined;
    totalWithFee?: number | undefined;
}

export interface CancelRegistrationRequestDTO {
    token?: string | undefined;
}

export interface CategoryQualificationDTO {
    gradingCategoryId?: string | undefined;
    categoryName?: string | undefined;
    year?: number | undefined;
    gradingTypeId?: string | undefined;
    gradingTypeName?: string | undefined;
    totalScoresSubmitted?: number | undefined;
    averageScore?: number | undefined;
    totalScore?: number | undefined;
    firstScoreDate?: Date | undefined;
    lastScoreDate?: Date | undefined;
    gradingLevel?: string | undefined;
    gradingLevelDescription?: string | undefined;
    nextGradingLevel?: string | undefined;
    nextGradingLevelThreshold?: number | undefined;
}

export interface CertificateStatusDTO {
    hunter?: string | undefined;
    sport?: string | undefined;
}

export interface CertificateTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CertificateTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CheckExamineeIdRequestDTO {
    examineeId?: string | undefined;
    memberId?: string | undefined;
    courseId?: string | undefined;
}

export interface ColourGradingDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colour?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ColourGradingSearchRequestDTO {
    title?: string | undefined;
    colour?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompanyInfoDTO {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    pbo?: string | undefined;
    npc?: string | undefined;
    webAddress?: string | undefined;
    vatNumber?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
    lastUsedPaymentNoticeNumber?: number | undefined;
}

export interface CompanyInfoSearchRequestDTO {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface CompetencyTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetencyTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionClassDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionClassSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionClassTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionClassTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amount?: number | undefined;
    registrationOpenDate?: Date | undefined;
    registrationCloseDate?: Date | undefined;
    targetDownloadOpenDate?: Date | undefined;
    targetDownloadCloseDate?: Date | undefined;
    rulesTargetUrl?: string | undefined;
    showBannerDate?: Date | undefined;
}

export interface CompetitionEntryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    competitionId?: string | undefined;
    competition?: CompetitionDTO | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    competitionClassId?: string | undefined;
    competitionClass?: CompetitionClassDTO | undefined;
    year?: number | undefined;
    age?: number | undefined;
    proofOfPaymentFileId?: string | undefined;
    reference?: string | undefined;
    isPaymentConfirmed?: boolean | undefined;
    paymentMethodId?: string | undefined;
    competitionStatusId?: string | undefined;
    competitionStatus?: CompetitionStatusDTO | undefined;
    courierProvinceId?: string | undefined;
    courierProvince?: ProvinceDTO | undefined;
    courierAddress?: string | undefined;
    courierStreet?: string | undefined;
    courierTown?: string | undefined;
    courierSuburb?: string | undefined;
    courierCode?: string | undefined;
    courierNote?: string | undefined;
    isDeleted?: boolean | undefined;
}

export interface CompetitionEntrySearchRequestDTO {
    generalSearchTerm?: string | undefined;
    competitionId?: string | undefined;
    memberId?: string | undefined;
    competitionClassId?: string | undefined;
    year?: number | undefined;
    age?: number | undefined;
    proofOfPaymentFileId?: string | undefined;
    reference?: string | undefined;
    isPaymentConfirmed?: boolean | undefined;
    competitionStatusId?: string | undefined;
    courierProvinceId?: string | undefined;
    courierAddress?: string | undefined;
    courierStreet?: string | undefined;
    courierTown?: string | undefined;
    courierSuburb?: string | undefined;
    courierCode?: string | undefined;
    courierNote?: string | undefined;
}

export interface CompetitionExerciseDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    competitionExerciseTypeId?: string | undefined;
    competitionExerciseType?: CompetitionExerciseTypeDTO | undefined;
    exerciseSpecificTitle?: string | undefined;
    exerciseSpecificId?: string | undefined;
    exerciseSpecific?: ExerciseSpecificDTO | undefined;
    competitionClassTypeId?: string | undefined;
    competitionClassType?: CompetitionClassTypeDTO | undefined;
    genderId?: string | undefined;
    gender?: GenderDTO | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionExerciseSearchRequestDTO {
    competitionExerciseTypeId?: string | undefined;
    exerciseSpecificTitle?: string | undefined;
    exerciseSpecificId?: string | undefined;
    competitionClassTypeId?: string | undefined;
    genderId?: string | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionExerciseTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionExerciseTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionResultDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    competitionId?: string | undefined;
    competition?: CompetitionDTO | undefined;
}

export interface CompetitionResultEntryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    competitionResultId?: string | undefined;
    competitionResult?: CompetitionResultDTO | undefined;
    competitionExerciseId?: string | undefined;
    competitionExercise?: CompetitionExerciseDTO | undefined;
    scoreId?: string | undefined;
    score?: ScoreDTO | undefined;
    position?: number | undefined;
    rank?: number | undefined;
}

export interface CompetitionResultEntryRankUpdateDTO {
    id?: string | undefined;
    position?: number | undefined;
    rank?: number | undefined;
}

export interface CompetitionResultEntrySearchRequestDTO {
    competitionResultId?: string | undefined;
    competitionExerciseId?: string | undefined;
    scoreId?: string | undefined;
    memberId?: string | undefined;
    position?: number | undefined;
    rank?: number | undefined;
}

export interface CompetitionResultSearchRequestDTO {
    competitionId?: string | undefined;
}

export interface CompetitionSearchRequestDTO {
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amount?: number | undefined;
    registrationOpenDate?: Date | undefined;
    registrationCloseDate?: Date | undefined;
    targetDownloadOpenDate?: Date | undefined;
    targetDownloadCloseDate?: Date | undefined;
    rulesTargetUrl?: string | undefined;
    showBannerDate?: Date | undefined;
}

export interface CompetitionStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CompetitionStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ComplianceHistoryResponseDTO {
    complianceYears?: ComplianceYearDTO[] | undefined;
}

export interface ComplianceYearDTO {
    yearKey?: string | undefined;
    title?: string | undefined;
    activities?: ActivityDTO[] | undefined;
    certificateStatus?: CertificateStatusDTO | undefined;
}

export interface ComponentActionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ComponentActionSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ComponentDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    placeholders?: ComponentPlaceholderDTO[] | undefined;
}

export interface ComponentPlaceholderDTO {
    id?: string | undefined;
    componentId?: string | undefined;
    tag?: string | undefined;
    path?: string | undefined;
    description?: string | undefined;
    type?: ComponentPlaceholderDTOType | undefined;
    isActive?: boolean | undefined;
}

export interface ComponentSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ConfirmEmailDTO {
    email?: string | undefined;
    token?: string | undefined;
}

export interface ContentCategoryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ContentCategorySearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ContentItemPublicDTO {
    id?: string | undefined;
    title?: string | undefined;
    slug?: string | undefined;
    date?: Date | undefined;
    summary?: string | undefined;
    contentCategoryId?: string | undefined;
    categoryTitle?: string | undefined;
    pictureUrl?: string | undefined;
    externalUrl?: string | undefined;
    content?: string | undefined;
}

export interface CountryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CountrySearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CourseDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    courseTypeId?: string | undefined;
    courseType?: CourseTypeDTO | undefined;
    courseMaterialTypeId?: string | undefined;
    courseMaterialType?: CourseMaterialTypeDTO | undefined;
    courseStatusId?: string | undefined;
    courseStatus?: CourseStatusDTO | undefined;
    paymentReference?: string | undefined;
    proofOfPaymentFileId?: string | undefined;
    courierProvinceId?: string | undefined;
    courierAddress?: string | undefined;
    courierStreet?: string | undefined;
    courierSuburb?: string | undefined;
    courierTown?: string | undefined;
    courierCode?: string | undefined;
    courierNote?: string | undefined;
    courierTrackingReference?: string | undefined;
    paymentTypeId?: string | undefined;
    paymentType?: PaymentTypeDTO | undefined;
    evaluationStatusId?: string | undefined;
    evaluationStatus?: EvaluationStatusDTO | undefined;
    evaluationScorePercentage?: number | undefined;
    evaluationScoreMark?: number | undefined;
    isHideDistinguished?: boolean | undefined;
    scores?: ScoreDTO[] | undefined;
    timeMaterialDownloaded?: Date | undefined;
    timeMaterialShipped?: Date | undefined;
    amountPaid?: number | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    note?: string | undefined;
    paidDate?: Date | undefined;
    emailSentDate?: Date | undefined;
    emailPaymentSentDate?: Date | undefined;
    termsAcceptedDate?: Date | undefined;
    invoiceCreatedDate?: Date | undefined;
    invoiceSentDate?: Date | undefined;
    theoryDate?: Date | undefined;
    practicalDate?: Date | undefined;
    statusDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    questionUse?: string | undefined;
    isDeleted?: boolean | undefined;
    sendFeedbackEmail?: boolean | undefined;
    forfeitureReasonId?: string | undefined;
    forfeitureReason?: ForfeitureReasonDTO | undefined;
    forfeitureDate?: Date | undefined;
    forfeitureSignedAtLocation?: string | undefined;
    forfeitureSignatureFileId?: string | undefined;
    forfeitureHasSection16Licence?: boolean | undefined;
    forfeitureOtherReason?: string | undefined;
}

export interface CourseEvaluationAnswerDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    courseEvaluationId?: string | undefined;
    memberId?: string | undefined;
    questionId?: string | undefined;
    userAnswerId?: string | undefined;
    isCorrect?: boolean | undefined;
}

export interface CourseEvaluationAnswerSearchRequestDTO {
    courseEvaluationId?: string | undefined;
    memberId?: string | undefined;
    questionId?: string | undefined;
    userAnswerId?: string | undefined;
    isCorrect?: boolean | undefined;
}

export interface CourseEvaluationDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    courseId?: string | undefined;
    memberId?: string | undefined;
    evaluationStatusId?: string | undefined;
    evaluationStatus?: EvaluationStatusDTO | undefined;
    courseTypeId?: string | undefined;
    courseType?: CourseTypeDTO | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    scorePercentage?: number | undefined;
    scoreMark?: number | undefined;
    userAgent?: string | undefined;
    ip?: string | undefined;
    cookieGuid?: string | undefined;
}

export interface CourseEvaluationSearchRequestDTO {
    courseId?: string | undefined;
    memberId?: string | undefined;
    evaluationStatusId?: string | undefined;
    courseTypeId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    scorePercentage?: number | undefined;
    scoreMark?: number | undefined;
    userAgent?: string | undefined;
    ip?: string | undefined;
    cookieGuid?: string | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface CourseEvaluationSubmissionAnswerDTO {
    questionId?: string | undefined;
    userAnswerId?: string | undefined;
    isCorrect?: boolean | undefined;
}

export interface CourseEvaluationSubmissionDTO {
    courseId?: string | undefined;
    memberId?: string | undefined;
    courseTypeId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    scorePercentage?: number | undefined;
    scoreMark?: number | undefined;
    cookieGuid?: string | undefined;
    answers?: CourseEvaluationSubmissionAnswerDTO[] | undefined;
}

export interface CourseEvaluationSubmissionResultDTO {
    courseEvaluationId?: string | undefined;
    isPassed?: boolean | undefined;
    evaluationStatusId?: string | undefined;
    courseStatusId?: string | undefined;
}

export interface CourseMaterialTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    fee?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CourseMaterialTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CourseSearchRequestDTO {
    generalSearchTerm?: string | undefined;
    memberId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idPassportNumber?: string | undefined;
    courseTypeId?: string | undefined;
    courseMaterialTypeId?: string | undefined;
    courseStatusId?: string | undefined;
    paymentReference?: string | undefined;
    proofOfPaymentFileId?: string | undefined;
    courierProvinceId?: string | undefined;
    courierAddress?: string | undefined;
    courierStreet?: string | undefined;
    courierSuburb?: string | undefined;
    courierTown?: string | undefined;
    courierCode?: string | undefined;
    courierNote?: string | undefined;
    courierTrackingReference?: string | undefined;
    paymentTypeId?: string | undefined;
    evaluationStatusId?: string | undefined;
    evaluationScorePercentage?: number | undefined;
    evaluationScoreMark?: number | undefined;
    isHideDistinguished?: boolean | undefined;
    timeMaterialDownloaded?: Date | undefined;
    timeMaterialShipped?: Date | undefined;
    amountPaid?: number | undefined;
    replyTemplateId?: string | undefined;
    note?: string | undefined;
    paidDate?: Date | undefined;
    emailSentDate?: Date | undefined;
    emailPaymentSentDate?: Date | undefined;
    termsAcceptedDate?: Date | undefined;
    invoiceCreatedDate?: Date | undefined;
    invoiceSentDate?: Date | undefined;
    theoryDate?: Date | undefined;
    practicalDate?: Date | undefined;
    statusDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    questionUse?: string | undefined;
    isDeleted?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface CourseStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CourseStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CourseTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    dedicatedStatusFee?: number | undefined;
    rplFee?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CourseTypeSearchRequestDTO {
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface CreateDebitOrderMandateRequestDTO {
    memberId?: string | undefined;
    signatureFileId?: string | undefined;
    accountHolder?: string | undefined;
    bankId?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    amount?: number | undefined;
    dayOfMonth?: number | undefined;
    firstDebitDate?: Date | undefined;
    signedAt?: string | undefined;
}

export interface CreateDebitOrderMandateResponseDTO {
    mandateId?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    fileToken?: string | undefined;
}

export interface CreateNetcashBatchRequestDTO {
    year?: number | undefined;
    month?: number | undefined;
}

export interface DocumentTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface DocumentTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EftPaymentDTO {
    componentId?: string | undefined;
    paymentId?: string | undefined;
    invoiceId?: string | undefined;
    entityType?: string | undefined;
    paidUpTo?: Date | undefined;
}

export interface EmailMessageAttachmentDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    emailMessageId?: string | undefined;
    fileRecordId?: string | undefined;
}

export interface EmailMessageAttachmentSearchRequestDTO {
    emailMessageId?: string | undefined;
    fileRecordId?: string | undefined;
}

export interface EmailMessageDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    adminUserId?: string | undefined;
    adminUser?: UserDTO | undefined;
    recordId?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    replyTo?: string | undefined;
    from?: string | undefined;
    parentEmailMessageId?: string | undefined;
    apiId?: string | undefined;
    apiResponse?: string | undefined;
    apiDateSent?: Date | undefined;
    isReply?: boolean | undefined;
    isReplyFromAdmin?: boolean | undefined;
    reference?: string | undefined;
    replyTypeId?: string | undefined;
    replyType?: ReplyTypeDTO | undefined;
    messageBodyFileId?: string | undefined;
    emailMessageThreadId?: string | undefined;
    emailCC?: string | undefined;
    emailBCC?: string | undefined;
    componentId?: string | undefined;
    emailAttachments?: EmailMessageAttachmentDTO[] | undefined;
}

export interface EmailMessageSearchRequestDTO {
    memberId?: string | undefined;
    adminUserId?: string | undefined;
    recordId?: string | undefined;
    subject?: string | undefined;
    replyTo?: string | undefined;
    from?: string | undefined;
    parentEmailMessageId?: string | undefined;
    apiId?: string | undefined;
    apiResponse?: string | undefined;
    apiDateSent?: Date | undefined;
    isReply?: boolean | undefined;
    isReplyFromAdmin?: boolean | undefined;
    reference?: string | undefined;
    replyTypeId?: string | undefined;
    messageBodyFileId?: string | undefined;
    emailMessageThreadId?: string | undefined;
    emailCC?: string | undefined;
    emailBCC?: string | undefined;
    componentId?: string | undefined;
}

export interface EmailMessageThreadDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    componentId?: string | undefined;
    component?: ComponentDTO | undefined;
    reference?: string | undefined;
    ticketRating?: number | undefined;
    subject?: string | undefined;
    rootEmailMessageId?: string | undefined;
    rootEmailMessage?: EmailMessageDTO | undefined;
    lastEmailMessageId?: string | undefined;
    lastEmailMessage?: EmailMessageDTO | undefined;
    isDeleted?: boolean | undefined;
}

export interface EmailMessageThreadSearchRequestDTO {
    generalSearchTerm?: string | undefined;
    componentId?: string | undefined;
    reference?: string | undefined;
    ticketRating?: number | undefined;
    subject?: string | undefined;
    rootEmailMessageId?: string | undefined;
    lastEmailMessageId?: string | undefined;
    adminUserId?: string | undefined;
    replyTypeId?: string | undefined;
    idPassportNumber?: string | undefined;
}

export interface EmailTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EmailTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EndorsementLicenceTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EndorsementLicenceTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EndorsementMotivationDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    isActive?: boolean | undefined;
}

export interface EndorsementMotivationSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EndorsementStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EndorsementStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EnquiryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    idPassportNumber?: string | undefined;
    emailAddress?: string | undefined;
    contact?: string | undefined;
    contactRequest?: string | undefined;
    enquiryTypeId?: string | undefined;
    enquiryType?: EnquiryTypeDTO | undefined;
}

export interface EnquirySearchRequestDTO {
    name?: string | undefined;
    surname?: string | undefined;
    idPassportNumber?: string | undefined;
    emailAddress?: string | undefined;
    contact?: string | undefined;
    contactRequest?: string | undefined;
    enquiryTypeId?: string | undefined;
}

export interface EnquiryTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    emailAddress?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EnquiryTypeSearchRequestDTO {
    title?: string | undefined;
    emailAddress?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EvaluationStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface EvaluationStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ExerciseActivityTargetDTO {
    id?: string | undefined;
    title?: string | undefined;
    isUrl?: boolean | undefined;
    imageUrl?: string | undefined;
    imageId?: string | undefined;
    displayPosition?: number | undefined;
    isPortrait?: boolean | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface ExerciseActivityTargetSearchRequestDTO {
    title?: string | undefined;
    isUrl?: boolean | undefined;
    imageUrl?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ExerciseSpecificDTO {
    id?: string | undefined;
    title?: string | undefined;
    exerciseTemplateId?: string | undefined;
    isComplianceHunt?: boolean | undefined;
    isComplianceSport?: boolean | undefined;
    isEvaluationHunt?: boolean | undefined;
    isEvaluationSport?: boolean | undefined;
    isCompetition?: boolean | undefined;
    isHuntActivity?: boolean | undefined;
    isSportShootingActivity?: boolean | undefined;
    isActive?: boolean | undefined;
    maxTargetsPerCategory?: number | undefined;
    exerciseTemplate?: ExerciseTemplateDTO | undefined;
    targets?: ExerciseTargetDTO[] | undefined;
    calibres?: FirearmCalibreDTO[] | undefined;
    createdUtc?: Date | undefined;
    exerciseSpecificTargets?: ExerciseSpecificTargetDTO[] | undefined;
}

export interface ExerciseSpecificSearchRequestDTO {
    title?: string | undefined;
    templateId?: string | undefined;
    isComplianceHunt?: boolean | undefined;
    isComplianceSport?: boolean | undefined;
    isEvaluationHunt?: boolean | undefined;
    isEvaluationSport?: boolean | undefined;
    isCompetition?: boolean | undefined;
    isHuntActivity?: boolean | undefined;
    isSportShootingActivity?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface ExerciseSpecificTargetDTO {
    exerciseSpecificId?: string | undefined;
    exerciseSpecific?: ExerciseSpecificDTO | undefined;
    exerciseTargetId?: string | undefined;
    exerciseTarget?: ExerciseTargetDTO | undefined;
}

export interface ExerciseTargetDTO {
    id?: string | undefined;
    title?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    targetImageId?: string | undefined;
    targetImage?: FileRecordDTO | undefined;
    targetImageBwId?: string | undefined;
    targetImageBw?: FileRecordDTO | undefined;
    rulesUrl?: string | undefined;
    evaluationSportImageId?: string | undefined;
    evaluationSportImage?: FileRecordDTO | undefined;
    evaluationHuntImageId?: string | undefined;
    evaluationHuntImage?: FileRecordDTO | undefined;
    competitionRulesUrl?: string | undefined;
    competitionImageId?: string | undefined;
    competitionImage?: FileRecordDTO | undefined;
    isPortrait?: boolean | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface ExerciseTargetSearchRequestDTO {
    title?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    imageBwUrl?: string | undefined;
    rulesUrl?: string | undefined;
    evaluationSportImageUrl?: string | undefined;
    evaluationHuntImageUrl?: string | undefined;
    competitionRulesUrl?: string | undefined;
    competitionImageUrl?: string | undefined;
    displayPosition?: number | undefined;
    isPortrait?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface ExerciseTemplateDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
    sections?: ExerciseTemplateSectionDTO[] | undefined;
}

export interface ExerciseTemplateSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ExerciseTemplateSectionDTO {
    id?: string | undefined;
    exerciseTemplateId?: string | undefined;
    title?: string | undefined;
    rows?: number | undefined;
    maxShots?: number | undefined;
    maxTotal?: number | undefined;
    shouldCaptureTime?: boolean | undefined;
    shouldCalculateMark?: boolean | undefined;
    shouldTotalBeDisabled?: boolean | undefined;
    shouldPercentageBeDisabled?: boolean | undefined;
    displayPosition?: number | undefined;
    createdUtc?: Date | undefined;
    exerciseTemplate?: ExerciseTemplateDTO | undefined;
    fields?: ExerciseTemplateSectionFieldDTO[] | undefined;
}

export interface ExerciseTemplateSectionFieldDTO {
    id?: string | undefined;
    exerciseTemplateSectionId?: string | undefined;
    title?: string | undefined;
    fieldType?: string | undefined;
    row?: number | undefined;
    pointValue?: number | undefined;
    displayPosition?: number | undefined;
    createdUtc?: Date | undefined;
    exerciseTemplateSection?: ExerciseTemplateSectionDTO | undefined;
}

export interface ExerciseTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    isPostal?: boolean | undefined;
    isCompetition?: boolean | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface ExerciseTypeSearchRequestDTO {
    title?: string | undefined;
    isPostal?: boolean | undefined;
    isCompetition?: boolean | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FarmStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FarmStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FarmTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FarmTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FellowDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    provinceId?: string | undefined;
    province?: ProvinceDTO | undefined;
    website?: string | undefined;
    canWriteEndorsementMotivations?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface FellowSearchRequestDTO {
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    provinceId?: string | undefined;
    website?: string | undefined;
    canWriteEndorsementMotivations?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface FileRecordDTO {
    id?: string | undefined;
    container?: string | undefined;
    fileName?: string | undefined;
    blobPath?: string | undefined;
    contentType?: string | undefined;
    originalSizeInBytes?: number | undefined;
    finalSizeInBytes?: number | undefined;
    status?: FileRecordDTOStatus | undefined;
}

export interface FileUrlResponseDTO {
    url?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeInBytes?: number | undefined;
    status?: string | undefined;
}

export interface FirearmActionDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmActionSearchRequestDTO {
    title?: string | undefined;
    firearmSpecificId?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmBarrelDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmBarrelMakeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmBarrelMakeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmBarrelSearchRequestDTO {
    title?: string | undefined;
    firearmSpecificId?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmCalibreDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmCalibreSearchRequestDTO {
    title?: string | undefined;
    firearmLooseBarrelTypeId?: string | undefined;
    firearmSpecificId?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmCompetencyTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmCompetencyTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmLooseBarrelTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    notOnList?: boolean | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    calibres?: FirearmCalibreDTO[] | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmLooseBarrelTypeSearchRequestDTO {
    title?: string | undefined;
    notOnList?: boolean | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmMakeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmMakeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmOwnerDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmOwnerSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmPurposeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmPurposeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmSerialTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmSerialTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmSpecificDTO {
    id?: string | undefined;
    title?: string | undefined;
    firearmTypeId?: string | undefined;
    notOnList?: boolean | undefined;
    barrelLength?: boolean | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
    firearmType?: FirearmTypeDTO | undefined;
    calibres?: FirearmCalibreDTO[] | undefined;
    actions?: FirearmActionDTO[] | undefined;
    barrels?: FirearmBarrelDTO[] | undefined;
    purposes?: FirearmPurposeDTO[] | undefined;
    exercises?: FirearmSpecificExerciseDTO[] | undefined;
}

export interface FirearmSpecificExerciseDTO {
    id?: string | undefined;
    exerciseTypeId?: string | undefined;
    firearmSpecific?: FirearmSpecificDTO | undefined;
    exerciseType?: ExerciseTypeDTO | undefined;
    exerciseSpecifics?: ExerciseSpecificDTO[] | undefined;
}

export interface FirearmSpecificSearchRequestDTO {
    title?: string | undefined;
    firearmTypeId?: string | undefined;
    notOnList?: boolean | undefined;
    barrelLength?: boolean | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FirearmTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface FirearmTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ForfeitureReasonDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ForfeitureReasonSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ForfeitureRequestDTO {
    forfeitureReasonId?: string | undefined;
    forfeitureDate?: Date | undefined;
    forfeitureSignedAtLocation?: string | undefined;
    forfeitureSignatureFileId?: string | undefined;
    forfeitureHasSection16Licence?: boolean | undefined;
    forfeitureOtherReason?: string | undefined;
}

export interface ForgotPasswordDTO {
    email: string;
}

export interface FriendAndPartnerDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    name?: string | undefined;
    websiteUrl?: string | undefined;
    showOnMemberDashboard?: boolean | undefined;
    allowOptIn?: boolean | undefined;
    optInUrl?: string | undefined;
    optInDescription?: string | undefined;
    imageFileRecordId?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface FriendAndPartnerSearchRequestDTO {
    name?: string | undefined;
    showOnMemberDashboard?: boolean | undefined;
    allowOptIn?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface GenderDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface GenderSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface GradingCategoryDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface GradingCategorySearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface GradingTypeCategoryDTO {
    id?: string | undefined;
    gradingCategoryId?: string | undefined;
    gradingExerciseSpecifics?: ExerciseSpecificDTO[] | undefined;
}

export interface GradingTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
    gradingCategories?: GradingTypeCategoryDTO[] | undefined;
}

export interface GradingTypeQualificationDTO {
    gradingTypeId?: string | undefined;
    gradingTypeName?: string | undefined;
    qualifiedCategories?: CategoryQualificationDTO[] | undefined;
}

export interface GradingTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ImpersonationDTO {
    memberId?: string | undefined;
    adminId?: string | undefined;
}

export interface InvoiceBatchDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    month?: number | undefined;
    year?: number | undefined;
    batchNo?: number | undefined;
    totalCreated?: number | undefined;
    totalPaid?: number | undefined;
    renewalEmailsSentUtc?: Date | undefined;
    netcashPushDateUtc?: Date | undefined;
    invoiceStatusId?: string | undefined;
    invoiceStatus?: InvoiceStatusDTO | undefined;
}

export interface InvoiceBatchRegenerationStatusDTO {
    batchId?: string | undefined;
    status?: string | undefined;
    requestedUtc?: Date | undefined;
    startedUtc?: Date | undefined;
    completedUtc?: Date | undefined;
    heartbeatUtc?: Date | undefined;
    processed?: number | undefined;
    total?: number | undefined;
    updated?: number | undefined;
    created?: number | undefined;
    deleted?: number | undefined;
    error?: string | undefined;
    isActive?: boolean | undefined;
    isStalled?: boolean | undefined;
}

export interface InvoiceBatchSearchRequestDTO {
    month?: number | undefined;
    year?: number | undefined;
    batchNo?: number | undefined;
    totalCreated?: number | undefined;
    totalPaid?: number | undefined;
    invoiceStatusId?: string | undefined;
}

export interface InvoiceDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    invoiceTypeId?: string | undefined;
    invoiceType?: InvoiceTypeDTO | undefined;
    invoiceStatus?: InvoiceStatusDTO | undefined;
    paymentType?: PaymentTypeDTO | undefined;
    paymentInterval?: PaymentIntervalDTO | undefined;
    adminComponentId?: string | undefined;
    adminComponent?: ComponentDTO | undefined;
    competitionEntryId?: string | undefined;
    dedicatedCourseId?: string | undefined;
    rplId?: string | undefined;
    invoiceBatchId?: string | undefined;
    year?: number | undefined;
    month?: number | undefined;
    yearMonth?: string | undefined;
    invoiceNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    totalDiscount?: number | undefined;
    totalExcl?: number | undefined;
    totalTax?: number | undefined;
    totalIncl?: number | undefined;
    totalPaid?: number | undefined;
    payFastTransactionFee?: number | undefined;
    totalInclWithPayFastFee?: number | undefined;
    paidUpDate?: Date | undefined;
    previousPaidUpDate?: Date | undefined;
    invoiceSentDate?: Date | undefined;
    salesOrderSentDate?: Date | undefined;
    invoiceStatusId?: string | undefined;
    emailDeliveredCount?: number | undefined;
    emailOpenCount?: number | undefined;
    emailClickCount?: number | undefined;
    emailBounceCount?: number | undefined;
    smsSentCount?: number | undefined;
    smsClickCount?: number | undefined;
    smsFailedCount?: number | undefined;
    smsNoticeTracker?: string | undefined;
    paidDate?: Date | undefined;
    paymentTypeId?: string | undefined;
    paymentMethodId?: string | undefined;
    notes?: string | undefined;
    lineItemNotes?: string | undefined;
    invoiceNumberCreatedAt?: Date | undefined;
    salesOrderNumberCreatedAt?: Date | undefined;
    invoiceLineItems?: InvoiceLineItemDTO[] | undefined;
}

export interface InvoiceLineItemDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    invoiceId?: string | undefined;
    description?: string | undefined;
    priceExcl?: number | undefined;
    priceTax?: number | undefined;
    priceIncl?: number | undefined;
    quantity?: number | undefined;
    lineExcl?: number | undefined;
    lineTax?: number | undefined;
    lineDiscount?: number | undefined;
    lineIncl?: number | undefined;
}

export interface InvoiceLineItemSearchRequestDTO {
    invoiceId?: string | undefined;
    description?: string | undefined;
    priceExcl?: number | undefined;
    priceTax?: number | undefined;
    priceIncl?: number | undefined;
    quantity?: number | undefined;
    lineExcl?: number | undefined;
    lineTax?: number | undefined;
    lineDiscount?: number | undefined;
    lineIncl?: number | undefined;
}

export interface InvoiceSearchRequestDTO {
    generalSearchTerm?: string | undefined;
    memberId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    invoiceTypeId?: string | undefined;
    invoiceTypeIds?: string[] | undefined;
    adminComponentId?: string | undefined;
    competitionEntryId?: string | undefined;
    dedicatedCourseId?: string | undefined;
    rplId?: string | undefined;
    invoiceBatchId?: string | undefined;
    isDebitOrderPayment?: boolean | undefined;
    year?: number | undefined;
    month?: number | undefined;
    yearMonth?: string | undefined;
    invoiceCounter?: number | undefined;
    salesOrderCounter?: number | undefined;
    invoiceNumber?: string | undefined;
    salesOrderNumber?: string | undefined;
    totalDiscount?: number | undefined;
    totalExcl?: number | undefined;
    totalTax?: number | undefined;
    totalIncl?: number | undefined;
    totalPaid?: number | undefined;
    paidUpDate?: Date | undefined;
    previousPaidUpDate?: Date | undefined;
    invoiceSentDate?: Date | undefined;
    salesOrderSentDate?: Date | undefined;
    invoiceStatusId?: string | undefined;
    emailDeliveredCount?: number | undefined;
    emailOpenCount?: number | undefined;
    emailClickCount?: number | undefined;
    emailBounceCount?: number | undefined;
    smsSentCount?: number | undefined;
    smsClickCount?: number | undefined;
    smsFailedCount?: number | undefined;
    smsNoticeTracker?: string | undefined;
    paidDate?: Date | undefined;
    fromPaidDate?: Date | undefined;
    toPaidDate?: Date | undefined;
    fromCreatedUtc?: Date | undefined;
    toCreatedUtc?: Date | undefined;
    paymentTypeId?: string | undefined;
    paymentMethodId?: string | undefined;
    notes?: string | undefined;
    lineItemNotes?: string | undefined;
    invoiceNumberCreatedAt?: Date | undefined;
    salesOrderNumberCreatedAt?: Date | undefined;
}

export interface InvoiceStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface InvoiceStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface InvoiceTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface InvoiceTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface LanguageDTO {
    id?: string | undefined;
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface LanguageSearchRequestDTO {
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ListingDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    listingTypeId?: string | undefined;
    listingType?: ListingTypeDTO | undefined;
    name?: string | undefined;
    registeredName?: string | undefined;
    provinceId?: string | undefined;
    province?: ProvinceDTO | undefined;
    closestCity?: string | undefined;
    physicalAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    websiteAddress?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    responsiblePersonName?: string | undefined;
    responsiblePersonSurname?: string | undefined;
    responsiblePersonIdNumber?: string | undefined;
    responsiblePersonEmail?: string | undefined;
    responsiblePersonCellNumber?: string | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    listingStatusId?: string | undefined;
    listingStatus?: ListingStatusDTO | undefined;
    listingFiles?: ListingFileDTO[] | undefined;
}

export interface ListingFileDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    listingId?: string | undefined;
    fileId?: string | undefined;
    file?: FileRecordDTO | undefined;
    isMain?: boolean | undefined;
}

export interface ListingSearchRequestDTO {
    listingTypeId?: string | undefined;
    name?: string | undefined;
    registeredName?: string | undefined;
    provinceId?: string | undefined;
    closestCity?: string | undefined;
    physicalAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    websiteAddress?: string | undefined;
    contactNumber?: string | undefined;
    email?: string | undefined;
    responsiblePersonName?: string | undefined;
    responsiblePersonSurname?: string | undefined;
    responsiblePersonIdNumber?: string | undefined;
    responsiblePersonEmail?: string | undefined;
    responsiblePersonCellNumber?: string | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    listingStatusId?: string | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface ListingStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ListingStatusSearchRequestDTO {
    title?: string | undefined;
    colourGradingId?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ListingTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ListingTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface LoginTwoFactorDTO {
    email?: string | undefined;
    tempToken?: string | undefined;
    code?: string | undefined;
}

export interface LoginUserDTO {
    emailOrPhone: string;
    password: string;
}

export interface LookupDTO {
    id?: string | undefined;
    title?: string | undefined;
}

export interface LookupMemberByCertificateDTO {
    componentId?: string | undefined;
    certificateCode?: string | undefined;
}

export interface MandateEditFormDataDTO {
    mandateId?: string | undefined;
    memberId?: string | undefined;
    accountHolder?: string | undefined;
    bankId?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    signedAt?: string | undefined;
    amount?: number | undefined;
    banks?: BankOptionDTO[] | undefined;
}

export interface MandateFormDataDTO {
    memberId?: string | undefined;
    memberPaidUpTo?: Date | undefined;
    amount?: number | undefined;
    invoiceNumber?: string | undefined;
    banks?: BankOptionDTO[] | undefined;
}

export interface MandateStatusDTO {
    mandateId?: string | undefined;
    memberId?: string | undefined;
    accountHolder?: string | undefined;
    bankId?: string | undefined;
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    amount?: number | undefined;
    dayOfMonth?: number | undefined;
    status?: string | undefined;
    netcashFileToken?: string | undefined;
    signedAt?: string | undefined;
    dateSubmitted?: Date | undefined;
    dateActivated?: Date | undefined;
}

export interface MarksmanGradingCertificateRequestDTO {
    memberId?: string | undefined;
    categoryQualification?: CategoryQualificationDTO | undefined;
}

export interface MarksmanGradingQualificationDTO {
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    yearQualifications?: YearQualificationDTO[] | undefined;
}

export interface MemberAdditionalDocumentDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    memberId?: string | undefined;
    documentId?: string | undefined;
    documentTypeId?: string | undefined;
    documentType?: DocumentTypeDTO | undefined;
    documentName?: string | undefined;
}

export interface MemberAdditionalDocumentSearchRequestDTO {
    memberId?: string | undefined;
    documentId?: string | undefined;
    documentTypeId?: string | undefined;
    documentName?: string | undefined;
}

export interface MemberCancelReasonDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberCancelReasonSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberCategoryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberCategorySearchRequestDTO {
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberCompetencyDTO {
    id?: string | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    createdUtc?: Date | undefined;
    createdBy?: string | undefined;
    competencyTypeId?: string | undefined;
    competencyType?: CompetencyTypeDTO | undefined;
    certificateNumber?: string | undefined;
    competencyCertificateId?: string | undefined;
    competencyIssueDate?: Date | undefined;
    competencyExpiryDate?: Date | undefined;
    isExpired?: boolean | undefined;
}

export interface MemberCompetencySearchRequestDTO {
    competencyTypeId?: string | undefined;
    certificateNumber?: string | undefined;
    competencyCertificate?: string | undefined;
    competencyIssueDate?: Date | undefined;
    competencyExpiryDate?: Date | undefined;
    isExpired?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface MemberDisciplinaryStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberDisciplinaryStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    deletedUtc?: Date | undefined;
    archivedUtc?: Date | undefined;
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    userID?: string | undefined;
    memberTypeId?: string | undefined;
    memberCategoryId?: string | undefined;
    memberTitleId?: string | undefined;
    initials?: string | undefined;
    dateOfBirth?: Date | undefined;
    memberIdTypeId?: string | undefined;
    idPassportNumber?: string | undefined;
    genderId?: string | undefined;
    gender?: GenderDTO | undefined;
    languageId?: string | undefined;
    language?: LanguageDTO | undefined;
    languageOther?: string | undefined;
    companyName?: string | undefined;
    companyVat?: string | undefined;
    landlinePhone?: string | undefined;
    officePhone?: string | undefined;
    countryId?: string | undefined;
    provinceId?: string | undefined;
    provinceOther?: string | undefined;
    physicalAddress?: string | undefined;
    physicalTown?: string | undefined;
    physicalSuburb?: string | undefined;
    physicalPostalCode?: string | undefined;
    courierAddress?: string | undefined;
    courierTown?: string | undefined;
    courierSuburb?: string | undefined;
    courierPostalCode?: string | undefined;
    isUnsubscribed?: boolean | undefined;
    isAlwaysCompliant?: boolean | undefined;
    memberStatusId?: string | undefined;
    isApprovalEmailSent?: boolean | undefined;
    memberDisciplinaryStatusId?: string | undefined;
    memberTerminationStatusId?: string | undefined;
    dateDisciplinaryEnd?: Date | undefined;
    disciplinaryReason?: string | undefined;
    isDistinguishedHidden?: boolean | undefined;
    isDedicatedStatusLapsed?: boolean | undefined;
    memberRegistrationTypeId?: string | undefined;
    memberRegistrationType?: MemberRegistrationTypeDTO | undefined;
    memberRegistrationStepId?: string | undefined;
    memberRegistrationStep?: MemberRegistrationStepDTO | undefined;
    memberReferralTypeId?: string | undefined;
    referredByName?: string | undefined;
    proofOfIdFileId?: string | undefined;
    dateWelcomeEmailSent?: Date | undefined;
    dateConfirmEmailSent?: Date | undefined;
    dateMemberConfirmed?: Date | undefined;
    notes?: string | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    password?: string | undefined;
    memberType?: MemberTypeDTO | undefined;
    memberCategory?: MemberCategoryDTO | undefined;
    memberDisciplinaryStatus?: MemberDisciplinaryStatusDTO | undefined;
    memberTerminationStatus?: MemberTerminationStatusDTO | undefined;
    memberStatus?: MemberStatusDTO | undefined;
    paidUpTo?: Date | undefined;
    paymentTypeId?: string | undefined;
    paymentType?: PaymentTypeDTO | undefined;
    paymentIntervalId?: string | undefined;
    paymentInterval?: PaymentIntervalDTO | undefined;
    dateInvoiceCreated?: Date | undefined;
    dateInvoiceSent?: Date | undefined;
    proofOfPaymentFileId?: string | undefined;
    dateCertificateHunter?: Date | undefined;
    dateCertificateSport?: Date | undefined;
    dateEnrolled?: Date | undefined;
    datePaidUpPrevious?: Date | undefined;
    amountPaid?: number | undefined;
    datePaid?: Date | undefined;
    datePaymentDetailsSent?: Date | undefined;
    isDebitOrderPayment?: boolean | undefined;
    feedback?: string | undefined;
    feedbackFileId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
    memberNotes?: NoteDTO[] | undefined;
    partnerOptInIds?: string[] | undefined;
}

export interface MemberEndorsementDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    statusId?: string | undefined;
    status?: EndorsementStatusDTO | undefined;
    licenceTypeId?: string | undefined;
    licenceType?: EndorsementLicenceTypeDTO | undefined;
    isAdditional?: boolean | undefined;
    memberFirearmId?: string | undefined;
    firearm?: MemberFirearmDTO | undefined;
    motivationTypeId?: string | undefined;
    motivationType?: EndorsementMotivationDTO | undefined;
    fellowId?: string | undefined;
    fellow?: FellowDTO | undefined;
    motivationAuthor?: string | undefined;
    motivationFile1Id?: string | undefined;
    motivationFile2Id?: string | undefined;
    motivationFile3Id?: string | undefined;
    motivationFile4Id?: string | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    feedbackFileId?: string | undefined;
    statusUpdateDate?: Date | undefined;
    statusEmailSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    approvedDate?: Date | undefined;
    isDeleted?: boolean | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface MemberEndorsementSearchRequestDTO {
    generalSearchTerm?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    memberId?: string | undefined;
    statusId?: string | undefined;
    licenceTypeId?: string | undefined;
    isAdditional?: boolean | undefined;
    memberFirearmId?: string | undefined;
    motivationTypeId?: string | undefined;
    fellowId?: string | undefined;
    motivationAuthor?: string | undefined;
    motivationFile1?: string | undefined;
    motivationFile2?: string | undefined;
    motivationFile3?: string | undefined;
    motivationFile4?: string | undefined;
    replyTemplateId?: string | undefined;
    statusUpdateDate?: Date | undefined;
    statusEmailSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    approvedDate?: Date | undefined;
    isDeleted?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface MemberFeeAmountDTO {
    id?: string | undefined;
    memberFeeId?: string | undefined;
    fee?: number | undefined;
    joinFee?: number | undefined;
    effectiveDate?: Date | undefined;
    createdUtc?: Date | undefined;
}

export interface MemberFeeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    memberFeeAmounts?: MemberFeeAmountDTO[] | undefined;
}

export interface MemberFeeSearchRequestDTO {
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
}

export interface MemberFirearmDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    firearmOwnerId?: string | undefined;
    firearmTypeId?: string | undefined;
    firearmType?: FirearmTypeDTO | undefined;
    firearmSpecificId?: string | undefined;
    firearmSpecific?: FirearmSpecificDTO | undefined;
    firearmLooseBarrelTypeId?: string | undefined;
    firearmMakeId?: string | undefined;
    firearmMake?: FirearmMakeDTO | undefined;
    firearmMakeOther?: string | undefined;
    firearmBarrelMakeId?: string | undefined;
    firearmBarrelMakeOther?: string | undefined;
    firearmCaliberId?: string | undefined;
    caliber?: FirearmCalibreDTO | undefined;
    caliberOther?: string | undefined;
    firearmActionId?: string | undefined;
    firearmAction?: FirearmActionDTO | undefined;
    firearmActionOther?: string | undefined;
    firearmSerialTypeId?: string | undefined;
    frameSerial?: string | undefined;
    barrelSerial?: string | undefined;
    firearmBarrelId?: string | undefined;
    barrelOther?: string | undefined;
    barrelLength?: string | undefined;
    firearmPurposeId?: string | undefined;
    purposeType?: FirearmPurposeDTO | undefined;
    licenceIssueDate?: Date | undefined;
    licenceExpiryDate?: Date | undefined;
    firearmFileId?: string | undefined;
    isCompleted?: boolean | undefined;
    renewalSubmitDate?: Date | undefined;
    recieptFileId?: string | undefined;
    isNotification?: boolean | undefined;
    description?: string | undefined;
    licenceCardNumber?: string | undefined;
    applicationRenewalDate?: Date | undefined;
    applicationNumber?: string | undefined;
    isExpired?: boolean | undefined;
    isEndorsementFirearm?: boolean | undefined;
}

export interface MemberFirearmSearchRequestDTO {
    memberId?: string | undefined;
    firearmOwnerId?: string | undefined;
    firearmTypeId?: string | undefined;
    firearmSpecificId?: string | undefined;
    firearmLooseBarrelTypeId?: string | undefined;
    firearmMakeId?: string | undefined;
    firearmMakeOther?: string | undefined;
    firearmBarrelMakeId?: string | undefined;
    firearmBarrelMakeOther?: string | undefined;
    firearmCaliberId?: string | undefined;
    caliberOther?: string | undefined;
    firearmActionId?: string | undefined;
    firearmActionOther?: string | undefined;
    firearmSerialTypeId?: string | undefined;
    frameSerial?: string | undefined;
    barrelSerial?: string | undefined;
    firearmBarrelId?: string | undefined;
    barrelOther?: string | undefined;
    barrelLength?: string | undefined;
    firearmPurposeId?: string | undefined;
    licenceIssueDate?: Date | undefined;
    licenceExpiryDate?: Date | undefined;
    firearmFilePath?: string | undefined;
    isCompleted?: boolean | undefined;
    renewalSubmitDate?: Date | undefined;
    recieptFilePath?: string | undefined;
    isNotification?: boolean | undefined;
    description?: string | undefined;
    licenceCardNumber?: string | undefined;
    applicationRenewalDate?: Date | undefined;
    applicationNumber?: string | undefined;
    isExpired?: boolean | undefined;
    isEndorsementFirearm?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface MemberIdTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberIdTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberProfileDTO {
    id?: string | undefined;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    memberTitleId?: string | undefined;
    genderId?: string | undefined;
    languageId?: string | undefined;
    countryId?: string | undefined;
    provinceId?: string | undefined;
    physicalAddress?: string | undefined;
    physicalTown?: string | undefined;
    physicalSuburb?: string | undefined;
    physicalPostalCode?: string | undefined;
    courierAddress?: string | undefined;
    courierTown?: string | undefined;
    courierSuburb?: string | undefined;
    courierPostalCode?: string | undefined;
    initials?: string | undefined;
    idPassportNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    landlinePhone?: string | undefined;
    companyName?: string | undefined;
    companyVat?: string | undefined;
    memberType?: MemberTypeDTO | undefined;
    memberCategory?: MemberCategoryDTO | undefined;
}

export interface MemberReferralTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberReferralTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberRegistrationStepDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberRegistrationStepSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberRegistrationTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberRegistrationTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberResetPasswordDTO {
    memberId?: string | undefined;
    newPassword?: string | undefined;
}

export interface MemberSearchRequestDTO {
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    initials?: string | undefined;
    dateOfBirth?: Date | undefined;
    idPassportNumber?: string | undefined;
    companyName?: string | undefined;
    companyVat?: string | undefined;
    landlinePhone?: string | undefined;
    officePhone?: string | undefined;
    physicalAddress?: string | undefined;
    physicalTown?: string | undefined;
    physicalSuburb?: string | undefined;
    physicalPostalCode?: string | undefined;
    courierAddress?: string | undefined;
    courierTown?: string | undefined;
    courierSuburb?: string | undefined;
    courierPostalCode?: string | undefined;
    isUnsubscribed?: boolean | undefined;
    isAlwaysCompliant?: boolean | undefined;
    memberTypeId?: string | undefined;
    memberCategoryId?: string | undefined;
    memberTitleId?: string | undefined;
    memberIdTypeId?: string | undefined;
    genderId?: string | undefined;
    languageId?: string | undefined;
    countryId?: string | undefined;
    provinceId?: string | undefined;
    provinceOther?: string | undefined;
    memberStatusId?: string | undefined;
    memberDisciplinaryStatusId?: string | undefined;
    memberTerminationStatusId?: string | undefined;
    memberRegistrationTypeId?: string | undefined;
    memberRegistrationStepId?: string | undefined;
    memberReferralTypeId?: string | undefined;
    isDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
    paymentTypeId?: string | undefined;
    paymentIntervalId?: string | undefined;
    generalSearchTerm?: string | undefined;
    datePaidUpPrevious?: Date | undefined;
    amountPaid?: number | undefined;
    datePaid?: Date | undefined;
    datePaymentDetailsSent?: Date | undefined;
    isDedicatedStatusLapsed?: boolean | undefined;
    isDebitOrderPayment?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface MemberSimpleDTO {
    title?: string | undefined;
    memberFirstName?: string | undefined;
    memberLastName?: string | undefined;
    maskedIdNumber?: string | undefined;
    idPassportNumber?: string | undefined;
    membershipType?: string | undefined;
    fcaStatus?: string | undefined;
    status?: string | undefined;
    paidUpTo?: Date | undefined;
}

export interface MemberStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberTerminationStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberTerminationStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberTitleDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberTitleSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberTypeDTO {
    id?: string | undefined;
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
    memberFeeId?: string | undefined;
    memberFee?: MemberFeeDTO | undefined;
}

export interface MemberTypeSearchRequestDTO {
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MemberVerificationRequestDTO {
    keyId?: string | undefined;
    encryptedId?: string | undefined;
}

export interface MemberVerificationResponseDTO {
    isMember?: boolean | undefined;
    isPaidUp?: boolean | undefined;
    paidUpUntil?: string | undefined;
}

export interface MessageTemplateStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MessageTemplateStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ModuleTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ModuleTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface MovePageRequestDTO {
    parentPageId?: string | undefined;
}

export interface NetcashAddInvoicesResultDTO {
    batch?: NetcashBatchDTO | undefined;
    addedCount?: number | undefined;
    alreadyInThisBatchCount?: number | undefined;
    alreadyInBatchCount?: number | undefined;
    ineligibleCount?: number | undefined;
}

export interface NetcashBatchDTO {
    id?: string | undefined;
    year?: number | undefined;
    month?: number | undefined;
    isPushed?: boolean | undefined;
    actionDate?: string | undefined;
    pushedUtc?: Date | undefined;
    isPushing?: boolean | undefined;
    pushErrorMessage?: string | undefined;
    fileToken?: string | undefined;
    createdUtc?: Date | undefined;
    totalCount?: number | undefined;
    totalAmount?: number | undefined;
    resultStatus?: string | undefined;
    pushAttempt?: number | undefined;
    pushedMemberCount?: number | undefined;
    pushedTotalAmount?: number | undefined;
    netcashReportedAmount?: number | undefined;
    netcashReportedUtc?: Date | undefined;
    netcashReportText?: string | undefined;
    lineItems?: NetcashBatchLineItemDTO[] | undefined;
}

export interface NetcashBatchLineItemDTO {
    id?: string | undefined;
    invoiceId?: string | undefined;
    salesOrderNumber?: string | undefined;
    memberId?: string | undefined;
    memberName?: string | undefined;
    memberIdPassportNumber?: string | undefined;
    amountAtAdd?: number | undefined;
    status?: string | undefined;
    exclusionReason?: string | undefined;
    bankingSource?: string | undefined;
    amountPushed?: number | undefined;
    netcashResultMessage?: string | undefined;
    statusUpdatedUtc?: Date | undefined;
}

export interface NetcashInvoiceAvailabilityItemDTO {
    invoiceId?: string | undefined;
    netcashBatchId?: string | undefined;
    state?: string | undefined;
    label?: string | undefined;
}

export interface NetcashInvoiceAvailabilityRequestDTO {
    invoiceIds?: string[] | undefined;
}

export interface NetcashInvoiceAvailabilityResultDTO {
    committed?: NetcashInvoiceAvailabilityItemDTO[] | undefined;
}

export interface NewsItemDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    slug?: string | undefined;
    date?: Date | undefined;
    summary?: string | undefined;
    contentFileId?: string | undefined;
    content?: string | undefined;
    body?: string | undefined;
    externalUrl?: string | undefined;
    pictureFileRecordId?: string | undefined;
    contentCategoryId?: string | undefined;
    contentCategory?: ContentCategoryDTO | undefined;
    showOnLanding?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface NewsItemSearchRequestDTO {
    title?: string | undefined;
    slug?: string | undefined;
    date?: Date | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    pictureFileRecordId?: string | undefined;
    contentCategoryId?: string | undefined;
    isActive?: boolean | undefined;
}

export interface NewsletterCategoryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface NewsletterCategorySearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface NewsletterDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    slug?: string | undefined;
    year?: number | undefined;
    volume?: string | undefined;
    date?: Date | undefined;
    newsletterCategoryId?: string | undefined;
    newsletterCategory?: NewsletterCategoryDTO | undefined;
    content?: string | undefined;
    isActive?: boolean | undefined;
}

export interface NewsletterPublicDTO {
    id?: string | undefined;
    title?: string | undefined;
    slug?: string | undefined;
    year?: number | undefined;
    volume?: string | undefined;
    date?: Date | undefined;
    categoryTitle?: string | undefined;
    content?: string | undefined;
}

export interface NewsletterSearchRequestDTO {
    title?: string | undefined;
    slug?: string | undefined;
    year?: number | undefined;
    volume?: string | undefined;
    date?: Date | undefined;
    newsletterCategoryId?: string | undefined;
    content?: string | undefined;
    isActive?: boolean | undefined;
}

export interface NoteDTO {
    id?: string | undefined;
    createdByUser?: UserDTO | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    assignedAdminId?: string | undefined;
    assignedAdmin?: UserDTO | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    componentId?: string | undefined;
    component?: ComponentDTO | undefined;
    recordId?: string | undefined;
    noteTypeId?: string | undefined;
    noteType?: NoteTypeDTO | undefined;
    description?: string | undefined;
    fileId?: string | undefined;
    isResolved?: boolean | undefined;
    reference?: string | undefined;
    referenceCounter?: number | undefined;
    colour?: string | undefined;
}

export interface NoteSearchRequestDTO {
    assignedAdminId?: string | undefined;
    memberId?: string | undefined;
    componentId?: string | undefined;
    recordId?: string | undefined;
    noteTypeId?: string | undefined;
    description?: string | undefined;
    isResolved?: boolean | undefined;
    reference?: string | undefined;
    referenceCounter?: number | undefined;
    colour?: string | undefined;
}

export interface NoteTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface NoteTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface PageContentDTO {
    id?: string | undefined;
    parentPageId?: string | undefined;
    slug?: string | undefined;
    slugFull?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    isVisible?: boolean | undefined;
    isRestricted?: boolean | undefined;
    isActive?: boolean | undefined;
    contentHtml?: string | undefined;
}

export interface PagesDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    parentPageId?: string | undefined;
    position?: number | undefined;
    slug?: string | undefined;
    slugFull?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    contentFileId?: string | undefined;
    content?: string | undefined;
    body?: string | undefined;
    isVisible?: boolean | undefined;
    isRestricted?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface PagesSearchRequestDTO {
    title?: string | undefined;
    slug?: string | undefined;
    parentPageId?: string | undefined;
    isVisible?: boolean | undefined;
    isRestricted?: boolean | undefined;
    isActive?: boolean | undefined;
}

export interface PaymentDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    merchantOrderId?: string | undefined;
    rplId?: string | undefined;
    courseId?: string | undefined;
    competitionEntryId?: string | undefined;
    invoiceId?: string | undefined;
    member?: MemberDTO | undefined;
    invoice?: InvoiceDTO | undefined;
    isInvoiceDeleted?: boolean | undefined;
}

export interface PaymentIntervalDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface PaymentIntervalSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface PaymentNotificationDTO {
    m_payment_id?: string | undefined;
    pf_payment_id?: string | undefined;
    payment_status?: string | undefined;
    item_name?: string | undefined;
    item_description?: string | undefined;
    amount_gross?: number | undefined;
    amount_fee?: number | undefined;
    amount_net?: number | undefined;
    custom_str1?: string | undefined;
    custom_str2?: string | undefined;
    custom_str3?: string | undefined;
    custom_str4?: string | undefined;
    custom_str5?: string | undefined;
    custom_int1?: number | undefined;
    custom_int2?: number | undefined;
    custom_int3?: number | undefined;
    custom_int4?: number | undefined;
    custom_int5?: number | undefined;
    name_first?: string | undefined;
    name_last?: string | undefined;
    email_address?: string | undefined;
    merchant_id?: string | undefined;
    signature?: string | undefined;
}

export interface PaymentSearchRequestDTO {
    memberId?: string | undefined;
    merchantOrderId?: string | undefined;
    rplId?: string | undefined;
    courseId?: string | undefined;
    competitionEntryId?: string | undefined;
    invoiceId?: string | undefined;
}

export interface PaymentTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface PaymentTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ProvinceDTO {
    id?: string | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
    createdUtc?: Date | undefined;
}

export interface ProvinceSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface PushNetcashBatchRequestDTO {
    actionDate?: string | undefined;
}

export interface QuestionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    imageId?: string | undefined;
    isActive?: boolean | undefined;
    questionSetId?: string | undefined;
    rotateOptions?: boolean | undefined;
    questionOptions?: QuestionOptionDTO[] | undefined;
}

export interface QuestionOptionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    isCorrectOption?: boolean | undefined;
    displayOrder?: number | undefined;
    questionId?: string | undefined;
}

export interface QuestionSearchRequestDTO {
    questionSetId?: string | undefined;
    title?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean | undefined;
    rotateOptions?: boolean | undefined;
}

export interface QuestionSetDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    questionsToShow?: number | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface QuestionSetSearchRequestDTO {
    title?: string | undefined;
    questionsToShow?: number | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface QuickEventDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    provinceId?: string | undefined;
    town?: string | undefined;
    location?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    isActive?: boolean | undefined;
    province?: ProvinceDTO | undefined;
    activityCategories?: ActivityCategoryDTO[] | undefined;
}

export interface QuickEventSearchRequestDTO {
    title?: string | undefined;
    provinceId?: string | undefined;
    town?: string | undefined;
    location?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    isActive?: boolean | undefined;
}

export interface RangeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    rangeTypeId?: string | undefined;
    rangeType?: RangeTypeDTO | undefined;
    rangeStatusId?: string | undefined;
    rangeStatus?: RangeStatusDTO | undefined;
    title?: string | undefined;
    isFriendly?: boolean | undefined;
    provinceId?: string | undefined;
    province?: ProvinceDTO | undefined;
    closestCity?: string | undefined;
    physicalAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    lengthOfRange?: number | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantIdNumber?: string | undefined;
    applicantEmail?: string | undefined;
    applicantAltEmail?: string | undefined;
    applicantPhone?: string | undefined;
    applicantAltPhone?: string | undefined;
    witnessFirstName?: string | undefined;
    witnessLastName?: string | undefined;
    witnessIdNumber?: string | undefined;
    witnessEmail?: string | undefined;
    witnessAltEmail?: string | undefined;
    witnessPhone?: string | undefined;
    witnessAltPhone?: string | undefined;
    rangeShootingReasonId?: string | undefined;
    rangeShootingReasonOther?: string | undefined;
    notes?: string | undefined;
    shootingPointImageId?: string | undefined;
    backStopImageId?: string | undefined;
    googleMapsImageId?: string | undefined;
    otherImageId?: string | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    emailFeedbackSentDate?: Date | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface RangeSearchRequestDTO {
    rangeTypeId?: string | undefined;
    rangeStatusId?: string | undefined;
    title?: string | undefined;
    isFriendly?: boolean | undefined;
    provinceId?: string | undefined;
    closestCity?: string | undefined;
    physicalAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    lengthOfRange?: number | undefined;
    applicantFirstName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantIdNumber?: string | undefined;
    applicantEmail?: string | undefined;
    applicantAltEmail?: string | undefined;
    applicantPhone?: string | undefined;
    applicantAltPhone?: string | undefined;
    witnessFirstName?: string | undefined;
    witnessLastName?: string | undefined;
    witnessIdNumber?: string | undefined;
    witnessEmail?: string | undefined;
    witnessAltEmail?: string | undefined;
    witnessPhone?: string | undefined;
    witnessAltPhone?: string | undefined;
    rangeShootingReasonId?: string | undefined;
    rangeShootingReasonOther?: string | undefined;
    notes?: string | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface RangeShootingReasonDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RangeShootingReasonSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RangeStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RangeStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RangeTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RangeTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ReconBatchDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    fileRecordId?: string | undefined;
    fileRecord?: FileRecordDTO | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface ReconBatchSearchRequestDTO {
    fileName?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface ReconTransactionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    reconBatchId?: string | undefined;
    reconBatch?: ReconBatchDTO | undefined;
    reconTypeId?: string | undefined;
    reconType?: ReconTypeDTO | undefined;
    memberId?: string | undefined;
    member?: MemberSimpleDTO | undefined;
    componentId?: string | undefined;
    component?: ComponentDTO | undefined;
    recordId?: string | undefined;
    transactionDate?: Date | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    isPaid?: boolean | undefined;
    isUnallocated?: boolean | undefined;
}

export interface ReconTransactionSearchRequestDTO {
    generalSearchTerm?: string | undefined;
    reconBatchId?: string | undefined;
    reconTypeId?: string | undefined;
    excludeReconTypeIds?: string[] | undefined;
    memberId?: string | undefined;
    componentId?: string | undefined;
    recordId?: string | undefined;
    transactionDate?: Date | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    isPaid?: boolean | undefined;
    isUnallocated?: boolean | undefined;
}

export interface ReconTransactionSetComponentRequestDTO {
    componentId?: string | undefined;
}

export interface ReconTransactionSetMemberRequestDTO {
    memberId?: string | undefined;
}

export interface ReconTransactionSetUnallocatedRequestDTO {
    isUnallocated?: boolean | undefined;
}

export interface ReconTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ReconTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RefreshTokenDTO {
    refreshToken?: string | undefined;
}

export interface RenewalStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RenewalStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ReplyTemplateDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    description?: string | undefined;
    body?: string | undefined;
    componentId?: string | undefined;
    statusId?: string | undefined;
    isActive?: boolean | undefined;
    component?: ComponentDTO | undefined;
}

export interface ReplyTemplateSearchRequestDTO {
    title?: string | undefined;
    description?: string | undefined;
    body?: string | undefined;
    componentId?: string | undefined;
    statusId?: string | undefined;
    isActive?: boolean | undefined;
}

export interface ReplyTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ReplyTypeSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ResetPasswordDTO {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export interface RplDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    isDeleted?: boolean | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    courseTypeId?: string | undefined;
    courseType?: CourseTypeDTO | undefined;
    rplStatusId?: string | undefined;
    rplStatus?: RplStatusDTO | undefined;
    question1_1?: boolean | undefined;
    question2_1?: boolean | undefined;
    question2_2?: boolean | undefined;
    question3_1?: boolean | undefined;
    question3_2?: boolean | undefined;
    question3_3?: boolean | undefined;
    question3_4?: boolean | undefined;
    question3_5?: boolean | undefined;
    question3_6?: boolean | undefined;
    question3_7?: boolean | undefined;
    question4_1?: boolean | undefined;
    question4_2?: boolean | undefined;
    question4_3?: boolean | undefined;
    question4_4?: boolean | undefined;
    question4_5?: boolean | undefined;
    question4_6?: boolean | undefined;
    questionFile3_1Id?: string | undefined;
    questionFile3_2Id?: string | undefined;
    questionFile3_3Id?: string | undefined;
    questionFile3_4Id?: string | undefined;
    questionFile3_5Id?: string | undefined;
    questionFile3_6Id?: string | undefined;
    questionFile3_7Id?: string | undefined;
    paymentTypeId?: string | undefined;
    paymentType?: PaymentTypeDTO | undefined;
    proofOfPaymentFileId?: string | undefined;
    isHideDistinguished?: boolean | undefined;
    amountPaid?: number | undefined;
    trackingReference?: string | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    feedbackFileId?: string | undefined;
    notes?: string | undefined;
    paidDate?: Date | undefined;
    emailSentDate?: Date | undefined;
    emailPaymentSentDate?: Date | undefined;
    invoiceCreatedDate?: Date | undefined;
    invoiceSentDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    statusDate?: Date | undefined;
    sendFeedbackEmail?: boolean | undefined;
    forfeitureReasonId?: string | undefined;
    forfeitureReason?: ForfeitureReasonDTO | undefined;
    forfeitureDate?: Date | undefined;
    forfeitureSignedAtLocation?: string | undefined;
    forfeitureSignatureFileId?: string | undefined;
    forfeitureHasSection16Licence?: boolean | undefined;
    forfeitureOtherReason?: string | undefined;
}

export interface RplSearchRequestDTO {
    generalSearchTerm?: string | undefined;
    memberId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    idPassportNumber?: string | undefined;
    courseTypeId?: string | undefined;
    rplStatusId?: string | undefined;
    question1_1?: boolean | undefined;
    question2_1?: boolean | undefined;
    question2_2?: boolean | undefined;
    question3_1?: boolean | undefined;
    question3_2?: boolean | undefined;
    question3_3?: boolean | undefined;
    question3_4?: boolean | undefined;
    question3_5?: boolean | undefined;
    question3_6?: boolean | undefined;
    question3_7?: boolean | undefined;
    question4_1?: boolean | undefined;
    question4_2?: boolean | undefined;
    question4_3?: boolean | undefined;
    question4_4?: boolean | undefined;
    question4_5?: boolean | undefined;
    question4_6?: boolean | undefined;
    questionFile3_1Id?: string | undefined;
    questionFile3_2Id?: string | undefined;
    questionFile3_3Id?: string | undefined;
    questionFile3_4Id?: string | undefined;
    questionFile3_5Id?: string | undefined;
    questionFile3_6Id?: string | undefined;
    questionFile3_7Id?: string | undefined;
    paymentTypeId?: string | undefined;
    proofOfPaymentFileId?: string | undefined;
    isHideDistinguished?: boolean | undefined;
    amountPaid?: number | undefined;
    trackingReference?: string | undefined;
    replyTemplateId?: string | undefined;
    notes?: string | undefined;
    paidDate?: Date | undefined;
    emailSentDate?: Date | undefined;
    emailPaymentSentDate?: Date | undefined;
    invoiceCreatedDate?: Date | undefined;
    invoiceSentDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    statusDate?: Date | undefined;
    isDeleted?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface RplStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface RplStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ScoreDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    updatedUtc?: Date | undefined;
    memberId?: string | undefined;
    member?: MemberDTO | undefined;
    scoreTypeId?: string | undefined;
    scoreType?: ScoreTypeDTO | undefined;
    scoreStatusId?: string | undefined;
    scoreStatus?: ScoreStatusDTO | undefined;
    exerciseTypeId?: string | undefined;
    exerciseType?: ExerciseTypeDTO | undefined;
    exerciseSpecificId?: string | undefined;
    exerciseSpecific?: ExerciseSpecificDTO | undefined;
    location?: string | undefined;
    distance?: string | undefined;
    dateActivity?: Date | undefined;
    complianceYearDisplay?: number | undefined;
    courseId?: string | undefined;
    course?: CourseDTO | undefined;
    competitionEntryId?: string | undefined;
    competitionEntry?: CompetitionEntryDTO | undefined;
    memberFirearmId?: string | undefined;
    memberFirearm?: MemberFirearmDTO | undefined;
    firearmTypeId?: string | undefined;
    firearmType?: FirearmTypeDTO | undefined;
    firearmSpecificId?: string | undefined;
    firearmSpecific?: FirearmSpecificDTO | undefined;
    firearmCalibreId?: string | undefined;
    firearmCalibre?: FirearmCalibreDTO | undefined;
    calibreOther?: string | undefined;
    fileAdditionalId?: string | undefined;
    grandTotalScore?: number | undefined;
    grandTotalPercentage?: number | undefined;
    grandTotalMark?: number | undefined;
    templateId?: string | undefined;
    exerciseTemplate?: ExerciseTemplateDTO | undefined;
    replyTemplateId?: string | undefined;
    feedback?: string | undefined;
    feedbackFileId?: string | undefined;
    statusDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    activityTypeId?: string | undefined;
    activityType?: ActivityTypeDTO | undefined;
    targetScore?: number | undefined;
    notes?: string | undefined;
    isDeleted?: boolean | undefined;
    isQrSubmission?: boolean | undefined;
    sendFeedbackEmail?: boolean | undefined;
    scoreSections?: ScoreSectionDTO[] | undefined;
    scoreTargetFiles?: ScoreTargetFileDTO[] | undefined;
}

export interface ScoreFieldDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    scoreSectionId?: string | undefined;
    exerciseTemplateSectionFieldId?: string | undefined;
    value?: number | undefined;
    scoreSection?: ScoreSectionDTO | undefined;
    exerciseTemplateSectionField?: ExerciseTemplateSectionFieldDTO | undefined;
    isDeleted?: boolean | undefined;
}

export interface ScoreSearchRequestDTO {
    id?: string | undefined;
    memberId?: string | undefined;
    idPassportNumber?: string | undefined;
    scoreTypeId?: string | undefined;
    scoreStatusId?: string | undefined;
    exerciseTypeId?: string | undefined;
    exerciseSpecificId?: string | undefined;
    location?: string | undefined;
    distance?: string | undefined;
    dateActivity?: Date | undefined;
    courseId?: string | undefined;
    competitionEntryId?: string | undefined;
    memberFirearmId?: string | undefined;
    firearmTypeId?: string | undefined;
    firearmSpecificId?: string | undefined;
    firearmCalibreId?: string | undefined;
    calibreOther?: string | undefined;
    fileAdditionalId?: string | undefined;
    scoreBlock1?: string | undefined;
    scoreBlock2?: string | undefined;
    scoreBlock3?: string | undefined;
    scoreBlock4?: string | undefined;
    scorePoints1?: number | undefined;
    scorePoints2?: number | undefined;
    scoreValue1?: number | undefined;
    scoreValue2?: number | undefined;
    scoreTime1?: number | undefined;
    scoreTime2?: number | undefined;
    scoreMark1?: number | undefined;
    scoreMark2?: number | undefined;
    scoreMarkFinal?: number | undefined;
    scorePercentage1?: number | undefined;
    scorePercentage2?: number | undefined;
    scorePercentageFinal?: number | undefined;
    replyTemplateId?: string | undefined;
    statusDate?: Date | undefined;
    emailStatusSentDate?: Date | undefined;
    emailFeedbackSentDate?: Date | undefined;
    activityTypeId?: string | undefined;
    targetScore?: number | undefined;
    notes?: string | undefined;
    generalSearchTerm?: string | undefined;
    isDeleted?: boolean | undefined;
    createdFrom?: Date | undefined;
    createdTo?: Date | undefined;
}

export interface ScoreSectionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    scoreId?: string | undefined;
    exerciseTemplateSectionId?: string | undefined;
    sectionScore?: number | undefined;
    sectionPercentage?: number | undefined;
    sectionMark?: number | undefined;
    timeValue?: string | undefined;
    score?: ScoreDTO | undefined;
    exerciseTemplateSection?: ExerciseTemplateSectionDTO | undefined;
    scoreFields?: ScoreFieldDTO[] | undefined;
    isDeleted?: boolean | undefined;
}

export interface ScoreStatusDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    colourGradingId?: string | undefined;
    colourGrading?: ColourGradingDTO | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ScoreStatusSearchRequestDTO {
    title?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ScoreTargetFileDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    scoreId?: string | undefined;
    exerciseTargetId?: string | undefined;
    fileRecordId?: string | undefined;
}

export interface ScoreTargetFileSearchRequestDTO {
    scoreId?: string | undefined;
    exerciseTargetId?: string | undefined;
    fileRecordId?: string | undefined;
}

export interface ScoreTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface ScoreTypeSearchRequestDTO {
    title?: string | undefined;
    titleShort?: string | undefined;
    displayPosition?: number | undefined;
    isActive?: boolean | undefined;
}

export interface SearchRequestDTO_activityCategorySearchRequestDTO {
    filters?: ActivityCategorySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_activitySearchRequestDTO {
    filters?: ActivitySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_activitySpeciesSearchRequestDTO {
    filters?: ActivitySpeciesSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_activitySpeciesTypeSearchRequestDTO {
    filters?: ActivitySpeciesTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_activityStatusSearchRequestDTO {
    filters?: ActivityStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_activityTypeSearchRequestDTO {
    filters?: ActivityTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_articleSearchRequestDTO {
    filters?: ArticleSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_auditLogSearchRequestDTO {
    filters?: AuditLogSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bankSearchRequestDTO {
    filters?: BankSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bulkEmailSearchRequestDTO {
    filters?: BulkEmailSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_certificateTypeSearchRequestDTO {
    filters?: CertificateTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_colourGradingSearchRequestDTO {
    filters?: ColourGradingSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_companyInfoSearchRequestDTO {
    filters?: CompanyInfoSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competencyTypeSearchRequestDTO {
    filters?: CompetencyTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionClassSearchRequestDTO {
    filters?: CompetitionClassSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionClassTypeSearchRequestDTO {
    filters?: CompetitionClassTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionEntrySearchRequestDTO {
    filters?: CompetitionEntrySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionExerciseSearchRequestDTO {
    filters?: CompetitionExerciseSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionExerciseTypeSearchRequestDTO {
    filters?: CompetitionExerciseTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionResultEntrySearchRequestDTO {
    filters?: CompetitionResultEntrySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionResultSearchRequestDTO {
    filters?: CompetitionResultSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionSearchRequestDTO {
    filters?: CompetitionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_competitionStatusSearchRequestDTO {
    filters?: CompetitionStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_componentActionSearchRequestDTO {
    filters?: ComponentActionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_componentSearchRequestDTO {
    filters?: ComponentSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_contentCategorySearchRequestDTO {
    filters?: ContentCategorySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_countrySearchRequestDTO {
    filters?: CountrySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseEvaluationAnswerSearchRequestDTO {
    filters?: CourseEvaluationAnswerSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseEvaluationSearchRequestDTO {
    filters?: CourseEvaluationSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseMaterialTypeSearchRequestDTO {
    filters?: CourseMaterialTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseSearchRequestDTO {
    filters?: CourseSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseStatusSearchRequestDTO {
    filters?: CourseStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseTypeSearchRequestDTO {
    filters?: CourseTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_documentTypeSearchRequestDTO {
    filters?: DocumentTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_emailMessageAttachmentSearchRequestDTO {
    filters?: EmailMessageAttachmentSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_emailMessageSearchRequestDTO {
    filters?: EmailMessageSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_emailMessageThreadSearchRequestDTO {
    filters?: EmailMessageThreadSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_emailTypeSearchRequestDTO {
    filters?: EmailTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_endorsementLicenceTypeSearchRequestDTO {
    filters?: EndorsementLicenceTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_endorsementMotivationSearchRequestDTO {
    filters?: EndorsementMotivationSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_endorsementStatusSearchRequestDTO {
    filters?: EndorsementStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_enquirySearchRequestDTO {
    filters?: EnquirySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_enquiryTypeSearchRequestDTO {
    filters?: EnquiryTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_evaluationStatusSearchRequestDTO {
    filters?: EvaluationStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_exerciseActivityTargetSearchRequestDTO {
    filters?: ExerciseActivityTargetSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_exerciseSpecificSearchRequestDTO {
    filters?: ExerciseSpecificSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_exerciseTargetSearchRequestDTO {
    filters?: ExerciseTargetSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_exerciseTemplateSearchRequestDTO {
    filters?: ExerciseTemplateSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_exerciseTypeSearchRequestDTO {
    filters?: ExerciseTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_farmStatusSearchRequestDTO {
    filters?: FarmStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_farmTypeSearchRequestDTO {
    filters?: FarmTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_fellowSearchRequestDTO {
    filters?: FellowSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmActionSearchRequestDTO {
    filters?: FirearmActionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmBarrelMakeSearchRequestDTO {
    filters?: FirearmBarrelMakeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmBarrelSearchRequestDTO {
    filters?: FirearmBarrelSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmCalibreSearchRequestDTO {
    filters?: FirearmCalibreSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmCompetencyTypeSearchRequestDTO {
    filters?: FirearmCompetencyTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmLooseBarrelTypeSearchRequestDTO {
    filters?: FirearmLooseBarrelTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmMakeSearchRequestDTO {
    filters?: FirearmMakeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmOwnerSearchRequestDTO {
    filters?: FirearmOwnerSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmPurposeSearchRequestDTO {
    filters?: FirearmPurposeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmSerialTypeSearchRequestDTO {
    filters?: FirearmSerialTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmSpecificSearchRequestDTO {
    filters?: FirearmSpecificSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_firearmTypeSearchRequestDTO {
    filters?: FirearmTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_forfeitureReasonSearchRequestDTO {
    filters?: ForfeitureReasonSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_friendAndPartnerSearchRequestDTO {
    filters?: FriendAndPartnerSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_genderSearchRequestDTO {
    filters?: GenderSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_gradingCategorySearchRequestDTO {
    filters?: GradingCategorySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_gradingTypeSearchRequestDTO {
    filters?: GradingTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_invoiceBatchSearchRequestDTO {
    filters?: InvoiceBatchSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_invoiceLineItemSearchRequestDTO {
    filters?: InvoiceLineItemSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_invoiceSearchRequestDTO {
    filters?: InvoiceSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_invoiceStatusSearchRequestDTO {
    filters?: InvoiceStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_invoiceTypeSearchRequestDTO {
    filters?: InvoiceTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_languageSearchRequestDTO {
    filters?: LanguageSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_listingSearchRequestDTO {
    filters?: ListingSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_listingStatusSearchRequestDTO {
    filters?: ListingStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_listingTypeSearchRequestDTO {
    filters?: ListingTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberAdditionalDocumentSearchRequestDTO {
    filters?: MemberAdditionalDocumentSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberCancelReasonSearchRequestDTO {
    filters?: MemberCancelReasonSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberCategorySearchRequestDTO {
    filters?: MemberCategorySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberCompetencySearchRequestDTO {
    filters?: MemberCompetencySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberDisciplinaryStatusSearchRequestDTO {
    filters?: MemberDisciplinaryStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberEndorsementSearchRequestDTO {
    filters?: MemberEndorsementSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberFeeSearchRequestDTO {
    filters?: MemberFeeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberFirearmSearchRequestDTO {
    filters?: MemberFirearmSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberIdTypeSearchRequestDTO {
    filters?: MemberIdTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberReferralTypeSearchRequestDTO {
    filters?: MemberReferralTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberRegistrationStepSearchRequestDTO {
    filters?: MemberRegistrationStepSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberRegistrationTypeSearchRequestDTO {
    filters?: MemberRegistrationTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberSearchRequestDTO {
    filters?: MemberSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberStatusSearchRequestDTO {
    filters?: MemberStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberTerminationStatusSearchRequestDTO {
    filters?: MemberTerminationStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberTitleSearchRequestDTO {
    filters?: MemberTitleSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberTypeSearchRequestDTO {
    filters?: MemberTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_messageTemplateStatusSearchRequestDTO {
    filters?: MessageTemplateStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_moduleTypeSearchRequestDTO {
    filters?: ModuleTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_newsItemSearchRequestDTO {
    filters?: NewsItemSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_newsletterCategorySearchRequestDTO {
    filters?: NewsletterCategorySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_newsletterSearchRequestDTO {
    filters?: NewsletterSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_noteSearchRequestDTO {
    filters?: NoteSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_noteTypeSearchRequestDTO {
    filters?: NoteTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_pagesSearchRequestDTO {
    filters?: PagesSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentIntervalSearchRequestDTO {
    filters?: PaymentIntervalSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentSearchRequestDTO {
    filters?: PaymentSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_paymentTypeSearchRequestDTO {
    filters?: PaymentTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_provinceSearchRequestDTO {
    filters?: ProvinceSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_questionSearchRequestDTO {
    filters?: QuestionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_questionSetSearchRequestDTO {
    filters?: QuestionSetSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_quickEventSearchRequestDTO {
    filters?: QuickEventSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rangeSearchRequestDTO {
    filters?: RangeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rangeShootingReasonSearchRequestDTO {
    filters?: RangeShootingReasonSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rangeStatusSearchRequestDTO {
    filters?: RangeStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rangeTypeSearchRequestDTO {
    filters?: RangeTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_reconBatchSearchRequestDTO {
    filters?: ReconBatchSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_reconTransactionSearchRequestDTO {
    filters?: ReconTransactionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_reconTypeSearchRequestDTO {
    filters?: ReconTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_renewalStatusSearchRequestDTO {
    filters?: RenewalStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_replyTemplateSearchRequestDTO {
    filters?: ReplyTemplateSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_replyTypeSearchRequestDTO {
    filters?: ReplyTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rplSearchRequestDTO {
    filters?: RplSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_rplStatusSearchRequestDTO {
    filters?: RplStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_scoreSearchRequestDTO {
    filters?: ScoreSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_scoreStatusSearchRequestDTO {
    filters?: ScoreStatusSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_scoreTargetFileSearchRequestDTO {
    filters?: ScoreTargetFileSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_scoreTypeSearchRequestDTO {
    filters?: ScoreTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_userSearchRequestDTO {
    filters?: UserSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_vatRateHistorySearchRequestDTO {
    filters?: VatRateHistorySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchResponseDTO_activityCategoryDTO {
    results?: ActivityCategoryDTO[] | undefined;
    totalCount?: number | undefined;
}

export interface SendTestBulkEmailRequestDTO {
    testEmailAddress?: string | undefined;
}

export interface SubmitQuickEventActivityRequestDTO {
    quickEventId?: string | undefined;
    idPassportNumber?: string | undefined;
    activityCategoryId?: string | undefined;
    activityDate?: Date | undefined;
}

export interface TokenExchangeDTO {
    token?: string | undefined;
}

export interface TwoFactorSetupResponseDTO {
    qrCodeUrl?: string | undefined;
}

export interface UnsubscribedEmailRequestDTO {
    token?: string | undefined;
    reason?: string | undefined;
}

export interface UpdateActivityStatusDTO {
    recordIds?: string[] | undefined;
    activityStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface UpdateCompetitionEntryStatusDTO {
    recordIds?: string[] | undefined;
    competitionStatusId?: string | undefined;
}

export interface UpdateCourseStatusDTO {
    recordIds?: string[] | undefined;
    courseStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
    member?: MemberDTO | undefined;
    courierTrackingReference?: string | undefined;
    timeMaterialShipped?: Date | undefined;
}

export interface UpdateDebitOrderMandateRequestDTO {
    signatureFileId?: string | undefined;
    accountHolder?: string | undefined;
    bankId?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    signedAt?: string | undefined;
    amount?: number | undefined;
}

export interface UpdateMemberEndorsementStatusDTO {
    recordIds?: string[] | undefined;
    endorsementStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface UpdateMemberRegistrationStepDTO {
    memberRegistrationStepId?: string | undefined;
    memberTypeId?: string | undefined;
    memberCategoryId?: string | undefined;
    proofOfPaymentFileId?: string | undefined;
}

export interface UpdateMemberStatusDTO {
    recordIds?: string[] | undefined;
    memberStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface UpdateRangeStatusDTO {
    recordIds?: string[] | undefined;
    rangeStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface UpdateRplStatusDTO {
    recordIds?: string[] | undefined;
    rplStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
    member?: MemberDTO | undefined;
}

export interface UpdateScoreStatusDTO {
    recordIds?: string[] | undefined;
    scoreStatusId?: string | undefined;
    feedback?: string | undefined;
    replyTemplateId?: string | undefined;
    sendFeedbackEmail?: boolean | undefined;
}

export interface UserCreateDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    permissions?: string[] | undefined;
}

export interface UserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    permissions?: string[] | undefined;
}

export interface UserEditDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePicture?: string | undefined;
    password?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    permissions?: string[] | undefined;
}

export interface UserSearchRequestDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
}

export interface VatRateHistoryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    rate?: number | undefined;
    effectiveDate?: Date | undefined;
}

export interface VatRateHistorySearchRequestDTO {
    rate?: number | undefined;
    effectiveDate?: Date | undefined;
}

export interface VerifyTwoFactorDTO {
    userId?: string | undefined;
    code?: string | undefined;
}

export interface YearQualificationDTO {
    year?: number | undefined;
    gradingTypeQualifications?: GradingTypeQualificationDTO[] | undefined;
}

export enum ComponentPlaceholderDTOType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum FileRecordDTOStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}